/**
 * Generated by @openapi-codegen
 *
 * @version v1 (2026-05-21T16:47+00:00.831cda76256f4706b4952df67167cf4defe9c1df)
 */
import * as reactQuery from "@tanstack/react-query";

import { type CrowdcoursingApiContext, queryKeyFn, useCrowdcoursingApiContext } from "./CrowdcoursingApiContext";
import { crowdcoursingApiFetch } from "./CrowdcoursingApiFetcher";
import { deepMerge } from "./CrowdcoursingApiUtils";

import type * as Fetcher from "./CrowdcoursingApiFetcher";
import type * as Schemas from "./CrowdcoursingApiSchemas";

interface QueryFnOptions {
  signal?: AbortController["signal"];
}

export type AiChatChatError = Fetcher.ErrorWrapper<undefined>;

export type AiChatChatVariables = {
  body?: Schemas.ChatRequest;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchAiChatChat = (variables: AiChatChatVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, AiChatChatError, Schemas.ChatRequest, {}, {}, {}>({
    method: "post",
    url: "/api/v1/chat/ai",
    ...variables,
    signal,
  });

export const useAiChatChat = (
  options?: Omit<reactQuery.UseMutationOptions<undefined, AiChatChatError, AiChatChatVariables>, "mutationFn">,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, AiChatChatError, AiChatChatVariables>({
    mutationFn: (variables: AiChatChatVariables) => fetchAiChatChat(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface AiChatGetUserConversationsQueryParams {
  /**
   * @format uuid
   */
  userId?: string;
  /**
   * @default false
   */
  includeArchived?: boolean;
}

export type AiChatGetUserConversationsError = Fetcher.ErrorWrapper<undefined>;

export type AiChatGetUserConversationsResponse = Schemas.ConversationThreadDto[];

export type AiChatGetUserConversationsVariables = {
  queryParams?: AiChatGetUserConversationsQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchAiChatGetUserConversations = (variables: AiChatGetUserConversationsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    AiChatGetUserConversationsResponse,
    AiChatGetUserConversationsError,
    undefined,
    {},
    AiChatGetUserConversationsQueryParams,
    {}
  >({ method: "get", url: "/api/v1/chat/ai/conversations", ...variables, signal });

export function aiChatGetUserConversationsQuery(variables: AiChatGetUserConversationsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<AiChatGetUserConversationsResponse>;
};

export function aiChatGetUserConversationsQuery(
  variables: AiChatGetUserConversationsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<AiChatGetUserConversationsResponse>) | reactQuery.SkipToken;
};

export function aiChatGetUserConversationsQuery(variables: AiChatGetUserConversationsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchAiChatGetUserConversations(variables, signal),
    queryKey: queryKeyFn({
      operationId: "aiChatGetUserConversations",
      path: "/api/v1/chat/ai/conversations",
      variables,
    }),
  };
}

export const useSuspenseAiChatGetUserConversations = <TData = AiChatGetUserConversationsResponse>(
  variables: AiChatGetUserConversationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<AiChatGetUserConversationsResponse, AiChatGetUserConversationsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<AiChatGetUserConversationsResponse, AiChatGetUserConversationsError, TData>({
    ...aiChatGetUserConversationsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useAiChatGetUserConversations = <TData = AiChatGetUserConversationsResponse>(
  variables: AiChatGetUserConversationsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<AiChatGetUserConversationsResponse, AiChatGetUserConversationsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<AiChatGetUserConversationsResponse, AiChatGetUserConversationsError, TData>({
    ...aiChatGetUserConversationsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface AiChatGetConversationPathParams {
  /**
   * @format uuid
   */
  threadId: string;
}

export type AiChatGetConversationError = Fetcher.ErrorWrapper<undefined>;

export type AiChatGetConversationVariables = {
  pathParams: AiChatGetConversationPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchAiChatGetConversation = (variables: AiChatGetConversationVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.ConversationDetailDto,
    AiChatGetConversationError,
    undefined,
    {},
    {},
    AiChatGetConversationPathParams
  >({ method: "get", url: "/api/v1/chat/ai/conversations/{threadId}", ...variables, signal });

export function aiChatGetConversationQuery(variables: AiChatGetConversationVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ConversationDetailDto>;
};

export function aiChatGetConversationQuery(variables: AiChatGetConversationVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.ConversationDetailDto>) | reactQuery.SkipToken;
};

export function aiChatGetConversationQuery(variables: AiChatGetConversationVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchAiChatGetConversation(variables, signal),
    queryKey: queryKeyFn({
      operationId: "aiChatGetConversation",
      path: "/api/v1/chat/ai/conversations/{threadId}",
      variables,
    }),
  };
}

export const useSuspenseAiChatGetConversation = <TData = Schemas.ConversationDetailDto>(
  variables: AiChatGetConversationVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ConversationDetailDto, AiChatGetConversationError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.ConversationDetailDto, AiChatGetConversationError, TData>({
    ...aiChatGetConversationQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useAiChatGetConversation = <TData = Schemas.ConversationDetailDto>(
  variables: AiChatGetConversationVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ConversationDetailDto, AiChatGetConversationError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.ConversationDetailDto, AiChatGetConversationError, TData>({
    ...aiChatGetConversationQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BackgroundCheckGetProductsQueryParams {
  /**
   * @format uuid
   */
  BubbleId?: string;
  /**
   * @format uuid
   */
  SchoolDistrictId?: string;
}

export type BackgroundCheckGetProductsError = Fetcher.ErrorWrapper<undefined>;

export type BackgroundCheckGetProductsResponse = Schemas.BackgroundCheckProduct[];

export type BackgroundCheckGetProductsVariables = {
  queryParams?: BackgroundCheckGetProductsQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBackgroundCheckGetProducts = (variables: BackgroundCheckGetProductsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    BackgroundCheckGetProductsResponse,
    BackgroundCheckGetProductsError,
    undefined,
    {},
    BackgroundCheckGetProductsQueryParams,
    {}
  >({ method: "get", url: "/api/v1/background-checks/products", ...variables, signal });

export function backgroundCheckGetProductsQuery(variables: BackgroundCheckGetProductsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BackgroundCheckGetProductsResponse>;
};

export function backgroundCheckGetProductsQuery(
  variables: BackgroundCheckGetProductsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BackgroundCheckGetProductsResponse>) | reactQuery.SkipToken;
};

export function backgroundCheckGetProductsQuery(variables: BackgroundCheckGetProductsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBackgroundCheckGetProducts(variables, signal),
    queryKey: queryKeyFn({
      operationId: "backgroundCheckGetProducts",
      path: "/api/v1/background-checks/products",
      variables,
    }),
  };
}

export const useSuspenseBackgroundCheckGetProducts = <TData = BackgroundCheckGetProductsResponse>(
  variables: BackgroundCheckGetProductsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<BackgroundCheckGetProductsResponse, BackgroundCheckGetProductsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<BackgroundCheckGetProductsResponse, BackgroundCheckGetProductsError, TData>({
    ...backgroundCheckGetProductsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBackgroundCheckGetProducts = <TData = BackgroundCheckGetProductsResponse>(
  variables: BackgroundCheckGetProductsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<BackgroundCheckGetProductsResponse, BackgroundCheckGetProductsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<BackgroundCheckGetProductsResponse, BackgroundCheckGetProductsError, TData>({
    ...backgroundCheckGetProductsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type BackgroundCheckCreateSelfPayError = Fetcher.ErrorWrapper<undefined>;

export type BackgroundCheckCreateSelfPayVariables = {
  body: Schemas.SelfPayRequest;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBackgroundCheckCreateSelfPay = (
  variables: BackgroundCheckCreateSelfPayVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<Schemas.SelfPayResult, BackgroundCheckCreateSelfPayError, Schemas.SelfPayRequest, {}, {}, {}>({
    method: "post",
    url: "/api/v1/background-checks/selfPay",
    ...variables,
    signal,
  });

export const useBackgroundCheckCreateSelfPay = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SelfPayResult,
      BackgroundCheckCreateSelfPayError,
      BackgroundCheckCreateSelfPayVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.SelfPayResult,
    BackgroundCheckCreateSelfPayError,
    BackgroundCheckCreateSelfPayVariables
  >({
    mutationFn: (variables: BackgroundCheckCreateSelfPayVariables) =>
      fetchBackgroundCheckCreateSelfPay(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BackgroundCheckCreateDistrictPayPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BackgroundCheckCreateDistrictPayError = Fetcher.ErrorWrapper<undefined>;

export type BackgroundCheckCreateDistrictPayVariables = {
  body: Schemas.DistrictPayRequest;
  pathParams: BackgroundCheckCreateDistrictPayPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBackgroundCheckCreateDistrictPay = (
  variables: BackgroundCheckCreateDistrictPayVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    BackgroundCheckCreateDistrictPayError,
    Schemas.DistrictPayRequest,
    {},
    {},
    BackgroundCheckCreateDistrictPayPathParams
  >({ method: "post", url: "/api/v1/background-checks/bubbles/{bubbleId}/districtPay", ...variables, signal });

export const useBackgroundCheckCreateDistrictPay = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      BackgroundCheckCreateDistrictPayError,
      BackgroundCheckCreateDistrictPayVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    BackgroundCheckCreateDistrictPayError,
    BackgroundCheckCreateDistrictPayVariables
  >({
    mutationFn: (variables: BackgroundCheckCreateDistrictPayVariables) =>
      fetchBackgroundCheckCreateDistrictPay(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type BubbleGetSiteIdError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetSiteIdVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetSiteId = (variables: BubbleGetSiteIdVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<string, BubbleGetSiteIdError, undefined, {}, {}, {}>({
    method: "get",
    url: "/api/v1/Bubbles/admin/site",
    ...variables,
    signal,
  });

export function bubbleGetSiteIdQuery(variables: BubbleGetSiteIdVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<string>;
};

export function bubbleGetSiteIdQuery(variables: BubbleGetSiteIdVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<string>) | reactQuery.SkipToken;
};

export function bubbleGetSiteIdQuery(variables: BubbleGetSiteIdVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGetSiteId(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGetSiteId",
      path: "/api/v1/Bubbles/admin/site",
      variables,
    }),
  };
}

export const useSuspenseBubbleGetSiteId = <TData = string>(
  variables: BubbleGetSiteIdVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<string, BubbleGetSiteIdError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<string, BubbleGetSiteIdError, TData>({
    ...bubbleGetSiteIdQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGetSiteId = <TData = string>(
  variables: BubbleGetSiteIdVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<string, BubbleGetSiteIdError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<string, BubbleGetSiteIdError, TData>({
    ...bubbleGetSiteIdQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleGetBubblePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleGetBubbleError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetBubbleVariables = {
  pathParams: BubbleGetBubblePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetBubble = (variables: BubbleGetBubbleVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<Schemas.BubbleDto, BubbleGetBubbleError, undefined, {}, {}, BubbleGetBubblePathParams>({
    method: "get",
    url: "/api/v1/Bubbles/{bubbleId}",
    ...variables,
    signal,
  });

export function bubbleGetBubbleQuery(variables: BubbleGetBubbleVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.BubbleDto>;
};

export function bubbleGetBubbleQuery(variables: BubbleGetBubbleVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.BubbleDto>) | reactQuery.SkipToken;
};

export function bubbleGetBubbleQuery(variables: BubbleGetBubbleVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGetBubble(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGetBubble",
      path: "/api/v1/Bubbles/{bubbleId}",
      variables,
    }),
  };
}

export const useSuspenseBubbleGetBubble = <TData = Schemas.BubbleDto>(
  variables: BubbleGetBubbleVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.BubbleDto, BubbleGetBubbleError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.BubbleDto, BubbleGetBubbleError, TData>({
    ...bubbleGetBubbleQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGetBubble = <TData = Schemas.BubbleDto>(
  variables: BubbleGetBubbleVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.BubbleDto, BubbleGetBubbleError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.BubbleDto, BubbleGetBubbleError, TData>({
    ...bubbleGetBubbleQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleGetBubblesForUserPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type BubbleGetBubblesForUserError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetBubblesForUserResponse = Schemas.BubbleDto[];

export type BubbleGetBubblesForUserVariables = {
  pathParams: BubbleGetBubblesForUserPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetBubblesForUser = (variables: BubbleGetBubblesForUserVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    BubbleGetBubblesForUserResponse,
    BubbleGetBubblesForUserError,
    undefined,
    {},
    {},
    BubbleGetBubblesForUserPathParams
  >({ method: "get", url: "/api/v1/Bubbles/users/{userId}", ...variables, signal });

export function bubbleGetBubblesForUserQuery(variables: BubbleGetBubblesForUserVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleGetBubblesForUserResponse>;
};

export function bubbleGetBubblesForUserQuery(variables: BubbleGetBubblesForUserVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleGetBubblesForUserResponse>) | reactQuery.SkipToken;
};

export function bubbleGetBubblesForUserQuery(variables: BubbleGetBubblesForUserVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGetBubblesForUser(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGetBubblesForUser",
      path: "/api/v1/Bubbles/users/{userId}",
      variables,
    }),
  };
}

export const useSuspenseBubbleGetBubblesForUser = <TData = BubbleGetBubblesForUserResponse>(
  variables: BubbleGetBubblesForUserVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetBubblesForUserResponse, BubbleGetBubblesForUserError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<BubbleGetBubblesForUserResponse, BubbleGetBubblesForUserError, TData>({
    ...bubbleGetBubblesForUserQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGetBubblesForUser = <TData = BubbleGetBubblesForUserResponse>(
  variables: BubbleGetBubblesForUserVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetBubblesForUserResponse, BubbleGetBubblesForUserError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<BubbleGetBubblesForUserResponse, BubbleGetBubblesForUserError, TData>({
    ...bubbleGetBubblesForUserQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleGetRolesPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleGetRolesError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetRolesResponse = string[];

export type BubbleGetRolesVariables = {
  pathParams: BubbleGetRolesPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetRoles = (variables: BubbleGetRolesVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<BubbleGetRolesResponse, BubbleGetRolesError, undefined, {}, {}, BubbleGetRolesPathParams>({
    method: "get",
    url: "/api/v1/Bubbles/{bubbleId}/role",
    ...variables,
    signal,
  });

export function bubbleGetRolesQuery(variables: BubbleGetRolesVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleGetRolesResponse>;
};

export function bubbleGetRolesQuery(variables: BubbleGetRolesVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleGetRolesResponse>) | reactQuery.SkipToken;
};

export function bubbleGetRolesQuery(variables: BubbleGetRolesVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGetRoles(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGetRoles",
      path: "/api/v1/Bubbles/{bubbleId}/role",
      variables,
    }),
  };
}

export const useSuspenseBubbleGetRoles = <TData = BubbleGetRolesResponse>(
  variables: BubbleGetRolesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetRolesResponse, BubbleGetRolesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<BubbleGetRolesResponse, BubbleGetRolesError, TData>({
    ...bubbleGetRolesQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGetRoles = <TData = BubbleGetRolesResponse>(
  variables: BubbleGetRolesVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetRolesResponse, BubbleGetRolesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<BubbleGetRolesResponse, BubbleGetRolesError, TData>({
    ...bubbleGetRolesQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleGetUsersForBubblePathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleGetUsersForBubbleError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetUsersForBubbleResponse = Schemas.UserDistrictSummary[];

export type BubbleGetUsersForBubbleVariables = {
  pathParams: BubbleGetUsersForBubblePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetUsersForBubble = (variables: BubbleGetUsersForBubbleVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    BubbleGetUsersForBubbleResponse,
    BubbleGetUsersForBubbleError,
    undefined,
    {},
    {},
    BubbleGetUsersForBubblePathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/users", ...variables, signal });

export function bubbleGetUsersForBubbleQuery(variables: BubbleGetUsersForBubbleVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleGetUsersForBubbleResponse>;
};

export function bubbleGetUsersForBubbleQuery(variables: BubbleGetUsersForBubbleVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleGetUsersForBubbleResponse>) | reactQuery.SkipToken;
};

export function bubbleGetUsersForBubbleQuery(variables: BubbleGetUsersForBubbleVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGetUsersForBubble(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGetUsersForBubble",
      path: "/api/v1/Bubbles/{bubbleId}/users",
      variables,
    }),
  };
}

export const useSuspenseBubbleGetUsersForBubble = <TData = BubbleGetUsersForBubbleResponse>(
  variables: BubbleGetUsersForBubbleVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetUsersForBubbleResponse, BubbleGetUsersForBubbleError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<BubbleGetUsersForBubbleResponse, BubbleGetUsersForBubbleError, TData>({
    ...bubbleGetUsersForBubbleQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGetUsersForBubble = <TData = BubbleGetUsersForBubbleResponse>(
  variables: BubbleGetUsersForBubbleVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetUsersForBubbleResponse, BubbleGetUsersForBubbleError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<BubbleGetUsersForBubbleResponse, BubbleGetUsersForBubbleError, TData>({
    ...bubbleGetUsersForBubbleQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleBulkAddUsersAsRolePathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleBulkAddUsersAsRoleError = Fetcher.ErrorWrapper<undefined>;

export type BubbleBulkAddUsersAsRoleVariables = {
  body?: Schemas.BulkAddUserRequest;
  pathParams: BubbleBulkAddUsersAsRolePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleBulkAddUsersAsRole = (variables: BubbleBulkAddUsersAsRoleVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    BubbleBulkAddUsersAsRoleError,
    Schemas.BulkAddUserRequest,
    {},
    {},
    BubbleBulkAddUsersAsRolePathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/users", ...variables, signal });

export const useBubbleBulkAddUsersAsRole = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, BubbleBulkAddUsersAsRoleError, BubbleBulkAddUsersAsRoleVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, BubbleBulkAddUsersAsRoleError, BubbleBulkAddUsersAsRoleVariables>({
    mutationFn: (variables: BubbleBulkAddUsersAsRoleVariables) =>
      fetchBubbleBulkAddUsersAsRole(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleAddRoleToUserPathParams {
  /**
   * Required, non-null
   *
   * @format uuid
   */
  bubbleId: string;
  /**
   * Required, non-null
   *
   * @format uuid
   */
  userId: string;
  /**
   * Required, must meet expected values
   */
  role: string;
}

export type BubbleAddRoleToUserError = Fetcher.ErrorWrapper<undefined>;

export type BubbleAddRoleToUserVariables = {
  pathParams: BubbleAddRoleToUserPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleAddRoleToUser = (variables: BubbleAddRoleToUserVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, BubbleAddRoleToUserError, undefined, {}, {}, BubbleAddRoleToUserPathParams>({
    method: "post",
    url: "/api/v1/Bubbles/{bubbleId}/users/{userId}/role/{role}",
    ...variables,
    signal,
  });

export const useBubbleAddRoleToUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, BubbleAddRoleToUserError, BubbleAddRoleToUserVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, BubbleAddRoleToUserError, BubbleAddRoleToUserVariables>({
    mutationFn: (variables: BubbleAddRoleToUserVariables) =>
      fetchBubbleAddRoleToUser(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleRemoveRoleFromUserPathParams {
  /**
   * Required, non-null
   *
   * @format uuid
   */
  bubbleId: string;
  /**
   * Required, non-null
   *
   * @format uuid
   */
  userId: string;
  /**
   * Required, must meet expected values
   */
  role: string;
}

export type BubbleRemoveRoleFromUserError = Fetcher.ErrorWrapper<undefined>;

export type BubbleRemoveRoleFromUserVariables = {
  pathParams: BubbleRemoveRoleFromUserPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleRemoveRoleFromUser = (variables: BubbleRemoveRoleFromUserVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    BubbleRemoveRoleFromUserError,
    undefined,
    {},
    {},
    BubbleRemoveRoleFromUserPathParams
  >({ method: "delete", url: "/api/v1/Bubbles/{bubbleId}/users/{userId}/role/{role}", ...variables, signal });

export const useBubbleRemoveRoleFromUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, BubbleRemoveRoleFromUserError, BubbleRemoveRoleFromUserVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, BubbleRemoveRoleFromUserError, BubbleRemoveRoleFromUserVariables>({
    mutationFn: (variables: BubbleRemoveRoleFromUserVariables) =>
      fetchBubbleRemoveRoleFromUser(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleGetUpcomingRsvpsPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleGetUpcomingRsvpsError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetUpcomingRsvpsResponse = Schemas.RsvpResponse[];

export type BubbleGetUpcomingRsvpsVariables = {
  pathParams: BubbleGetUpcomingRsvpsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetUpcomingRsvps = (variables: BubbleGetUpcomingRsvpsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    BubbleGetUpcomingRsvpsResponse,
    BubbleGetUpcomingRsvpsError,
    undefined,
    {},
    {},
    BubbleGetUpcomingRsvpsPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/upcoming-rsvps", ...variables, signal });

export function bubbleGetUpcomingRsvpsQuery(variables: BubbleGetUpcomingRsvpsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleGetUpcomingRsvpsResponse>;
};

export function bubbleGetUpcomingRsvpsQuery(variables: BubbleGetUpcomingRsvpsVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleGetUpcomingRsvpsResponse>) | reactQuery.SkipToken;
};

export function bubbleGetUpcomingRsvpsQuery(variables: BubbleGetUpcomingRsvpsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGetUpcomingRsvps(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGetUpcomingRsvps",
      path: "/api/v1/Bubbles/{bubbleId}/upcoming-rsvps",
      variables,
    }),
  };
}

export const useSuspenseBubbleGetUpcomingRsvps = <TData = BubbleGetUpcomingRsvpsResponse>(
  variables: BubbleGetUpcomingRsvpsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetUpcomingRsvpsResponse, BubbleGetUpcomingRsvpsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<BubbleGetUpcomingRsvpsResponse, BubbleGetUpcomingRsvpsError, TData>({
    ...bubbleGetUpcomingRsvpsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGetUpcomingRsvps = <TData = BubbleGetUpcomingRsvpsResponse>(
  variables: BubbleGetUpcomingRsvpsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetUpcomingRsvpsResponse, BubbleGetUpcomingRsvpsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<BubbleGetUpcomingRsvpsResponse, BubbleGetUpcomingRsvpsError, TData>({
    ...bubbleGetUpcomingRsvpsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleGetAllEventsForBubblePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleGetAllEventsForBubbleError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetAllEventsForBubbleResponse = Schemas.EventDto[];

export type BubbleGetAllEventsForBubbleVariables = {
  pathParams: BubbleGetAllEventsForBubblePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetAllEventsForBubble = (
  variables: BubbleGetAllEventsForBubbleVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    BubbleGetAllEventsForBubbleResponse,
    BubbleGetAllEventsForBubbleError,
    undefined,
    {},
    {},
    BubbleGetAllEventsForBubblePathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/events", ...variables, signal });

export function bubbleGetAllEventsForBubbleQuery(variables: BubbleGetAllEventsForBubbleVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleGetAllEventsForBubbleResponse>;
};

export function bubbleGetAllEventsForBubbleQuery(
  variables: BubbleGetAllEventsForBubbleVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleGetAllEventsForBubbleResponse>) | reactQuery.SkipToken;
};

export function bubbleGetAllEventsForBubbleQuery(
  variables: BubbleGetAllEventsForBubbleVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGetAllEventsForBubble(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGetAllEventsForBubble",
      path: "/api/v1/Bubbles/{bubbleId}/events",
      variables,
    }),
  };
}

export const useSuspenseBubbleGetAllEventsForBubble = <TData = BubbleGetAllEventsForBubbleResponse>(
  variables: BubbleGetAllEventsForBubbleVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetAllEventsForBubbleResponse, BubbleGetAllEventsForBubbleError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<BubbleGetAllEventsForBubbleResponse, BubbleGetAllEventsForBubbleError, TData>({
    ...bubbleGetAllEventsForBubbleQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGetAllEventsForBubble = <TData = BubbleGetAllEventsForBubbleResponse>(
  variables: BubbleGetAllEventsForBubbleVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetAllEventsForBubbleResponse, BubbleGetAllEventsForBubbleError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<BubbleGetAllEventsForBubbleResponse, BubbleGetAllEventsForBubbleError, TData>({
    ...bubbleGetAllEventsForBubbleQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleGetUpcomingEventsForBubblePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleGetUpcomingEventsForBubbleError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetUpcomingEventsForBubbleResponse = Schemas.EventDto[];

export type BubbleGetUpcomingEventsForBubbleVariables = {
  pathParams: BubbleGetUpcomingEventsForBubblePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetUpcomingEventsForBubble = (
  variables: BubbleGetUpcomingEventsForBubbleVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    BubbleGetUpcomingEventsForBubbleResponse,
    BubbleGetUpcomingEventsForBubbleError,
    undefined,
    {},
    {},
    BubbleGetUpcomingEventsForBubblePathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/upcoming-events", ...variables, signal });

export function bubbleGetUpcomingEventsForBubbleQuery(variables: BubbleGetUpcomingEventsForBubbleVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleGetUpcomingEventsForBubbleResponse>;
};

export function bubbleGetUpcomingEventsForBubbleQuery(
  variables: BubbleGetUpcomingEventsForBubbleVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleGetUpcomingEventsForBubbleResponse>) | reactQuery.SkipToken;
};

export function bubbleGetUpcomingEventsForBubbleQuery(
  variables: BubbleGetUpcomingEventsForBubbleVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGetUpcomingEventsForBubble(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGetUpcomingEventsForBubble",
      path: "/api/v1/Bubbles/{bubbleId}/upcoming-events",
      variables,
    }),
  };
}

export const useSuspenseBubbleGetUpcomingEventsForBubble = <TData = BubbleGetUpcomingEventsForBubbleResponse>(
  variables: BubbleGetUpcomingEventsForBubbleVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetUpcomingEventsForBubbleResponse, BubbleGetUpcomingEventsForBubbleError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    BubbleGetUpcomingEventsForBubbleResponse,
    BubbleGetUpcomingEventsForBubbleError,
    TData
  >({
    ...bubbleGetUpcomingEventsForBubbleQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGetUpcomingEventsForBubble = <TData = BubbleGetUpcomingEventsForBubbleResponse>(
  variables: BubbleGetUpcomingEventsForBubbleVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetUpcomingEventsForBubbleResponse, BubbleGetUpcomingEventsForBubbleError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<BubbleGetUpcomingEventsForBubbleResponse, BubbleGetUpcomingEventsForBubbleError, TData>({
    ...bubbleGetUpcomingEventsForBubbleQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleUploadBubblePicturePathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleUploadBubblePictureError = Fetcher.ErrorWrapper<undefined>;

export interface BubbleUploadBubblePictureRequestBody {
  /**
   * @format binary
   */
  FormFile?: Blob;
}

export type BubbleUploadBubblePictureVariables = {
  body?: BubbleUploadBubblePictureRequestBody;
  pathParams: BubbleUploadBubblePicturePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleUploadBubblePicture = (variables: BubbleUploadBubblePictureVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    BubbleUploadBubblePictureError,
    BubbleUploadBubblePictureRequestBody,
    {},
    {},
    BubbleUploadBubblePicturePathParams
  >({ method: "put", url: "/api/v1/Bubbles/{bubbleId}/picture", ...variables, signal });

export const useBubbleUploadBubblePicture = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, BubbleUploadBubblePictureError, BubbleUploadBubblePictureVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, BubbleUploadBubblePictureError, BubbleUploadBubblePictureVariables>({
    mutationFn: (variables: BubbleUploadBubblePictureVariables) =>
      fetchBubbleUploadBubblePicture(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleGetBubblePicturePathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleGetBubblePictureError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetBubblePictureVariables = {
  pathParams: BubbleGetBubblePicturePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetBubblePicture = (variables: BubbleGetBubblePictureVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, BubbleGetBubblePictureError, undefined, {}, {}, BubbleGetBubblePicturePathParams>({
    method: "get",
    url: "/api/v1/Bubbles/{bubbleId}/picture",
    ...variables,
    signal,
  });

export function bubbleGetBubblePictureQuery(variables: BubbleGetBubblePictureVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function bubbleGetBubblePictureQuery(variables: BubbleGetBubblePictureVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function bubbleGetBubblePictureQuery(variables: BubbleGetBubblePictureVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGetBubblePicture(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGetBubblePicture",
      path: "/api/v1/Bubbles/{bubbleId}/picture",
      variables,
    }),
  };
}

export const useSuspenseBubbleGetBubblePicture = <TData = undefined>(
  variables: BubbleGetBubblePictureVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, BubbleGetBubblePictureError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, BubbleGetBubblePictureError, TData>({
    ...bubbleGetBubblePictureQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGetBubblePicture = <TData = undefined>(
  variables: BubbleGetBubblePictureVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, BubbleGetBubblePictureError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, BubbleGetBubblePictureError, TData>({
    ...bubbleGetBubblePictureQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleGetPublicPageSettingsPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleGetPublicPageSettingsError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetPublicPageSettingsVariables = {
  pathParams: BubbleGetPublicPageSettingsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetPublicPageSettings = (
  variables: BubbleGetPublicPageSettingsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    BubbleGetPublicPageSettingsError,
    undefined,
    {},
    {},
    BubbleGetPublicPageSettingsPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/public-page", ...variables, signal });

export function bubbleGetPublicPageSettingsQuery(variables: BubbleGetPublicPageSettingsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function bubbleGetPublicPageSettingsQuery(
  variables: BubbleGetPublicPageSettingsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function bubbleGetPublicPageSettingsQuery(
  variables: BubbleGetPublicPageSettingsVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGetPublicPageSettings(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGetPublicPageSettings",
      path: "/api/v1/Bubbles/{bubbleId}/public-page",
      variables,
    }),
  };
}

export const useSuspenseBubbleGetPublicPageSettings = <TData = undefined>(
  variables: BubbleGetPublicPageSettingsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, BubbleGetPublicPageSettingsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, BubbleGetPublicPageSettingsError, TData>({
    ...bubbleGetPublicPageSettingsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGetPublicPageSettings = <TData = undefined>(
  variables: BubbleGetPublicPageSettingsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, BubbleGetPublicPageSettingsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, BubbleGetPublicPageSettingsError, TData>({
    ...bubbleGetPublicPageSettingsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleUpdatePublicPageSettingsPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleUpdatePublicPageSettingsError = Fetcher.ErrorWrapper<undefined>;

export type BubbleUpdatePublicPageSettingsVariables = {
  body?: Schemas.PublicPageSettingsDto;
  pathParams: BubbleUpdatePublicPageSettingsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleUpdatePublicPageSettings = (
  variables: BubbleUpdatePublicPageSettingsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    BubbleUpdatePublicPageSettingsError,
    Schemas.PublicPageSettingsDto,
    {},
    {},
    BubbleUpdatePublicPageSettingsPathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/public-page", ...variables, signal });

export const useBubbleUpdatePublicPageSettings = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      BubbleUpdatePublicPageSettingsError,
      BubbleUpdatePublicPageSettingsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    BubbleUpdatePublicPageSettingsError,
    BubbleUpdatePublicPageSettingsVariables
  >({
    mutationFn: (variables: BubbleUpdatePublicPageSettingsVariables) =>
      fetchBubbleUpdatePublicPageSettings(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleSetPublicPageVisibilityPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleSetPublicPageVisibilityError = Fetcher.ErrorWrapper<undefined>;

export type BubbleSetPublicPageVisibilityVariables = {
  body?: Schemas.SetPublicPageVisibilityRequestDto;
  pathParams: BubbleSetPublicPageVisibilityPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleSetPublicPageVisibility = (
  variables: BubbleSetPublicPageVisibilityVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    BubbleSetPublicPageVisibilityError,
    Schemas.SetPublicPageVisibilityRequestDto,
    {},
    {},
    BubbleSetPublicPageVisibilityPathParams
  >({ method: "put", url: "/api/v1/Bubbles/{bubbleId}/public-page/visibility", ...variables, signal });

export const useBubbleSetPublicPageVisibility = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      BubbleSetPublicPageVisibilityError,
      BubbleSetPublicPageVisibilityVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, BubbleSetPublicPageVisibilityError, BubbleSetPublicPageVisibilityVariables>({
    mutationFn: (variables: BubbleSetPublicPageVisibilityVariables) =>
      fetchBubbleSetPublicPageVisibility(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleSetBubbleTimeZonePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleSetBubbleTimeZoneError = Fetcher.ErrorWrapper<undefined>;

export type BubbleSetBubbleTimeZoneVariables = {
  body?: Schemas.SetBubbleTimeZoneRequestDto;
  pathParams: BubbleSetBubbleTimeZonePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleSetBubbleTimeZone = (variables: BubbleSetBubbleTimeZoneVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    BubbleSetBubbleTimeZoneError,
    Schemas.SetBubbleTimeZoneRequestDto,
    {},
    {},
    BubbleSetBubbleTimeZonePathParams
  >({ method: "put", url: "/api/v1/Bubbles/{bubbleId}/time-zone", ...variables, signal });

export const useBubbleSetBubbleTimeZone = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, BubbleSetBubbleTimeZoneError, BubbleSetBubbleTimeZoneVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, BubbleSetBubbleTimeZoneError, BubbleSetBubbleTimeZoneVariables>({
    mutationFn: (variables: BubbleSetBubbleTimeZoneVariables) =>
      fetchBubbleSetBubbleTimeZone(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleGetDynamicStatsPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleGetDynamicStatsError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetDynamicStatsVariables = {
  body?: Schemas.DynamicStatsRequest;
  pathParams: BubbleGetDynamicStatsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetDynamicStats = (variables: BubbleGetDynamicStatsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.DynamicStatsDto,
    BubbleGetDynamicStatsError,
    Schemas.DynamicStatsRequest,
    {},
    {},
    BubbleGetDynamicStatsPathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/dynamic-stats", ...variables, signal });

export const useBubbleGetDynamicStats = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.DynamicStatsDto, BubbleGetDynamicStatsError, BubbleGetDynamicStatsVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<Schemas.DynamicStatsDto, BubbleGetDynamicStatsError, BubbleGetDynamicStatsVariables>({
    mutationFn: (variables: BubbleGetDynamicStatsVariables) =>
      fetchBubbleGetDynamicStats(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleSetCandidateAsFavoritePathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export interface BubbleSetCandidateAsFavoriteQueryParams {
  /**
   * Optional, defaults to true
   *
   * @default true
   */
  isFavorite?: boolean;
}

export type BubbleSetCandidateAsFavoriteError = Fetcher.ErrorWrapper<undefined>;

export type BubbleSetCandidateAsFavoriteVariables = {
  pathParams: BubbleSetCandidateAsFavoritePathParams;
  queryParams?: BubbleSetCandidateAsFavoriteQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleSetCandidateAsFavorite = (
  variables: BubbleSetCandidateAsFavoriteVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    BubbleSetCandidateAsFavoriteError,
    undefined,
    {},
    BubbleSetCandidateAsFavoriteQueryParams,
    BubbleSetCandidateAsFavoritePathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/candidates/{userId}/favorite", ...variables, signal });

export const useBubbleSetCandidateAsFavorite = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, BubbleSetCandidateAsFavoriteError, BubbleSetCandidateAsFavoriteVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, BubbleSetCandidateAsFavoriteError, BubbleSetCandidateAsFavoriteVariables>({
    mutationFn: (variables: BubbleSetCandidateAsFavoriteVariables) =>
      fetchBubbleSetCandidateAsFavorite(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleRemoveCandidatePathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type BubbleRemoveCandidateError = Fetcher.ErrorWrapper<undefined>;

export type BubbleRemoveCandidateVariables = {
  pathParams: BubbleRemoveCandidatePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleRemoveCandidate = (variables: BubbleRemoveCandidateVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, BubbleRemoveCandidateError, undefined, {}, {}, BubbleRemoveCandidatePathParams>({
    method: "delete",
    url: "/api/v1/Bubbles/{bubbleId}/candidates/{userId}",
    ...variables,
    signal,
  });

export const useBubbleRemoveCandidate = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, BubbleRemoveCandidateError, BubbleRemoveCandidateVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, BubbleRemoveCandidateError, BubbleRemoveCandidateVariables>({
    mutationFn: (variables: BubbleRemoveCandidateVariables) =>
      fetchBubbleRemoveCandidate(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleGetCandidatesPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleGetCandidatesError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetCandidatesResponse = Schemas.CandidateDto[];

export type BubbleGetCandidatesVariables = {
  pathParams: BubbleGetCandidatesPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetCandidates = (variables: BubbleGetCandidatesVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    BubbleGetCandidatesResponse,
    BubbleGetCandidatesError,
    undefined,
    {},
    {},
    BubbleGetCandidatesPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/candidates", ...variables, signal });

export function bubbleGetCandidatesQuery(variables: BubbleGetCandidatesVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleGetCandidatesResponse>;
};

export function bubbleGetCandidatesQuery(variables: BubbleGetCandidatesVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleGetCandidatesResponse>) | reactQuery.SkipToken;
};

export function bubbleGetCandidatesQuery(variables: BubbleGetCandidatesVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGetCandidates(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGetCandidates",
      path: "/api/v1/Bubbles/{bubbleId}/candidates",
      variables,
    }),
  };
}

export const useSuspenseBubbleGetCandidates = <TData = BubbleGetCandidatesResponse>(
  variables: BubbleGetCandidatesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetCandidatesResponse, BubbleGetCandidatesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<BubbleGetCandidatesResponse, BubbleGetCandidatesError, TData>({
    ...bubbleGetCandidatesQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGetCandidates = <TData = BubbleGetCandidatesResponse>(
  variables: BubbleGetCandidatesVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetCandidatesResponse, BubbleGetCandidatesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<BubbleGetCandidatesResponse, BubbleGetCandidatesError, TData>({
    ...bubbleGetCandidatesQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleGetCandidateStatsPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export interface BubbleGetCandidateStatsQueryParams {
  /**
   * Required
   *
   * @format date-time
   */
  startDate?: string;
  /**
   * Required
   *
   * @format date-time
   */
  endDate?: string;
  /**
   * Optional, defaults to false
   *
   * @default true
   */
  isAggregate?: boolean;
}

export type BubbleGetCandidateStatsError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetCandidateStatsVariables = {
  pathParams: BubbleGetCandidateStatsPathParams;
  queryParams?: BubbleGetCandidateStatsQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetCandidateStats = (variables: BubbleGetCandidateStatsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.CandidateStatsDto,
    BubbleGetCandidateStatsError,
    undefined,
    {},
    BubbleGetCandidateStatsQueryParams,
    BubbleGetCandidateStatsPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/candidate-stats", ...variables, signal });

export function bubbleGetCandidateStatsQuery(variables: BubbleGetCandidateStatsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.CandidateStatsDto>;
};

export function bubbleGetCandidateStatsQuery(variables: BubbleGetCandidateStatsVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.CandidateStatsDto>) | reactQuery.SkipToken;
};

export function bubbleGetCandidateStatsQuery(variables: BubbleGetCandidateStatsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGetCandidateStats(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGetCandidateStats",
      path: "/api/v1/Bubbles/{bubbleId}/candidate-stats",
      variables,
    }),
  };
}

export const useSuspenseBubbleGetCandidateStats = <TData = Schemas.CandidateStatsDto>(
  variables: BubbleGetCandidateStatsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.CandidateStatsDto, BubbleGetCandidateStatsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.CandidateStatsDto, BubbleGetCandidateStatsError, TData>({
    ...bubbleGetCandidateStatsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGetCandidateStats = <TData = Schemas.CandidateStatsDto>(
  variables: BubbleGetCandidateStatsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.CandidateStatsDto, BubbleGetCandidateStatsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.CandidateStatsDto, BubbleGetCandidateStatsError, TData>({
    ...bubbleGetCandidateStatsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleGetSkillsAndCertsStatsForBubblePathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleGetSkillsAndCertsStatsForBubbleError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetSkillsAndCertsStatsForBubbleVariables = {
  pathParams: BubbleGetSkillsAndCertsStatsForBubblePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetSkillsAndCertsStatsForBubble = (
  variables: BubbleGetSkillsAndCertsStatsForBubbleVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.CertsAndSkillsDto,
    BubbleGetSkillsAndCertsStatsForBubbleError,
    undefined,
    {},
    {},
    BubbleGetSkillsAndCertsStatsForBubblePathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/skills-and-certs-stats", ...variables, signal });

export function bubbleGetSkillsAndCertsStatsForBubbleQuery(variables: BubbleGetSkillsAndCertsStatsForBubbleVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.CertsAndSkillsDto>;
};

export function bubbleGetSkillsAndCertsStatsForBubbleQuery(
  variables: BubbleGetSkillsAndCertsStatsForBubbleVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.CertsAndSkillsDto>) | reactQuery.SkipToken;
};

export function bubbleGetSkillsAndCertsStatsForBubbleQuery(
  variables: BubbleGetSkillsAndCertsStatsForBubbleVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGetSkillsAndCertsStatsForBubble(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGetSkillsAndCertsStatsForBubble",
      path: "/api/v1/Bubbles/{bubbleId}/skills-and-certs-stats",
      variables,
    }),
  };
}

export const useSuspenseBubbleGetSkillsAndCertsStatsForBubble = <TData = Schemas.CertsAndSkillsDto>(
  variables: BubbleGetSkillsAndCertsStatsForBubbleVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.CertsAndSkillsDto, BubbleGetSkillsAndCertsStatsForBubbleError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.CertsAndSkillsDto, BubbleGetSkillsAndCertsStatsForBubbleError, TData>({
    ...bubbleGetSkillsAndCertsStatsForBubbleQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGetSkillsAndCertsStatsForBubble = <TData = Schemas.CertsAndSkillsDto>(
  variables: BubbleGetSkillsAndCertsStatsForBubbleVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.CertsAndSkillsDto, BubbleGetSkillsAndCertsStatsForBubbleError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.CertsAndSkillsDto, BubbleGetSkillsAndCertsStatsForBubbleError, TData>({
    ...bubbleGetSkillsAndCertsStatsForBubbleQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleGetCandidateSearchHistoryForBubblePathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export interface BubbleGetCandidateSearchHistoryForBubbleQueryParams {
  /**
   * Optional, defaults to one week ago
   *
   * @format date-time
   */
  start?: string;
  /**
   * Optional, defaults to now
   *
   * @format date-time
   */
  end?: string;
}

export type BubbleGetCandidateSearchHistoryForBubbleError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetCandidateSearchHistoryForBubbleResponse = Schemas.SearchAnalyticsEventDto[];

export type BubbleGetCandidateSearchHistoryForBubbleVariables = {
  pathParams: BubbleGetCandidateSearchHistoryForBubblePathParams;
  queryParams?: BubbleGetCandidateSearchHistoryForBubbleQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetCandidateSearchHistoryForBubble = (
  variables: BubbleGetCandidateSearchHistoryForBubbleVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    BubbleGetCandidateSearchHistoryForBubbleResponse,
    BubbleGetCandidateSearchHistoryForBubbleError,
    undefined,
    {},
    BubbleGetCandidateSearchHistoryForBubbleQueryParams,
    BubbleGetCandidateSearchHistoryForBubblePathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/candidate-search-history", ...variables, signal });

export function bubbleGetCandidateSearchHistoryForBubbleQuery(
  variables: BubbleGetCandidateSearchHistoryForBubbleVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleGetCandidateSearchHistoryForBubbleResponse>;
};

export function bubbleGetCandidateSearchHistoryForBubbleQuery(
  variables: BubbleGetCandidateSearchHistoryForBubbleVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<BubbleGetCandidateSearchHistoryForBubbleResponse>)
    | reactQuery.SkipToken;
};

export function bubbleGetCandidateSearchHistoryForBubbleQuery(
  variables: BubbleGetCandidateSearchHistoryForBubbleVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGetCandidateSearchHistoryForBubble(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGetCandidateSearchHistoryForBubble",
      path: "/api/v1/Bubbles/{bubbleId}/candidate-search-history",
      variables,
    }),
  };
}

export const useSuspenseBubbleGetCandidateSearchHistoryForBubble = <
  TData = BubbleGetCandidateSearchHistoryForBubbleResponse,
>(
  variables: BubbleGetCandidateSearchHistoryForBubbleVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      BubbleGetCandidateSearchHistoryForBubbleResponse,
      BubbleGetCandidateSearchHistoryForBubbleError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    BubbleGetCandidateSearchHistoryForBubbleResponse,
    BubbleGetCandidateSearchHistoryForBubbleError,
    TData
  >({
    ...bubbleGetCandidateSearchHistoryForBubbleQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGetCandidateSearchHistoryForBubble = <TData = BubbleGetCandidateSearchHistoryForBubbleResponse>(
  variables: BubbleGetCandidateSearchHistoryForBubbleVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      BubbleGetCandidateSearchHistoryForBubbleResponse,
      BubbleGetCandidateSearchHistoryForBubbleError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    BubbleGetCandidateSearchHistoryForBubbleResponse,
    BubbleGetCandidateSearchHistoryForBubbleError,
    TData
  >({
    ...bubbleGetCandidateSearchHistoryForBubbleQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleCreateInterviewEventPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type BubbleCreateInterviewEventError = Fetcher.ErrorWrapper<undefined>;

export type BubbleCreateInterviewEventVariables = {
  pathParams: BubbleCreateInterviewEventPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleCreateInterviewEvent = (variables: BubbleCreateInterviewEventVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    string,
    BubbleCreateInterviewEventError,
    undefined,
    {},
    {},
    BubbleCreateInterviewEventPathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/candidates/{userId}/interview", ...variables, signal });

export const useBubbleCreateInterviewEvent = (
  options?: Omit<
    reactQuery.UseMutationOptions<string, BubbleCreateInterviewEventError, BubbleCreateInterviewEventVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<string, BubbleCreateInterviewEventError, BubbleCreateInterviewEventVariables>({
    mutationFn: (variables: BubbleCreateInterviewEventVariables) =>
      fetchBubbleCreateInterviewEvent(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleMarkCandidateAsHiredPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type BubbleMarkCandidateAsHiredError = Fetcher.ErrorWrapper<undefined>;

export type BubbleMarkCandidateAsHiredVariables = {
  body?: Schemas.HireCandidateRequest;
  pathParams: BubbleMarkCandidateAsHiredPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleMarkCandidateAsHired = (variables: BubbleMarkCandidateAsHiredVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    BubbleMarkCandidateAsHiredError,
    Schemas.HireCandidateRequest,
    {},
    {},
    BubbleMarkCandidateAsHiredPathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/candidates/{userId}/hired", ...variables, signal });

export const useBubbleMarkCandidateAsHired = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, BubbleMarkCandidateAsHiredError, BubbleMarkCandidateAsHiredVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, BubbleMarkCandidateAsHiredError, BubbleMarkCandidateAsHiredVariables>({
    mutationFn: (variables: BubbleMarkCandidateAsHiredVariables) =>
      fetchBubbleMarkCandidateAsHired(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleGetBubbleCheckInQrCodePathParams {
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleGetBubbleCheckInQrCodeError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetBubbleCheckInQrCodeVariables = {
  pathParams: BubbleGetBubbleCheckInQrCodePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetBubbleCheckInQrCode = (
  variables: BubbleGetBubbleCheckInQrCodeVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    string,
    BubbleGetBubbleCheckInQrCodeError,
    undefined,
    {},
    {},
    BubbleGetBubbleCheckInQrCodePathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/check-in.svg", ...variables, signal });

export function bubbleGetBubbleCheckInQrCodeQuery(variables: BubbleGetBubbleCheckInQrCodeVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<string>;
};

export function bubbleGetBubbleCheckInQrCodeQuery(
  variables: BubbleGetBubbleCheckInQrCodeVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<string>) | reactQuery.SkipToken;
};

export function bubbleGetBubbleCheckInQrCodeQuery(
  variables: BubbleGetBubbleCheckInQrCodeVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGetBubbleCheckInQrCode(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGetBubbleCheckInQrCode",
      path: "/api/v1/Bubbles/{bubbleId}/check-in.svg",
      variables,
    }),
  };
}

export const useSuspenseBubbleGetBubbleCheckInQrCode = <TData = string>(
  variables: BubbleGetBubbleCheckInQrCodeVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<string, BubbleGetBubbleCheckInQrCodeError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<string, BubbleGetBubbleCheckInQrCodeError, TData>({
    ...bubbleGetBubbleCheckInQrCodeQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGetBubbleCheckInQrCode = <TData = string>(
  variables: BubbleGetBubbleCheckInQrCodeVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<string, BubbleGetBubbleCheckInQrCodeError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<string, BubbleGetBubbleCheckInQrCodeError, TData>({
    ...bubbleGetBubbleCheckInQrCodeQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleBubbleCheckInPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleBubbleCheckInError = Fetcher.ErrorWrapper<undefined>;

export type BubbleBubbleCheckInVariables = {
  pathParams: BubbleBubbleCheckInPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleBubbleCheckIn = (variables: BubbleBubbleCheckInVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, BubbleBubbleCheckInError, undefined, {}, {}, BubbleBubbleCheckInPathParams>({
    method: "post",
    url: "/api/v1/Bubbles/{bubbleId}/check-in",
    ...variables,
    signal,
  });

export const useBubbleBubbleCheckIn = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, BubbleBubbleCheckInError, BubbleBubbleCheckInVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, BubbleBubbleCheckInError, BubbleBubbleCheckInVariables>({
    mutationFn: (variables: BubbleBubbleCheckInVariables) =>
      fetchBubbleBubbleCheckIn(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleGetRecentSignUpsPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export interface BubbleGetRecentSignUpsQueryParams {
  /**
   * Optional, defaults to yesterday
   *
   * @format date-time
   */
  start?: string;
  /**
   * Optional, defaults to now
   *
   * @format date-time
   */
  end?: string;
}

export type BubbleGetRecentSignUpsError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetRecentSignUpsResponse = Schemas.RsvpResponse[];

export type BubbleGetRecentSignUpsVariables = {
  pathParams: BubbleGetRecentSignUpsPathParams;
  queryParams?: BubbleGetRecentSignUpsQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetRecentSignUps = (variables: BubbleGetRecentSignUpsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    BubbleGetRecentSignUpsResponse,
    BubbleGetRecentSignUpsError,
    undefined,
    {},
    BubbleGetRecentSignUpsQueryParams,
    BubbleGetRecentSignUpsPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/recent-sign-ups", ...variables, signal });

export function bubbleGetRecentSignUpsQuery(variables: BubbleGetRecentSignUpsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleGetRecentSignUpsResponse>;
};

export function bubbleGetRecentSignUpsQuery(variables: BubbleGetRecentSignUpsVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleGetRecentSignUpsResponse>) | reactQuery.SkipToken;
};

export function bubbleGetRecentSignUpsQuery(variables: BubbleGetRecentSignUpsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGetRecentSignUps(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGetRecentSignUps",
      path: "/api/v1/Bubbles/{bubbleId}/recent-sign-ups",
      variables,
    }),
  };
}

export const useSuspenseBubbleGetRecentSignUps = <TData = BubbleGetRecentSignUpsResponse>(
  variables: BubbleGetRecentSignUpsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetRecentSignUpsResponse, BubbleGetRecentSignUpsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<BubbleGetRecentSignUpsResponse, BubbleGetRecentSignUpsError, TData>({
    ...bubbleGetRecentSignUpsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGetRecentSignUps = <TData = BubbleGetRecentSignUpsResponse>(
  variables: BubbleGetRecentSignUpsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetRecentSignUpsResponse, BubbleGetRecentSignUpsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<BubbleGetRecentSignUpsResponse, BubbleGetRecentSignUpsError, TData>({
    ...bubbleGetRecentSignUpsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleGetVolunteeringStatisticsPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleGetVolunteeringStatisticsError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetVolunteeringStatisticsResponse = Schemas.VolunteeringRecordDto[];

export type BubbleGetVolunteeringStatisticsVariables = {
  pathParams: BubbleGetVolunteeringStatisticsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetVolunteeringStatistics = (
  variables: BubbleGetVolunteeringStatisticsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    BubbleGetVolunteeringStatisticsResponse,
    BubbleGetVolunteeringStatisticsError,
    undefined,
    {},
    {},
    BubbleGetVolunteeringStatisticsPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/volunteering-statistics", ...variables, signal });

export function bubbleGetVolunteeringStatisticsQuery(variables: BubbleGetVolunteeringStatisticsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleGetVolunteeringStatisticsResponse>;
};

export function bubbleGetVolunteeringStatisticsQuery(
  variables: BubbleGetVolunteeringStatisticsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleGetVolunteeringStatisticsResponse>) | reactQuery.SkipToken;
};

export function bubbleGetVolunteeringStatisticsQuery(
  variables: BubbleGetVolunteeringStatisticsVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGetVolunteeringStatistics(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGetVolunteeringStatistics",
      path: "/api/v1/Bubbles/{bubbleId}/volunteering-statistics",
      variables,
    }),
  };
}

export const useSuspenseBubbleGetVolunteeringStatistics = <TData = BubbleGetVolunteeringStatisticsResponse>(
  variables: BubbleGetVolunteeringStatisticsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetVolunteeringStatisticsResponse, BubbleGetVolunteeringStatisticsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    BubbleGetVolunteeringStatisticsResponse,
    BubbleGetVolunteeringStatisticsError,
    TData
  >({
    ...bubbleGetVolunteeringStatisticsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGetVolunteeringStatistics = <TData = BubbleGetVolunteeringStatisticsResponse>(
  variables: BubbleGetVolunteeringStatisticsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetVolunteeringStatisticsResponse, BubbleGetVolunteeringStatisticsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<BubbleGetVolunteeringStatisticsResponse, BubbleGetVolunteeringStatisticsError, TData>({
    ...bubbleGetVolunteeringStatisticsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleGetAllRelatedBubblesPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleGetAllRelatedBubblesError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGetAllRelatedBubblesResponse = Schemas.BubbleDto[];

export type BubbleGetAllRelatedBubblesVariables = {
  pathParams: BubbleGetAllRelatedBubblesPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGetAllRelatedBubbles = (variables: BubbleGetAllRelatedBubblesVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    BubbleGetAllRelatedBubblesResponse,
    BubbleGetAllRelatedBubblesError,
    undefined,
    {},
    {},
    BubbleGetAllRelatedBubblesPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/all-related-bubbles", ...variables, signal });

export function bubbleGetAllRelatedBubblesQuery(variables: BubbleGetAllRelatedBubblesVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleGetAllRelatedBubblesResponse>;
};

export function bubbleGetAllRelatedBubblesQuery(
  variables: BubbleGetAllRelatedBubblesVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleGetAllRelatedBubblesResponse>) | reactQuery.SkipToken;
};

export function bubbleGetAllRelatedBubblesQuery(variables: BubbleGetAllRelatedBubblesVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGetAllRelatedBubbles(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGetAllRelatedBubbles",
      path: "/api/v1/Bubbles/{bubbleId}/all-related-bubbles",
      variables,
    }),
  };
}

export const useSuspenseBubbleGetAllRelatedBubbles = <TData = BubbleGetAllRelatedBubblesResponse>(
  variables: BubbleGetAllRelatedBubblesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetAllRelatedBubblesResponse, BubbleGetAllRelatedBubblesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<BubbleGetAllRelatedBubblesResponse, BubbleGetAllRelatedBubblesError, TData>({
    ...bubbleGetAllRelatedBubblesQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGetAllRelatedBubbles = <TData = BubbleGetAllRelatedBubblesResponse>(
  variables: BubbleGetAllRelatedBubblesVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGetAllRelatedBubblesResponse, BubbleGetAllRelatedBubblesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<BubbleGetAllRelatedBubblesResponse, BubbleGetAllRelatedBubblesError, TData>({
    ...bubbleGetAllRelatedBubblesQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleDayOfEmergencyGetCurrentPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleDayOfEmergencyGetCurrentError = Fetcher.ErrorWrapper<undefined>;

export type BubbleDayOfEmergencyGetCurrentVariables = {
  pathParams: BubbleDayOfEmergencyGetCurrentPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleDayOfEmergencyGetCurrent = (
  variables: BubbleDayOfEmergencyGetCurrentVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.DayOfEmergencyDto,
    BubbleDayOfEmergencyGetCurrentError,
    undefined,
    {},
    {},
    BubbleDayOfEmergencyGetCurrentPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/current", ...variables, signal });

export function bubbleDayOfEmergencyGetCurrentQuery(variables: BubbleDayOfEmergencyGetCurrentVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.DayOfEmergencyDto>;
};

export function bubbleDayOfEmergencyGetCurrentQuery(
  variables: BubbleDayOfEmergencyGetCurrentVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.DayOfEmergencyDto>) | reactQuery.SkipToken;
};

export function bubbleDayOfEmergencyGetCurrentQuery(
  variables: BubbleDayOfEmergencyGetCurrentVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleDayOfEmergencyGetCurrent(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleDayOfEmergencyGetCurrent",
      path: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/current",
      variables,
    }),
  };
}

export const useSuspenseBubbleDayOfEmergencyGetCurrent = <TData = Schemas.DayOfEmergencyDto>(
  variables: BubbleDayOfEmergencyGetCurrentVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.DayOfEmergencyDto, BubbleDayOfEmergencyGetCurrentError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.DayOfEmergencyDto, BubbleDayOfEmergencyGetCurrentError, TData>({
    ...bubbleDayOfEmergencyGetCurrentQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleDayOfEmergencyGetCurrent = <TData = Schemas.DayOfEmergencyDto>(
  variables: BubbleDayOfEmergencyGetCurrentVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.DayOfEmergencyDto, BubbleDayOfEmergencyGetCurrentError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.DayOfEmergencyDto, BubbleDayOfEmergencyGetCurrentError, TData>({
    ...bubbleDayOfEmergencyGetCurrentQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleDayOfEmergencyGetByIdPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export type BubbleDayOfEmergencyGetByIdError = Fetcher.ErrorWrapper<undefined>;

export type BubbleDayOfEmergencyGetByIdVariables = {
  pathParams: BubbleDayOfEmergencyGetByIdPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleDayOfEmergencyGetById = (
  variables: BubbleDayOfEmergencyGetByIdVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.DayOfEmergencyDto,
    BubbleDayOfEmergencyGetByIdError,
    undefined,
    {},
    {},
    BubbleDayOfEmergencyGetByIdPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/{dayOfEmergencyId}", ...variables, signal });

export function bubbleDayOfEmergencyGetByIdQuery(variables: BubbleDayOfEmergencyGetByIdVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.DayOfEmergencyDto>;
};

export function bubbleDayOfEmergencyGetByIdQuery(
  variables: BubbleDayOfEmergencyGetByIdVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.DayOfEmergencyDto>) | reactQuery.SkipToken;
};

export function bubbleDayOfEmergencyGetByIdQuery(
  variables: BubbleDayOfEmergencyGetByIdVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleDayOfEmergencyGetById(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleDayOfEmergencyGetById",
      path: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/{dayOfEmergencyId}",
      variables,
    }),
  };
}

export const useSuspenseBubbleDayOfEmergencyGetById = <TData = Schemas.DayOfEmergencyDto>(
  variables: BubbleDayOfEmergencyGetByIdVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.DayOfEmergencyDto, BubbleDayOfEmergencyGetByIdError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.DayOfEmergencyDto, BubbleDayOfEmergencyGetByIdError, TData>({
    ...bubbleDayOfEmergencyGetByIdQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleDayOfEmergencyGetById = <TData = Schemas.DayOfEmergencyDto>(
  variables: BubbleDayOfEmergencyGetByIdVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.DayOfEmergencyDto, BubbleDayOfEmergencyGetByIdError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.DayOfEmergencyDto, BubbleDayOfEmergencyGetByIdError, TData>({
    ...bubbleDayOfEmergencyGetByIdQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleDayOfEmergencyListTimelinePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export type BubbleDayOfEmergencyListTimelineError = Fetcher.ErrorWrapper<undefined>;

export type BubbleDayOfEmergencyListTimelineResponse = Schemas.DayOfEmergencyTimelineEntryDto[];

export type BubbleDayOfEmergencyListTimelineVariables = {
  pathParams: BubbleDayOfEmergencyListTimelinePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleDayOfEmergencyListTimeline = (
  variables: BubbleDayOfEmergencyListTimelineVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    BubbleDayOfEmergencyListTimelineResponse,
    BubbleDayOfEmergencyListTimelineError,
    undefined,
    {},
    {},
    BubbleDayOfEmergencyListTimelinePathParams
  >({
    method: "get",
    url: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/{dayOfEmergencyId}/timeline",
    ...variables,
    signal,
  });

export function bubbleDayOfEmergencyListTimelineQuery(variables: BubbleDayOfEmergencyListTimelineVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleDayOfEmergencyListTimelineResponse>;
};

export function bubbleDayOfEmergencyListTimelineQuery(
  variables: BubbleDayOfEmergencyListTimelineVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleDayOfEmergencyListTimelineResponse>) | reactQuery.SkipToken;
};

export function bubbleDayOfEmergencyListTimelineQuery(
  variables: BubbleDayOfEmergencyListTimelineVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleDayOfEmergencyListTimeline(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleDayOfEmergencyListTimeline",
      path: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/{dayOfEmergencyId}/timeline",
      variables,
    }),
  };
}

export const useSuspenseBubbleDayOfEmergencyListTimeline = <TData = BubbleDayOfEmergencyListTimelineResponse>(
  variables: BubbleDayOfEmergencyListTimelineVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleDayOfEmergencyListTimelineResponse, BubbleDayOfEmergencyListTimelineError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    BubbleDayOfEmergencyListTimelineResponse,
    BubbleDayOfEmergencyListTimelineError,
    TData
  >({
    ...bubbleDayOfEmergencyListTimelineQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleDayOfEmergencyListTimeline = <TData = BubbleDayOfEmergencyListTimelineResponse>(
  variables: BubbleDayOfEmergencyListTimelineVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleDayOfEmergencyListTimelineResponse, BubbleDayOfEmergencyListTimelineError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<BubbleDayOfEmergencyListTimelineResponse, BubbleDayOfEmergencyListTimelineError, TData>({
    ...bubbleDayOfEmergencyListTimelineQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleDayOfEmergencyListParticipantsPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export type BubbleDayOfEmergencyListParticipantsError = Fetcher.ErrorWrapper<undefined>;

export type BubbleDayOfEmergencyListParticipantsResponse = Schemas.DayOfEmergencyParticipantDto[];

export type BubbleDayOfEmergencyListParticipantsVariables = {
  pathParams: BubbleDayOfEmergencyListParticipantsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleDayOfEmergencyListParticipants = (
  variables: BubbleDayOfEmergencyListParticipantsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    BubbleDayOfEmergencyListParticipantsResponse,
    BubbleDayOfEmergencyListParticipantsError,
    undefined,
    {},
    {},
    BubbleDayOfEmergencyListParticipantsPathParams
  >({
    method: "get",
    url: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/{dayOfEmergencyId}/participants",
    ...variables,
    signal,
  });

export function bubbleDayOfEmergencyListParticipantsQuery(variables: BubbleDayOfEmergencyListParticipantsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleDayOfEmergencyListParticipantsResponse>;
};

export function bubbleDayOfEmergencyListParticipantsQuery(
  variables: BubbleDayOfEmergencyListParticipantsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleDayOfEmergencyListParticipantsResponse>) | reactQuery.SkipToken;
};

export function bubbleDayOfEmergencyListParticipantsQuery(
  variables: BubbleDayOfEmergencyListParticipantsVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleDayOfEmergencyListParticipants(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleDayOfEmergencyListParticipants",
      path: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/{dayOfEmergencyId}/participants",
      variables,
    }),
  };
}

export const useSuspenseBubbleDayOfEmergencyListParticipants = <TData = BubbleDayOfEmergencyListParticipantsResponse>(
  variables: BubbleDayOfEmergencyListParticipantsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      BubbleDayOfEmergencyListParticipantsResponse,
      BubbleDayOfEmergencyListParticipantsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    BubbleDayOfEmergencyListParticipantsResponse,
    BubbleDayOfEmergencyListParticipantsError,
    TData
  >({
    ...bubbleDayOfEmergencyListParticipantsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleDayOfEmergencyListParticipants = <TData = BubbleDayOfEmergencyListParticipantsResponse>(
  variables: BubbleDayOfEmergencyListParticipantsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      BubbleDayOfEmergencyListParticipantsResponse,
      BubbleDayOfEmergencyListParticipantsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    BubbleDayOfEmergencyListParticipantsResponse,
    BubbleDayOfEmergencyListParticipantsError,
    TData
  >({
    ...bubbleDayOfEmergencyListParticipantsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleDayOfEmergencyPatchMePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export type BubbleDayOfEmergencyPatchMeError = Fetcher.ErrorWrapper<undefined>;

export type BubbleDayOfEmergencyPatchMeVariables = {
  body?: Schemas.PatchDayOfEmergencyParticipantRequestDto;
  pathParams: BubbleDayOfEmergencyPatchMePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleDayOfEmergencyPatchMe = (
  variables: BubbleDayOfEmergencyPatchMeVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.DayOfEmergencyParticipantDto,
    BubbleDayOfEmergencyPatchMeError,
    Schemas.PatchDayOfEmergencyParticipantRequestDto,
    {},
    {},
    BubbleDayOfEmergencyPatchMePathParams
  >({
    method: "patch",
    url: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/{dayOfEmergencyId}/participants/me",
    ...variables,
    signal,
  });

export const useBubbleDayOfEmergencyPatchMe = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DayOfEmergencyParticipantDto,
      BubbleDayOfEmergencyPatchMeError,
      BubbleDayOfEmergencyPatchMeVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.DayOfEmergencyParticipantDto,
    BubbleDayOfEmergencyPatchMeError,
    BubbleDayOfEmergencyPatchMeVariables
  >({
    mutationFn: (variables: BubbleDayOfEmergencyPatchMeVariables) =>
      fetchBubbleDayOfEmergencyPatchMe(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleDayOfEmergencyPatchUserPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
  /**
   * @format uuid
   */
  userId: string;
}

export type BubbleDayOfEmergencyPatchUserError = Fetcher.ErrorWrapper<undefined>;

export type BubbleDayOfEmergencyPatchUserVariables = {
  body?: Schemas.PatchDayOfEmergencyParticipantRequestDto;
  pathParams: BubbleDayOfEmergencyPatchUserPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleDayOfEmergencyPatchUser = (
  variables: BubbleDayOfEmergencyPatchUserVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.DayOfEmergencyParticipantDto,
    BubbleDayOfEmergencyPatchUserError,
    Schemas.PatchDayOfEmergencyParticipantRequestDto,
    {},
    {},
    BubbleDayOfEmergencyPatchUserPathParams
  >({
    method: "patch",
    url: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/{dayOfEmergencyId}/participants/{userId}",
    ...variables,
    signal,
  });

export const useBubbleDayOfEmergencyPatchUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DayOfEmergencyParticipantDto,
      BubbleDayOfEmergencyPatchUserError,
      BubbleDayOfEmergencyPatchUserVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.DayOfEmergencyParticipantDto,
    BubbleDayOfEmergencyPatchUserError,
    BubbleDayOfEmergencyPatchUserVariables
  >({
    mutationFn: (variables: BubbleDayOfEmergencyPatchUserVariables) =>
      fetchBubbleDayOfEmergencyPatchUser(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleDayOfEmergencyBatchPatchPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export type BubbleDayOfEmergencyBatchPatchError = Fetcher.ErrorWrapper<undefined>;

export type BubbleDayOfEmergencyBatchPatchResponse = Schemas.DayOfEmergencyParticipantDto[];

export type BubbleDayOfEmergencyBatchPatchVariables = {
  body?: Schemas.BatchPatchDayOfEmergencyParticipantsRequestDto;
  pathParams: BubbleDayOfEmergencyBatchPatchPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleDayOfEmergencyBatchPatch = (
  variables: BubbleDayOfEmergencyBatchPatchVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    BubbleDayOfEmergencyBatchPatchResponse,
    BubbleDayOfEmergencyBatchPatchError,
    Schemas.BatchPatchDayOfEmergencyParticipantsRequestDto,
    {},
    {},
    BubbleDayOfEmergencyBatchPatchPathParams
  >({
    method: "post",
    url: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/{dayOfEmergencyId}/participants/batch",
    ...variables,
    signal,
  });

export const useBubbleDayOfEmergencyBatchPatch = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      BubbleDayOfEmergencyBatchPatchResponse,
      BubbleDayOfEmergencyBatchPatchError,
      BubbleDayOfEmergencyBatchPatchVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    BubbleDayOfEmergencyBatchPatchResponse,
    BubbleDayOfEmergencyBatchPatchError,
    BubbleDayOfEmergencyBatchPatchVariables
  >({
    mutationFn: (variables: BubbleDayOfEmergencyBatchPatchVariables) =>
      fetchBubbleDayOfEmergencyBatchPatch(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleDayOfEmergencyBatchSetSameStatusPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export type BubbleDayOfEmergencyBatchSetSameStatusError = Fetcher.ErrorWrapper<undefined>;

export type BubbleDayOfEmergencyBatchSetSameStatusResponse = Schemas.DayOfEmergencyParticipantDto[];

export type BubbleDayOfEmergencyBatchSetSameStatusVariables = {
  body?: Schemas.BatchSetParticipantsStatusRequestDto;
  pathParams: BubbleDayOfEmergencyBatchSetSameStatusPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleDayOfEmergencyBatchSetSameStatus = (
  variables: BubbleDayOfEmergencyBatchSetSameStatusVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    BubbleDayOfEmergencyBatchSetSameStatusResponse,
    BubbleDayOfEmergencyBatchSetSameStatusError,
    Schemas.BatchSetParticipantsStatusRequestDto,
    {},
    {},
    BubbleDayOfEmergencyBatchSetSameStatusPathParams
  >({
    method: "post",
    url: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/{dayOfEmergencyId}/participants/batch-same-status",
    ...variables,
    signal,
  });

export const useBubbleDayOfEmergencyBatchSetSameStatus = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      BubbleDayOfEmergencyBatchSetSameStatusResponse,
      BubbleDayOfEmergencyBatchSetSameStatusError,
      BubbleDayOfEmergencyBatchSetSameStatusVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    BubbleDayOfEmergencyBatchSetSameStatusResponse,
    BubbleDayOfEmergencyBatchSetSameStatusError,
    BubbleDayOfEmergencyBatchSetSameStatusVariables
  >({
    mutationFn: (variables: BubbleDayOfEmergencyBatchSetSameStatusVariables) =>
      fetchBubbleDayOfEmergencyBatchSetSameStatus(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleDayOfEmergencyMintAccessTokensPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export type BubbleDayOfEmergencyMintAccessTokensError = Fetcher.ErrorWrapper<undefined>;

export type BubbleDayOfEmergencyMintAccessTokensVariables = {
  pathParams: BubbleDayOfEmergencyMintAccessTokensPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleDayOfEmergencyMintAccessTokens = (
  variables: BubbleDayOfEmergencyMintAccessTokensVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.MintEmergencyAccessTokensResponseDto,
    BubbleDayOfEmergencyMintAccessTokensError,
    undefined,
    {},
    {},
    BubbleDayOfEmergencyMintAccessTokensPathParams
  >({
    method: "post",
    url: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/{dayOfEmergencyId}/access-tokens",
    ...variables,
    signal,
  });

export const useBubbleDayOfEmergencyMintAccessTokens = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.MintEmergencyAccessTokensResponseDto,
      BubbleDayOfEmergencyMintAccessTokensError,
      BubbleDayOfEmergencyMintAccessTokensVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.MintEmergencyAccessTokensResponseDto,
    BubbleDayOfEmergencyMintAccessTokensError,
    BubbleDayOfEmergencyMintAccessTokensVariables
  >({
    mutationFn: (variables: BubbleDayOfEmergencyMintAccessTokensVariables) =>
      fetchBubbleDayOfEmergencyMintAccessTokens(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleDayOfEmergencyListAccessAuditsPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export type BubbleDayOfEmergencyListAccessAuditsError = Fetcher.ErrorWrapper<undefined>;

export type BubbleDayOfEmergencyListAccessAuditsResponse = Schemas.EmergencyPlanAccessAuditEntryDto[];

export type BubbleDayOfEmergencyListAccessAuditsVariables = {
  pathParams: BubbleDayOfEmergencyListAccessAuditsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleDayOfEmergencyListAccessAudits = (
  variables: BubbleDayOfEmergencyListAccessAuditsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    BubbleDayOfEmergencyListAccessAuditsResponse,
    BubbleDayOfEmergencyListAccessAuditsError,
    undefined,
    {},
    {},
    BubbleDayOfEmergencyListAccessAuditsPathParams
  >({
    method: "get",
    url: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/{dayOfEmergencyId}/access-audits",
    ...variables,
    signal,
  });

export function bubbleDayOfEmergencyListAccessAuditsQuery(variables: BubbleDayOfEmergencyListAccessAuditsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleDayOfEmergencyListAccessAuditsResponse>;
};

export function bubbleDayOfEmergencyListAccessAuditsQuery(
  variables: BubbleDayOfEmergencyListAccessAuditsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleDayOfEmergencyListAccessAuditsResponse>) | reactQuery.SkipToken;
};

export function bubbleDayOfEmergencyListAccessAuditsQuery(
  variables: BubbleDayOfEmergencyListAccessAuditsVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleDayOfEmergencyListAccessAudits(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleDayOfEmergencyListAccessAudits",
      path: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/{dayOfEmergencyId}/access-audits",
      variables,
    }),
  };
}

export const useSuspenseBubbleDayOfEmergencyListAccessAudits = <TData = BubbleDayOfEmergencyListAccessAuditsResponse>(
  variables: BubbleDayOfEmergencyListAccessAuditsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      BubbleDayOfEmergencyListAccessAuditsResponse,
      BubbleDayOfEmergencyListAccessAuditsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    BubbleDayOfEmergencyListAccessAuditsResponse,
    BubbleDayOfEmergencyListAccessAuditsError,
    TData
  >({
    ...bubbleDayOfEmergencyListAccessAuditsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleDayOfEmergencyListAccessAudits = <TData = BubbleDayOfEmergencyListAccessAuditsResponse>(
  variables: BubbleDayOfEmergencyListAccessAuditsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      BubbleDayOfEmergencyListAccessAuditsResponse,
      BubbleDayOfEmergencyListAccessAuditsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    BubbleDayOfEmergencyListAccessAuditsResponse,
    BubbleDayOfEmergencyListAccessAuditsError,
    TData
  >({
    ...bubbleDayOfEmergencyListAccessAuditsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleDayOfEmergencyRequestSchoolwideSafetyStatusSmsPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export type BubbleDayOfEmergencyRequestSchoolwideSafetyStatusSmsError = Fetcher.ErrorWrapper<undefined>;

export type BubbleDayOfEmergencyRequestSchoolwideSafetyStatusSmsVariables = {
  body?: Schemas.RequestEmergencySafetyStatusSmsRequestDto;
  pathParams: BubbleDayOfEmergencyRequestSchoolwideSafetyStatusSmsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleDayOfEmergencyRequestSchoolwideSafetyStatusSms = (
  variables: BubbleDayOfEmergencyRequestSchoolwideSafetyStatusSmsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.RequestEmergencySafetyStatusSmsResponseDto,
    BubbleDayOfEmergencyRequestSchoolwideSafetyStatusSmsError,
    Schemas.RequestEmergencySafetyStatusSmsRequestDto,
    {},
    {},
    BubbleDayOfEmergencyRequestSchoolwideSafetyStatusSmsPathParams
  >({
    method: "post",
    url: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/{dayOfEmergencyId}/request-schoolwide-safety-status-sms",
    ...variables,
    signal,
  });

export const useBubbleDayOfEmergencyRequestSchoolwideSafetyStatusSms = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RequestEmergencySafetyStatusSmsResponseDto,
      BubbleDayOfEmergencyRequestSchoolwideSafetyStatusSmsError,
      BubbleDayOfEmergencyRequestSchoolwideSafetyStatusSmsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.RequestEmergencySafetyStatusSmsResponseDto,
    BubbleDayOfEmergencyRequestSchoolwideSafetyStatusSmsError,
    BubbleDayOfEmergencyRequestSchoolwideSafetyStatusSmsVariables
  >({
    mutationFn: (variables: BubbleDayOfEmergencyRequestSchoolwideSafetyStatusSmsVariables) =>
      fetchBubbleDayOfEmergencyRequestSchoolwideSafetyStatusSms(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleEmergencyConfigGetConfigPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleEmergencyConfigGetConfigError = Fetcher.ErrorWrapper<undefined>;

export type BubbleEmergencyConfigGetConfigVariables = {
  pathParams: BubbleEmergencyConfigGetConfigPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleEmergencyConfigGetConfig = (
  variables: BubbleEmergencyConfigGetConfigVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.BubbleEmergencyConfigDto,
    BubbleEmergencyConfigGetConfigError,
    undefined,
    {},
    {},
    BubbleEmergencyConfigGetConfigPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/emergency-config", ...variables, signal });

export function bubbleEmergencyConfigGetConfigQuery(variables: BubbleEmergencyConfigGetConfigVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.BubbleEmergencyConfigDto>;
};

export function bubbleEmergencyConfigGetConfigQuery(
  variables: BubbleEmergencyConfigGetConfigVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.BubbleEmergencyConfigDto>) | reactQuery.SkipToken;
};

export function bubbleEmergencyConfigGetConfigQuery(
  variables: BubbleEmergencyConfigGetConfigVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleEmergencyConfigGetConfig(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleEmergencyConfigGetConfig",
      path: "/api/v1/Bubbles/{bubbleId}/emergency-config",
      variables,
    }),
  };
}

export const useSuspenseBubbleEmergencyConfigGetConfig = <TData = Schemas.BubbleEmergencyConfigDto>(
  variables: BubbleEmergencyConfigGetConfigVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.BubbleEmergencyConfigDto, BubbleEmergencyConfigGetConfigError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.BubbleEmergencyConfigDto, BubbleEmergencyConfigGetConfigError, TData>({
    ...bubbleEmergencyConfigGetConfigQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleEmergencyConfigGetConfig = <TData = Schemas.BubbleEmergencyConfigDto>(
  variables: BubbleEmergencyConfigGetConfigVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.BubbleEmergencyConfigDto, BubbleEmergencyConfigGetConfigError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.BubbleEmergencyConfigDto, BubbleEmergencyConfigGetConfigError, TData>({
    ...bubbleEmergencyConfigGetConfigQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleEmergencyConfigPutConfigPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleEmergencyConfigPutConfigError = Fetcher.ErrorWrapper<undefined>;

export type BubbleEmergencyConfigPutConfigVariables = {
  body?: Schemas.BubbleEmergencyConfigDto;
  pathParams: BubbleEmergencyConfigPutConfigPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleEmergencyConfigPutConfig = (
  variables: BubbleEmergencyConfigPutConfigVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    BubbleEmergencyConfigPutConfigError,
    Schemas.BubbleEmergencyConfigDto,
    {},
    {},
    BubbleEmergencyConfigPutConfigPathParams
  >({ method: "put", url: "/api/v1/Bubbles/{bubbleId}/emergency-config", ...variables, signal });

export const useBubbleEmergencyConfigPutConfig = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      BubbleEmergencyConfigPutConfigError,
      BubbleEmergencyConfigPutConfigVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    BubbleEmergencyConfigPutConfigError,
    BubbleEmergencyConfigPutConfigVariables
  >({
    mutationFn: (variables: BubbleEmergencyConfigPutConfigVariables) =>
      fetchBubbleEmergencyConfigPutConfig(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleEmergencyDeclarationsListPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleEmergencyDeclarationsListError = Fetcher.ErrorWrapper<undefined>;

export type BubbleEmergencyDeclarationsListResponse = Schemas.EmergencyDeclarationDto[];

export type BubbleEmergencyDeclarationsListVariables = {
  pathParams: BubbleEmergencyDeclarationsListPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleEmergencyDeclarationsList = (
  variables: BubbleEmergencyDeclarationsListVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    BubbleEmergencyDeclarationsListResponse,
    BubbleEmergencyDeclarationsListError,
    undefined,
    {},
    {},
    BubbleEmergencyDeclarationsListPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/emergency-declarations", ...variables, signal });

export function bubbleEmergencyDeclarationsListQuery(variables: BubbleEmergencyDeclarationsListVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleEmergencyDeclarationsListResponse>;
};

export function bubbleEmergencyDeclarationsListQuery(
  variables: BubbleEmergencyDeclarationsListVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleEmergencyDeclarationsListResponse>) | reactQuery.SkipToken;
};

export function bubbleEmergencyDeclarationsListQuery(
  variables: BubbleEmergencyDeclarationsListVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleEmergencyDeclarationsList(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleEmergencyDeclarationsList",
      path: "/api/v1/Bubbles/{bubbleId}/emergency-declarations",
      variables,
    }),
  };
}

export const useSuspenseBubbleEmergencyDeclarationsList = <TData = BubbleEmergencyDeclarationsListResponse>(
  variables: BubbleEmergencyDeclarationsListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleEmergencyDeclarationsListResponse, BubbleEmergencyDeclarationsListError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    BubbleEmergencyDeclarationsListResponse,
    BubbleEmergencyDeclarationsListError,
    TData
  >({
    ...bubbleEmergencyDeclarationsListQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleEmergencyDeclarationsList = <TData = BubbleEmergencyDeclarationsListResponse>(
  variables: BubbleEmergencyDeclarationsListVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleEmergencyDeclarationsListResponse, BubbleEmergencyDeclarationsListError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<BubbleEmergencyDeclarationsListResponse, BubbleEmergencyDeclarationsListError, TData>({
    ...bubbleEmergencyDeclarationsListQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleEmergencyDeclarationsGetActivePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleEmergencyDeclarationsGetActiveError = Fetcher.ErrorWrapper<undefined>;

export type BubbleEmergencyDeclarationsGetActiveVariables = {
  pathParams: BubbleEmergencyDeclarationsGetActivePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleEmergencyDeclarationsGetActive = (
  variables: BubbleEmergencyDeclarationsGetActiveVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.EmergencyDeclarationDto,
    BubbleEmergencyDeclarationsGetActiveError,
    undefined,
    {},
    {},
    BubbleEmergencyDeclarationsGetActivePathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/emergency-declarations/active", ...variables, signal });

export function bubbleEmergencyDeclarationsGetActiveQuery(variables: BubbleEmergencyDeclarationsGetActiveVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.EmergencyDeclarationDto>;
};

export function bubbleEmergencyDeclarationsGetActiveQuery(
  variables: BubbleEmergencyDeclarationsGetActiveVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.EmergencyDeclarationDto>) | reactQuery.SkipToken;
};

export function bubbleEmergencyDeclarationsGetActiveQuery(
  variables: BubbleEmergencyDeclarationsGetActiveVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleEmergencyDeclarationsGetActive(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleEmergencyDeclarationsGetActive",
      path: "/api/v1/Bubbles/{bubbleId}/emergency-declarations/active",
      variables,
    }),
  };
}

export const useSuspenseBubbleEmergencyDeclarationsGetActive = <TData = Schemas.EmergencyDeclarationDto>(
  variables: BubbleEmergencyDeclarationsGetActiveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.EmergencyDeclarationDto, BubbleEmergencyDeclarationsGetActiveError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.EmergencyDeclarationDto, BubbleEmergencyDeclarationsGetActiveError, TData>(
    {
      ...bubbleEmergencyDeclarationsGetActiveQuery(deepMerge(fetcherOptions, variables)),
      ...options,
      ...queryOptions,
    },
  );
};

export const useBubbleEmergencyDeclarationsGetActive = <TData = Schemas.EmergencyDeclarationDto>(
  variables: BubbleEmergencyDeclarationsGetActiveVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.EmergencyDeclarationDto, BubbleEmergencyDeclarationsGetActiveError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.EmergencyDeclarationDto, BubbleEmergencyDeclarationsGetActiveError, TData>({
    ...bubbleEmergencyDeclarationsGetActiveQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleEmergencyDeclarationsListActivePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleEmergencyDeclarationsListActiveError = Fetcher.ErrorWrapper<undefined>;

export type BubbleEmergencyDeclarationsListActiveResponse = Schemas.EmergencyDeclarationDto[];

export type BubbleEmergencyDeclarationsListActiveVariables = {
  pathParams: BubbleEmergencyDeclarationsListActivePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleEmergencyDeclarationsListActive = (
  variables: BubbleEmergencyDeclarationsListActiveVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    BubbleEmergencyDeclarationsListActiveResponse,
    BubbleEmergencyDeclarationsListActiveError,
    undefined,
    {},
    {},
    BubbleEmergencyDeclarationsListActivePathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/emergency-declarations/active-list", ...variables, signal });

export function bubbleEmergencyDeclarationsListActiveQuery(variables: BubbleEmergencyDeclarationsListActiveVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleEmergencyDeclarationsListActiveResponse>;
};

export function bubbleEmergencyDeclarationsListActiveQuery(
  variables: BubbleEmergencyDeclarationsListActiveVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleEmergencyDeclarationsListActiveResponse>) | reactQuery.SkipToken;
};

export function bubbleEmergencyDeclarationsListActiveQuery(
  variables: BubbleEmergencyDeclarationsListActiveVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleEmergencyDeclarationsListActive(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleEmergencyDeclarationsListActive",
      path: "/api/v1/Bubbles/{bubbleId}/emergency-declarations/active-list",
      variables,
    }),
  };
}

export const useSuspenseBubbleEmergencyDeclarationsListActive = <TData = BubbleEmergencyDeclarationsListActiveResponse>(
  variables: BubbleEmergencyDeclarationsListActiveVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      BubbleEmergencyDeclarationsListActiveResponse,
      BubbleEmergencyDeclarationsListActiveError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    BubbleEmergencyDeclarationsListActiveResponse,
    BubbleEmergencyDeclarationsListActiveError,
    TData
  >({
    ...bubbleEmergencyDeclarationsListActiveQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleEmergencyDeclarationsListActive = <TData = BubbleEmergencyDeclarationsListActiveResponse>(
  variables: BubbleEmergencyDeclarationsListActiveVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      BubbleEmergencyDeclarationsListActiveResponse,
      BubbleEmergencyDeclarationsListActiveError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    BubbleEmergencyDeclarationsListActiveResponse,
    BubbleEmergencyDeclarationsListActiveError,
    TData
  >({
    ...bubbleEmergencyDeclarationsListActiveQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleEmergencyDeclarationsEndPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  declarationId: string;
}

export type BubbleEmergencyDeclarationsEndError = Fetcher.ErrorWrapper<undefined>;

export type BubbleEmergencyDeclarationsEndVariables = {
  body?: Schemas.EndEmergencyDeclarationRequestDto;
  pathParams: BubbleEmergencyDeclarationsEndPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleEmergencyDeclarationsEnd = (
  variables: BubbleEmergencyDeclarationsEndVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.EmergencyDeclarationDto,
    BubbleEmergencyDeclarationsEndError,
    Schemas.EndEmergencyDeclarationRequestDto,
    {},
    {},
    BubbleEmergencyDeclarationsEndPathParams
  >({
    method: "post",
    url: "/api/v1/Bubbles/{bubbleId}/emergency-declarations/{declarationId}/end",
    ...variables,
    signal,
  });

export const useBubbleEmergencyDeclarationsEnd = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.EmergencyDeclarationDto,
      BubbleEmergencyDeclarationsEndError,
      BubbleEmergencyDeclarationsEndVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.EmergencyDeclarationDto,
    BubbleEmergencyDeclarationsEndError,
    BubbleEmergencyDeclarationsEndVariables
  >({
    mutationFn: (variables: BubbleEmergencyDeclarationsEndVariables) =>
      fetchBubbleEmergencyDeclarationsEnd(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleEmergencyDispatchDispatchPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleEmergencyDispatchDispatchError = Fetcher.ErrorWrapper<undefined>;

export type BubbleEmergencyDispatchDispatchVariables = {
  body?: Schemas.EmergencyDispatchRequestDto;
  pathParams: BubbleEmergencyDispatchDispatchPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleEmergencyDispatchDispatch = (
  variables: BubbleEmergencyDispatchDispatchVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.EmergencyDispatchResponseDto,
    BubbleEmergencyDispatchDispatchError,
    Schemas.EmergencyDispatchRequestDto,
    {},
    {},
    BubbleEmergencyDispatchDispatchPathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/emergency-dispatch", ...variables, signal });

export const useBubbleEmergencyDispatchDispatch = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.EmergencyDispatchResponseDto,
      BubbleEmergencyDispatchDispatchError,
      BubbleEmergencyDispatchDispatchVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.EmergencyDispatchResponseDto,
    BubbleEmergencyDispatchDispatchError,
    BubbleEmergencyDispatchDispatchVariables
  >({
    mutationFn: (variables: BubbleEmergencyDispatchDispatchVariables) =>
      fetchBubbleEmergencyDispatchDispatch(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleEmergencyMapLocationsListPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleEmergencyMapLocationsListError = Fetcher.ErrorWrapper<undefined>;

export type BubbleEmergencyMapLocationsListResponse = Schemas.BubbleMapLocationDto[];

export type BubbleEmergencyMapLocationsListVariables = {
  pathParams: BubbleEmergencyMapLocationsListPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleEmergencyMapLocationsList = (
  variables: BubbleEmergencyMapLocationsListVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    BubbleEmergencyMapLocationsListResponse,
    BubbleEmergencyMapLocationsListError,
    undefined,
    {},
    {},
    BubbleEmergencyMapLocationsListPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/emergency-map-locations", ...variables, signal });

export function bubbleEmergencyMapLocationsListQuery(variables: BubbleEmergencyMapLocationsListVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleEmergencyMapLocationsListResponse>;
};

export function bubbleEmergencyMapLocationsListQuery(
  variables: BubbleEmergencyMapLocationsListVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleEmergencyMapLocationsListResponse>) | reactQuery.SkipToken;
};

export function bubbleEmergencyMapLocationsListQuery(
  variables: BubbleEmergencyMapLocationsListVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleEmergencyMapLocationsList(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleEmergencyMapLocationsList",
      path: "/api/v1/Bubbles/{bubbleId}/emergency-map-locations",
      variables,
    }),
  };
}

export const useSuspenseBubbleEmergencyMapLocationsList = <TData = BubbleEmergencyMapLocationsListResponse>(
  variables: BubbleEmergencyMapLocationsListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleEmergencyMapLocationsListResponse, BubbleEmergencyMapLocationsListError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    BubbleEmergencyMapLocationsListResponse,
    BubbleEmergencyMapLocationsListError,
    TData
  >({
    ...bubbleEmergencyMapLocationsListQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleEmergencyMapLocationsList = <TData = BubbleEmergencyMapLocationsListResponse>(
  variables: BubbleEmergencyMapLocationsListVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleEmergencyMapLocationsListResponse, BubbleEmergencyMapLocationsListError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<BubbleEmergencyMapLocationsListResponse, BubbleEmergencyMapLocationsListError, TData>({
    ...bubbleEmergencyMapLocationsListQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleEmergencyMapLocationsCreatePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleEmergencyMapLocationsCreateError = Fetcher.ErrorWrapper<undefined>;

export type BubbleEmergencyMapLocationsCreateVariables = {
  body?: Schemas.CreateBubbleMapLocationRequestDto;
  pathParams: BubbleEmergencyMapLocationsCreatePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleEmergencyMapLocationsCreate = (
  variables: BubbleEmergencyMapLocationsCreateVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.BubbleMapLocationDto,
    BubbleEmergencyMapLocationsCreateError,
    Schemas.CreateBubbleMapLocationRequestDto,
    {},
    {},
    BubbleEmergencyMapLocationsCreatePathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/emergency-map-locations", ...variables, signal });

export const useBubbleEmergencyMapLocationsCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BubbleMapLocationDto,
      BubbleEmergencyMapLocationsCreateError,
      BubbleEmergencyMapLocationsCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.BubbleMapLocationDto,
    BubbleEmergencyMapLocationsCreateError,
    BubbleEmergencyMapLocationsCreateVariables
  >({
    mutationFn: (variables: BubbleEmergencyMapLocationsCreateVariables) =>
      fetchBubbleEmergencyMapLocationsCreate(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleEmergencyMapLocationsUpdatePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  locationId: string;
}

export type BubbleEmergencyMapLocationsUpdateError = Fetcher.ErrorWrapper<undefined>;

export type BubbleEmergencyMapLocationsUpdateVariables = {
  body?: Schemas.UpdateBubbleMapLocationRequestDto;
  pathParams: BubbleEmergencyMapLocationsUpdatePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleEmergencyMapLocationsUpdate = (
  variables: BubbleEmergencyMapLocationsUpdateVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.BubbleMapLocationDto,
    BubbleEmergencyMapLocationsUpdateError,
    Schemas.UpdateBubbleMapLocationRequestDto,
    {},
    {},
    BubbleEmergencyMapLocationsUpdatePathParams
  >({ method: "patch", url: "/api/v1/Bubbles/{bubbleId}/emergency-map-locations/{locationId}", ...variables, signal });

export const useBubbleEmergencyMapLocationsUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BubbleMapLocationDto,
      BubbleEmergencyMapLocationsUpdateError,
      BubbleEmergencyMapLocationsUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.BubbleMapLocationDto,
    BubbleEmergencyMapLocationsUpdateError,
    BubbleEmergencyMapLocationsUpdateVariables
  >({
    mutationFn: (variables: BubbleEmergencyMapLocationsUpdateVariables) =>
      fetchBubbleEmergencyMapLocationsUpdate(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleEmergencyMapLocationsDeletePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  locationId: string;
}

export type BubbleEmergencyMapLocationsDeleteError = Fetcher.ErrorWrapper<undefined>;

export type BubbleEmergencyMapLocationsDeleteVariables = {
  pathParams: BubbleEmergencyMapLocationsDeletePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleEmergencyMapLocationsDelete = (
  variables: BubbleEmergencyMapLocationsDeleteVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    BubbleEmergencyMapLocationsDeleteError,
    undefined,
    {},
    {},
    BubbleEmergencyMapLocationsDeletePathParams
  >({ method: "delete", url: "/api/v1/Bubbles/{bubbleId}/emergency-map-locations/{locationId}", ...variables, signal });

export const useBubbleEmergencyMapLocationsDelete = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      BubbleEmergencyMapLocationsDeleteError,
      BubbleEmergencyMapLocationsDeleteVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    BubbleEmergencyMapLocationsDeleteError,
    BubbleEmergencyMapLocationsDeleteVariables
  >({
    mutationFn: (variables: BubbleEmergencyMapLocationsDeleteVariables) =>
      fetchBubbleEmergencyMapLocationsDelete(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleEmergencyPlanVisibilityGetPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleEmergencyPlanVisibilityGetError = Fetcher.ErrorWrapper<undefined>;

export type BubbleEmergencyPlanVisibilityGetVariables = {
  pathParams: BubbleEmergencyPlanVisibilityGetPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleEmergencyPlanVisibilityGet = (
  variables: BubbleEmergencyPlanVisibilityGetVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.EmergencyPlanVisibilityDto,
    BubbleEmergencyPlanVisibilityGetError,
    undefined,
    {},
    {},
    BubbleEmergencyPlanVisibilityGetPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/emergency-plan-visibility", ...variables, signal });

export function bubbleEmergencyPlanVisibilityGetQuery(variables: BubbleEmergencyPlanVisibilityGetVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.EmergencyPlanVisibilityDto>;
};

export function bubbleEmergencyPlanVisibilityGetQuery(
  variables: BubbleEmergencyPlanVisibilityGetVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.EmergencyPlanVisibilityDto>) | reactQuery.SkipToken;
};

export function bubbleEmergencyPlanVisibilityGetQuery(
  variables: BubbleEmergencyPlanVisibilityGetVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleEmergencyPlanVisibilityGet(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleEmergencyPlanVisibilityGet",
      path: "/api/v1/Bubbles/{bubbleId}/emergency-plan-visibility",
      variables,
    }),
  };
}

export const useSuspenseBubbleEmergencyPlanVisibilityGet = <TData = Schemas.EmergencyPlanVisibilityDto>(
  variables: BubbleEmergencyPlanVisibilityGetVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.EmergencyPlanVisibilityDto, BubbleEmergencyPlanVisibilityGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.EmergencyPlanVisibilityDto, BubbleEmergencyPlanVisibilityGetError, TData>({
    ...bubbleEmergencyPlanVisibilityGetQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleEmergencyPlanVisibilityGet = <TData = Schemas.EmergencyPlanVisibilityDto>(
  variables: BubbleEmergencyPlanVisibilityGetVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.EmergencyPlanVisibilityDto, BubbleEmergencyPlanVisibilityGetError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.EmergencyPlanVisibilityDto, BubbleEmergencyPlanVisibilityGetError, TData>({
    ...bubbleEmergencyPlanVisibilityGetQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleEmergencyPlanVisibilityPutPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleEmergencyPlanVisibilityPutError = Fetcher.ErrorWrapper<undefined>;

export type BubbleEmergencyPlanVisibilityPutVariables = {
  body?: Schemas.EmergencyPlanVisibilityDto;
  pathParams: BubbleEmergencyPlanVisibilityPutPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleEmergencyPlanVisibilityPut = (
  variables: BubbleEmergencyPlanVisibilityPutVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    BubbleEmergencyPlanVisibilityPutError,
    Schemas.EmergencyPlanVisibilityDto,
    {},
    {},
    BubbleEmergencyPlanVisibilityPutPathParams
  >({ method: "put", url: "/api/v1/Bubbles/{bubbleId}/emergency-plan-visibility", ...variables, signal });

export const useBubbleEmergencyPlanVisibilityPut = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      BubbleEmergencyPlanVisibilityPutError,
      BubbleEmergencyPlanVisibilityPutVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    BubbleEmergencyPlanVisibilityPutError,
    BubbleEmergencyPlanVisibilityPutVariables
  >({
    mutationFn: (variables: BubbleEmergencyPlanVisibilityPutVariables) =>
      fetchBubbleEmergencyPlanVisibilityPut(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleGroupsListGroupsPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleGroupsListGroupsError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGroupsListGroupsResponse = Schemas.BubbleGroupDto[];

export type BubbleGroupsListGroupsVariables = {
  pathParams: BubbleGroupsListGroupsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGroupsListGroups = (variables: BubbleGroupsListGroupsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    BubbleGroupsListGroupsResponse,
    BubbleGroupsListGroupsError,
    undefined,
    {},
    {},
    BubbleGroupsListGroupsPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/groups", ...variables, signal });

export function bubbleGroupsListGroupsQuery(variables: BubbleGroupsListGroupsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleGroupsListGroupsResponse>;
};

export function bubbleGroupsListGroupsQuery(variables: BubbleGroupsListGroupsVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleGroupsListGroupsResponse>) | reactQuery.SkipToken;
};

export function bubbleGroupsListGroupsQuery(variables: BubbleGroupsListGroupsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGroupsListGroups(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGroupsListGroups",
      path: "/api/v1/Bubbles/{bubbleId}/groups",
      variables,
    }),
  };
}

export const useSuspenseBubbleGroupsListGroups = <TData = BubbleGroupsListGroupsResponse>(
  variables: BubbleGroupsListGroupsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGroupsListGroupsResponse, BubbleGroupsListGroupsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<BubbleGroupsListGroupsResponse, BubbleGroupsListGroupsError, TData>({
    ...bubbleGroupsListGroupsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGroupsListGroups = <TData = BubbleGroupsListGroupsResponse>(
  variables: BubbleGroupsListGroupsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGroupsListGroupsResponse, BubbleGroupsListGroupsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<BubbleGroupsListGroupsResponse, BubbleGroupsListGroupsError, TData>({
    ...bubbleGroupsListGroupsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleGroupsCreateGroupPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleGroupsCreateGroupError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGroupsCreateGroupVariables = {
  body: Schemas.CreateBubbleGroupRequest;
  pathParams: BubbleGroupsCreateGroupPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGroupsCreateGroup = (variables: BubbleGroupsCreateGroupVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.BubbleGroupDto,
    BubbleGroupsCreateGroupError,
    Schemas.CreateBubbleGroupRequest,
    {},
    {},
    BubbleGroupsCreateGroupPathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/groups", ...variables, signal });

export const useBubbleGroupsCreateGroup = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BubbleGroupDto,
      BubbleGroupsCreateGroupError,
      BubbleGroupsCreateGroupVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<Schemas.BubbleGroupDto, BubbleGroupsCreateGroupError, BubbleGroupsCreateGroupVariables>(
    {
      mutationFn: (variables: BubbleGroupsCreateGroupVariables) =>
        fetchBubbleGroupsCreateGroup(deepMerge(fetcherOptions, variables)),
      ...options,
    },
  );
};

export interface BubbleGroupsGetGroupPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  groupId: string;
}

export type BubbleGroupsGetGroupError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGroupsGetGroupVariables = {
  pathParams: BubbleGroupsGetGroupPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGroupsGetGroup = (variables: BubbleGroupsGetGroupVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.BubbleGroupDetailDto,
    BubbleGroupsGetGroupError,
    undefined,
    {},
    {},
    BubbleGroupsGetGroupPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/groups/{groupId}", ...variables, signal });

export function bubbleGroupsGetGroupQuery(variables: BubbleGroupsGetGroupVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.BubbleGroupDetailDto>;
};

export function bubbleGroupsGetGroupQuery(variables: BubbleGroupsGetGroupVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.BubbleGroupDetailDto>) | reactQuery.SkipToken;
};

export function bubbleGroupsGetGroupQuery(variables: BubbleGroupsGetGroupVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGroupsGetGroup(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGroupsGetGroup",
      path: "/api/v1/Bubbles/{bubbleId}/groups/{groupId}",
      variables,
    }),
  };
}

export const useSuspenseBubbleGroupsGetGroup = <TData = Schemas.BubbleGroupDetailDto>(
  variables: BubbleGroupsGetGroupVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.BubbleGroupDetailDto, BubbleGroupsGetGroupError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.BubbleGroupDetailDto, BubbleGroupsGetGroupError, TData>({
    ...bubbleGroupsGetGroupQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGroupsGetGroup = <TData = Schemas.BubbleGroupDetailDto>(
  variables: BubbleGroupsGetGroupVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.BubbleGroupDetailDto, BubbleGroupsGetGroupError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.BubbleGroupDetailDto, BubbleGroupsGetGroupError, TData>({
    ...bubbleGroupsGetGroupQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleGroupsUpdateGroupPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  groupId: string;
}

export type BubbleGroupsUpdateGroupError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGroupsUpdateGroupVariables = {
  body: Schemas.UpdateBubbleGroupRequest;
  pathParams: BubbleGroupsUpdateGroupPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGroupsUpdateGroup = (variables: BubbleGroupsUpdateGroupVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.BubbleGroupDto,
    BubbleGroupsUpdateGroupError,
    Schemas.UpdateBubbleGroupRequest,
    {},
    {},
    BubbleGroupsUpdateGroupPathParams
  >({ method: "put", url: "/api/v1/Bubbles/{bubbleId}/groups/{groupId}", ...variables, signal });

export const useBubbleGroupsUpdateGroup = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.BubbleGroupDto,
      BubbleGroupsUpdateGroupError,
      BubbleGroupsUpdateGroupVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<Schemas.BubbleGroupDto, BubbleGroupsUpdateGroupError, BubbleGroupsUpdateGroupVariables>(
    {
      mutationFn: (variables: BubbleGroupsUpdateGroupVariables) =>
        fetchBubbleGroupsUpdateGroup(deepMerge(fetcherOptions, variables)),
      ...options,
    },
  );
};

export interface BubbleGroupsDeleteGroupPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  groupId: string;
}

export type BubbleGroupsDeleteGroupError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGroupsDeleteGroupVariables = {
  pathParams: BubbleGroupsDeleteGroupPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGroupsDeleteGroup = (variables: BubbleGroupsDeleteGroupVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, BubbleGroupsDeleteGroupError, undefined, {}, {}, BubbleGroupsDeleteGroupPathParams>({
    method: "delete",
    url: "/api/v1/Bubbles/{bubbleId}/groups/{groupId}",
    ...variables,
    signal,
  });

export const useBubbleGroupsDeleteGroup = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, BubbleGroupsDeleteGroupError, BubbleGroupsDeleteGroupVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, BubbleGroupsDeleteGroupError, BubbleGroupsDeleteGroupVariables>({
    mutationFn: (variables: BubbleGroupsDeleteGroupVariables) =>
      fetchBubbleGroupsDeleteGroup(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleGroupsListMembersPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  groupId: string;
}

export type BubbleGroupsListMembersError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGroupsListMembersResponse = string[];

export type BubbleGroupsListMembersVariables = {
  pathParams: BubbleGroupsListMembersPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGroupsListMembers = (variables: BubbleGroupsListMembersVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    BubbleGroupsListMembersResponse,
    BubbleGroupsListMembersError,
    undefined,
    {},
    {},
    BubbleGroupsListMembersPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/groups/{groupId}/members", ...variables, signal });

export function bubbleGroupsListMembersQuery(variables: BubbleGroupsListMembersVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleGroupsListMembersResponse>;
};

export function bubbleGroupsListMembersQuery(variables: BubbleGroupsListMembersVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleGroupsListMembersResponse>) | reactQuery.SkipToken;
};

export function bubbleGroupsListMembersQuery(variables: BubbleGroupsListMembersVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleGroupsListMembers(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleGroupsListMembers",
      path: "/api/v1/Bubbles/{bubbleId}/groups/{groupId}/members",
      variables,
    }),
  };
}

export const useSuspenseBubbleGroupsListMembers = <TData = BubbleGroupsListMembersResponse>(
  variables: BubbleGroupsListMembersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGroupsListMembersResponse, BubbleGroupsListMembersError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<BubbleGroupsListMembersResponse, BubbleGroupsListMembersError, TData>({
    ...bubbleGroupsListMembersQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleGroupsListMembers = <TData = BubbleGroupsListMembersResponse>(
  variables: BubbleGroupsListMembersVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleGroupsListMembersResponse, BubbleGroupsListMembersError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<BubbleGroupsListMembersResponse, BubbleGroupsListMembersError, TData>({
    ...bubbleGroupsListMembersQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleGroupsAddMemberPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  groupId: string;
}

export type BubbleGroupsAddMemberError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGroupsAddMemberVariables = {
  body: Schemas.AddBubbleGroupMemberRequest;
  pathParams: BubbleGroupsAddMemberPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGroupsAddMember = (variables: BubbleGroupsAddMemberVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    BubbleGroupsAddMemberError,
    Schemas.AddBubbleGroupMemberRequest,
    {},
    {},
    BubbleGroupsAddMemberPathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/groups/{groupId}/members", ...variables, signal });

export const useBubbleGroupsAddMember = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, BubbleGroupsAddMemberError, BubbleGroupsAddMemberVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, BubbleGroupsAddMemberError, BubbleGroupsAddMemberVariables>({
    mutationFn: (variables: BubbleGroupsAddMemberVariables) =>
      fetchBubbleGroupsAddMember(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleGroupsRemoveMemberPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  groupId: string;
  /**
   * @format uuid
   */
  userId: string;
}

export type BubbleGroupsRemoveMemberError = Fetcher.ErrorWrapper<undefined>;

export type BubbleGroupsRemoveMemberVariables = {
  pathParams: BubbleGroupsRemoveMemberPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleGroupsRemoveMember = (variables: BubbleGroupsRemoveMemberVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    BubbleGroupsRemoveMemberError,
    undefined,
    {},
    {},
    BubbleGroupsRemoveMemberPathParams
  >({ method: "delete", url: "/api/v1/Bubbles/{bubbleId}/groups/{groupId}/members/{userId}", ...variables, signal });

export const useBubbleGroupsRemoveMember = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, BubbleGroupsRemoveMemberError, BubbleGroupsRemoveMemberVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, BubbleGroupsRemoveMemberError, BubbleGroupsRemoveMemberVariables>({
    mutationFn: (variables: BubbleGroupsRemoveMemberVariables) =>
      fetchBubbleGroupsRemoveMember(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleLawEnforcementUsersListPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleLawEnforcementUsersListError = Fetcher.ErrorWrapper<undefined>;

export type BubbleLawEnforcementUsersListResponse = Schemas.LawEnforcementUserDto[];

export type BubbleLawEnforcementUsersListVariables = {
  pathParams: BubbleLawEnforcementUsersListPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleLawEnforcementUsersList = (
  variables: BubbleLawEnforcementUsersListVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    BubbleLawEnforcementUsersListResponse,
    BubbleLawEnforcementUsersListError,
    undefined,
    {},
    {},
    BubbleLawEnforcementUsersListPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/law-enforcement-users", ...variables, signal });

export function bubbleLawEnforcementUsersListQuery(variables: BubbleLawEnforcementUsersListVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<BubbleLawEnforcementUsersListResponse>;
};

export function bubbleLawEnforcementUsersListQuery(
  variables: BubbleLawEnforcementUsersListVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<BubbleLawEnforcementUsersListResponse>) | reactQuery.SkipToken;
};

export function bubbleLawEnforcementUsersListQuery(
  variables: BubbleLawEnforcementUsersListVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchBubbleLawEnforcementUsersList(variables, signal),
    queryKey: queryKeyFn({
      operationId: "bubbleLawEnforcementUsersList",
      path: "/api/v1/Bubbles/{bubbleId}/law-enforcement-users",
      variables,
    }),
  };
}

export const useSuspenseBubbleLawEnforcementUsersList = <TData = BubbleLawEnforcementUsersListResponse>(
  variables: BubbleLawEnforcementUsersListVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleLawEnforcementUsersListResponse, BubbleLawEnforcementUsersListError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<BubbleLawEnforcementUsersListResponse, BubbleLawEnforcementUsersListError, TData>({
    ...bubbleLawEnforcementUsersListQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useBubbleLawEnforcementUsersList = <TData = BubbleLawEnforcementUsersListResponse>(
  variables: BubbleLawEnforcementUsersListVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<BubbleLawEnforcementUsersListResponse, BubbleLawEnforcementUsersListError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<BubbleLawEnforcementUsersListResponse, BubbleLawEnforcementUsersListError, TData>({
    ...bubbleLawEnforcementUsersListQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface BubbleLawEnforcementUsersCreatePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type BubbleLawEnforcementUsersCreateError = Fetcher.ErrorWrapper<undefined>;

export type BubbleLawEnforcementUsersCreateVariables = {
  body?: Schemas.LawEnforcementUserDto;
  pathParams: BubbleLawEnforcementUsersCreatePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleLawEnforcementUsersCreate = (
  variables: BubbleLawEnforcementUsersCreateVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.LawEnforcementUserDto,
    BubbleLawEnforcementUsersCreateError,
    Schemas.LawEnforcementUserDto,
    {},
    {},
    BubbleLawEnforcementUsersCreatePathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/law-enforcement-users", ...variables, signal });

export const useBubbleLawEnforcementUsersCreate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LawEnforcementUserDto,
      BubbleLawEnforcementUsersCreateError,
      BubbleLawEnforcementUsersCreateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.LawEnforcementUserDto,
    BubbleLawEnforcementUsersCreateError,
    BubbleLawEnforcementUsersCreateVariables
  >({
    mutationFn: (variables: BubbleLawEnforcementUsersCreateVariables) =>
      fetchBubbleLawEnforcementUsersCreate(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleLawEnforcementUsersUpdatePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type BubbleLawEnforcementUsersUpdateError = Fetcher.ErrorWrapper<undefined>;

export type BubbleLawEnforcementUsersUpdateVariables = {
  body?: Schemas.LawEnforcementUserDto;
  pathParams: BubbleLawEnforcementUsersUpdatePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleLawEnforcementUsersUpdate = (
  variables: BubbleLawEnforcementUsersUpdateVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.LawEnforcementUserDto,
    BubbleLawEnforcementUsersUpdateError,
    Schemas.LawEnforcementUserDto,
    {},
    {},
    BubbleLawEnforcementUsersUpdatePathParams
  >({ method: "put", url: "/api/v1/Bubbles/{bubbleId}/law-enforcement-users/{id}", ...variables, signal });

export const useBubbleLawEnforcementUsersUpdate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.LawEnforcementUserDto,
      BubbleLawEnforcementUsersUpdateError,
      BubbleLawEnforcementUsersUpdateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.LawEnforcementUserDto,
    BubbleLawEnforcementUsersUpdateError,
    BubbleLawEnforcementUsersUpdateVariables
  >({
    mutationFn: (variables: BubbleLawEnforcementUsersUpdateVariables) =>
      fetchBubbleLawEnforcementUsersUpdate(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface BubbleLawEnforcementUsersDeletePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type BubbleLawEnforcementUsersDeleteError = Fetcher.ErrorWrapper<undefined>;

export type BubbleLawEnforcementUsersDeleteVariables = {
  pathParams: BubbleLawEnforcementUsersDeletePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchBubbleLawEnforcementUsersDelete = (
  variables: BubbleLawEnforcementUsersDeleteVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    BubbleLawEnforcementUsersDeleteError,
    undefined,
    {},
    {},
    BubbleLawEnforcementUsersDeletePathParams
  >({ method: "delete", url: "/api/v1/Bubbles/{bubbleId}/law-enforcement-users/{id}", ...variables, signal });

export const useBubbleLawEnforcementUsersDelete = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      BubbleLawEnforcementUsersDeleteError,
      BubbleLawEnforcementUsersDeleteVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    BubbleLawEnforcementUsersDeleteError,
    BubbleLawEnforcementUsersDeleteVariables
  >({
    mutationFn: (variables: BubbleLawEnforcementUsersDeleteVariables) =>
      fetchBubbleLawEnforcementUsersDelete(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type CalendarCreateLinkError = Fetcher.ErrorWrapper<undefined>;

export type CalendarCreateLinkVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchCalendarCreateLink = (variables: CalendarCreateLinkVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<Schemas.CalendarLinkDto, CalendarCreateLinkError, undefined, {}, {}, {}>({
    method: "post",
    url: "/api/v1/Calendar/links",
    ...variables,
    signal,
  });

export const useCalendarCreateLink = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.CalendarLinkDto, CalendarCreateLinkError, CalendarCreateLinkVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<Schemas.CalendarLinkDto, CalendarCreateLinkError, CalendarCreateLinkVariables>({
    mutationFn: (variables: CalendarCreateLinkVariables) =>
      fetchCalendarCreateLink(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type CalendarLinksError = Fetcher.ErrorWrapper<undefined>;

export type CalendarLinksResponse = Schemas.CalendarLinkDto[];

export type CalendarLinksVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchCalendarLinks = (variables: CalendarLinksVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<CalendarLinksResponse, CalendarLinksError, undefined, {}, {}, {}>({
    method: "get",
    url: "/api/v1/Calendar/links",
    ...variables,
    signal,
  });

export function calendarLinksQuery(variables: CalendarLinksVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<CalendarLinksResponse>;
};

export function calendarLinksQuery(variables: CalendarLinksVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<CalendarLinksResponse>) | reactQuery.SkipToken;
};

export function calendarLinksQuery(variables: CalendarLinksVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchCalendarLinks(variables, signal),
    queryKey: queryKeyFn({
      operationId: "calendarLinks",
      path: "/api/v1/Calendar/links",
      variables,
    }),
  };
}

export const useSuspenseCalendarLinks = <TData = CalendarLinksResponse>(
  variables: CalendarLinksVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<CalendarLinksResponse, CalendarLinksError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<CalendarLinksResponse, CalendarLinksError, TData>({
    ...calendarLinksQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useCalendarLinks = <TData = CalendarLinksResponse>(
  variables: CalendarLinksVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<CalendarLinksResponse, CalendarLinksError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<CalendarLinksResponse, CalendarLinksError, TData>({
    ...calendarLinksQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface CalendarDeleteLinkPathParams {
  /**
   * @format uuid
   */
  id: string;
}

export type CalendarDeleteLinkError = Fetcher.ErrorWrapper<undefined>;

export type CalendarDeleteLinkVariables = {
  pathParams: CalendarDeleteLinkPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchCalendarDeleteLink = (variables: CalendarDeleteLinkVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, CalendarDeleteLinkError, undefined, {}, {}, CalendarDeleteLinkPathParams>({
    method: "delete",
    url: "/api/v1/Calendar/links/{id}",
    ...variables,
    signal,
  });

export const useCalendarDeleteLink = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, CalendarDeleteLinkError, CalendarDeleteLinkVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, CalendarDeleteLinkError, CalendarDeleteLinkVariables>({
    mutationFn: (variables: CalendarDeleteLinkVariables) =>
      fetchCalendarDeleteLink(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface DayOfEmergencyAnonymousAccessValidateUserPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export type DayOfEmergencyAnonymousAccessValidateUserError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessValidateUserVariables = {
  body?: Schemas.ValidateUserEmergencyAccessRequestDto;
  pathParams: DayOfEmergencyAnonymousAccessValidateUserPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessValidateUser = (
  variables: DayOfEmergencyAnonymousAccessValidateUserVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.EmergencyAccessValidationResponseDto,
    DayOfEmergencyAnonymousAccessValidateUserError,
    Schemas.ValidateUserEmergencyAccessRequestDto,
    {},
    {},
    DayOfEmergencyAnonymousAccessValidateUserPathParams
  >({ method: "post", url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/access/validate-user", ...variables, signal });

export const useDayOfEmergencyAnonymousAccessValidateUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.EmergencyAccessValidationResponseDto,
      DayOfEmergencyAnonymousAccessValidateUserError,
      DayOfEmergencyAnonymousAccessValidateUserVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.EmergencyAccessValidationResponseDto,
    DayOfEmergencyAnonymousAccessValidateUserError,
    DayOfEmergencyAnonymousAccessValidateUserVariables
  >({
    mutationFn: (variables: DayOfEmergencyAnonymousAccessValidateUserVariables) =>
      fetchDayOfEmergencyAnonymousAccessValidateUser(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface DayOfEmergencyAnonymousAccessValidateLawEnforcementPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export type DayOfEmergencyAnonymousAccessValidateLawEnforcementError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessValidateLawEnforcementVariables = {
  body?: Schemas.ValidateLawEnforcementEmergencyAccessRequestDto;
  pathParams: DayOfEmergencyAnonymousAccessValidateLawEnforcementPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessValidateLawEnforcement = (
  variables: DayOfEmergencyAnonymousAccessValidateLawEnforcementVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.EmergencyAccessValidationResponseDto,
    DayOfEmergencyAnonymousAccessValidateLawEnforcementError,
    Schemas.ValidateLawEnforcementEmergencyAccessRequestDto,
    {},
    {},
    DayOfEmergencyAnonymousAccessValidateLawEnforcementPathParams
  >({
    method: "post",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/access/validate-law-enforcement",
    ...variables,
    signal,
  });

export const useDayOfEmergencyAnonymousAccessValidateLawEnforcement = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.EmergencyAccessValidationResponseDto,
      DayOfEmergencyAnonymousAccessValidateLawEnforcementError,
      DayOfEmergencyAnonymousAccessValidateLawEnforcementVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.EmergencyAccessValidationResponseDto,
    DayOfEmergencyAnonymousAccessValidateLawEnforcementError,
    DayOfEmergencyAnonymousAccessValidateLawEnforcementVariables
  >({
    mutationFn: (variables: DayOfEmergencyAnonymousAccessValidateLawEnforcementVariables) =>
      fetchDayOfEmergencyAnonymousAccessValidateLawEnforcement(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface DayOfEmergencyAnonymousAccessValidateRecipientPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export type DayOfEmergencyAnonymousAccessValidateRecipientError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessValidateRecipientVariables = {
  body?: Schemas.ValidateRecipientEmergencyAccessRequestDto;
  pathParams: DayOfEmergencyAnonymousAccessValidateRecipientPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessValidateRecipient = (
  variables: DayOfEmergencyAnonymousAccessValidateRecipientVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.RecipientEmergencyAccessValidationResponseDto,
    DayOfEmergencyAnonymousAccessValidateRecipientError,
    Schemas.ValidateRecipientEmergencyAccessRequestDto,
    {},
    {},
    DayOfEmergencyAnonymousAccessValidateRecipientPathParams
  >({
    method: "post",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/access/validate-recipient",
    ...variables,
    signal,
  });

export const useDayOfEmergencyAnonymousAccessValidateRecipient = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RecipientEmergencyAccessValidationResponseDto,
      DayOfEmergencyAnonymousAccessValidateRecipientError,
      DayOfEmergencyAnonymousAccessValidateRecipientVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.RecipientEmergencyAccessValidationResponseDto,
    DayOfEmergencyAnonymousAccessValidateRecipientError,
    DayOfEmergencyAnonymousAccessValidateRecipientVariables
  >({
    mutationFn: (variables: DayOfEmergencyAnonymousAccessValidateRecipientVariables) =>
      fetchDayOfEmergencyAnonymousAccessValidateRecipient(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface DayOfEmergencyAnonymousAccessGetDayForLawEnforcementPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessGetDayForLawEnforcementHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessGetDayForLawEnforcementError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessGetDayForLawEnforcementVariables = {
  headers?: DayOfEmergencyAnonymousAccessGetDayForLawEnforcementHeaders;
  pathParams: DayOfEmergencyAnonymousAccessGetDayForLawEnforcementPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessGetDayForLawEnforcement = (
  variables: DayOfEmergencyAnonymousAccessGetDayForLawEnforcementVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.DayOfEmergencyDto,
    DayOfEmergencyAnonymousAccessGetDayForLawEnforcementError,
    undefined,
    DayOfEmergencyAnonymousAccessGetDayForLawEnforcementHeaders,
    {},
    DayOfEmergencyAnonymousAccessGetDayForLawEnforcementPathParams
  >({ method: "get", url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/day", ...variables, signal });

export function dayOfEmergencyAnonymousAccessGetDayForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessGetDayForLawEnforcementVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.DayOfEmergencyDto>;
};

export function dayOfEmergencyAnonymousAccessGetDayForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessGetDayForLawEnforcementVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.DayOfEmergencyDto>) | reactQuery.SkipToken;
};

export function dayOfEmergencyAnonymousAccessGetDayForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessGetDayForLawEnforcementVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchDayOfEmergencyAnonymousAccessGetDayForLawEnforcement(variables, signal),
    queryKey: queryKeyFn({
      operationId: "dayOfEmergencyAnonymousAccessGetDayForLawEnforcement",
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/day",
      variables,
    }),
  };
}

export const useSuspenseDayOfEmergencyAnonymousAccessGetDayForLawEnforcement = <TData = Schemas.DayOfEmergencyDto>(
  variables: DayOfEmergencyAnonymousAccessGetDayForLawEnforcementVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DayOfEmergencyDto,
      DayOfEmergencyAnonymousAccessGetDayForLawEnforcementError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.DayOfEmergencyDto,
    DayOfEmergencyAnonymousAccessGetDayForLawEnforcementError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessGetDayForLawEnforcementQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDayOfEmergencyAnonymousAccessGetDayForLawEnforcement = <TData = Schemas.DayOfEmergencyDto>(
  variables: DayOfEmergencyAnonymousAccessGetDayForLawEnforcementVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DayOfEmergencyDto,
      DayOfEmergencyAnonymousAccessGetDayForLawEnforcementError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    Schemas.DayOfEmergencyDto,
    DayOfEmergencyAnonymousAccessGetDayForLawEnforcementError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessGetDayForLawEnforcementQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementResponse =
  Schemas.DayOfEmergencyParticipantDto[];

export type DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementVariables = {
  headers?: DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementHeaders;
  pathParams: DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessListParticipantsForLawEnforcement = (
  variables: DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementResponse,
    DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementError,
    undefined,
    DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementHeaders,
    {},
    DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementPathParams
  >({
    method: "get",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/participants",
    ...variables,
    signal,
  });

export function dayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementResponse>;
};

export function dayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementResponse>)
    | reactQuery.SkipToken;
};

export function dayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDayOfEmergencyAnonymousAccessListParticipantsForLawEnforcement(variables, signal),
    queryKey: queryKeyFn({
      operationId: "dayOfEmergencyAnonymousAccessListParticipantsForLawEnforcement",
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/participants",
      variables,
    }),
  };
}

export const useSuspenseDayOfEmergencyAnonymousAccessListParticipantsForLawEnforcement = <
  TData = DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementResponse,
      DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementResponse,
    DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDayOfEmergencyAnonymousAccessListParticipantsForLawEnforcement = <
  TData = DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementResponse,
      DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementResponse,
    DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementResponse =
  Schemas.DayOfEmergencyTimelineEntryDto[];

export type DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementVariables = {
  headers?: DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementHeaders;
  pathParams: DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessListTimelineForLawEnforcement = (
  variables: DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementResponse,
    DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementError,
    undefined,
    DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementHeaders,
    {},
    DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementPathParams
  >({
    method: "get",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/timeline",
    ...variables,
    signal,
  });

export function dayOfEmergencyAnonymousAccessListTimelineForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementResponse>;
};

export function dayOfEmergencyAnonymousAccessListTimelineForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementResponse>)
    | reactQuery.SkipToken;
};

export function dayOfEmergencyAnonymousAccessListTimelineForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDayOfEmergencyAnonymousAccessListTimelineForLawEnforcement(variables, signal),
    queryKey: queryKeyFn({
      operationId: "dayOfEmergencyAnonymousAccessListTimelineForLawEnforcement",
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/timeline",
      variables,
    }),
  };
}

export const useSuspenseDayOfEmergencyAnonymousAccessListTimelineForLawEnforcement = <
  TData = DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementResponse,
      DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementResponse,
    DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListTimelineForLawEnforcementQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDayOfEmergencyAnonymousAccessListTimelineForLawEnforcement = <
  TData = DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementResponse,
      DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementResponse,
    DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListTimelineForLawEnforcementQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementError =
  Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementResponse =
  Schemas.EmergencyDeclarationDto[];

export type DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementVariables = {
  headers?: DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementHeaders;
  pathParams: DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcement = (
  variables: DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementResponse,
    DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementError,
    undefined,
    DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementHeaders,
    {},
    DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementPathParams
  >({
    method: "get",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/emergency-declarations/active",
    ...variables,
    signal,
  });

export function dayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementResponse>;
};

export function dayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementQuery(
  variables:
    | DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementVariables
    | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementResponse>)
    | reactQuery.SkipToken;
};

export function dayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementQuery(
  variables:
    | DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementVariables
    | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcement(variables, signal),
    queryKey: queryKeyFn({
      operationId: "dayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcement",
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/emergency-declarations/active",
      variables,
    }),
  };
}

export const useSuspenseDayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcement = <
  TData = DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementResponse,
      DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementResponse,
    DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useDayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcement = <
  TData = DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementResponse,
>(
  variables:
    | DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementVariables
    | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementResponse,
      DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementResponse,
    DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementVariables = {
  headers?: DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementHeaders;
  pathParams: DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcement = (
  variables: DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.LawEnforcementBubbleContextDto,
    DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementError,
    undefined,
    DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementHeaders,
    {},
    DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementPathParams
  >({
    method: "get",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/bubble-context",
    ...variables,
    signal,
  });

export function dayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.LawEnforcementBubbleContextDto>;
};

export function dayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.LawEnforcementBubbleContextDto>) | reactQuery.SkipToken;
};

export function dayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcement(variables, signal),
    queryKey: queryKeyFn({
      operationId: "dayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcement",
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/bubble-context",
      variables,
    }),
  };
}

export const useSuspenseDayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcement = <
  TData = Schemas.LawEnforcementBubbleContextDto,
>(
  variables: DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LawEnforcementBubbleContextDto,
      DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.LawEnforcementBubbleContextDto,
    DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcement = <
  TData = Schemas.LawEnforcementBubbleContextDto,
>(
  variables: DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LawEnforcementBubbleContextDto,
      DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    Schemas.LawEnforcementBubbleContextDto,
    DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementResponse =
  Schemas.LawEnforcementAdminContactDto[];

export type DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementVariables = {
  headers?: DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementHeaders;
  pathParams: DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcement = (
  variables: DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementResponse,
    DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementError,
    undefined,
    DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementHeaders,
    {},
    DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementPathParams
  >({
    method: "get",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/admin-contacts",
    ...variables,
    signal,
  });

export function dayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementResponse>;
};

export function dayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementResponse>)
    | reactQuery.SkipToken;
};

export function dayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcement(variables, signal),
    queryKey: queryKeyFn({
      operationId: "dayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcement",
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/admin-contacts",
      variables,
    }),
  };
}

export const useSuspenseDayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcement = <
  TData = DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementResponse,
      DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementResponse,
    DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcement = <
  TData = DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementResponse,
      DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementResponse,
    DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementResponse = Schemas.BubbleMapLocationDto[];

export type DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementVariables = {
  headers?: DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementHeaders;
  pathParams: DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcement = (
  variables: DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementResponse,
    DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementError,
    undefined,
    DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementHeaders,
    {},
    DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementPathParams
  >({
    method: "get",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/map-locations",
    ...variables,
    signal,
  });

export function dayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementResponse>;
};

export function dayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementResponse>)
    | reactQuery.SkipToken;
};

export function dayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementQuery(
  variables: DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcement(variables, signal),
    queryKey: queryKeyFn({
      operationId: "dayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcement",
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/map-locations",
      variables,
    }),
  };
}

export const useSuspenseDayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcement = <
  TData = DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementResponse,
      DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementResponse,
    DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcement = <
  TData = DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementResponse,
      DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementResponse,
    DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DayOfEmergencyAnonymousAccessPatchParticipantForLawEnforcementPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
  /**
   * @format uuid
   */
  userId: string;
}

export interface DayOfEmergencyAnonymousAccessPatchParticipantForLawEnforcementHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessPatchParticipantForLawEnforcementError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessPatchParticipantForLawEnforcementVariables = {
  body?: Schemas.PatchDayOfEmergencyParticipantRequestDto;
  headers?: DayOfEmergencyAnonymousAccessPatchParticipantForLawEnforcementHeaders;
  pathParams: DayOfEmergencyAnonymousAccessPatchParticipantForLawEnforcementPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessPatchParticipantForLawEnforcement = (
  variables: DayOfEmergencyAnonymousAccessPatchParticipantForLawEnforcementVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.DayOfEmergencyParticipantDto,
    DayOfEmergencyAnonymousAccessPatchParticipantForLawEnforcementError,
    Schemas.PatchDayOfEmergencyParticipantRequestDto,
    DayOfEmergencyAnonymousAccessPatchParticipantForLawEnforcementHeaders,
    {},
    DayOfEmergencyAnonymousAccessPatchParticipantForLawEnforcementPathParams
  >({
    method: "patch",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/participants/{userId}",
    ...variables,
    signal,
  });

export const useDayOfEmergencyAnonymousAccessPatchParticipantForLawEnforcement = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DayOfEmergencyParticipantDto,
      DayOfEmergencyAnonymousAccessPatchParticipantForLawEnforcementError,
      DayOfEmergencyAnonymousAccessPatchParticipantForLawEnforcementVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.DayOfEmergencyParticipantDto,
    DayOfEmergencyAnonymousAccessPatchParticipantForLawEnforcementError,
    DayOfEmergencyAnonymousAccessPatchParticipantForLawEnforcementVariables
  >({
    mutationFn: (variables: DayOfEmergencyAnonymousAccessPatchParticipantForLawEnforcementVariables) =>
      fetchDayOfEmergencyAnonymousAccessPatchParticipantForLawEnforcement(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementResponse =
  Schemas.DayOfEmergencyParticipantDto[];

export type DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementVariables = {
  body?: Schemas.BatchSetParticipantsStatusRequestDto;
  headers?: DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementHeaders;
  pathParams: DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcement = (
  variables: DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementResponse,
    DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementError,
    Schemas.BatchSetParticipantsStatusRequestDto,
    DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementHeaders,
    {},
    DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementPathParams
  >({
    method: "post",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/participants/batch-same-status",
    ...variables,
    signal,
  });

export const useDayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcement = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementResponse,
      DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementError,
      DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementResponse,
    DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementError,
    DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementVariables
  >({
    mutationFn: (variables: DayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcementVariables) =>
      fetchDayOfEmergencyAnonymousAccessBatchSetSameStatusForLawEnforcement(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForLawEnforcementPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForLawEnforcementHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForLawEnforcementError =
  Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForLawEnforcementVariables = {
  body?: Schemas.RequestEmergencySafetyStatusSmsRequestDto;
  headers?: DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForLawEnforcementHeaders;
  pathParams: DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForLawEnforcementPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForLawEnforcement = (
  variables: DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForLawEnforcementVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.RequestEmergencySafetyStatusSmsResponseDto,
    DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForLawEnforcementError,
    Schemas.RequestEmergencySafetyStatusSmsRequestDto,
    DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForLawEnforcementHeaders,
    {},
    DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForLawEnforcementPathParams
  >({
    method: "post",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/request-schoolwide-safety-status-sms",
    ...variables,
    signal,
  });

export const useDayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForLawEnforcement = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RequestEmergencySafetyStatusSmsResponseDto,
      DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForLawEnforcementError,
      DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForLawEnforcementVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.RequestEmergencySafetyStatusSmsResponseDto,
    DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForLawEnforcementError,
    DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForLawEnforcementVariables
  >({
    mutationFn: (variables: DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForLawEnforcementVariables) =>
      fetchDayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForLawEnforcement(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export interface DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForRecipientPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForRecipientHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForRecipientError =
  Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForRecipientVariables = {
  body?: Schemas.RequestEmergencySafetyStatusSmsRequestDto;
  headers?: DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForRecipientHeaders;
  pathParams: DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForRecipientPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForRecipient = (
  variables: DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForRecipientVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.RequestEmergencySafetyStatusSmsResponseDto,
    DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForRecipientError,
    Schemas.RequestEmergencySafetyStatusSmsRequestDto,
    DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForRecipientHeaders,
    {},
    DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForRecipientPathParams
  >({
    method: "post",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/request-schoolwide-safety-status-sms",
    ...variables,
    signal,
  });

export const useDayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForRecipient = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.RequestEmergencySafetyStatusSmsResponseDto,
      DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForRecipientError,
      DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForRecipientVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.RequestEmergencySafetyStatusSmsResponseDto,
    DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForRecipientError,
    DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForRecipientVariables
  >({
    mutationFn: (variables: DayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForRecipientVariables) =>
      fetchDayOfEmergencyAnonymousAccessRequestSchoolwideSafetyStatusSmsForRecipient(
        deepMerge(fetcherOptions, variables),
      ),
    ...options,
  });
};

export interface DayOfEmergencyAnonymousAccessGetDayForRecipientPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessGetDayForRecipientHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessGetDayForRecipientError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessGetDayForRecipientVariables = {
  headers?: DayOfEmergencyAnonymousAccessGetDayForRecipientHeaders;
  pathParams: DayOfEmergencyAnonymousAccessGetDayForRecipientPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessGetDayForRecipient = (
  variables: DayOfEmergencyAnonymousAccessGetDayForRecipientVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.DayOfEmergencyDto,
    DayOfEmergencyAnonymousAccessGetDayForRecipientError,
    undefined,
    DayOfEmergencyAnonymousAccessGetDayForRecipientHeaders,
    {},
    DayOfEmergencyAnonymousAccessGetDayForRecipientPathParams
  >({ method: "get", url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/day", ...variables, signal });

export function dayOfEmergencyAnonymousAccessGetDayForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessGetDayForRecipientVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.DayOfEmergencyDto>;
};

export function dayOfEmergencyAnonymousAccessGetDayForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessGetDayForRecipientVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.DayOfEmergencyDto>) | reactQuery.SkipToken;
};

export function dayOfEmergencyAnonymousAccessGetDayForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessGetDayForRecipientVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchDayOfEmergencyAnonymousAccessGetDayForRecipient(variables, signal),
    queryKey: queryKeyFn({
      operationId: "dayOfEmergencyAnonymousAccessGetDayForRecipient",
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/day",
      variables,
    }),
  };
}

export const useSuspenseDayOfEmergencyAnonymousAccessGetDayForRecipient = <TData = Schemas.DayOfEmergencyDto>(
  variables: DayOfEmergencyAnonymousAccessGetDayForRecipientVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.DayOfEmergencyDto, DayOfEmergencyAnonymousAccessGetDayForRecipientError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.DayOfEmergencyDto,
    DayOfEmergencyAnonymousAccessGetDayForRecipientError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessGetDayForRecipientQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDayOfEmergencyAnonymousAccessGetDayForRecipient = <TData = Schemas.DayOfEmergencyDto>(
  variables: DayOfEmergencyAnonymousAccessGetDayForRecipientVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.DayOfEmergencyDto, DayOfEmergencyAnonymousAccessGetDayForRecipientError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.DayOfEmergencyDto, DayOfEmergencyAnonymousAccessGetDayForRecipientError, TData>({
    ...dayOfEmergencyAnonymousAccessGetDayForRecipientQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DayOfEmergencyAnonymousAccessListParticipantsForRecipientPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessListParticipantsForRecipientHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessListParticipantsForRecipientError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessListParticipantsForRecipientResponse = Schemas.DayOfEmergencyParticipantDto[];

export type DayOfEmergencyAnonymousAccessListParticipantsForRecipientVariables = {
  headers?: DayOfEmergencyAnonymousAccessListParticipantsForRecipientHeaders;
  pathParams: DayOfEmergencyAnonymousAccessListParticipantsForRecipientPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessListParticipantsForRecipient = (
  variables: DayOfEmergencyAnonymousAccessListParticipantsForRecipientVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    DayOfEmergencyAnonymousAccessListParticipantsForRecipientResponse,
    DayOfEmergencyAnonymousAccessListParticipantsForRecipientError,
    undefined,
    DayOfEmergencyAnonymousAccessListParticipantsForRecipientHeaders,
    {},
    DayOfEmergencyAnonymousAccessListParticipantsForRecipientPathParams
  >({ method: "get", url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/participants", ...variables, signal });

export function dayOfEmergencyAnonymousAccessListParticipantsForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessListParticipantsForRecipientVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<DayOfEmergencyAnonymousAccessListParticipantsForRecipientResponse>;
};

export function dayOfEmergencyAnonymousAccessListParticipantsForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessListParticipantsForRecipientVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<DayOfEmergencyAnonymousAccessListParticipantsForRecipientResponse>)
    | reactQuery.SkipToken;
};

export function dayOfEmergencyAnonymousAccessListParticipantsForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessListParticipantsForRecipientVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDayOfEmergencyAnonymousAccessListParticipantsForRecipient(variables, signal),
    queryKey: queryKeyFn({
      operationId: "dayOfEmergencyAnonymousAccessListParticipantsForRecipient",
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/participants",
      variables,
    }),
  };
}

export const useSuspenseDayOfEmergencyAnonymousAccessListParticipantsForRecipient = <
  TData = DayOfEmergencyAnonymousAccessListParticipantsForRecipientResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListParticipantsForRecipientVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListParticipantsForRecipientResponse,
      DayOfEmergencyAnonymousAccessListParticipantsForRecipientError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    DayOfEmergencyAnonymousAccessListParticipantsForRecipientResponse,
    DayOfEmergencyAnonymousAccessListParticipantsForRecipientError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListParticipantsForRecipientQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDayOfEmergencyAnonymousAccessListParticipantsForRecipient = <
  TData = DayOfEmergencyAnonymousAccessListParticipantsForRecipientResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListParticipantsForRecipientVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListParticipantsForRecipientResponse,
      DayOfEmergencyAnonymousAccessListParticipantsForRecipientError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    DayOfEmergencyAnonymousAccessListParticipantsForRecipientResponse,
    DayOfEmergencyAnonymousAccessListParticipantsForRecipientError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListParticipantsForRecipientQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DayOfEmergencyAnonymousAccessListTimelineForRecipientPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessListTimelineForRecipientHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessListTimelineForRecipientError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessListTimelineForRecipientResponse = Schemas.DayOfEmergencyTimelineEntryDto[];

export type DayOfEmergencyAnonymousAccessListTimelineForRecipientVariables = {
  headers?: DayOfEmergencyAnonymousAccessListTimelineForRecipientHeaders;
  pathParams: DayOfEmergencyAnonymousAccessListTimelineForRecipientPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessListTimelineForRecipient = (
  variables: DayOfEmergencyAnonymousAccessListTimelineForRecipientVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    DayOfEmergencyAnonymousAccessListTimelineForRecipientResponse,
    DayOfEmergencyAnonymousAccessListTimelineForRecipientError,
    undefined,
    DayOfEmergencyAnonymousAccessListTimelineForRecipientHeaders,
    {},
    DayOfEmergencyAnonymousAccessListTimelineForRecipientPathParams
  >({ method: "get", url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/timeline", ...variables, signal });

export function dayOfEmergencyAnonymousAccessListTimelineForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessListTimelineForRecipientVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<DayOfEmergencyAnonymousAccessListTimelineForRecipientResponse>;
};

export function dayOfEmergencyAnonymousAccessListTimelineForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessListTimelineForRecipientVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<DayOfEmergencyAnonymousAccessListTimelineForRecipientResponse>)
    | reactQuery.SkipToken;
};

export function dayOfEmergencyAnonymousAccessListTimelineForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessListTimelineForRecipientVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchDayOfEmergencyAnonymousAccessListTimelineForRecipient(variables, signal),
    queryKey: queryKeyFn({
      operationId: "dayOfEmergencyAnonymousAccessListTimelineForRecipient",
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/timeline",
      variables,
    }),
  };
}

export const useSuspenseDayOfEmergencyAnonymousAccessListTimelineForRecipient = <
  TData = DayOfEmergencyAnonymousAccessListTimelineForRecipientResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListTimelineForRecipientVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListTimelineForRecipientResponse,
      DayOfEmergencyAnonymousAccessListTimelineForRecipientError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    DayOfEmergencyAnonymousAccessListTimelineForRecipientResponse,
    DayOfEmergencyAnonymousAccessListTimelineForRecipientError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListTimelineForRecipientQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDayOfEmergencyAnonymousAccessListTimelineForRecipient = <
  TData = DayOfEmergencyAnonymousAccessListTimelineForRecipientResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListTimelineForRecipientVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListTimelineForRecipientResponse,
      DayOfEmergencyAnonymousAccessListTimelineForRecipientError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    DayOfEmergencyAnonymousAccessListTimelineForRecipientResponse,
    DayOfEmergencyAnonymousAccessListTimelineForRecipientError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListTimelineForRecipientQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientError =
  Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientResponse =
  Schemas.EmergencyDeclarationDto[];

export type DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientVariables = {
  headers?: DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientHeaders;
  pathParams: DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipient = (
  variables: DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientResponse,
    DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientError,
    undefined,
    DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientHeaders,
    {},
    DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientPathParams
  >({
    method: "get",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/emergency-declarations/active",
    ...variables,
    signal,
  });

export function dayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientResponse>;
};

export function dayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((
        options: QueryFnOptions,
      ) => Promise<DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientResponse>)
    | reactQuery.SkipToken;
};

export function dayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipient(variables, signal),
    queryKey: queryKeyFn({
      operationId: "dayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipient",
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/emergency-declarations/active",
      variables,
    }),
  };
}

export const useSuspenseDayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipient = <
  TData = DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientResponse,
      DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientResponse,
    DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientQuery(
      deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export const useDayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipient = <
  TData = DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientResponse,
      DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientResponse,
    DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientVariables = {
  headers?: DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientHeaders;
  pathParams: DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessGetBubbleContextForRecipient = (
  variables: DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.LawEnforcementBubbleContextDto,
    DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientError,
    undefined,
    DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientHeaders,
    {},
    DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientPathParams
  >({
    method: "get",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/bubble-context",
    ...variables,
    signal,
  });

export function dayOfEmergencyAnonymousAccessGetBubbleContextForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.LawEnforcementBubbleContextDto>;
};

export function dayOfEmergencyAnonymousAccessGetBubbleContextForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.LawEnforcementBubbleContextDto>) | reactQuery.SkipToken;
};

export function dayOfEmergencyAnonymousAccessGetBubbleContextForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDayOfEmergencyAnonymousAccessGetBubbleContextForRecipient(variables, signal),
    queryKey: queryKeyFn({
      operationId: "dayOfEmergencyAnonymousAccessGetBubbleContextForRecipient",
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/bubble-context",
      variables,
    }),
  };
}

export const useSuspenseDayOfEmergencyAnonymousAccessGetBubbleContextForRecipient = <
  TData = Schemas.LawEnforcementBubbleContextDto,
>(
  variables: DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LawEnforcementBubbleContextDto,
      DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.LawEnforcementBubbleContextDto,
    DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessGetBubbleContextForRecipientQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDayOfEmergencyAnonymousAccessGetBubbleContextForRecipient = <
  TData = Schemas.LawEnforcementBubbleContextDto,
>(
  variables: DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.LawEnforcementBubbleContextDto,
      DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    Schemas.LawEnforcementBubbleContextDto,
    DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessGetBubbleContextForRecipientQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DayOfEmergencyAnonymousAccessListAdminContactsForRecipientPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessListAdminContactsForRecipientHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessListAdminContactsForRecipientError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessListAdminContactsForRecipientResponse =
  Schemas.LawEnforcementAdminContactDto[];

export type DayOfEmergencyAnonymousAccessListAdminContactsForRecipientVariables = {
  headers?: DayOfEmergencyAnonymousAccessListAdminContactsForRecipientHeaders;
  pathParams: DayOfEmergencyAnonymousAccessListAdminContactsForRecipientPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessListAdminContactsForRecipient = (
  variables: DayOfEmergencyAnonymousAccessListAdminContactsForRecipientVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    DayOfEmergencyAnonymousAccessListAdminContactsForRecipientResponse,
    DayOfEmergencyAnonymousAccessListAdminContactsForRecipientError,
    undefined,
    DayOfEmergencyAnonymousAccessListAdminContactsForRecipientHeaders,
    {},
    DayOfEmergencyAnonymousAccessListAdminContactsForRecipientPathParams
  >({
    method: "get",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/admin-contacts",
    ...variables,
    signal,
  });

export function dayOfEmergencyAnonymousAccessListAdminContactsForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessListAdminContactsForRecipientVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<DayOfEmergencyAnonymousAccessListAdminContactsForRecipientResponse>;
};

export function dayOfEmergencyAnonymousAccessListAdminContactsForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessListAdminContactsForRecipientVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<DayOfEmergencyAnonymousAccessListAdminContactsForRecipientResponse>)
    | reactQuery.SkipToken;
};

export function dayOfEmergencyAnonymousAccessListAdminContactsForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessListAdminContactsForRecipientVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDayOfEmergencyAnonymousAccessListAdminContactsForRecipient(variables, signal),
    queryKey: queryKeyFn({
      operationId: "dayOfEmergencyAnonymousAccessListAdminContactsForRecipient",
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/admin-contacts",
      variables,
    }),
  };
}

export const useSuspenseDayOfEmergencyAnonymousAccessListAdminContactsForRecipient = <
  TData = DayOfEmergencyAnonymousAccessListAdminContactsForRecipientResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListAdminContactsForRecipientVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListAdminContactsForRecipientResponse,
      DayOfEmergencyAnonymousAccessListAdminContactsForRecipientError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    DayOfEmergencyAnonymousAccessListAdminContactsForRecipientResponse,
    DayOfEmergencyAnonymousAccessListAdminContactsForRecipientError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListAdminContactsForRecipientQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDayOfEmergencyAnonymousAccessListAdminContactsForRecipient = <
  TData = DayOfEmergencyAnonymousAccessListAdminContactsForRecipientResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListAdminContactsForRecipientVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListAdminContactsForRecipientResponse,
      DayOfEmergencyAnonymousAccessListAdminContactsForRecipientError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    DayOfEmergencyAnonymousAccessListAdminContactsForRecipientResponse,
    DayOfEmergencyAnonymousAccessListAdminContactsForRecipientError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListAdminContactsForRecipientQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DayOfEmergencyAnonymousAccessListMapLocationsForRecipientPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessListMapLocationsForRecipientHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessListMapLocationsForRecipientError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessListMapLocationsForRecipientResponse = Schemas.BubbleMapLocationDto[];

export type DayOfEmergencyAnonymousAccessListMapLocationsForRecipientVariables = {
  headers?: DayOfEmergencyAnonymousAccessListMapLocationsForRecipientHeaders;
  pathParams: DayOfEmergencyAnonymousAccessListMapLocationsForRecipientPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessListMapLocationsForRecipient = (
  variables: DayOfEmergencyAnonymousAccessListMapLocationsForRecipientVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    DayOfEmergencyAnonymousAccessListMapLocationsForRecipientResponse,
    DayOfEmergencyAnonymousAccessListMapLocationsForRecipientError,
    undefined,
    DayOfEmergencyAnonymousAccessListMapLocationsForRecipientHeaders,
    {},
    DayOfEmergencyAnonymousAccessListMapLocationsForRecipientPathParams
  >({
    method: "get",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/map-locations",
    ...variables,
    signal,
  });

export function dayOfEmergencyAnonymousAccessListMapLocationsForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessListMapLocationsForRecipientVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<DayOfEmergencyAnonymousAccessListMapLocationsForRecipientResponse>;
};

export function dayOfEmergencyAnonymousAccessListMapLocationsForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessListMapLocationsForRecipientVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<DayOfEmergencyAnonymousAccessListMapLocationsForRecipientResponse>)
    | reactQuery.SkipToken;
};

export function dayOfEmergencyAnonymousAccessListMapLocationsForRecipientQuery(
  variables: DayOfEmergencyAnonymousAccessListMapLocationsForRecipientVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDayOfEmergencyAnonymousAccessListMapLocationsForRecipient(variables, signal),
    queryKey: queryKeyFn({
      operationId: "dayOfEmergencyAnonymousAccessListMapLocationsForRecipient",
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/map-locations",
      variables,
    }),
  };
}

export const useSuspenseDayOfEmergencyAnonymousAccessListMapLocationsForRecipient = <
  TData = DayOfEmergencyAnonymousAccessListMapLocationsForRecipientResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListMapLocationsForRecipientVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListMapLocationsForRecipientResponse,
      DayOfEmergencyAnonymousAccessListMapLocationsForRecipientError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    DayOfEmergencyAnonymousAccessListMapLocationsForRecipientResponse,
    DayOfEmergencyAnonymousAccessListMapLocationsForRecipientError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListMapLocationsForRecipientQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDayOfEmergencyAnonymousAccessListMapLocationsForRecipient = <
  TData = DayOfEmergencyAnonymousAccessListMapLocationsForRecipientResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListMapLocationsForRecipientVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListMapLocationsForRecipientResponse,
      DayOfEmergencyAnonymousAccessListMapLocationsForRecipientError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    DayOfEmergencyAnonymousAccessListMapLocationsForRecipientResponse,
    DayOfEmergencyAnonymousAccessListMapLocationsForRecipientError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListMapLocationsForRecipientQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DayOfEmergencyAnonymousAccessPatchParticipantSelfForRecipientPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessPatchParticipantSelfForRecipientHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessPatchParticipantSelfForRecipientError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessPatchParticipantSelfForRecipientVariables = {
  body?: Schemas.PatchDayOfEmergencyParticipantRequestDto;
  headers?: DayOfEmergencyAnonymousAccessPatchParticipantSelfForRecipientHeaders;
  pathParams: DayOfEmergencyAnonymousAccessPatchParticipantSelfForRecipientPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessPatchParticipantSelfForRecipient = (
  variables: DayOfEmergencyAnonymousAccessPatchParticipantSelfForRecipientVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.DayOfEmergencyParticipantDto,
    DayOfEmergencyAnonymousAccessPatchParticipantSelfForRecipientError,
    Schemas.PatchDayOfEmergencyParticipantRequestDto,
    DayOfEmergencyAnonymousAccessPatchParticipantSelfForRecipientHeaders,
    {},
    DayOfEmergencyAnonymousAccessPatchParticipantSelfForRecipientPathParams
  >({
    method: "patch",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/participants/me",
    ...variables,
    signal,
  });

export const useDayOfEmergencyAnonymousAccessPatchParticipantSelfForRecipient = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DayOfEmergencyParticipantDto,
      DayOfEmergencyAnonymousAccessPatchParticipantSelfForRecipientError,
      DayOfEmergencyAnonymousAccessPatchParticipantSelfForRecipientVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.DayOfEmergencyParticipantDto,
    DayOfEmergencyAnonymousAccessPatchParticipantSelfForRecipientError,
    DayOfEmergencyAnonymousAccessPatchParticipantSelfForRecipientVariables
  >({
    mutationFn: (variables: DayOfEmergencyAnonymousAccessPatchParticipantSelfForRecipientVariables) =>
      fetchDayOfEmergencyAnonymousAccessPatchParticipantSelfForRecipient(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface DayOfEmergencyAnonymousAccessPatchParticipantForRecipientPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
  /**
   * @format uuid
   */
  userId: string;
}

export interface DayOfEmergencyAnonymousAccessPatchParticipantForRecipientHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessPatchParticipantForRecipientError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessPatchParticipantForRecipientVariables = {
  body?: Schemas.PatchDayOfEmergencyParticipantRequestDto;
  headers?: DayOfEmergencyAnonymousAccessPatchParticipantForRecipientHeaders;
  pathParams: DayOfEmergencyAnonymousAccessPatchParticipantForRecipientPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessPatchParticipantForRecipient = (
  variables: DayOfEmergencyAnonymousAccessPatchParticipantForRecipientVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.DayOfEmergencyParticipantDto,
    DayOfEmergencyAnonymousAccessPatchParticipantForRecipientError,
    Schemas.PatchDayOfEmergencyParticipantRequestDto,
    DayOfEmergencyAnonymousAccessPatchParticipantForRecipientHeaders,
    {},
    DayOfEmergencyAnonymousAccessPatchParticipantForRecipientPathParams
  >({
    method: "patch",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/participants/{userId}",
    ...variables,
    signal,
  });

export const useDayOfEmergencyAnonymousAccessPatchParticipantForRecipient = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.DayOfEmergencyParticipantDto,
      DayOfEmergencyAnonymousAccessPatchParticipantForRecipientError,
      DayOfEmergencyAnonymousAccessPatchParticipantForRecipientVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.DayOfEmergencyParticipantDto,
    DayOfEmergencyAnonymousAccessPatchParticipantForRecipientError,
    DayOfEmergencyAnonymousAccessPatchParticipantForRecipientVariables
  >({
    mutationFn: (variables: DayOfEmergencyAnonymousAccessPatchParticipantForRecipientVariables) =>
      fetchDayOfEmergencyAnonymousAccessPatchParticipantForRecipient(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientResponse =
  Schemas.DayOfEmergencyParticipantDto[];

export type DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientVariables = {
  body?: Schemas.BatchSetParticipantsStatusRequestDto;
  headers?: DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientHeaders;
  pathParams: DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipient = (
  variables: DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientResponse,
    DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientError,
    Schemas.BatchSetParticipantsStatusRequestDto,
    DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientHeaders,
    {},
    DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientPathParams
  >({
    method: "post",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/participants/batch-same-status",
    ...variables,
    signal,
  });

export const useDayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipient = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientResponse,
      DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientError,
      DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientResponse,
    DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientError,
    DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientVariables
  >({
    mutationFn: (variables: DayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipientVariables) =>
      fetchDayOfEmergencyAnonymousAccessBatchSetSameStatusForRecipient(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface DayOfEmergencyAnonymousAccessEndEmergencyDeclarationForRecipientPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
  /**
   * @format uuid
   */
  declarationId: string;
}

export interface DayOfEmergencyAnonymousAccessEndEmergencyDeclarationForRecipientHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessEndEmergencyDeclarationForRecipientError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessEndEmergencyDeclarationForRecipientVariables = {
  body?: Schemas.EndEmergencyDeclarationRequestDto;
  headers?: DayOfEmergencyAnonymousAccessEndEmergencyDeclarationForRecipientHeaders;
  pathParams: DayOfEmergencyAnonymousAccessEndEmergencyDeclarationForRecipientPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessEndEmergencyDeclarationForRecipient = (
  variables: DayOfEmergencyAnonymousAccessEndEmergencyDeclarationForRecipientVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.EmergencyDeclarationDto,
    DayOfEmergencyAnonymousAccessEndEmergencyDeclarationForRecipientError,
    Schemas.EndEmergencyDeclarationRequestDto,
    DayOfEmergencyAnonymousAccessEndEmergencyDeclarationForRecipientHeaders,
    {},
    DayOfEmergencyAnonymousAccessEndEmergencyDeclarationForRecipientPathParams
  >({
    method: "post",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/emergency-declarations/{declarationId}/end",
    ...variables,
    signal,
  });

export const useDayOfEmergencyAnonymousAccessEndEmergencyDeclarationForRecipient = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.EmergencyDeclarationDto,
      DayOfEmergencyAnonymousAccessEndEmergencyDeclarationForRecipientError,
      DayOfEmergencyAnonymousAccessEndEmergencyDeclarationForRecipientVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.EmergencyDeclarationDto,
    DayOfEmergencyAnonymousAccessEndEmergencyDeclarationForRecipientError,
    DayOfEmergencyAnonymousAccessEndEmergencyDeclarationForRecipientVariables
  >({
    mutationFn: (variables: DayOfEmergencyAnonymousAccessEndEmergencyDeclarationForRecipientVariables) =>
      fetchDayOfEmergencyAnonymousAccessEndEmergencyDeclarationForRecipient(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesResponse =
  Schemas.LawEnforcementChatMessageDto[];

export type DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesVariables = {
  headers?: DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesHeaders;
  pathParams: DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessListLawEnforcementChatMessages = (
  variables: DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesResponse,
    DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesError,
    undefined,
    DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesHeaders,
    {},
    DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesPathParams
  >({
    method: "get",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/chat/messages",
    ...variables,
    signal,
  });

export function dayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesQuery(
  variables: DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesResponse>;
};

export function dayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesQuery(
  variables: DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesResponse>)
    | reactQuery.SkipToken;
};

export function dayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesQuery(
  variables: DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDayOfEmergencyAnonymousAccessListLawEnforcementChatMessages(variables, signal),
    queryKey: queryKeyFn({
      operationId: "dayOfEmergencyAnonymousAccessListLawEnforcementChatMessages",
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/chat/messages",
      variables,
    }),
  };
}

export const useSuspenseDayOfEmergencyAnonymousAccessListLawEnforcementChatMessages = <
  TData = DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesResponse,
      DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesResponse,
    DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDayOfEmergencyAnonymousAccessListLawEnforcementChatMessages = <
  TData = DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesResponse,
      DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesResponse,
    DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesPathParams {
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export interface DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesHeaders {
  ["X-Emergency-Access-Token"]?: string;
}

export type DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesError = Fetcher.ErrorWrapper<undefined>;

export type DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesResponse = Schemas.ChatMessageDto[];

export type DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesVariables = {
  headers?: DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesHeaders;
  pathParams: DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessages = (
  variables: DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesResponse,
    DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesError,
    undefined,
    DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesHeaders,
    {},
    DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesPathParams
  >({
    method: "get",
    url: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/chat/messages",
    ...variables,
    signal,
  });

export function dayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesQuery(
  variables: DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (
    options: QueryFnOptions,
  ) => Promise<DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesResponse>;
};

export function dayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesQuery(
  variables: DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesResponse>)
    | reactQuery.SkipToken;
};

export function dayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesQuery(
  variables: DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) =>
            fetchDayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessages(variables, signal),
    queryKey: queryKeyFn({
      operationId: "dayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessages",
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/chat/messages",
      variables,
    }),
  };
}

export const useSuspenseDayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessages = <
  TData = DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesResponse,
      DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesResponse,
    DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessages = <
  TData = DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesResponse,
>(
  variables: DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesResponse,
      DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesResponse,
    DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesError,
    TData
  >({
    ...dayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DistrictEmergencyConsoleGetSnapshotPathParams {
  /**
   * @format uuid
   */
  schoolDistrictId: string;
}

export type DistrictEmergencyConsoleGetSnapshotError = Fetcher.ErrorWrapper<
  | {
      status: 403;
      payload: Schemas.ProblemDetails;
    }
  | {
      status: 404;
      payload: Schemas.ProblemDetails;
    }
>;

export type DistrictEmergencyConsoleGetSnapshotVariables = {
  pathParams: DistrictEmergencyConsoleGetSnapshotPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDistrictEmergencyConsoleGetSnapshot = (
  variables: DistrictEmergencyConsoleGetSnapshotVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.DistrictEmergencyConsoleSnapshotDto,
    DistrictEmergencyConsoleGetSnapshotError,
    undefined,
    {},
    {},
    DistrictEmergencyConsoleGetSnapshotPathParams
  >({
    method: "get",
    url: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/snapshot",
    ...variables,
    signal,
  });

export function districtEmergencyConsoleGetSnapshotQuery(variables: DistrictEmergencyConsoleGetSnapshotVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.DistrictEmergencyConsoleSnapshotDto>;
};

export function districtEmergencyConsoleGetSnapshotQuery(
  variables: DistrictEmergencyConsoleGetSnapshotVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.DistrictEmergencyConsoleSnapshotDto>) | reactQuery.SkipToken;
};

export function districtEmergencyConsoleGetSnapshotQuery(
  variables: DistrictEmergencyConsoleGetSnapshotVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchDistrictEmergencyConsoleGetSnapshot(variables, signal),
    queryKey: queryKeyFn({
      operationId: "districtEmergencyConsoleGetSnapshot",
      path: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/snapshot",
      variables,
    }),
  };
}

export const useSuspenseDistrictEmergencyConsoleGetSnapshot = <TData = Schemas.DistrictEmergencyConsoleSnapshotDto>(
  variables: DistrictEmergencyConsoleGetSnapshotVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DistrictEmergencyConsoleSnapshotDto,
      DistrictEmergencyConsoleGetSnapshotError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.DistrictEmergencyConsoleSnapshotDto,
    DistrictEmergencyConsoleGetSnapshotError,
    TData
  >({
    ...districtEmergencyConsoleGetSnapshotQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDistrictEmergencyConsoleGetSnapshot = <TData = Schemas.DistrictEmergencyConsoleSnapshotDto>(
  variables: DistrictEmergencyConsoleGetSnapshotVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DistrictEmergencyConsoleSnapshotDto,
      DistrictEmergencyConsoleGetSnapshotError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    Schemas.DistrictEmergencyConsoleSnapshotDto,
    DistrictEmergencyConsoleGetSnapshotError,
    TData
  >({
    ...districtEmergencyConsoleGetSnapshotQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DistrictEmergencyConsoleGetMapAggregatePathParams {
  /**
   * @format uuid
   */
  schoolDistrictId: string;
}

export type DistrictEmergencyConsoleGetMapAggregateError = Fetcher.ErrorWrapper<
  | {
      status: 403;
      payload: Schemas.ProblemDetails;
    }
  | {
      status: 404;
      payload: Schemas.ProblemDetails;
    }
>;

export type DistrictEmergencyConsoleGetMapAggregateVariables = {
  pathParams: DistrictEmergencyConsoleGetMapAggregatePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDistrictEmergencyConsoleGetMapAggregate = (
  variables: DistrictEmergencyConsoleGetMapAggregateVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.DistrictEmergencyMapAggregateDto,
    DistrictEmergencyConsoleGetMapAggregateError,
    undefined,
    {},
    {},
    DistrictEmergencyConsoleGetMapAggregatePathParams
  >({
    method: "get",
    url: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/map-aggregate",
    ...variables,
    signal,
  });

export function districtEmergencyConsoleGetMapAggregateQuery(
  variables: DistrictEmergencyConsoleGetMapAggregateVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.DistrictEmergencyMapAggregateDto>;
};

export function districtEmergencyConsoleGetMapAggregateQuery(
  variables: DistrictEmergencyConsoleGetMapAggregateVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.DistrictEmergencyMapAggregateDto>) | reactQuery.SkipToken;
};

export function districtEmergencyConsoleGetMapAggregateQuery(
  variables: DistrictEmergencyConsoleGetMapAggregateVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchDistrictEmergencyConsoleGetMapAggregate(variables, signal),
    queryKey: queryKeyFn({
      operationId: "districtEmergencyConsoleGetMapAggregate",
      path: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/map-aggregate",
      variables,
    }),
  };
}

export const useSuspenseDistrictEmergencyConsoleGetMapAggregate = <TData = Schemas.DistrictEmergencyMapAggregateDto>(
  variables: DistrictEmergencyConsoleGetMapAggregateVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DistrictEmergencyMapAggregateDto,
      DistrictEmergencyConsoleGetMapAggregateError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.DistrictEmergencyMapAggregateDto,
    DistrictEmergencyConsoleGetMapAggregateError,
    TData
  >({
    ...districtEmergencyConsoleGetMapAggregateQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDistrictEmergencyConsoleGetMapAggregate = <TData = Schemas.DistrictEmergencyMapAggregateDto>(
  variables: DistrictEmergencyConsoleGetMapAggregateVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.DistrictEmergencyMapAggregateDto,
      DistrictEmergencyConsoleGetMapAggregateError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    Schemas.DistrictEmergencyMapAggregateDto,
    DistrictEmergencyConsoleGetMapAggregateError,
    TData
  >({
    ...districtEmergencyConsoleGetMapAggregateQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DistrictEmergencyConsoleGetDayForSchoolPathParams {
  /**
   * @format uuid
   */
  schoolDistrictId: string;
  /**
   * @format uuid
   */
  schoolBubbleId: string;
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export type DistrictEmergencyConsoleGetDayForSchoolError = Fetcher.ErrorWrapper<
  | {
      status: 403;
      payload: Schemas.ProblemDetails;
    }
  | {
      status: 404;
      payload: Schemas.ProblemDetails;
    }
>;

export type DistrictEmergencyConsoleGetDayForSchoolVariables = {
  pathParams: DistrictEmergencyConsoleGetDayForSchoolPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDistrictEmergencyConsoleGetDayForSchool = (
  variables: DistrictEmergencyConsoleGetDayForSchoolVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.DayOfEmergencyDto,
    DistrictEmergencyConsoleGetDayForSchoolError,
    undefined,
    {},
    {},
    DistrictEmergencyConsoleGetDayForSchoolPathParams
  >({
    method: "get",
    url: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/schools/{schoolBubbleId}/day/{dayOfEmergencyId}",
    ...variables,
    signal,
  });

export function districtEmergencyConsoleGetDayForSchoolQuery(
  variables: DistrictEmergencyConsoleGetDayForSchoolVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.DayOfEmergencyDto>;
};

export function districtEmergencyConsoleGetDayForSchoolQuery(
  variables: DistrictEmergencyConsoleGetDayForSchoolVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.DayOfEmergencyDto>) | reactQuery.SkipToken;
};

export function districtEmergencyConsoleGetDayForSchoolQuery(
  variables: DistrictEmergencyConsoleGetDayForSchoolVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchDistrictEmergencyConsoleGetDayForSchool(variables, signal),
    queryKey: queryKeyFn({
      operationId: "districtEmergencyConsoleGetDayForSchool",
      path: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/schools/{schoolBubbleId}/day/{dayOfEmergencyId}",
      variables,
    }),
  };
}

export const useSuspenseDistrictEmergencyConsoleGetDayForSchool = <TData = Schemas.DayOfEmergencyDto>(
  variables: DistrictEmergencyConsoleGetDayForSchoolVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.DayOfEmergencyDto, DistrictEmergencyConsoleGetDayForSchoolError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.DayOfEmergencyDto, DistrictEmergencyConsoleGetDayForSchoolError, TData>({
    ...districtEmergencyConsoleGetDayForSchoolQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDistrictEmergencyConsoleGetDayForSchool = <TData = Schemas.DayOfEmergencyDto>(
  variables: DistrictEmergencyConsoleGetDayForSchoolVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.DayOfEmergencyDto, DistrictEmergencyConsoleGetDayForSchoolError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.DayOfEmergencyDto, DistrictEmergencyConsoleGetDayForSchoolError, TData>({
    ...districtEmergencyConsoleGetDayForSchoolQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DistrictEmergencyConsoleListParticipantsPathParams {
  /**
   * @format uuid
   */
  schoolDistrictId: string;
  /**
   * @format uuid
   */
  schoolBubbleId: string;
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export type DistrictEmergencyConsoleListParticipantsError = Fetcher.ErrorWrapper<
  | {
      status: 403;
      payload: Schemas.ProblemDetails;
    }
  | {
      status: 404;
      payload: Schemas.ProblemDetails;
    }
>;

export type DistrictEmergencyConsoleListParticipantsResponse = Schemas.DayOfEmergencyParticipantDto[];

export type DistrictEmergencyConsoleListParticipantsVariables = {
  pathParams: DistrictEmergencyConsoleListParticipantsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDistrictEmergencyConsoleListParticipants = (
  variables: DistrictEmergencyConsoleListParticipantsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    DistrictEmergencyConsoleListParticipantsResponse,
    DistrictEmergencyConsoleListParticipantsError,
    undefined,
    {},
    {},
    DistrictEmergencyConsoleListParticipantsPathParams
  >({
    method: "get",
    url: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/schools/{schoolBubbleId}/day/{dayOfEmergencyId}/participants",
    ...variables,
    signal,
  });

export function districtEmergencyConsoleListParticipantsQuery(
  variables: DistrictEmergencyConsoleListParticipantsVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<DistrictEmergencyConsoleListParticipantsResponse>;
};

export function districtEmergencyConsoleListParticipantsQuery(
  variables: DistrictEmergencyConsoleListParticipantsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<DistrictEmergencyConsoleListParticipantsResponse>)
    | reactQuery.SkipToken;
};

export function districtEmergencyConsoleListParticipantsQuery(
  variables: DistrictEmergencyConsoleListParticipantsVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchDistrictEmergencyConsoleListParticipants(variables, signal),
    queryKey: queryKeyFn({
      operationId: "districtEmergencyConsoleListParticipants",
      path: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/schools/{schoolBubbleId}/day/{dayOfEmergencyId}/participants",
      variables,
    }),
  };
}

export const useSuspenseDistrictEmergencyConsoleListParticipants = <
  TData = DistrictEmergencyConsoleListParticipantsResponse,
>(
  variables: DistrictEmergencyConsoleListParticipantsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DistrictEmergencyConsoleListParticipantsResponse,
      DistrictEmergencyConsoleListParticipantsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    DistrictEmergencyConsoleListParticipantsResponse,
    DistrictEmergencyConsoleListParticipantsError,
    TData
  >({
    ...districtEmergencyConsoleListParticipantsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDistrictEmergencyConsoleListParticipants = <TData = DistrictEmergencyConsoleListParticipantsResponse>(
  variables: DistrictEmergencyConsoleListParticipantsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DistrictEmergencyConsoleListParticipantsResponse,
      DistrictEmergencyConsoleListParticipantsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    DistrictEmergencyConsoleListParticipantsResponse,
    DistrictEmergencyConsoleListParticipantsError,
    TData
  >({
    ...districtEmergencyConsoleListParticipantsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DistrictEmergencyConsoleListTimelinePathParams {
  /**
   * @format uuid
   */
  schoolDistrictId: string;
  /**
   * @format uuid
   */
  schoolBubbleId: string;
  /**
   * @format uuid
   */
  dayOfEmergencyId: string;
}

export type DistrictEmergencyConsoleListTimelineError = Fetcher.ErrorWrapper<
  | {
      status: 403;
      payload: Schemas.ProblemDetails;
    }
  | {
      status: 404;
      payload: Schemas.ProblemDetails;
    }
>;

export type DistrictEmergencyConsoleListTimelineResponse = Schemas.DayOfEmergencyTimelineEntryDto[];

export type DistrictEmergencyConsoleListTimelineVariables = {
  pathParams: DistrictEmergencyConsoleListTimelinePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDistrictEmergencyConsoleListTimeline = (
  variables: DistrictEmergencyConsoleListTimelineVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    DistrictEmergencyConsoleListTimelineResponse,
    DistrictEmergencyConsoleListTimelineError,
    undefined,
    {},
    {},
    DistrictEmergencyConsoleListTimelinePathParams
  >({
    method: "get",
    url: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/schools/{schoolBubbleId}/day/{dayOfEmergencyId}/timeline",
    ...variables,
    signal,
  });

export function districtEmergencyConsoleListTimelineQuery(variables: DistrictEmergencyConsoleListTimelineVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<DistrictEmergencyConsoleListTimelineResponse>;
};

export function districtEmergencyConsoleListTimelineQuery(
  variables: DistrictEmergencyConsoleListTimelineVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<DistrictEmergencyConsoleListTimelineResponse>) | reactQuery.SkipToken;
};

export function districtEmergencyConsoleListTimelineQuery(
  variables: DistrictEmergencyConsoleListTimelineVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchDistrictEmergencyConsoleListTimeline(variables, signal),
    queryKey: queryKeyFn({
      operationId: "districtEmergencyConsoleListTimeline",
      path: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/schools/{schoolBubbleId}/day/{dayOfEmergencyId}/timeline",
      variables,
    }),
  };
}

export const useSuspenseDistrictEmergencyConsoleListTimeline = <TData = DistrictEmergencyConsoleListTimelineResponse>(
  variables: DistrictEmergencyConsoleListTimelineVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DistrictEmergencyConsoleListTimelineResponse,
      DistrictEmergencyConsoleListTimelineError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    DistrictEmergencyConsoleListTimelineResponse,
    DistrictEmergencyConsoleListTimelineError,
    TData
  >({
    ...districtEmergencyConsoleListTimelineQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDistrictEmergencyConsoleListTimeline = <TData = DistrictEmergencyConsoleListTimelineResponse>(
  variables: DistrictEmergencyConsoleListTimelineVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DistrictEmergencyConsoleListTimelineResponse,
      DistrictEmergencyConsoleListTimelineError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    DistrictEmergencyConsoleListTimelineResponse,
    DistrictEmergencyConsoleListTimelineError,
    TData
  >({
    ...districtEmergencyConsoleListTimelineQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DistrictEmergencyConsoleListMapLocationsPathParams {
  /**
   * @format uuid
   */
  schoolDistrictId: string;
  /**
   * @format uuid
   */
  schoolBubbleId: string;
}

export type DistrictEmergencyConsoleListMapLocationsError = Fetcher.ErrorWrapper<
  | {
      status: 403;
      payload: Schemas.ProblemDetails;
    }
  | {
      status: 404;
      payload: Schemas.ProblemDetails;
    }
>;

export type DistrictEmergencyConsoleListMapLocationsResponse = Schemas.BubbleMapLocationDto[];

export type DistrictEmergencyConsoleListMapLocationsVariables = {
  pathParams: DistrictEmergencyConsoleListMapLocationsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDistrictEmergencyConsoleListMapLocations = (
  variables: DistrictEmergencyConsoleListMapLocationsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    DistrictEmergencyConsoleListMapLocationsResponse,
    DistrictEmergencyConsoleListMapLocationsError,
    undefined,
    {},
    {},
    DistrictEmergencyConsoleListMapLocationsPathParams
  >({
    method: "get",
    url: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/schools/{schoolBubbleId}/map-locations",
    ...variables,
    signal,
  });

export function districtEmergencyConsoleListMapLocationsQuery(
  variables: DistrictEmergencyConsoleListMapLocationsVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<DistrictEmergencyConsoleListMapLocationsResponse>;
};

export function districtEmergencyConsoleListMapLocationsQuery(
  variables: DistrictEmergencyConsoleListMapLocationsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<DistrictEmergencyConsoleListMapLocationsResponse>)
    | reactQuery.SkipToken;
};

export function districtEmergencyConsoleListMapLocationsQuery(
  variables: DistrictEmergencyConsoleListMapLocationsVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchDistrictEmergencyConsoleListMapLocations(variables, signal),
    queryKey: queryKeyFn({
      operationId: "districtEmergencyConsoleListMapLocations",
      path: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/schools/{schoolBubbleId}/map-locations",
      variables,
    }),
  };
}

export const useSuspenseDistrictEmergencyConsoleListMapLocations = <
  TData = DistrictEmergencyConsoleListMapLocationsResponse,
>(
  variables: DistrictEmergencyConsoleListMapLocationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DistrictEmergencyConsoleListMapLocationsResponse,
      DistrictEmergencyConsoleListMapLocationsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    DistrictEmergencyConsoleListMapLocationsResponse,
    DistrictEmergencyConsoleListMapLocationsError,
    TData
  >({
    ...districtEmergencyConsoleListMapLocationsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDistrictEmergencyConsoleListMapLocations = <TData = DistrictEmergencyConsoleListMapLocationsResponse>(
  variables: DistrictEmergencyConsoleListMapLocationsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DistrictEmergencyConsoleListMapLocationsResponse,
      DistrictEmergencyConsoleListMapLocationsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    DistrictEmergencyConsoleListMapLocationsResponse,
    DistrictEmergencyConsoleListMapLocationsError,
    TData
  >({
    ...districtEmergencyConsoleListMapLocationsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface DistrictEmergencyConsoleListActiveDeclarationsPathParams {
  /**
   * @format uuid
   */
  schoolDistrictId: string;
  /**
   * @format uuid
   */
  schoolBubbleId: string;
}

export type DistrictEmergencyConsoleListActiveDeclarationsError = Fetcher.ErrorWrapper<
  | {
      status: 403;
      payload: Schemas.ProblemDetails;
    }
  | {
      status: 404;
      payload: Schemas.ProblemDetails;
    }
>;

export type DistrictEmergencyConsoleListActiveDeclarationsResponse = Schemas.EmergencyDeclarationDto[];

export type DistrictEmergencyConsoleListActiveDeclarationsVariables = {
  pathParams: DistrictEmergencyConsoleListActiveDeclarationsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchDistrictEmergencyConsoleListActiveDeclarations = (
  variables: DistrictEmergencyConsoleListActiveDeclarationsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    DistrictEmergencyConsoleListActiveDeclarationsResponse,
    DistrictEmergencyConsoleListActiveDeclarationsError,
    undefined,
    {},
    {},
    DistrictEmergencyConsoleListActiveDeclarationsPathParams
  >({
    method: "get",
    url: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/schools/{schoolBubbleId}/emergency-declarations/active",
    ...variables,
    signal,
  });

export function districtEmergencyConsoleListActiveDeclarationsQuery(
  variables: DistrictEmergencyConsoleListActiveDeclarationsVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<DistrictEmergencyConsoleListActiveDeclarationsResponse>;
};

export function districtEmergencyConsoleListActiveDeclarationsQuery(
  variables: DistrictEmergencyConsoleListActiveDeclarationsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<DistrictEmergencyConsoleListActiveDeclarationsResponse>)
    | reactQuery.SkipToken;
};

export function districtEmergencyConsoleListActiveDeclarationsQuery(
  variables: DistrictEmergencyConsoleListActiveDeclarationsVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchDistrictEmergencyConsoleListActiveDeclarations(variables, signal),
    queryKey: queryKeyFn({
      operationId: "districtEmergencyConsoleListActiveDeclarations",
      path: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/schools/{schoolBubbleId}/emergency-declarations/active",
      variables,
    }),
  };
}

export const useSuspenseDistrictEmergencyConsoleListActiveDeclarations = <
  TData = DistrictEmergencyConsoleListActiveDeclarationsResponse,
>(
  variables: DistrictEmergencyConsoleListActiveDeclarationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DistrictEmergencyConsoleListActiveDeclarationsResponse,
      DistrictEmergencyConsoleListActiveDeclarationsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    DistrictEmergencyConsoleListActiveDeclarationsResponse,
    DistrictEmergencyConsoleListActiveDeclarationsError,
    TData
  >({
    ...districtEmergencyConsoleListActiveDeclarationsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useDistrictEmergencyConsoleListActiveDeclarations = <
  TData = DistrictEmergencyConsoleListActiveDeclarationsResponse,
>(
  variables: DistrictEmergencyConsoleListActiveDeclarationsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      DistrictEmergencyConsoleListActiveDeclarationsResponse,
      DistrictEmergencyConsoleListActiveDeclarationsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    DistrictEmergencyConsoleListActiveDeclarationsResponse,
    DistrictEmergencyConsoleListActiveDeclarationsError,
    TData
  >({
    ...districtEmergencyConsoleListActiveDeclarationsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type EmailBulkEmailUsersError = Fetcher.ErrorWrapper<undefined>;

export type EmailBulkEmailUsersVariables = {
  body?: Schemas.BulkEmailDto;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEmailBulkEmailUsers = (variables: EmailBulkEmailUsersVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EmailBulkEmailUsersError, Schemas.BulkEmailDto, {}, {}, {}>({
    method: "post",
    url: "/api/v1/email/bulk",
    ...variables,
    signal,
  });

export const useEmailBulkEmailUsers = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EmailBulkEmailUsersError, EmailBulkEmailUsersVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EmailBulkEmailUsersError, EmailBulkEmailUsersVariables>({
    mutationFn: (variables: EmailBulkEmailUsersVariables) =>
      fetchEmailBulkEmailUsers(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type EndToEndSeedDatabaseError = Fetcher.ErrorWrapper<undefined>;

export type EndToEndSeedDatabaseVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchEndToEndSeedDatabase = (variables: EndToEndSeedDatabaseVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<Schemas.SeedDbResult, EndToEndSeedDatabaseError, undefined, {}, {}, {}>({
    method: "post",
    url: "/api/v1/e2e/seed-db",
    ...variables,
    signal,
  });

export const useEndToEndSeedDatabase = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.SeedDbResult, EndToEndSeedDatabaseError, EndToEndSeedDatabaseVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<Schemas.SeedDbResult, EndToEndSeedDatabaseError, EndToEndSeedDatabaseVariables>({
    mutationFn: (variables: EndToEndSeedDatabaseVariables) =>
      fetchEndToEndSeedDatabase(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EndToEndSeedEmergencyQueryParams {
  /**
   * @format int32
   * @default 1
   */
  count?: number;
}

export type EndToEndSeedEmergencyError = Fetcher.ErrorWrapper<undefined>;

export type EndToEndSeedEmergencyVariables = {
  queryParams?: EndToEndSeedEmergencyQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEndToEndSeedEmergency = (variables: EndToEndSeedEmergencyVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.SeedEmergencyResult,
    EndToEndSeedEmergencyError,
    undefined,
    {},
    EndToEndSeedEmergencyQueryParams,
    {}
  >({ method: "post", url: "/api/v1/e2e/seed-emergency", ...variables, signal });

export const useEndToEndSeedEmergency = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SeedEmergencyResult,
      EndToEndSeedEmergencyError,
      EndToEndSeedEmergencyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.SeedEmergencyResult,
    EndToEndSeedEmergencyError,
    EndToEndSeedEmergencyVariables
  >({
    mutationFn: (variables: EndToEndSeedEmergencyVariables) =>
      fetchEndToEndSeedEmergency(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventGetEventPathParams {
  /**
   * Required, non-null
   *
   * @format uuid
   */
  eventId: string;
}

export type EventGetEventError = Fetcher.ErrorWrapper<undefined>;

export type EventGetEventVariables = {
  pathParams: EventGetEventPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventGetEvent = (variables: EventGetEventVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventGetEventError, undefined, {}, {}, EventGetEventPathParams>({
    method: "get",
    url: "/api/v1/event/{eventId}",
    ...variables,
    signal,
  });

export function eventGetEventQuery(variables: EventGetEventVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function eventGetEventQuery(variables: EventGetEventVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function eventGetEventQuery(variables: EventGetEventVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchEventGetEvent(variables, signal),
    queryKey: queryKeyFn({
      operationId: "eventGetEvent",
      path: "/api/v1/event/{eventId}",
      variables,
    }),
  };
}

export const useSuspenseEventGetEvent = <TData = undefined>(
  variables: EventGetEventVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, EventGetEventError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, EventGetEventError, TData>({
    ...eventGetEventQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useEventGetEvent = <TData = undefined>(
  variables: EventGetEventVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, EventGetEventError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, EventGetEventError, TData>({
    ...eventGetEventQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface EventDeleteEventPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  eventId: string;
}

export type EventDeleteEventError = Fetcher.ErrorWrapper<undefined>;

export type EventDeleteEventVariables = {
  pathParams: EventDeleteEventPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventDeleteEvent = (variables: EventDeleteEventVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventDeleteEventError, undefined, {}, {}, EventDeleteEventPathParams>({
    method: "delete",
    url: "/api/v1/event/{eventId}",
    ...variables,
    signal,
  });

export const useEventDeleteEvent = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventDeleteEventError, EventDeleteEventVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventDeleteEventError, EventDeleteEventVariables>({
    mutationFn: (variables: EventDeleteEventVariables) => fetchEventDeleteEvent(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventUpdateEventPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  eventId: string;
}

export type EventUpdateEventError = Fetcher.ErrorWrapper<undefined>;

export type EventUpdateEventVariables = {
  body: Schemas.UpdateEventRequest;
  pathParams: EventUpdateEventPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventUpdateEvent = (variables: EventUpdateEventVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.EventDto,
    EventUpdateEventError,
    Schemas.UpdateEventRequest,
    {},
    {},
    EventUpdateEventPathParams
  >({ method: "post", url: "/api/v1/event/{eventId}/update", ...variables, signal });

export const useEventUpdateEvent = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.EventDto, EventUpdateEventError, EventUpdateEventVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<Schemas.EventDto, EventUpdateEventError, EventUpdateEventVariables>({
    mutationFn: (variables: EventUpdateEventVariables) => fetchEventUpdateEvent(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type EventCreateEventError = Fetcher.ErrorWrapper<undefined>;

export type EventCreateEventVariables = {
  body: Schemas.CreateEventRequest;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventCreateEvent = (variables: EventCreateEventVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<Schemas.EventDto, EventCreateEventError, Schemas.CreateEventRequest, {}, {}, {}>({
    method: "post",
    url: "/api/v1/event",
    ...variables,
    signal,
  });

export const useEventCreateEvent = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.EventDto, EventCreateEventError, EventCreateEventVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<Schemas.EventDto, EventCreateEventError, EventCreateEventVariables>({
    mutationFn: (variables: EventCreateEventVariables) => fetchEventCreateEvent(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventAddToEventPathParams {
  /**
   * @format uuid
   */
  eventId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type EventAddToEventError = Fetcher.ErrorWrapper<undefined>;

export type EventAddToEventVariables = {
  pathParams: EventAddToEventPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventAddToEvent = (variables: EventAddToEventVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventAddToEventError, undefined, {}, {}, EventAddToEventPathParams>({
    method: "post",
    url: "/api/v1/event/{eventId}/add/{userId}",
    ...variables,
    signal,
  });

export const useEventAddToEvent = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventAddToEventError, EventAddToEventVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventAddToEventError, EventAddToEventVariables>({
    mutationFn: (variables: EventAddToEventVariables) => fetchEventAddToEvent(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventGetMyEventsPathParams {
  /**
   * Required, non-default
   *
   * @format uuid
   */
  userId: string;
}

export type EventGetMyEventsError = Fetcher.ErrorWrapper<undefined>;

export type EventGetMyEventsResponse = Schemas.EventDto[];

export type EventGetMyEventsVariables = {
  pathParams: EventGetMyEventsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventGetMyEvents = (variables: EventGetMyEventsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<EventGetMyEventsResponse, EventGetMyEventsError, undefined, {}, {}, EventGetMyEventsPathParams>(
    { method: "get", url: "/api/v1/event/my-events/{userId}", ...variables, signal },
  );

export function eventGetMyEventsQuery(variables: EventGetMyEventsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<EventGetMyEventsResponse>;
};

export function eventGetMyEventsQuery(variables: EventGetMyEventsVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<EventGetMyEventsResponse>) | reactQuery.SkipToken;
};

export function eventGetMyEventsQuery(variables: EventGetMyEventsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchEventGetMyEvents(variables, signal),
    queryKey: queryKeyFn({
      operationId: "eventGetMyEvents",
      path: "/api/v1/event/my-events/{userId}",
      variables,
    }),
  };
}

export const useSuspenseEventGetMyEvents = <TData = EventGetMyEventsResponse>(
  variables: EventGetMyEventsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<EventGetMyEventsResponse, EventGetMyEventsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<EventGetMyEventsResponse, EventGetMyEventsError, TData>({
    ...eventGetMyEventsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useEventGetMyEvents = <TData = EventGetMyEventsResponse>(
  variables: EventGetMyEventsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<EventGetMyEventsResponse, EventGetMyEventsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<EventGetMyEventsResponse, EventGetMyEventsError, TData>({
    ...eventGetMyEventsQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface EventAddToEventByEmailPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  eventId: string;
}

export type EventAddToEventByEmailError = Fetcher.ErrorWrapper<undefined>;

export type EventAddToEventByEmailVariables = {
  body: Schemas.AddMemberRequest;
  pathParams: EventAddToEventByEmailPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventAddToEventByEmail = (variables: EventAddToEventByEmailVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    EventAddToEventByEmailError,
    Schemas.AddMemberRequest,
    {},
    {},
    EventAddToEventByEmailPathParams
  >({ method: "post", url: "/api/v1/event/{eventId}/add-member-by-email", ...variables, signal });

export const useEventAddToEventByEmail = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventAddToEventByEmailError, EventAddToEventByEmailVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventAddToEventByEmailError, EventAddToEventByEmailVariables>({
    mutationFn: (variables: EventAddToEventByEmailVariables) =>
      fetchEventAddToEventByEmail(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventRequestAddToEventPathParams {
  /**
   * @format uuid
   */
  eventId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type EventRequestAddToEventError = Fetcher.ErrorWrapper<undefined>;

export type EventRequestAddToEventVariables = {
  pathParams: EventRequestAddToEventPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventRequestAddToEvent = (variables: EventRequestAddToEventVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventRequestAddToEventError, undefined, {}, {}, EventRequestAddToEventPathParams>({
    method: "post",
    url: "/api/v1/event/{eventId}/request/{userId}",
    ...variables,
    signal,
  });

export const useEventRequestAddToEvent = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventRequestAddToEventError, EventRequestAddToEventVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventRequestAddToEventError, EventRequestAddToEventVariables>({
    mutationFn: (variables: EventRequestAddToEventVariables) =>
      fetchEventRequestAddToEvent(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventCancelRequestAddToEventPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  eventId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type EventCancelRequestAddToEventError = Fetcher.ErrorWrapper<undefined>;

export type EventCancelRequestAddToEventVariables = {
  pathParams: EventCancelRequestAddToEventPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventCancelRequestAddToEvent = (
  variables: EventCancelRequestAddToEventVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    EventCancelRequestAddToEventError,
    undefined,
    {},
    {},
    EventCancelRequestAddToEventPathParams
  >({ method: "delete", url: "/api/v1/event/{eventId}/request/{userId}", ...variables, signal });

export const useEventCancelRequestAddToEvent = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventCancelRequestAddToEventError, EventCancelRequestAddToEventVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventCancelRequestAddToEventError, EventCancelRequestAddToEventVariables>({
    mutationFn: (variables: EventCancelRequestAddToEventVariables) =>
      fetchEventCancelRequestAddToEvent(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventCreateMeetingTimePathParams {
  eventId: string;
}

export type EventCreateMeetingTimeError = Fetcher.ErrorWrapper<undefined>;

export type EventCreateMeetingTimeVariables = {
  body?: Schemas.CreateMeetingTimeRequest;
  pathParams: EventCreateMeetingTimePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventCreateMeetingTime = (variables: EventCreateMeetingTimeVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    EventCreateMeetingTimeError,
    Schemas.CreateMeetingTimeRequest,
    {},
    {},
    EventCreateMeetingTimePathParams
  >({ method: "post", url: "/api/v1/event/{eventId}/meeting-time", ...variables, signal });

export const useEventCreateMeetingTime = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventCreateMeetingTimeError, EventCreateMeetingTimeVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventCreateMeetingTimeError, EventCreateMeetingTimeVariables>({
    mutationFn: (variables: EventCreateMeetingTimeVariables) =>
      fetchEventCreateMeetingTime(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventBulkCreateEventTimesPathParams {
  /**
   * @format uuid
   */
  eventId: string;
}

export type EventBulkCreateEventTimesError = Fetcher.ErrorWrapper<undefined>;

export type EventBulkCreateEventTimesVariables = {
  body?: Schemas.CreateEventTimesRequest;
  pathParams: EventBulkCreateEventTimesPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventBulkCreateEventTimes = (variables: EventBulkCreateEventTimesVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    EventBulkCreateEventTimesError,
    Schemas.CreateEventTimesRequest,
    {},
    {},
    EventBulkCreateEventTimesPathParams
  >({ method: "post", url: "/api/v1/event/{eventId}/event-times/bulk", ...variables, signal });

export const useEventBulkCreateEventTimes = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventBulkCreateEventTimesError, EventBulkCreateEventTimesVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventBulkCreateEventTimesError, EventBulkCreateEventTimesVariables>({
    mutationFn: (variables: EventBulkCreateEventTimesVariables) =>
      fetchEventBulkCreateEventTimes(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventDenyRequestPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  eventId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type EventDenyRequestError = Fetcher.ErrorWrapper<undefined>;

export type EventDenyRequestVariables = {
  pathParams: EventDenyRequestPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventDenyRequest = (variables: EventDenyRequestVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventDenyRequestError, undefined, {}, {}, EventDenyRequestPathParams>({
    method: "post",
    url: "/api/v1/event/{eventId}/request/{userId}/deny",
    ...variables,
    signal,
  });

export const useEventDenyRequest = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventDenyRequestError, EventDenyRequestVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventDenyRequestError, EventDenyRequestVariables>({
    mutationFn: (variables: EventDenyRequestVariables) => fetchEventDenyRequest(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventRemoveFromEventPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  eventId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type EventRemoveFromEventError = Fetcher.ErrorWrapper<undefined>;

export type EventRemoveFromEventVariables = {
  pathParams: EventRemoveFromEventPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventRemoveFromEvent = (variables: EventRemoveFromEventVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventRemoveFromEventError, undefined, {}, {}, EventRemoveFromEventPathParams>({
    method: "post",
    url: "/api/v1/event/{eventId}/remove/{userId}",
    ...variables,
    signal,
  });

export const useEventRemoveFromEvent = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventRemoveFromEventError, EventRemoveFromEventVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventRemoveFromEventError, EventRemoveFromEventVariables>({
    mutationFn: (variables: EventRemoveFromEventVariables) =>
      fetchEventRemoveFromEvent(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventLeaveEventPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  eventId: string;
}

export type EventLeaveEventError = Fetcher.ErrorWrapper<undefined>;

export type EventLeaveEventVariables = {
  pathParams: EventLeaveEventPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventLeaveEvent = (variables: EventLeaveEventVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventLeaveEventError, undefined, {}, {}, EventLeaveEventPathParams>({
    method: "post",
    url: "/api/v1/event/{eventId}/leave",
    ...variables,
    signal,
  });

export const useEventLeaveEvent = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventLeaveEventError, EventLeaveEventVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventLeaveEventError, EventLeaveEventVariables>({
    mutationFn: (variables: EventLeaveEventVariables) => fetchEventLeaveEvent(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventDeleteMeetingTimePathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  eventId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  meetingId: string;
}

export type EventDeleteMeetingTimeError = Fetcher.ErrorWrapper<undefined>;

export type EventDeleteMeetingTimeVariables = {
  pathParams: EventDeleteMeetingTimePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventDeleteMeetingTime = (variables: EventDeleteMeetingTimeVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventDeleteMeetingTimeError, undefined, {}, {}, EventDeleteMeetingTimePathParams>({
    method: "delete",
    url: "/api/v1/event/{eventId}/meeting-time/{meetingId}",
    ...variables,
    signal,
  });

export const useEventDeleteMeetingTime = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventDeleteMeetingTimeError, EventDeleteMeetingTimeVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventDeleteMeetingTimeError, EventDeleteMeetingTimeVariables>({
    mutationFn: (variables: EventDeleteMeetingTimeVariables) =>
      fetchEventDeleteMeetingTime(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventUpdateMeetingTimePathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  meetingId: string;
  eventId: string;
}

export type EventUpdateMeetingTimeError = Fetcher.ErrorWrapper<undefined>;

export type EventUpdateMeetingTimeVariables = {
  body: Schemas.UpdateMeetingTimeDto;
  pathParams: EventUpdateMeetingTimePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventUpdateMeetingTime = (variables: EventUpdateMeetingTimeVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    EventUpdateMeetingTimeError,
    Schemas.UpdateMeetingTimeDto,
    {},
    {},
    EventUpdateMeetingTimePathParams
  >({ method: "post", url: "/api/v1/event/{eventId}/meeting-time/{meetingId}", ...variables, signal });

export const useEventUpdateMeetingTime = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventUpdateMeetingTimeError, EventUpdateMeetingTimeVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventUpdateMeetingTimeError, EventUpdateMeetingTimeVariables>({
    mutationFn: (variables: EventUpdateMeetingTimeVariables) =>
      fetchEventUpdateMeetingTime(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventAddRsvpPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  meetingId: string;
  eventId: string;
}

export type EventAddRsvpError = Fetcher.ErrorWrapper<undefined>;

export type EventAddRsvpVariables = {
  pathParams: EventAddRsvpPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventAddRsvp = (variables: EventAddRsvpVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventAddRsvpError, undefined, {}, {}, EventAddRsvpPathParams>({
    method: "post",
    url: "/api/v1/event/{eventId}/meeting-time/{meetingId}/rsvp",
    ...variables,
    signal,
  });

export const useEventAddRsvp = (
  options?: Omit<reactQuery.UseMutationOptions<undefined, EventAddRsvpError, EventAddRsvpVariables>, "mutationFn">,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventAddRsvpError, EventAddRsvpVariables>({
    mutationFn: (variables: EventAddRsvpVariables) => fetchEventAddRsvp(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventRemoveRsvpPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  meetingId: string;
  eventId: string;
}

export type EventRemoveRsvpError = Fetcher.ErrorWrapper<undefined>;

export type EventRemoveRsvpVariables = {
  pathParams: EventRemoveRsvpPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventRemoveRsvp = (variables: EventRemoveRsvpVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventRemoveRsvpError, undefined, {}, {}, EventRemoveRsvpPathParams>({
    method: "delete",
    url: "/api/v1/event/{eventId}/meeting-time/{meetingId}/rsvp",
    ...variables,
    signal,
  });

export const useEventRemoveRsvp = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventRemoveRsvpError, EventRemoveRsvpVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventRemoveRsvpError, EventRemoveRsvpVariables>({
    mutationFn: (variables: EventRemoveRsvpVariables) => fetchEventRemoveRsvp(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventMarkUserAsNoShowPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  meetingId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
  eventId: string;
}

export type EventMarkUserAsNoShowError = Fetcher.ErrorWrapper<undefined>;

export type EventMarkUserAsNoShowVariables = {
  pathParams: EventMarkUserAsNoShowPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventMarkUserAsNoShow = (variables: EventMarkUserAsNoShowVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventMarkUserAsNoShowError, undefined, {}, {}, EventMarkUserAsNoShowPathParams>({
    method: "post",
    url: "/api/v1/event/{eventId}/meeting-time/{meetingId}/user/{userId}/no-show",
    ...variables,
    signal,
  });

export const useEventMarkUserAsNoShow = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventMarkUserAsNoShowError, EventMarkUserAsNoShowVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventMarkUserAsNoShowError, EventMarkUserAsNoShowVariables>({
    mutationFn: (variables: EventMarkUserAsNoShowVariables) =>
      fetchEventMarkUserAsNoShow(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventRemoveNoShowMarkPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  meetingId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
  eventId: string;
}

export type EventRemoveNoShowMarkError = Fetcher.ErrorWrapper<undefined>;

export type EventRemoveNoShowMarkVariables = {
  pathParams: EventRemoveNoShowMarkPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventRemoveNoShowMark = (variables: EventRemoveNoShowMarkVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventRemoveNoShowMarkError, undefined, {}, {}, EventRemoveNoShowMarkPathParams>({
    method: "delete",
    url: "/api/v1/event/{eventId}/meeting-time/{meetingId}/user/{userId}/no-show",
    ...variables,
    signal,
  });

export const useEventRemoveNoShowMark = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventRemoveNoShowMarkError, EventRemoveNoShowMarkVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventRemoveNoShowMarkError, EventRemoveNoShowMarkVariables>({
    mutationFn: (variables: EventRemoveNoShowMarkVariables) =>
      fetchEventRemoveNoShowMark(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventAddResourcePathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  eventId: string;
}

export type EventAddResourceError = Fetcher.ErrorWrapper<undefined>;

export type EventAddResourceVariables = {
  body: Schemas.ResourceDto;
  pathParams: EventAddResourcePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventAddResource = (variables: EventAddResourceVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<string, EventAddResourceError, Schemas.ResourceDto, {}, {}, EventAddResourcePathParams>({
    method: "post",
    url: "/api/v1/event/{eventId}/resource",
    ...variables,
    signal,
  });

export const useEventAddResource = (
  options?: Omit<reactQuery.UseMutationOptions<string, EventAddResourceError, EventAddResourceVariables>, "mutationFn">,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<string, EventAddResourceError, EventAddResourceVariables>({
    mutationFn: (variables: EventAddResourceVariables) => fetchEventAddResource(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventRemoveResourcePathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  eventId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  resourceId: string;
}

export type EventRemoveResourceError = Fetcher.ErrorWrapper<undefined>;

export type EventRemoveResourceVariables = {
  pathParams: EventRemoveResourcePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventRemoveResource = (variables: EventRemoveResourceVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventRemoveResourceError, undefined, {}, {}, EventRemoveResourcePathParams>({
    method: "delete",
    url: "/api/v1/event/{eventId}/resource/{resourceId}",
    ...variables,
    signal,
  });

export const useEventRemoveResource = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventRemoveResourceError, EventRemoveResourceVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventRemoveResourceError, EventRemoveResourceVariables>({
    mutationFn: (variables: EventRemoveResourceVariables) =>
      fetchEventRemoveResource(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventAddFacilitatorPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  eventId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type EventAddFacilitatorError = Fetcher.ErrorWrapper<undefined>;

export type EventAddFacilitatorVariables = {
  pathParams: EventAddFacilitatorPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventAddFacilitator = (variables: EventAddFacilitatorVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventAddFacilitatorError, undefined, {}, {}, EventAddFacilitatorPathParams>({
    method: "post",
    url: "/api/v1/event/{eventId}/facilitator/{userId}",
    ...variables,
    signal,
  });

export const useEventAddFacilitator = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventAddFacilitatorError, EventAddFacilitatorVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventAddFacilitatorError, EventAddFacilitatorVariables>({
    mutationFn: (variables: EventAddFacilitatorVariables) =>
      fetchEventAddFacilitator(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventDeleteFacilitatorPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  eventId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type EventDeleteFacilitatorError = Fetcher.ErrorWrapper<undefined>;

export type EventDeleteFacilitatorVariables = {
  pathParams: EventDeleteFacilitatorPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventDeleteFacilitator = (variables: EventDeleteFacilitatorVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventDeleteFacilitatorError, undefined, {}, {}, EventDeleteFacilitatorPathParams>({
    method: "delete",
    url: "/api/v1/event/{eventId}/facilitator/{userId}",
    ...variables,
    signal,
  });

export const useEventDeleteFacilitator = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventDeleteFacilitatorError, EventDeleteFacilitatorVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventDeleteFacilitatorError, EventDeleteFacilitatorVariables>({
    mutationFn: (variables: EventDeleteFacilitatorVariables) =>
      fetchEventDeleteFacilitator(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventCreateEventMilestonePathParams {
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  eventId: string;
}

export type EventCreateEventMilestoneError = Fetcher.ErrorWrapper<undefined>;

export type EventCreateEventMilestoneVariables = {
  body: Schemas.CreateEventMilestoneRequest;
  pathParams: EventCreateEventMilestonePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventCreateEventMilestone = (variables: EventCreateEventMilestoneVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    string,
    EventCreateEventMilestoneError,
    Schemas.CreateEventMilestoneRequest,
    {},
    {},
    EventCreateEventMilestonePathParams
  >({ method: "post", url: "/api/v1/event/{eventId}/milestones", ...variables, signal });

export const useEventCreateEventMilestone = (
  options?: Omit<
    reactQuery.UseMutationOptions<string, EventCreateEventMilestoneError, EventCreateEventMilestoneVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<string, EventCreateEventMilestoneError, EventCreateEventMilestoneVariables>({
    mutationFn: (variables: EventCreateEventMilestoneVariables) =>
      fetchEventCreateEventMilestone(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventDeleteEventMilestonePathParams {
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  eventId: string;
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  milestoneId: string;
}

export type EventDeleteEventMilestoneError = Fetcher.ErrorWrapper<undefined>;

export type EventDeleteEventMilestoneVariables = {
  pathParams: EventDeleteEventMilestonePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventDeleteEventMilestone = (variables: EventDeleteEventMilestoneVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    EventDeleteEventMilestoneError,
    undefined,
    {},
    {},
    EventDeleteEventMilestonePathParams
  >({ method: "post", url: "/api/v1/event/{eventId}/milestones/{milestoneId}", ...variables, signal });

export const useEventDeleteEventMilestone = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventDeleteEventMilestoneError, EventDeleteEventMilestoneVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventDeleteEventMilestoneError, EventDeleteEventMilestoneVariables>({
    mutationFn: (variables: EventDeleteEventMilestoneVariables) =>
      fetchEventDeleteEventMilestone(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventCreateEventTaskPathParams {
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  eventId: string;
}

export type EventCreateEventTaskError = Fetcher.ErrorWrapper<undefined>;

export type EventCreateEventTaskVariables = {
  body: Schemas.CreateEventTaskRequest;
  pathParams: EventCreateEventTaskPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventCreateEventTask = (variables: EventCreateEventTaskVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    string,
    EventCreateEventTaskError,
    Schemas.CreateEventTaskRequest,
    {},
    {},
    EventCreateEventTaskPathParams
  >({ method: "post", url: "/api/v1/event/{eventId}/tasks", ...variables, signal });

export const useEventCreateEventTask = (
  options?: Omit<
    reactQuery.UseMutationOptions<string, EventCreateEventTaskError, EventCreateEventTaskVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<string, EventCreateEventTaskError, EventCreateEventTaskVariables>({
    mutationFn: (variables: EventCreateEventTaskVariables) =>
      fetchEventCreateEventTask(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventDeleteEventTaskPathParams {
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  eventId: string;
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  taskId: string;
}

export type EventDeleteEventTaskError = Fetcher.ErrorWrapper<undefined>;

export type EventDeleteEventTaskVariables = {
  pathParams: EventDeleteEventTaskPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventDeleteEventTask = (variables: EventDeleteEventTaskVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventDeleteEventTaskError, undefined, {}, {}, EventDeleteEventTaskPathParams>({
    method: "post",
    url: "/api/v1/event/{eventId}/tasks/{taskId}",
    ...variables,
    signal,
  });

export const useEventDeleteEventTask = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventDeleteEventTaskError, EventDeleteEventTaskVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventDeleteEventTaskError, EventDeleteEventTaskVariables>({
    mutationFn: (variables: EventDeleteEventTaskVariables) =>
      fetchEventDeleteEventTask(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventGetEventCheckInQrCodePathParams {
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  eventId: string;
}

export type EventGetEventCheckInQrCodeError = Fetcher.ErrorWrapper<undefined>;

export type EventGetEventCheckInQrCodeVariables = {
  pathParams: EventGetEventCheckInQrCodePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventGetEventCheckInQrCode = (variables: EventGetEventCheckInQrCodeVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    string,
    EventGetEventCheckInQrCodeError,
    undefined,
    {},
    {},
    EventGetEventCheckInQrCodePathParams
  >({ method: "get", url: "/api/v1/event/{eventId}/check-in.svg", ...variables, signal });

export function eventGetEventCheckInQrCodeQuery(variables: EventGetEventCheckInQrCodeVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<string>;
};

export function eventGetEventCheckInQrCodeQuery(
  variables: EventGetEventCheckInQrCodeVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<string>) | reactQuery.SkipToken;
};

export function eventGetEventCheckInQrCodeQuery(variables: EventGetEventCheckInQrCodeVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchEventGetEventCheckInQrCode(variables, signal),
    queryKey: queryKeyFn({
      operationId: "eventGetEventCheckInQrCode",
      path: "/api/v1/event/{eventId}/check-in.svg",
      variables,
    }),
  };
}

export const useSuspenseEventGetEventCheckInQrCode = <TData = string>(
  variables: EventGetEventCheckInQrCodeVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<string, EventGetEventCheckInQrCodeError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<string, EventGetEventCheckInQrCodeError, TData>({
    ...eventGetEventCheckInQrCodeQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useEventGetEventCheckInQrCode = <TData = string>(
  variables: EventGetEventCheckInQrCodeVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<string, EventGetEventCheckInQrCodeError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<string, EventGetEventCheckInQrCodeError, TData>({
    ...eventGetEventCheckInQrCodeQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface EventEventCheckInPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  eventId: string;
}

export type EventEventCheckInError = Fetcher.ErrorWrapper<undefined>;

export type EventEventCheckInVariables = {
  pathParams: EventEventCheckInPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventEventCheckIn = (variables: EventEventCheckInVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventEventCheckInError, undefined, {}, {}, EventEventCheckInPathParams>({
    method: "post",
    url: "/api/v1/event/{eventId}/check-in",
    ...variables,
    signal,
  });

export const useEventEventCheckIn = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventEventCheckInError, EventEventCheckInVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventEventCheckInError, EventEventCheckInVariables>({
    mutationFn: (variables: EventEventCheckInVariables) => fetchEventEventCheckIn(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventEventCheckInByIdentifierPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  eventId: string;
  /**
   * Required, non-empty
   */
  identifier: string;
}

export type EventEventCheckInByIdentifierError = Fetcher.ErrorWrapper<undefined>;

export type EventEventCheckInByIdentifierVariables = {
  pathParams: EventEventCheckInByIdentifierPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventEventCheckInByIdentifier = (
  variables: EventEventCheckInByIdentifierVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    EventEventCheckInByIdentifierError,
    undefined,
    {},
    {},
    EventEventCheckInByIdentifierPathParams
  >({ method: "post", url: "/api/v1/event/{eventId}/check-in/{identifier}", ...variables, signal });

export const useEventEventCheckInByIdentifier = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      EventEventCheckInByIdentifierError,
      EventEventCheckInByIdentifierVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventEventCheckInByIdentifierError, EventEventCheckInByIdentifierVariables>({
    mutationFn: (variables: EventEventCheckInByIdentifierVariables) =>
      fetchEventEventCheckInByIdentifier(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventUploadEventPicturePathParams {
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  eventId: string;
}

export type EventUploadEventPictureError = Fetcher.ErrorWrapper<undefined>;

export interface EventUploadEventPictureRequestBody {
  /**
   * @format binary
   */
  FormFile?: Blob;
}

export type EventUploadEventPictureVariables = {
  body?: EventUploadEventPictureRequestBody;
  pathParams: EventUploadEventPicturePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventUploadEventPicture = (variables: EventUploadEventPictureVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    EventUploadEventPictureError,
    EventUploadEventPictureRequestBody,
    {},
    {},
    EventUploadEventPicturePathParams
  >({ method: "put", url: "/api/v1/event/{eventId}/picture", ...variables, signal });

export const useEventUploadEventPicture = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventUploadEventPictureError, EventUploadEventPictureVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventUploadEventPictureError, EventUploadEventPictureVariables>({
    mutationFn: (variables: EventUploadEventPictureVariables) =>
      fetchEventUploadEventPicture(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventGetEventPicturePathParams {
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  eventId: string;
}

export type EventGetEventPictureError = Fetcher.ErrorWrapper<undefined>;

export type EventGetEventPictureVariables = {
  pathParams: EventGetEventPicturePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventGetEventPicture = (variables: EventGetEventPictureVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventGetEventPictureError, undefined, {}, {}, EventGetEventPicturePathParams>({
    method: "get",
    url: "/api/v1/event/{eventId}/picture",
    ...variables,
    signal,
  });

export function eventGetEventPictureQuery(variables: EventGetEventPictureVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function eventGetEventPictureQuery(variables: EventGetEventPictureVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function eventGetEventPictureQuery(variables: EventGetEventPictureVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchEventGetEventPicture(variables, signal),
    queryKey: queryKeyFn({
      operationId: "eventGetEventPicture",
      path: "/api/v1/event/{eventId}/picture",
      variables,
    }),
  };
}

export const useSuspenseEventGetEventPicture = <TData = undefined>(
  variables: EventGetEventPictureVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, EventGetEventPictureError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, EventGetEventPictureError, TData>({
    ...eventGetEventPictureQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useEventGetEventPicture = <TData = undefined>(
  variables: EventGetEventPictureVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, EventGetEventPictureError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, EventGetEventPictureError, TData>({
    ...eventGetEventPictureQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface EventChangeOwnershipPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  eventId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type EventChangeOwnershipError = Fetcher.ErrorWrapper<undefined>;

export type EventChangeOwnershipVariables = {
  pathParams: EventChangeOwnershipPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventChangeOwnership = (variables: EventChangeOwnershipVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventChangeOwnershipError, undefined, {}, {}, EventChangeOwnershipPathParams>({
    method: "post",
    url: "/api/v1/event/{eventId}/owner/{userId}",
    ...variables,
    signal,
  });

export const useEventChangeOwnership = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventChangeOwnershipError, EventChangeOwnershipVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventChangeOwnershipError, EventChangeOwnershipVariables>({
    mutationFn: (variables: EventChangeOwnershipVariables) =>
      fetchEventChangeOwnership(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventUpdateEventRulesPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  eventId: string;
}

export type EventUpdateEventRulesError = Fetcher.ErrorWrapper<undefined>;

export type EventUpdateEventRulesVariables = {
  body?: Schemas.UpdateEventRulesDto;
  pathParams: EventUpdateEventRulesPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventUpdateEventRules = (variables: EventUpdateEventRulesVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    EventUpdateEventRulesError,
    Schemas.UpdateEventRulesDto,
    {},
    {},
    EventUpdateEventRulesPathParams
  >({ method: "post", url: "/api/v1/event/{eventId}/rules", ...variables, signal });

export const useEventUpdateEventRules = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventUpdateEventRulesError, EventUpdateEventRulesVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventUpdateEventRulesError, EventUpdateEventRulesVariables>({
    mutationFn: (variables: EventUpdateEventRulesVariables) =>
      fetchEventUpdateEventRules(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventCreateMeetingTimeSeriesPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  eventId: string;
}

export type EventCreateMeetingTimeSeriesError = Fetcher.ErrorWrapper<undefined>;

export type EventCreateMeetingTimeSeriesVariables = {
  body?: Schemas.CreateMeetingTimeSeriesRequest;
  pathParams: EventCreateMeetingTimeSeriesPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventCreateMeetingTimeSeries = (
  variables: EventCreateMeetingTimeSeriesVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    EventCreateMeetingTimeSeriesError,
    Schemas.CreateMeetingTimeSeriesRequest,
    {},
    {},
    EventCreateMeetingTimeSeriesPathParams
  >({ method: "post", url: "/api/v1/event/{eventId}/meeting-time-series", ...variables, signal });

export const useEventCreateMeetingTimeSeries = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventCreateMeetingTimeSeriesError, EventCreateMeetingTimeSeriesVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventCreateMeetingTimeSeriesError, EventCreateMeetingTimeSeriesVariables>({
    mutationFn: (variables: EventCreateMeetingTimeSeriesVariables) =>
      fetchEventCreateMeetingTimeSeries(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventDeleteMeetingTimeSeriesPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  meetingTimeSeriesId: string;
  eventId: string;
}

export type EventDeleteMeetingTimeSeriesError = Fetcher.ErrorWrapper<undefined>;

export type EventDeleteMeetingTimeSeriesVariables = {
  pathParams: EventDeleteMeetingTimeSeriesPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventDeleteMeetingTimeSeries = (
  variables: EventDeleteMeetingTimeSeriesVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    EventDeleteMeetingTimeSeriesError,
    undefined,
    {},
    {},
    EventDeleteMeetingTimeSeriesPathParams
  >({ method: "post", url: "/api/v1/event/{eventId}/meeting-time-series/{meetingTimeSeriesId}", ...variables, signal });

export const useEventDeleteMeetingTimeSeries = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventDeleteMeetingTimeSeriesError, EventDeleteMeetingTimeSeriesVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventDeleteMeetingTimeSeriesError, EventDeleteMeetingTimeSeriesVariables>({
    mutationFn: (variables: EventDeleteMeetingTimeSeriesVariables) =>
      fetchEventDeleteMeetingTimeSeries(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface EventDeleteMeetingTimeSeriesAndMeetingTimesPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  meetingTimeSeriesId: string;
  eventId: string;
}

export type EventDeleteMeetingTimeSeriesAndMeetingTimesError = Fetcher.ErrorWrapper<undefined>;

export type EventDeleteMeetingTimeSeriesAndMeetingTimesVariables = {
  pathParams: EventDeleteMeetingTimeSeriesAndMeetingTimesPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventDeleteMeetingTimeSeriesAndMeetingTimes = (
  variables: EventDeleteMeetingTimeSeriesAndMeetingTimesVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    EventDeleteMeetingTimeSeriesAndMeetingTimesError,
    undefined,
    {},
    {},
    EventDeleteMeetingTimeSeriesAndMeetingTimesPathParams
  >({
    method: "post",
    url: "/api/v1/event/{eventId}/meeting-time-series/{meetingTimeSeriesId}/cascade",
    ...variables,
    signal,
  });

export const useEventDeleteMeetingTimeSeriesAndMeetingTimes = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      EventDeleteMeetingTimeSeriesAndMeetingTimesError,
      EventDeleteMeetingTimeSeriesAndMeetingTimesVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    EventDeleteMeetingTimeSeriesAndMeetingTimesError,
    EventDeleteMeetingTimeSeriesAndMeetingTimesVariables
  >({
    mutationFn: (variables: EventDeleteMeetingTimeSeriesAndMeetingTimesVariables) =>
      fetchEventDeleteMeetingTimeSeriesAndMeetingTimes(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type EventBulkUnrsvpError = Fetcher.ErrorWrapper<undefined>;

export type EventBulkUnrsvpVariables = {
  body?: Schemas.BulkUnrsvpDto;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchEventBulkUnrsvp = (variables: EventBulkUnrsvpVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, EventBulkUnrsvpError, Schemas.BulkUnrsvpDto, {}, {}, {}>({
    method: "post",
    url: "/api/v1/event/bulk-unrsvp",
    ...variables,
    signal,
  });

export const useEventBulkUnrsvp = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, EventBulkUnrsvpError, EventBulkUnrsvpVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, EventBulkUnrsvpError, EventBulkUnrsvpVariables>({
    mutationFn: (variables: EventBulkUnrsvpVariables) => fetchEventBulkUnrsvp(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type LoginSendAuthCodeError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: Schemas.ProblemDetails;
}>;

export type LoginSendAuthCodeVariables = {
  body?: Schemas.LoginRequest;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchLoginSendAuthCode = (variables: LoginSendAuthCodeVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, LoginSendAuthCodeError, Schemas.LoginRequest, {}, {}, {}>({
    method: "post",
    url: "/api/v1/Login",
    ...variables,
    signal,
  });

export const useLoginSendAuthCode = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, LoginSendAuthCodeError, LoginSendAuthCodeVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, LoginSendAuthCodeError, LoginSendAuthCodeVariables>({
    mutationFn: (variables: LoginSendAuthCodeVariables) => fetchLoginSendAuthCode(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type LoginResendAuthCodeError = Fetcher.ErrorWrapper<{
  status: 400;
  payload: Schemas.ProblemDetails;
}>;

export type LoginResendAuthCodeVariables = {
  body?: Schemas.LoginRequest;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchLoginResendAuthCode = (variables: LoginResendAuthCodeVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, LoginResendAuthCodeError, Schemas.LoginRequest, {}, {}, {}>({
    method: "post",
    url: "/api/v1/Login/resend",
    ...variables,
    signal,
  });

export const useLoginResendAuthCode = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, LoginResendAuthCodeError, LoginResendAuthCodeVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, LoginResendAuthCodeError, LoginResendAuthCodeVariables>({
    mutationFn: (variables: LoginResendAuthCodeVariables) =>
      fetchLoginResendAuthCode(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type LoginVerifyAuthenticationError = Fetcher.ErrorWrapper<undefined>;

export type LoginVerifyAuthenticationVariables = {
  body?: Schemas.VerifyLoginRequest;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchLoginVerifyAuthentication = (variables: LoginVerifyAuthenticationVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.VerificationDto,
    LoginVerifyAuthenticationError,
    Schemas.VerifyLoginRequest,
    {},
    {},
    {}
  >({ method: "post", url: "/api/v1/Login/verify", ...variables, signal });

export const useLoginVerifyAuthentication = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.VerificationDto,
      LoginVerifyAuthenticationError,
      LoginVerifyAuthenticationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.VerificationDto,
    LoginVerifyAuthenticationError,
    LoginVerifyAuthenticationVariables
  >({
    mutationFn: (variables: LoginVerifyAuthenticationVariables) =>
      fetchLoginVerifyAuthentication(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type LoginWhoAmIError = Fetcher.ErrorWrapper<undefined>;

export type LoginWhoAmIVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchLoginWhoAmI = (variables: LoginWhoAmIVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<Schemas.ProfileDto, LoginWhoAmIError, undefined, {}, {}, {}>({
    method: "get",
    url: "/api/v1/Login/whoami",
    ...variables,
    signal,
  });

export function loginWhoAmIQuery(variables: LoginWhoAmIVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ProfileDto>;
};

export function loginWhoAmIQuery(variables: LoginWhoAmIVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.ProfileDto>) | reactQuery.SkipToken;
};

export function loginWhoAmIQuery(variables: LoginWhoAmIVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchLoginWhoAmI(variables, signal),
    queryKey: queryKeyFn({
      operationId: "loginWhoAmI",
      path: "/api/v1/Login/whoami",
      variables,
    }),
  };
}

export const useSuspenseLoginWhoAmI = <TData = Schemas.ProfileDto>(
  variables: LoginWhoAmIVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ProfileDto, LoginWhoAmIError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.ProfileDto, LoginWhoAmIError, TData>({
    ...loginWhoAmIQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useLoginWhoAmI = <TData = Schemas.ProfileDto>(
  variables: LoginWhoAmIVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ProfileDto, LoginWhoAmIError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.ProfileDto, LoginWhoAmIError, TData>({
    ...loginWhoAmIQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface LoginGoogleStartQueryParams {
  returnUrl?: string;
}

export type LoginGoogleStartError = Fetcher.ErrorWrapper<undefined>;

export type LoginGoogleStartVariables = {
  queryParams?: LoginGoogleStartQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchLoginGoogleStart = (variables: LoginGoogleStartVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, LoginGoogleStartError, undefined, {}, LoginGoogleStartQueryParams, {}>({
    method: "get",
    url: "/api/v1/Login/google",
    ...variables,
    signal,
  });

export function loginGoogleStartQuery(variables: LoginGoogleStartVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function loginGoogleStartQuery(variables: LoginGoogleStartVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function loginGoogleStartQuery(variables: LoginGoogleStartVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchLoginGoogleStart(variables, signal),
    queryKey: queryKeyFn({
      operationId: "loginGoogleStart",
      path: "/api/v1/Login/google",
      variables,
    }),
  };
}

export const useSuspenseLoginGoogleStart = <TData = undefined>(
  variables: LoginGoogleStartVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, LoginGoogleStartError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, LoginGoogleStartError, TData>({
    ...loginGoogleStartQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useLoginGoogleStart = <TData = undefined>(
  variables: LoginGoogleStartVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, LoginGoogleStartError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, LoginGoogleStartError, TData>({
    ...loginGoogleStartQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface LoginGoogleCallbackQueryParams {
  returnUrl?: string;
}

export type LoginGoogleCallbackError = Fetcher.ErrorWrapper<undefined>;

export type LoginGoogleCallbackVariables = {
  queryParams?: LoginGoogleCallbackQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchLoginGoogleCallback = (variables: LoginGoogleCallbackVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, LoginGoogleCallbackError, undefined, {}, LoginGoogleCallbackQueryParams, {}>({
    method: "get",
    url: "/api/v1/Login/google/callback",
    ...variables,
    signal,
  });

export function loginGoogleCallbackQuery(variables: LoginGoogleCallbackVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function loginGoogleCallbackQuery(variables: LoginGoogleCallbackVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function loginGoogleCallbackQuery(variables: LoginGoogleCallbackVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchLoginGoogleCallback(variables, signal),
    queryKey: queryKeyFn({
      operationId: "loginGoogleCallback",
      path: "/api/v1/Login/google/callback",
      variables,
    }),
  };
}

export const useSuspenseLoginGoogleCallback = <TData = undefined>(
  variables: LoginGoogleCallbackVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, LoginGoogleCallbackError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, LoginGoogleCallbackError, TData>({
    ...loginGoogleCallbackQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useLoginGoogleCallback = <TData = undefined>(
  variables: LoginGoogleCallbackVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, LoginGoogleCallbackError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, LoginGoogleCallbackError, TData>({
    ...loginGoogleCallbackQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface LoginGoogleFinishQueryParams {
  returnUrl?: string;
}

export type LoginGoogleFinishError = Fetcher.ErrorWrapper<undefined>;

export type LoginGoogleFinishVariables = {
  queryParams?: LoginGoogleFinishQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchLoginGoogleFinish = (variables: LoginGoogleFinishVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, LoginGoogleFinishError, undefined, {}, LoginGoogleFinishQueryParams, {}>({
    method: "get",
    url: "/api/v1/Login/google/finish",
    ...variables,
    signal,
  });

export function loginGoogleFinishQuery(variables: LoginGoogleFinishVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function loginGoogleFinishQuery(variables: LoginGoogleFinishVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function loginGoogleFinishQuery(variables: LoginGoogleFinishVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchLoginGoogleFinish(variables, signal),
    queryKey: queryKeyFn({
      operationId: "loginGoogleFinish",
      path: "/api/v1/Login/google/finish",
      variables,
    }),
  };
}

export const useSuspenseLoginGoogleFinish = <TData = undefined>(
  variables: LoginGoogleFinishVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, LoginGoogleFinishError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, LoginGoogleFinishError, TData>({
    ...loginGoogleFinishQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useLoginGoogleFinish = <TData = undefined>(
  variables: LoginGoogleFinishVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, LoginGoogleFinishError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, LoginGoogleFinishError, TData>({
    ...loginGoogleFinishQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export type OrganizationCreateOrganizationError = Fetcher.ErrorWrapper<undefined>;

export type OrganizationCreateOrganizationVariables = {
  body?: Schemas.CreateOrganizationDto;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchOrganizationCreateOrganization = (
  variables: OrganizationCreateOrganizationVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<string, OrganizationCreateOrganizationError, Schemas.CreateOrganizationDto, {}, {}, {}>({
    method: "post",
    url: "/api/v1/Organization",
    ...variables,
    signal,
  });

export const useOrganizationCreateOrganization = (
  options?: Omit<
    reactQuery.UseMutationOptions<string, OrganizationCreateOrganizationError, OrganizationCreateOrganizationVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<string, OrganizationCreateOrganizationError, OrganizationCreateOrganizationVariables>({
    mutationFn: (variables: OrganizationCreateOrganizationVariables) =>
      fetchOrganizationCreateOrganization(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface OrganizationUpdateOrganizationPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  organizationId: string;
}

export type OrganizationUpdateOrganizationError = Fetcher.ErrorWrapper<undefined>;

export type OrganizationUpdateOrganizationVariables = {
  body?: Schemas.UpdateOrganizationDto;
  pathParams: OrganizationUpdateOrganizationPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchOrganizationUpdateOrganization = (
  variables: OrganizationUpdateOrganizationVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    OrganizationUpdateOrganizationError,
    Schemas.UpdateOrganizationDto,
    {},
    {},
    OrganizationUpdateOrganizationPathParams
  >({ method: "post", url: "/api/v1/Organization/{organizationId}/update", ...variables, signal });

export const useOrganizationUpdateOrganization = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      OrganizationUpdateOrganizationError,
      OrganizationUpdateOrganizationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    OrganizationUpdateOrganizationError,
    OrganizationUpdateOrganizationVariables
  >({
    mutationFn: (variables: OrganizationUpdateOrganizationVariables) =>
      fetchOrganizationUpdateOrganization(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface OrganizationGetOrganizationPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  organizationId: string;
}

export type OrganizationGetOrganizationError = Fetcher.ErrorWrapper<undefined>;

export type OrganizationGetOrganizationVariables = {
  pathParams: OrganizationGetOrganizationPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchOrganizationGetOrganization = (
  variables: OrganizationGetOrganizationVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.OrganizationSummary,
    OrganizationGetOrganizationError,
    undefined,
    {},
    {},
    OrganizationGetOrganizationPathParams
  >({ method: "get", url: "/api/v1/Organization/{organizationId}", ...variables, signal });

export function organizationGetOrganizationQuery(variables: OrganizationGetOrganizationVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.OrganizationSummary>;
};

export function organizationGetOrganizationQuery(
  variables: OrganizationGetOrganizationVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.OrganizationSummary>) | reactQuery.SkipToken;
};

export function organizationGetOrganizationQuery(
  variables: OrganizationGetOrganizationVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchOrganizationGetOrganization(variables, signal),
    queryKey: queryKeyFn({
      operationId: "organizationGetOrganization",
      path: "/api/v1/Organization/{organizationId}",
      variables,
    }),
  };
}

export const useSuspenseOrganizationGetOrganization = <TData = Schemas.OrganizationSummary>(
  variables: OrganizationGetOrganizationVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.OrganizationSummary, OrganizationGetOrganizationError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.OrganizationSummary, OrganizationGetOrganizationError, TData>({
    ...organizationGetOrganizationQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useOrganizationGetOrganization = <TData = Schemas.OrganizationSummary>(
  variables: OrganizationGetOrganizationVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.OrganizationSummary, OrganizationGetOrganizationError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.OrganizationSummary, OrganizationGetOrganizationError, TData>({
    ...organizationGetOrganizationQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface OrganizationDeleteOrganizationPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  organizationId: string;
}

export type OrganizationDeleteOrganizationError = Fetcher.ErrorWrapper<undefined>;

export type OrganizationDeleteOrganizationVariables = {
  pathParams: OrganizationDeleteOrganizationPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchOrganizationDeleteOrganization = (
  variables: OrganizationDeleteOrganizationVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    OrganizationDeleteOrganizationError,
    undefined,
    {},
    {},
    OrganizationDeleteOrganizationPathParams
  >({ method: "delete", url: "/api/v1/Organization/{organizationId}", ...variables, signal });

export const useOrganizationDeleteOrganization = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      OrganizationDeleteOrganizationError,
      OrganizationDeleteOrganizationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    OrganizationDeleteOrganizationError,
    OrganizationDeleteOrganizationVariables
  >({
    mutationFn: (variables: OrganizationDeleteOrganizationVariables) =>
      fetchOrganizationDeleteOrganization(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface OrganizationUploadOrganizationPicturePathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  organizationId: string;
}

export type OrganizationUploadOrganizationPictureError = Fetcher.ErrorWrapper<undefined>;

export interface OrganizationUploadOrganizationPictureRequestBody {
  /**
   * @format binary
   */
  FormFile?: Blob;
}

export type OrganizationUploadOrganizationPictureVariables = {
  body?: OrganizationUploadOrganizationPictureRequestBody;
  pathParams: OrganizationUploadOrganizationPicturePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchOrganizationUploadOrganizationPicture = (
  variables: OrganizationUploadOrganizationPictureVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    OrganizationUploadOrganizationPictureError,
    OrganizationUploadOrganizationPictureRequestBody,
    {},
    {},
    OrganizationUploadOrganizationPicturePathParams
  >({ method: "put", url: "/api/v1/Organization/{organizationId}/picture", ...variables, signal });

export const useOrganizationUploadOrganizationPicture = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      OrganizationUploadOrganizationPictureError,
      OrganizationUploadOrganizationPictureVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    OrganizationUploadOrganizationPictureError,
    OrganizationUploadOrganizationPictureVariables
  >({
    mutationFn: (variables: OrganizationUploadOrganizationPictureVariables) =>
      fetchOrganizationUploadOrganizationPicture(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface OrganizationGetOrganizationPicturePathParams {
  /**
   * Required, non-null
   *
   * @format uuid
   */
  organizationId: string;
}

export type OrganizationGetOrganizationPictureError = Fetcher.ErrorWrapper<undefined>;

export type OrganizationGetOrganizationPictureVariables = {
  pathParams: OrganizationGetOrganizationPicturePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchOrganizationGetOrganizationPicture = (
  variables: OrganizationGetOrganizationPictureVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    OrganizationGetOrganizationPictureError,
    undefined,
    {},
    {},
    OrganizationGetOrganizationPicturePathParams
  >({ method: "get", url: "/api/v1/Organization/{organizationId}/picture", ...variables, signal });

export function organizationGetOrganizationPictureQuery(variables: OrganizationGetOrganizationPictureVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function organizationGetOrganizationPictureQuery(
  variables: OrganizationGetOrganizationPictureVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function organizationGetOrganizationPictureQuery(
  variables: OrganizationGetOrganizationPictureVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchOrganizationGetOrganizationPicture(variables, signal),
    queryKey: queryKeyFn({
      operationId: "organizationGetOrganizationPicture",
      path: "/api/v1/Organization/{organizationId}/picture",
      variables,
    }),
  };
}

export const useSuspenseOrganizationGetOrganizationPicture = <TData = undefined>(
  variables: OrganizationGetOrganizationPictureVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, OrganizationGetOrganizationPictureError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, OrganizationGetOrganizationPictureError, TData>({
    ...organizationGetOrganizationPictureQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useOrganizationGetOrganizationPicture = <TData = undefined>(
  variables: OrganizationGetOrganizationPictureVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, OrganizationGetOrganizationPictureError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, OrganizationGetOrganizationPictureError, TData>({
    ...organizationGetOrganizationPictureQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface OrganizationAddNewUserToOrganizationPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  organizationId: string;
}

export type OrganizationAddNewUserToOrganizationError = Fetcher.ErrorWrapper<undefined>;

export type OrganizationAddNewUserToOrganizationVariables = {
  body?: Schemas.AddUserToOrgDto;
  pathParams: OrganizationAddNewUserToOrganizationPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchOrganizationAddNewUserToOrganization = (
  variables: OrganizationAddNewUserToOrganizationVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    string,
    OrganizationAddNewUserToOrganizationError,
    Schemas.AddUserToOrgDto,
    {},
    {},
    OrganizationAddNewUserToOrganizationPathParams
  >({ method: "post", url: "/api/v1/Organization/{organizationId}/user", ...variables, signal });

export const useOrganizationAddNewUserToOrganization = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      string,
      OrganizationAddNewUserToOrganizationError,
      OrganizationAddNewUserToOrganizationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    string,
    OrganizationAddNewUserToOrganizationError,
    OrganizationAddNewUserToOrganizationVariables
  >({
    mutationFn: (variables: OrganizationAddNewUserToOrganizationVariables) =>
      fetchOrganizationAddNewUserToOrganization(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface OrganizationAddOrganizationDonationPathParams {
  organizationId: string;
}

export type OrganizationAddOrganizationDonationError = Fetcher.ErrorWrapper<undefined>;

export type OrganizationAddOrganizationDonationVariables = {
  body: Schemas.OrgDonationDto;
  pathParams: OrganizationAddOrganizationDonationPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchOrganizationAddOrganizationDonation = (
  variables: OrganizationAddOrganizationDonationVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    string,
    OrganizationAddOrganizationDonationError,
    Schemas.OrgDonationDto,
    {},
    {},
    OrganizationAddOrganizationDonationPathParams
  >({ method: "post", url: "/api/v1/Organization/{organizationId}/donation", ...variables, signal });

export const useOrganizationAddOrganizationDonation = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      string,
      OrganizationAddOrganizationDonationError,
      OrganizationAddOrganizationDonationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    string,
    OrganizationAddOrganizationDonationError,
    OrganizationAddOrganizationDonationVariables
  >({
    mutationFn: (variables: OrganizationAddOrganizationDonationVariables) =>
      fetchOrganizationAddOrganizationDonation(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface OrganizationDeleteOrganizationDonationPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  donationId: string;
  organizationId: string;
}

export type OrganizationDeleteOrganizationDonationError = Fetcher.ErrorWrapper<undefined>;

export type OrganizationDeleteOrganizationDonationVariables = {
  pathParams: OrganizationDeleteOrganizationDonationPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchOrganizationDeleteOrganizationDonation = (
  variables: OrganizationDeleteOrganizationDonationVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    OrganizationDeleteOrganizationDonationError,
    undefined,
    {},
    {},
    OrganizationDeleteOrganizationDonationPathParams
  >({ method: "post", url: "/api/v1/Organization/{organizationId}/donation/{donationId}", ...variables, signal });

export const useOrganizationDeleteOrganizationDonation = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      OrganizationDeleteOrganizationDonationError,
      OrganizationDeleteOrganizationDonationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    OrganizationDeleteOrganizationDonationError,
    OrganizationDeleteOrganizationDonationVariables
  >({
    mutationFn: (variables: OrganizationDeleteOrganizationDonationVariables) =>
      fetchOrganizationDeleteOrganizationDonation(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface OrganizationGetOrganizationDonationsPathParams {
  /**
   * @format uuid
   */
  organizationId: string;
}

export type OrganizationGetOrganizationDonationsError = Fetcher.ErrorWrapper<undefined>;

export type OrganizationGetOrganizationDonationsResponse = Schemas.OrgDonationDto[];

export type OrganizationGetOrganizationDonationsVariables = {
  pathParams: OrganizationGetOrganizationDonationsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchOrganizationGetOrganizationDonations = (
  variables: OrganizationGetOrganizationDonationsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    OrganizationGetOrganizationDonationsResponse,
    OrganizationGetOrganizationDonationsError,
    undefined,
    {},
    {},
    OrganizationGetOrganizationDonationsPathParams
  >({ method: "get", url: "/api/v1/Organization/{organizationId}/donations", ...variables, signal });

export function organizationGetOrganizationDonationsQuery(variables: OrganizationGetOrganizationDonationsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<OrganizationGetOrganizationDonationsResponse>;
};

export function organizationGetOrganizationDonationsQuery(
  variables: OrganizationGetOrganizationDonationsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<OrganizationGetOrganizationDonationsResponse>) | reactQuery.SkipToken;
};

export function organizationGetOrganizationDonationsQuery(
  variables: OrganizationGetOrganizationDonationsVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchOrganizationGetOrganizationDonations(variables, signal),
    queryKey: queryKeyFn({
      operationId: "organizationGetOrganizationDonations",
      path: "/api/v1/Organization/{organizationId}/donations",
      variables,
    }),
  };
}

export const useSuspenseOrganizationGetOrganizationDonations = <TData = OrganizationGetOrganizationDonationsResponse>(
  variables: OrganizationGetOrganizationDonationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      OrganizationGetOrganizationDonationsResponse,
      OrganizationGetOrganizationDonationsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    OrganizationGetOrganizationDonationsResponse,
    OrganizationGetOrganizationDonationsError,
    TData
  >({
    ...organizationGetOrganizationDonationsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useOrganizationGetOrganizationDonations = <TData = OrganizationGetOrganizationDonationsResponse>(
  variables: OrganizationGetOrganizationDonationsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      OrganizationGetOrganizationDonationsResponse,
      OrganizationGetOrganizationDonationsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    OrganizationGetOrganizationDonationsResponse,
    OrganizationGetOrganizationDonationsError,
    TData
  >({
    ...organizationGetOrganizationDonationsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface OrganizationGetOrganizationMembersPathParams {
  /**
   * @format uuid
   */
  organizationId: string;
}

export type OrganizationGetOrganizationMembersError = Fetcher.ErrorWrapper<undefined>;

export type OrganizationGetOrganizationMembersResponse = Schemas.UserDto[];

export type OrganizationGetOrganizationMembersVariables = {
  pathParams: OrganizationGetOrganizationMembersPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchOrganizationGetOrganizationMembers = (
  variables: OrganizationGetOrganizationMembersVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    OrganizationGetOrganizationMembersResponse,
    OrganizationGetOrganizationMembersError,
    undefined,
    {},
    {},
    OrganizationGetOrganizationMembersPathParams
  >({ method: "get", url: "/api/v1/Organization/{organizationId}/members", ...variables, signal });

export function organizationGetOrganizationMembersQuery(variables: OrganizationGetOrganizationMembersVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<OrganizationGetOrganizationMembersResponse>;
};

export function organizationGetOrganizationMembersQuery(
  variables: OrganizationGetOrganizationMembersVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<OrganizationGetOrganizationMembersResponse>) | reactQuery.SkipToken;
};

export function organizationGetOrganizationMembersQuery(
  variables: OrganizationGetOrganizationMembersVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchOrganizationGetOrganizationMembers(variables, signal),
    queryKey: queryKeyFn({
      operationId: "organizationGetOrganizationMembers",
      path: "/api/v1/Organization/{organizationId}/members",
      variables,
    }),
  };
}

export const useSuspenseOrganizationGetOrganizationMembers = <TData = OrganizationGetOrganizationMembersResponse>(
  variables: OrganizationGetOrganizationMembersVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      OrganizationGetOrganizationMembersResponse,
      OrganizationGetOrganizationMembersError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    OrganizationGetOrganizationMembersResponse,
    OrganizationGetOrganizationMembersError,
    TData
  >({
    ...organizationGetOrganizationMembersQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useOrganizationGetOrganizationMembers = <TData = OrganizationGetOrganizationMembersResponse>(
  variables: OrganizationGetOrganizationMembersVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      OrganizationGetOrganizationMembersResponse,
      OrganizationGetOrganizationMembersError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    OrganizationGetOrganizationMembersResponse,
    OrganizationGetOrganizationMembersError,
    TData
  >({
    ...organizationGetOrganizationMembersQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type OrganizationGetOrganizationRolesError = Fetcher.ErrorWrapper<undefined>;

export type OrganizationGetOrganizationRolesResponse = string[];

export type OrganizationGetOrganizationRolesVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchOrganizationGetOrganizationRoles = (
  variables: OrganizationGetOrganizationRolesVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    OrganizationGetOrganizationRolesResponse,
    OrganizationGetOrganizationRolesError,
    undefined,
    {},
    {},
    {}
  >({ method: "get", url: "/api/v1/Organization/roles", ...variables, signal });

export function organizationGetOrganizationRolesQuery(variables: OrganizationGetOrganizationRolesVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<OrganizationGetOrganizationRolesResponse>;
};

export function organizationGetOrganizationRolesQuery(
  variables: OrganizationGetOrganizationRolesVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<OrganizationGetOrganizationRolesResponse>) | reactQuery.SkipToken;
};

export function organizationGetOrganizationRolesQuery(
  variables: OrganizationGetOrganizationRolesVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchOrganizationGetOrganizationRoles(variables, signal),
    queryKey: queryKeyFn({
      operationId: "organizationGetOrganizationRoles",
      path: "/api/v1/Organization/roles",
      variables,
    }),
  };
}

export const useSuspenseOrganizationGetOrganizationRoles = <TData = OrganizationGetOrganizationRolesResponse>(
  variables: OrganizationGetOrganizationRolesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<OrganizationGetOrganizationRolesResponse, OrganizationGetOrganizationRolesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    OrganizationGetOrganizationRolesResponse,
    OrganizationGetOrganizationRolesError,
    TData
  >({
    ...organizationGetOrganizationRolesQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useOrganizationGetOrganizationRoles = <TData = OrganizationGetOrganizationRolesResponse>(
  variables: OrganizationGetOrganizationRolesVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<OrganizationGetOrganizationRolesResponse, OrganizationGetOrganizationRolesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<OrganizationGetOrganizationRolesResponse, OrganizationGetOrganizationRolesError, TData>({
    ...organizationGetOrganizationRolesQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type OrganizationGetMyOrganizationsError = Fetcher.ErrorWrapper<undefined>;

export type OrganizationGetMyOrganizationsResponse = Schemas.OrganizationSummary[];

export type OrganizationGetMyOrganizationsVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchOrganizationGetMyOrganizations = (
  variables: OrganizationGetMyOrganizationsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    OrganizationGetMyOrganizationsResponse,
    OrganizationGetMyOrganizationsError,
    undefined,
    {},
    {},
    {}
  >({ method: "get", url: "/api/v1/Organization/my-organizations", ...variables, signal });

export function organizationGetMyOrganizationsQuery(variables: OrganizationGetMyOrganizationsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<OrganizationGetMyOrganizationsResponse>;
};

export function organizationGetMyOrganizationsQuery(
  variables: OrganizationGetMyOrganizationsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<OrganizationGetMyOrganizationsResponse>) | reactQuery.SkipToken;
};

export function organizationGetMyOrganizationsQuery(
  variables: OrganizationGetMyOrganizationsVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchOrganizationGetMyOrganizations(variables, signal),
    queryKey: queryKeyFn({
      operationId: "organizationGetMyOrganizations",
      path: "/api/v1/Organization/my-organizations",
      variables,
    }),
  };
}

export const useSuspenseOrganizationGetMyOrganizations = <TData = OrganizationGetMyOrganizationsResponse>(
  variables: OrganizationGetMyOrganizationsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<OrganizationGetMyOrganizationsResponse, OrganizationGetMyOrganizationsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    OrganizationGetMyOrganizationsResponse,
    OrganizationGetMyOrganizationsError,
    TData
  >({
    ...organizationGetMyOrganizationsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useOrganizationGetMyOrganizations = <TData = OrganizationGetMyOrganizationsResponse>(
  variables: OrganizationGetMyOrganizationsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<OrganizationGetMyOrganizationsResponse, OrganizationGetMyOrganizationsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<OrganizationGetMyOrganizationsResponse, OrganizationGetMyOrganizationsError, TData>({
    ...organizationGetMyOrganizationsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface PaymentCreatePaymentAccountPathParams {
  /**
   * current logged in user
   *
   * @format uuid
   */
  userId: string;
}

export type PaymentCreatePaymentAccountError = Fetcher.ErrorWrapper<undefined>;

export type PaymentCreatePaymentAccountVariables = {
  pathParams: PaymentCreatePaymentAccountPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchPaymentCreatePaymentAccount = (
  variables: PaymentCreatePaymentAccountVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.UrlResult,
    PaymentCreatePaymentAccountError,
    undefined,
    {},
    {},
    PaymentCreatePaymentAccountPathParams
  >({ method: "post", url: "/api/v1/Profile/{userId}/payment-account", ...variables, signal });

export const usePaymentCreatePaymentAccount = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UrlResult,
      PaymentCreatePaymentAccountError,
      PaymentCreatePaymentAccountVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.UrlResult,
    PaymentCreatePaymentAccountError,
    PaymentCreatePaymentAccountVariables
  >({
    mutationFn: (variables: PaymentCreatePaymentAccountVariables) =>
      fetchPaymentCreatePaymentAccount(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface PaymentGetPaymentAccountPathParams {
  /**
   * @format uuid
   */
  userId: string;
}

export type PaymentGetPaymentAccountError = Fetcher.ErrorWrapper<undefined>;

export type PaymentGetPaymentAccountVariables = {
  pathParams: PaymentGetPaymentAccountPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchPaymentGetPaymentAccount = (variables: PaymentGetPaymentAccountVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.PaymentAccountStatusDto,
    PaymentGetPaymentAccountError,
    undefined,
    {},
    {},
    PaymentGetPaymentAccountPathParams
  >({ method: "get", url: "/api/v1/Profile/{userId}/payment-account", ...variables, signal });

export function paymentGetPaymentAccountQuery(variables: PaymentGetPaymentAccountVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.PaymentAccountStatusDto>;
};

export function paymentGetPaymentAccountQuery(variables: PaymentGetPaymentAccountVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.PaymentAccountStatusDto>) | reactQuery.SkipToken;
};

export function paymentGetPaymentAccountQuery(variables: PaymentGetPaymentAccountVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchPaymentGetPaymentAccount(variables, signal),
    queryKey: queryKeyFn({
      operationId: "paymentGetPaymentAccount",
      path: "/api/v1/Profile/{userId}/payment-account",
      variables,
    }),
  };
}

export const useSuspensePaymentGetPaymentAccount = <TData = Schemas.PaymentAccountStatusDto>(
  variables: PaymentGetPaymentAccountVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.PaymentAccountStatusDto, PaymentGetPaymentAccountError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.PaymentAccountStatusDto, PaymentGetPaymentAccountError, TData>({
    ...paymentGetPaymentAccountQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const usePaymentGetPaymentAccount = <TData = Schemas.PaymentAccountStatusDto>(
  variables: PaymentGetPaymentAccountVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.PaymentAccountStatusDto, PaymentGetPaymentAccountError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.PaymentAccountStatusDto, PaymentGetPaymentAccountError, TData>({
    ...paymentGetPaymentAccountQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface PaymentGetStripeLoginPathParams {
  /**
   * current logged in user
   *
   * @format uuid
   */
  userId: string;
}

export type PaymentGetStripeLoginError = Fetcher.ErrorWrapper<
  | {
      status: 400;
      payload: Schemas.ProblemDetails;
    }
  | {
      status: 401;
      payload: Schemas.ProblemDetails;
    }
>;

export type PaymentGetStripeLoginVariables = {
  pathParams: PaymentGetStripeLoginPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchPaymentGetStripeLogin = (variables: PaymentGetStripeLoginVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.UrlResult,
    PaymentGetStripeLoginError,
    undefined,
    {},
    {},
    PaymentGetStripeLoginPathParams
  >({ method: "get", url: "/api/v1/Profile/{userId}/payment-account/login", ...variables, signal });

export function paymentGetStripeLoginQuery(variables: PaymentGetStripeLoginVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.UrlResult>;
};

export function paymentGetStripeLoginQuery(variables: PaymentGetStripeLoginVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.UrlResult>) | reactQuery.SkipToken;
};

export function paymentGetStripeLoginQuery(variables: PaymentGetStripeLoginVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchPaymentGetStripeLogin(variables, signal),
    queryKey: queryKeyFn({
      operationId: "paymentGetStripeLogin",
      path: "/api/v1/Profile/{userId}/payment-account/login",
      variables,
    }),
  };
}

export const useSuspensePaymentGetStripeLogin = <TData = Schemas.UrlResult>(
  variables: PaymentGetStripeLoginVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.UrlResult, PaymentGetStripeLoginError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.UrlResult, PaymentGetStripeLoginError, TData>({
    ...paymentGetStripeLoginQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const usePaymentGetStripeLogin = <TData = Schemas.UrlResult>(
  variables: PaymentGetStripeLoginVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.UrlResult, PaymentGetStripeLoginError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.UrlResult, PaymentGetStripeLoginError, TData>({
    ...paymentGetStripeLoginQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface PaymentGetCheckoutSessionPathParams {
  /**
   * current logged in user
   *
   * @format uuid
   */
  userId: string;
}

export type PaymentGetCheckoutSessionError = Fetcher.ErrorWrapper<{
  status: 401;
  payload: Schemas.ProblemDetails;
}>;

export type PaymentGetCheckoutSessionVariables = {
  body?: Schemas.PaymentSessionDto;
  pathParams: PaymentGetCheckoutSessionPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchPaymentGetCheckoutSession = (variables: PaymentGetCheckoutSessionVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.UrlResult,
    PaymentGetCheckoutSessionError,
    Schemas.PaymentSessionDto,
    {},
    {},
    PaymentGetCheckoutSessionPathParams
  >({ method: "post", url: "/api/v1/Profile/{userId}/payment-sessions", ...variables, signal });

export const usePaymentGetCheckoutSession = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.UrlResult,
      PaymentGetCheckoutSessionError,
      PaymentGetCheckoutSessionVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<Schemas.UrlResult, PaymentGetCheckoutSessionError, PaymentGetCheckoutSessionVariables>({
    mutationFn: (variables: PaymentGetCheckoutSessionVariables) =>
      fetchPaymentGetCheckoutSession(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface PlatformChatsGetMyChatsPathParams {
  /**
   * @format uuid
   */
  userId: string;
}

export type PlatformChatsGetMyChatsError = Fetcher.ErrorWrapper<undefined>;

export type PlatformChatsGetMyChatsResponse = Schemas.PlatformChatThreadDto[];

export type PlatformChatsGetMyChatsVariables = {
  pathParams: PlatformChatsGetMyChatsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchPlatformChatsGetMyChats = (variables: PlatformChatsGetMyChatsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    PlatformChatsGetMyChatsResponse,
    PlatformChatsGetMyChatsError,
    undefined,
    {},
    {},
    PlatformChatsGetMyChatsPathParams
  >({ method: "get", url: "/api/v1/platform-chats/my-chats/{userId}", ...variables, signal });

export function platformChatsGetMyChatsQuery(variables: PlatformChatsGetMyChatsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<PlatformChatsGetMyChatsResponse>;
};

export function platformChatsGetMyChatsQuery(variables: PlatformChatsGetMyChatsVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<PlatformChatsGetMyChatsResponse>) | reactQuery.SkipToken;
};

export function platformChatsGetMyChatsQuery(variables: PlatformChatsGetMyChatsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchPlatformChatsGetMyChats(variables, signal),
    queryKey: queryKeyFn({
      operationId: "platformChatsGetMyChats",
      path: "/api/v1/platform-chats/my-chats/{userId}",
      variables,
    }),
  };
}

export const useSuspensePlatformChatsGetMyChats = <TData = PlatformChatsGetMyChatsResponse>(
  variables: PlatformChatsGetMyChatsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<PlatformChatsGetMyChatsResponse, PlatformChatsGetMyChatsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<PlatformChatsGetMyChatsResponse, PlatformChatsGetMyChatsError, TData>({
    ...platformChatsGetMyChatsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const usePlatformChatsGetMyChats = <TData = PlatformChatsGetMyChatsResponse>(
  variables: PlatformChatsGetMyChatsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<PlatformChatsGetMyChatsResponse, PlatformChatsGetMyChatsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<PlatformChatsGetMyChatsResponse, PlatformChatsGetMyChatsError, TData>({
    ...platformChatsGetMyChatsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface PlatformChatsMarkReadPathParams {
  /**
   * @format uuid
   */
  userId: string;
}

export type PlatformChatsMarkReadError = Fetcher.ErrorWrapper<undefined>;

export type PlatformChatsMarkReadVariables = {
  body?: Schemas.MarkPlatformChatReadRequest;
  pathParams: PlatformChatsMarkReadPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchPlatformChatsMarkRead = (variables: PlatformChatsMarkReadVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    PlatformChatsMarkReadError,
    Schemas.MarkPlatformChatReadRequest,
    {},
    {},
    PlatformChatsMarkReadPathParams
  >({ method: "post", url: "/api/v1/platform-chats/{userId}/mark-read", ...variables, signal });

export const usePlatformChatsMarkRead = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, PlatformChatsMarkReadError, PlatformChatsMarkReadVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, PlatformChatsMarkReadError, PlatformChatsMarkReadVariables>({
    mutationFn: (variables: PlatformChatsMarkReadVariables) =>
      fetchPlatformChatsMarkRead(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface PlatformInsightsGetLoginHistoryQueryParams {
  /**
   * Inclusive lower bound; default is 30 days before UTC midnight today.
   *
   * @format date-time
   */
  start?: string;
  /**
   * Exclusive upper bound; default is UTC midnight tomorrow (includes all of "today").
   *
   * @format date-time
   */
  end?: string;
}

export type PlatformInsightsGetLoginHistoryError = Fetcher.ErrorWrapper<undefined>;

export type PlatformInsightsGetLoginHistoryResponse = Schemas.PlatformLogInHistoryDto[];

export type PlatformInsightsGetLoginHistoryVariables = {
  queryParams?: PlatformInsightsGetLoginHistoryQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchPlatformInsightsGetLoginHistory = (
  variables: PlatformInsightsGetLoginHistoryVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    PlatformInsightsGetLoginHistoryResponse,
    PlatformInsightsGetLoginHistoryError,
    undefined,
    {},
    PlatformInsightsGetLoginHistoryQueryParams,
    {}
  >({ method: "get", url: "/api/v1/platform-insights/login-history", ...variables, signal });

export function platformInsightsGetLoginHistoryQuery(variables: PlatformInsightsGetLoginHistoryVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<PlatformInsightsGetLoginHistoryResponse>;
};

export function platformInsightsGetLoginHistoryQuery(
  variables: PlatformInsightsGetLoginHistoryVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<PlatformInsightsGetLoginHistoryResponse>) | reactQuery.SkipToken;
};

export function platformInsightsGetLoginHistoryQuery(
  variables: PlatformInsightsGetLoginHistoryVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchPlatformInsightsGetLoginHistory(variables, signal),
    queryKey: queryKeyFn({
      operationId: "platformInsightsGetLoginHistory",
      path: "/api/v1/platform-insights/login-history",
      variables,
    }),
  };
}

export const useSuspensePlatformInsightsGetLoginHistory = <TData = PlatformInsightsGetLoginHistoryResponse>(
  variables: PlatformInsightsGetLoginHistoryVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<PlatformInsightsGetLoginHistoryResponse, PlatformInsightsGetLoginHistoryError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    PlatformInsightsGetLoginHistoryResponse,
    PlatformInsightsGetLoginHistoryError,
    TData
  >({
    ...platformInsightsGetLoginHistoryQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const usePlatformInsightsGetLoginHistory = <TData = PlatformInsightsGetLoginHistoryResponse>(
  variables: PlatformInsightsGetLoginHistoryVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<PlatformInsightsGetLoginHistoryResponse, PlatformInsightsGetLoginHistoryError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<PlatformInsightsGetLoginHistoryResponse, PlatformInsightsGetLoginHistoryError, TData>({
    ...platformInsightsGetLoginHistoryQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type PlatformInsightsGetDistrictOnboardingError = Fetcher.ErrorWrapper<undefined>;

export type PlatformInsightsGetDistrictOnboardingVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchPlatformInsightsGetDistrictOnboarding = (
  variables: PlatformInsightsGetDistrictOnboardingVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.PlatformInsightsOnboardingResponseDto,
    PlatformInsightsGetDistrictOnboardingError,
    undefined,
    {},
    {},
    {}
  >({ method: "get", url: "/api/v1/platform-insights/district-onboarding", ...variables, signal });

export function platformInsightsGetDistrictOnboardingQuery(variables: PlatformInsightsGetDistrictOnboardingVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.PlatformInsightsOnboardingResponseDto>;
};

export function platformInsightsGetDistrictOnboardingQuery(
  variables: PlatformInsightsGetDistrictOnboardingVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.PlatformInsightsOnboardingResponseDto>) | reactQuery.SkipToken;
};

export function platformInsightsGetDistrictOnboardingQuery(
  variables: PlatformInsightsGetDistrictOnboardingVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchPlatformInsightsGetDistrictOnboarding(variables, signal),
    queryKey: queryKeyFn({
      operationId: "platformInsightsGetDistrictOnboarding",
      path: "/api/v1/platform-insights/district-onboarding",
      variables,
    }),
  };
}

export const useSuspensePlatformInsightsGetDistrictOnboarding = <TData = Schemas.PlatformInsightsOnboardingResponseDto>(
  variables: PlatformInsightsGetDistrictOnboardingVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PlatformInsightsOnboardingResponseDto,
      PlatformInsightsGetDistrictOnboardingError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    Schemas.PlatformInsightsOnboardingResponseDto,
    PlatformInsightsGetDistrictOnboardingError,
    TData
  >({
    ...platformInsightsGetDistrictOnboardingQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const usePlatformInsightsGetDistrictOnboarding = <TData = Schemas.PlatformInsightsOnboardingResponseDto>(
  variables: PlatformInsightsGetDistrictOnboardingVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      Schemas.PlatformInsightsOnboardingResponseDto,
      PlatformInsightsGetDistrictOnboardingError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    Schemas.PlatformInsightsOnboardingResponseDto,
    PlatformInsightsGetDistrictOnboardingError,
    TData
  >({
    ...platformInsightsGetDistrictOnboardingQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface ProficiencyCreateProficiencyPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type ProficiencyCreateProficiencyError = Fetcher.ErrorWrapper<undefined>;

export type ProficiencyCreateProficiencyVariables = {
  body?: Schemas.ProficiencyDTO;
  pathParams: ProficiencyCreateProficiencyPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchProficiencyCreateProficiency = (
  variables: ProficiencyCreateProficiencyVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    string,
    ProficiencyCreateProficiencyError,
    Schemas.ProficiencyDTO,
    {},
    {},
    ProficiencyCreateProficiencyPathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/proficiency", ...variables, signal });

export const useProficiencyCreateProficiency = (
  options?: Omit<
    reactQuery.UseMutationOptions<string, ProficiencyCreateProficiencyError, ProficiencyCreateProficiencyVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<string, ProficiencyCreateProficiencyError, ProficiencyCreateProficiencyVariables>({
    mutationFn: (variables: ProficiencyCreateProficiencyVariables) =>
      fetchProficiencyCreateProficiency(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface ProficiencyUpdateProficiencyPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  proficiencyId: string;
}

export type ProficiencyUpdateProficiencyError = Fetcher.ErrorWrapper<undefined>;

export type ProficiencyUpdateProficiencyVariables = {
  body?: Schemas.ProficiencyDTO;
  pathParams: ProficiencyUpdateProficiencyPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchProficiencyUpdateProficiency = (
  variables: ProficiencyUpdateProficiencyVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.ProficiencyDTO,
    ProficiencyUpdateProficiencyError,
    Schemas.ProficiencyDTO,
    {},
    {},
    ProficiencyUpdateProficiencyPathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/proficiency/{proficiencyId}", ...variables, signal });

export const useProficiencyUpdateProficiency = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ProficiencyDTO,
      ProficiencyUpdateProficiencyError,
      ProficiencyUpdateProficiencyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.ProficiencyDTO,
    ProficiencyUpdateProficiencyError,
    ProficiencyUpdateProficiencyVariables
  >({
    mutationFn: (variables: ProficiencyUpdateProficiencyVariables) =>
      fetchProficiencyUpdateProficiency(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface ProficiencyGetProficiencyPathParams {
  /**
   * @format uuid
   */
  proficiencyId: string;
  bubbleId: string;
}

export type ProficiencyGetProficiencyError = Fetcher.ErrorWrapper<undefined>;

export type ProficiencyGetProficiencyVariables = {
  pathParams: ProficiencyGetProficiencyPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchProficiencyGetProficiency = (variables: ProficiencyGetProficiencyVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.ProficiencyDTO,
    ProficiencyGetProficiencyError,
    undefined,
    {},
    {},
    ProficiencyGetProficiencyPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/proficiency/{proficiencyId}", ...variables, signal });

export function proficiencyGetProficiencyQuery(variables: ProficiencyGetProficiencyVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ProficiencyDTO>;
};

export function proficiencyGetProficiencyQuery(variables: ProficiencyGetProficiencyVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.ProficiencyDTO>) | reactQuery.SkipToken;
};

export function proficiencyGetProficiencyQuery(variables: ProficiencyGetProficiencyVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchProficiencyGetProficiency(variables, signal),
    queryKey: queryKeyFn({
      operationId: "proficiencyGetProficiency",
      path: "/api/v1/Bubbles/{bubbleId}/proficiency/{proficiencyId}",
      variables,
    }),
  };
}

export const useSuspenseProficiencyGetProficiency = <TData = Schemas.ProficiencyDTO>(
  variables: ProficiencyGetProficiencyVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ProficiencyDTO, ProficiencyGetProficiencyError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.ProficiencyDTO, ProficiencyGetProficiencyError, TData>({
    ...proficiencyGetProficiencyQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useProficiencyGetProficiency = <TData = Schemas.ProficiencyDTO>(
  variables: ProficiencyGetProficiencyVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ProficiencyDTO, ProficiencyGetProficiencyError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.ProficiencyDTO, ProficiencyGetProficiencyError, TData>({
    ...proficiencyGetProficiencyQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface ProficiencyDeleteProficiencyPathParams {
  /**
   * @format uuid
   */
  proficiencyId: string;
  bubbleId: string;
}

export type ProficiencyDeleteProficiencyError = Fetcher.ErrorWrapper<undefined>;

export type ProficiencyDeleteProficiencyVariables = {
  pathParams: ProficiencyDeleteProficiencyPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchProficiencyDeleteProficiency = (
  variables: ProficiencyDeleteProficiencyVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    ProficiencyDeleteProficiencyError,
    undefined,
    {},
    {},
    ProficiencyDeleteProficiencyPathParams
  >({ method: "delete", url: "/api/v1/Bubbles/{bubbleId}/proficiency/{proficiencyId}", ...variables, signal });

export const useProficiencyDeleteProficiency = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, ProficiencyDeleteProficiencyError, ProficiencyDeleteProficiencyVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, ProficiencyDeleteProficiencyError, ProficiencyDeleteProficiencyVariables>({
    mutationFn: (variables: ProficiencyDeleteProficiencyVariables) =>
      fetchProficiencyDeleteProficiency(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface ProficiencyGetAllProficienciesPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type ProficiencyGetAllProficienciesError = Fetcher.ErrorWrapper<undefined>;

export type ProficiencyGetAllProficienciesResponse = Schemas.ProficiencyDTO[];

export type ProficiencyGetAllProficienciesVariables = {
  pathParams: ProficiencyGetAllProficienciesPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchProficiencyGetAllProficiencies = (
  variables: ProficiencyGetAllProficienciesVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    ProficiencyGetAllProficienciesResponse,
    ProficiencyGetAllProficienciesError,
    undefined,
    {},
    {},
    ProficiencyGetAllProficienciesPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/proficiencies", ...variables, signal });

export function proficiencyGetAllProficienciesQuery(variables: ProficiencyGetAllProficienciesVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<ProficiencyGetAllProficienciesResponse>;
};

export function proficiencyGetAllProficienciesQuery(
  variables: ProficiencyGetAllProficienciesVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<ProficiencyGetAllProficienciesResponse>) | reactQuery.SkipToken;
};

export function proficiencyGetAllProficienciesQuery(
  variables: ProficiencyGetAllProficienciesVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchProficiencyGetAllProficiencies(variables, signal),
    queryKey: queryKeyFn({
      operationId: "proficiencyGetAllProficiencies",
      path: "/api/v1/Bubbles/{bubbleId}/proficiencies",
      variables,
    }),
  };
}

export const useSuspenseProficiencyGetAllProficiencies = <TData = ProficiencyGetAllProficienciesResponse>(
  variables: ProficiencyGetAllProficienciesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<ProficiencyGetAllProficienciesResponse, ProficiencyGetAllProficienciesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    ProficiencyGetAllProficienciesResponse,
    ProficiencyGetAllProficienciesError,
    TData
  >({
    ...proficiencyGetAllProficienciesQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useProficiencyGetAllProficiencies = <TData = ProficiencyGetAllProficienciesResponse>(
  variables: ProficiencyGetAllProficienciesVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<ProficiencyGetAllProficienciesResponse, ProficiencyGetAllProficienciesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<ProficiencyGetAllProficienciesResponse, ProficiencyGetAllProficienciesError, TData>({
    ...proficiencyGetAllProficienciesQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface ProficiencyAssignProficiencyPathParams {
  /**
   * @format uuid
   */
  proficiencyId: string;
  /**
   * @format uuid
   */
  userId: string;
  bubbleId: string;
}

export type ProficiencyAssignProficiencyError = Fetcher.ErrorWrapper<undefined>;

export type ProficiencyAssignProficiencyVariables = {
  pathParams: ProficiencyAssignProficiencyPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchProficiencyAssignProficiency = (
  variables: ProficiencyAssignProficiencyVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    ProficiencyAssignProficiencyError,
    undefined,
    {},
    {},
    ProficiencyAssignProficiencyPathParams
  >({
    method: "post",
    url: "/api/v1/Bubbles/{bubbleId}/proficiency/{proficiencyId}/user/{userId}",
    ...variables,
    signal,
  });

export const useProficiencyAssignProficiency = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, ProficiencyAssignProficiencyError, ProficiencyAssignProficiencyVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, ProficiencyAssignProficiencyError, ProficiencyAssignProficiencyVariables>({
    mutationFn: (variables: ProficiencyAssignProficiencyVariables) =>
      fetchProficiencyAssignProficiency(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface ProficiencyUnassignProficiencyPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  proficiencyId: string;
  /**
   * @format uuid
   */
  userId: string;
}

export type ProficiencyUnassignProficiencyError = Fetcher.ErrorWrapper<undefined>;

export type ProficiencyUnassignProficiencyVariables = {
  pathParams: ProficiencyUnassignProficiencyPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchProficiencyUnassignProficiency = (
  variables: ProficiencyUnassignProficiencyVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    ProficiencyUnassignProficiencyError,
    undefined,
    {},
    {},
    ProficiencyUnassignProficiencyPathParams
  >({
    method: "delete",
    url: "/api/v1/Bubbles/{bubbleId}/proficiency/{proficiencyId}/user/{userId}",
    ...variables,
    signal,
  });

export const useProficiencyUnassignProficiency = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ProficiencyUnassignProficiencyError,
      ProficiencyUnassignProficiencyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    ProficiencyUnassignProficiencyError,
    ProficiencyUnassignProficiencyVariables
  >({
    mutationFn: (variables: ProficiencyUnassignProficiencyVariables) =>
      fetchProficiencyUnassignProficiency(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface ProficiencyMarkCompleteProficiencyPathParams {
  /**
   * @format uuid
   */
  proficiencyId: string;
  /**
   * @format uuid
   */
  userId: string;
  bubbleId: string;
}

export type ProficiencyMarkCompleteProficiencyError = Fetcher.ErrorWrapper<undefined>;

export type ProficiencyMarkCompleteProficiencyVariables = {
  pathParams: ProficiencyMarkCompleteProficiencyPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchProficiencyMarkCompleteProficiency = (
  variables: ProficiencyMarkCompleteProficiencyVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    ProficiencyMarkCompleteProficiencyError,
    undefined,
    {},
    {},
    ProficiencyMarkCompleteProficiencyPathParams
  >({
    method: "post",
    url: "/api/v1/Bubbles/{bubbleId}/proficiency/{proficiencyId}/user/{userId}/complete",
    ...variables,
    signal,
  });

export const useProficiencyMarkCompleteProficiency = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ProficiencyMarkCompleteProficiencyError,
      ProficiencyMarkCompleteProficiencyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    ProficiencyMarkCompleteProficiencyError,
    ProficiencyMarkCompleteProficiencyVariables
  >({
    mutationFn: (variables: ProficiencyMarkCompleteProficiencyVariables) =>
      fetchProficiencyMarkCompleteProficiency(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface ProficiencyMarkIncompleteProficiencyPathParams {
  /**
   * @format uuid
   */
  proficiencyId: string;
  /**
   * @format uuid
   */
  userId: string;
  bubbleId: string;
}

export type ProficiencyMarkIncompleteProficiencyError = Fetcher.ErrorWrapper<undefined>;

export type ProficiencyMarkIncompleteProficiencyVariables = {
  pathParams: ProficiencyMarkIncompleteProficiencyPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchProficiencyMarkIncompleteProficiency = (
  variables: ProficiencyMarkIncompleteProficiencyVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    ProficiencyMarkIncompleteProficiencyError,
    undefined,
    {},
    {},
    ProficiencyMarkIncompleteProficiencyPathParams
  >({
    method: "delete",
    url: "/api/v1/Bubbles/{bubbleId}/proficiency/{proficiencyId}/user/{userId}/complete",
    ...variables,
    signal,
  });

export const useProficiencyMarkIncompleteProficiency = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ProficiencyMarkIncompleteProficiencyError,
      ProficiencyMarkIncompleteProficiencyVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    ProficiencyMarkIncompleteProficiencyError,
    ProficiencyMarkIncompleteProficiencyVariables
  >({
    mutationFn: (variables: ProficiencyMarkIncompleteProficiencyVariables) =>
      fetchProficiencyMarkIncompleteProficiency(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface ProfileGetProfilePathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type ProfileGetProfileError = Fetcher.ErrorWrapper<undefined>;

export type ProfileGetProfileVariables = {
  pathParams: ProfileGetProfilePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchProfileGetProfile = (variables: ProfileGetProfileVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, ProfileGetProfileError, undefined, {}, {}, ProfileGetProfilePathParams>({
    method: "get",
    url: "/api/v1/Profile/{userId}",
    ...variables,
    signal,
  });

export function profileGetProfileQuery(variables: ProfileGetProfileVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function profileGetProfileQuery(variables: ProfileGetProfileVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function profileGetProfileQuery(variables: ProfileGetProfileVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchProfileGetProfile(variables, signal),
    queryKey: queryKeyFn({
      operationId: "profileGetProfile",
      path: "/api/v1/Profile/{userId}",
      variables,
    }),
  };
}

export const useSuspenseProfileGetProfile = <TData = undefined>(
  variables: ProfileGetProfileVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, ProfileGetProfileError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, ProfileGetProfileError, TData>({
    ...profileGetProfileQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useProfileGetProfile = <TData = undefined>(
  variables: ProfileGetProfileVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, ProfileGetProfileError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, ProfileGetProfileError, TData>({
    ...profileGetProfileQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface ProfileUploadProfilePicturePathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type ProfileUploadProfilePictureError = Fetcher.ErrorWrapper<undefined>;

export interface ProfileUploadProfilePictureRequestBody {
  /**
   * @format binary
   */
  FormFile?: Blob;
}

export type ProfileUploadProfilePictureVariables = {
  body?: ProfileUploadProfilePictureRequestBody;
  pathParams: ProfileUploadProfilePicturePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchProfileUploadProfilePicture = (
  variables: ProfileUploadProfilePictureVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    ProfileUploadProfilePictureError,
    ProfileUploadProfilePictureRequestBody,
    {},
    {},
    ProfileUploadProfilePicturePathParams
  >({ method: "put", url: "/api/v1/Profile/{userId}/picture", ...variables, signal });

export const useProfileUploadProfilePicture = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, ProfileUploadProfilePictureError, ProfileUploadProfilePictureVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, ProfileUploadProfilePictureError, ProfileUploadProfilePictureVariables>({
    mutationFn: (variables: ProfileUploadProfilePictureVariables) =>
      fetchProfileUploadProfilePicture(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface ProfileGetProfilePicturePathParams {
  /**
   * Required, non-null
   *
   * @format uuid
   */
  userId: string;
}

export type ProfileGetProfilePictureError = Fetcher.ErrorWrapper<undefined>;

export type ProfileGetProfilePictureVariables = {
  pathParams: ProfileGetProfilePicturePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchProfileGetProfilePicture = (variables: ProfileGetProfilePictureVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    ProfileGetProfilePictureError,
    undefined,
    {},
    {},
    ProfileGetProfilePicturePathParams
  >({ method: "get", url: "/api/v1/Profile/{userId}/picture", ...variables, signal });

export function profileGetProfilePictureQuery(variables: ProfileGetProfilePictureVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function profileGetProfilePictureQuery(variables: ProfileGetProfilePictureVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function profileGetProfilePictureQuery(variables: ProfileGetProfilePictureVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchProfileGetProfilePicture(variables, signal),
    queryKey: queryKeyFn({
      operationId: "profileGetProfilePicture",
      path: "/api/v1/Profile/{userId}/picture",
      variables,
    }),
  };
}

export const useSuspenseProfileGetProfilePicture = <TData = undefined>(
  variables: ProfileGetProfilePictureVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, ProfileGetProfilePictureError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, ProfileGetProfilePictureError, TData>({
    ...profileGetProfilePictureQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useProfileGetProfilePicture = <TData = undefined>(
  variables: ProfileGetProfilePictureVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, ProfileGetProfilePictureError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, ProfileGetProfilePictureError, TData>({
    ...profileGetProfilePictureQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface ProfileUpdatePersonalInformationPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type ProfileUpdatePersonalInformationError = Fetcher.ErrorWrapper<undefined>;

export type ProfileUpdatePersonalInformationVariables = {
  body: Schemas.PersonalInfoUpdateRequest;
  pathParams: ProfileUpdatePersonalInformationPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchProfileUpdatePersonalInformation = (
  variables: ProfileUpdatePersonalInformationVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    ProfileUpdatePersonalInformationError,
    Schemas.PersonalInfoUpdateRequest,
    {},
    {},
    ProfileUpdatePersonalInformationPathParams
  >({ method: "put", url: "/api/v1/Profile/{userId}/personal-information", ...variables, signal });

export const useProfileUpdatePersonalInformation = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ProfileUpdatePersonalInformationError,
      ProfileUpdatePersonalInformationVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    ProfileUpdatePersonalInformationError,
    ProfileUpdatePersonalInformationVariables
  >({
    mutationFn: (variables: ProfileUpdatePersonalInformationVariables) =>
      fetchProfileUpdatePersonalInformation(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type PublicOrganizationGetDirectoryError = Fetcher.ErrorWrapper<undefined>;

export type PublicOrganizationGetDirectoryVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchPublicOrganizationGetDirectory = (
  variables: PublicOrganizationGetDirectoryVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<Schemas.PublicDirectoryResponseDto, PublicOrganizationGetDirectoryError, undefined, {}, {}, {}>(
    { method: "get", url: "/api/v1/public/organizations", ...variables, signal },
  );

export function publicOrganizationGetDirectoryQuery(variables: PublicOrganizationGetDirectoryVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.PublicDirectoryResponseDto>;
};

export function publicOrganizationGetDirectoryQuery(
  variables: PublicOrganizationGetDirectoryVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.PublicDirectoryResponseDto>) | reactQuery.SkipToken;
};

export function publicOrganizationGetDirectoryQuery(
  variables: PublicOrganizationGetDirectoryVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchPublicOrganizationGetDirectory(variables, signal),
    queryKey: queryKeyFn({
      operationId: "publicOrganizationGetDirectory",
      path: "/api/v1/public/organizations",
      variables,
    }),
  };
}

export const useSuspensePublicOrganizationGetDirectory = <TData = Schemas.PublicDirectoryResponseDto>(
  variables: PublicOrganizationGetDirectoryVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.PublicDirectoryResponseDto, PublicOrganizationGetDirectoryError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.PublicDirectoryResponseDto, PublicOrganizationGetDirectoryError, TData>({
    ...publicOrganizationGetDirectoryQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const usePublicOrganizationGetDirectory = <TData = Schemas.PublicDirectoryResponseDto>(
  variables: PublicOrganizationGetDirectoryVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.PublicDirectoryResponseDto, PublicOrganizationGetDirectoryError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.PublicDirectoryResponseDto, PublicOrganizationGetDirectoryError, TData>({
    ...publicOrganizationGetDirectoryQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface PublicOrganizationGetBySlugPathParams {
  /**
   * URL-safe identifier (e.g. "acme-foundation", "lincoln-elementary")
   */
  slug: string;
}

export type PublicOrganizationGetBySlugError = Fetcher.ErrorWrapper<{
  status: 404;
  payload: Schemas.ProblemDetails;
}>;

export type PublicOrganizationGetBySlugVariables = {
  pathParams: PublicOrganizationGetBySlugPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchPublicOrganizationGetBySlug = (
  variables: PublicOrganizationGetBySlugVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.PublicOrganizationPageDto,
    PublicOrganizationGetBySlugError,
    undefined,
    {},
    {},
    PublicOrganizationGetBySlugPathParams
  >({ method: "get", url: "/api/v1/public/organizations/{slug}", ...variables, signal });

export function publicOrganizationGetBySlugQuery(variables: PublicOrganizationGetBySlugVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.PublicOrganizationPageDto>;
};

export function publicOrganizationGetBySlugQuery(
  variables: PublicOrganizationGetBySlugVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.PublicOrganizationPageDto>) | reactQuery.SkipToken;
};

export function publicOrganizationGetBySlugQuery(
  variables: PublicOrganizationGetBySlugVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchPublicOrganizationGetBySlug(variables, signal),
    queryKey: queryKeyFn({
      operationId: "publicOrganizationGetBySlug",
      path: "/api/v1/public/organizations/{slug}",
      variables,
    }),
  };
}

export const useSuspensePublicOrganizationGetBySlug = <TData = Schemas.PublicOrganizationPageDto>(
  variables: PublicOrganizationGetBySlugVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.PublicOrganizationPageDto, PublicOrganizationGetBySlugError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.PublicOrganizationPageDto, PublicOrganizationGetBySlugError, TData>({
    ...publicOrganizationGetBySlugQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const usePublicOrganizationGetBySlug = <TData = Schemas.PublicOrganizationPageDto>(
  variables: PublicOrganizationGetBySlugVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.PublicOrganizationPageDto, PublicOrganizationGetBySlugError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.PublicOrganizationPageDto, PublicOrganizationGetBySlugError, TData>({
    ...publicOrganizationGetBySlugQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface PublicOrganizationGetUpcomingEventsPathParams {
  /**
   * URL-safe identifier
   */
  slug: string;
}

export interface PublicOrganizationGetUpcomingEventsQueryParams {
  /**
   * Max events to return (default 20)
   *
   * @format int32
   * @default 20
   */
  limit?: number;
}

export type PublicOrganizationGetUpcomingEventsError = Fetcher.ErrorWrapper<{
  status: 404;
  payload: Schemas.ProblemDetails;
}>;

export type PublicOrganizationGetUpcomingEventsResponse = Schemas.PublicUpcomingEventDto[];

export type PublicOrganizationGetUpcomingEventsVariables = {
  pathParams: PublicOrganizationGetUpcomingEventsPathParams;
  queryParams?: PublicOrganizationGetUpcomingEventsQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchPublicOrganizationGetUpcomingEvents = (
  variables: PublicOrganizationGetUpcomingEventsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    PublicOrganizationGetUpcomingEventsResponse,
    PublicOrganizationGetUpcomingEventsError,
    undefined,
    {},
    PublicOrganizationGetUpcomingEventsQueryParams,
    PublicOrganizationGetUpcomingEventsPathParams
  >({ method: "get", url: "/api/v1/public/organizations/{slug}/upcoming-events", ...variables, signal });

export function publicOrganizationGetUpcomingEventsQuery(variables: PublicOrganizationGetUpcomingEventsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<PublicOrganizationGetUpcomingEventsResponse>;
};

export function publicOrganizationGetUpcomingEventsQuery(
  variables: PublicOrganizationGetUpcomingEventsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<PublicOrganizationGetUpcomingEventsResponse>) | reactQuery.SkipToken;
};

export function publicOrganizationGetUpcomingEventsQuery(
  variables: PublicOrganizationGetUpcomingEventsVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchPublicOrganizationGetUpcomingEvents(variables, signal),
    queryKey: queryKeyFn({
      operationId: "publicOrganizationGetUpcomingEvents",
      path: "/api/v1/public/organizations/{slug}/upcoming-events",
      variables,
    }),
  };
}

export const useSuspensePublicOrganizationGetUpcomingEvents = <TData = PublicOrganizationGetUpcomingEventsResponse>(
  variables: PublicOrganizationGetUpcomingEventsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      PublicOrganizationGetUpcomingEventsResponse,
      PublicOrganizationGetUpcomingEventsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    PublicOrganizationGetUpcomingEventsResponse,
    PublicOrganizationGetUpcomingEventsError,
    TData
  >({
    ...publicOrganizationGetUpcomingEventsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const usePublicOrganizationGetUpcomingEvents = <TData = PublicOrganizationGetUpcomingEventsResponse>(
  variables: PublicOrganizationGetUpcomingEventsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      PublicOrganizationGetUpcomingEventsResponse,
      PublicOrganizationGetUpcomingEventsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    PublicOrganizationGetUpcomingEventsResponse,
    PublicOrganizationGetUpcomingEventsError,
    TData
  >({
    ...publicOrganizationGetUpcomingEventsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface PublicSlugCheckAvailabilityPathParams {
  /**
   * URL-safe identifier to check
   */
  slug: string;
}

export interface PublicSlugCheckAvailabilityQueryParams {
  /**
   * Bubble being edited (excluded from check)
   *
   * @format uuid
   */
  excludeBubbleId?: string;
}

export type PublicSlugCheckAvailabilityError = Fetcher.ErrorWrapper<undefined>;

export type PublicSlugCheckAvailabilityVariables = {
  pathParams: PublicSlugCheckAvailabilityPathParams;
  queryParams?: PublicSlugCheckAvailabilityQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchPublicSlugCheckAvailability = (
  variables: PublicSlugCheckAvailabilityVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.SlugAvailabilityResponse,
    PublicSlugCheckAvailabilityError,
    undefined,
    {},
    PublicSlugCheckAvailabilityQueryParams,
    PublicSlugCheckAvailabilityPathParams
  >({ method: "get", url: "/api/v1/public/slugs/available/{slug}", ...variables, signal });

export function publicSlugCheckAvailabilityQuery(variables: PublicSlugCheckAvailabilityVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.SlugAvailabilityResponse>;
};

export function publicSlugCheckAvailabilityQuery(
  variables: PublicSlugCheckAvailabilityVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.SlugAvailabilityResponse>) | reactQuery.SkipToken;
};

export function publicSlugCheckAvailabilityQuery(
  variables: PublicSlugCheckAvailabilityVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchPublicSlugCheckAvailability(variables, signal),
    queryKey: queryKeyFn({
      operationId: "publicSlugCheckAvailability",
      path: "/api/v1/public/slugs/available/{slug}",
      variables,
    }),
  };
}

export const useSuspensePublicSlugCheckAvailability = <TData = Schemas.SlugAvailabilityResponse>(
  variables: PublicSlugCheckAvailabilityVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.SlugAvailabilityResponse, PublicSlugCheckAvailabilityError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.SlugAvailabilityResponse, PublicSlugCheckAvailabilityError, TData>({
    ...publicSlugCheckAvailabilityQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const usePublicSlugCheckAvailability = <TData = Schemas.SlugAvailabilityResponse>(
  variables: PublicSlugCheckAvailabilityVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.SlugAvailabilityResponse, PublicSlugCheckAvailabilityError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.SlugAvailabilityResponse, PublicSlugCheckAvailabilityError, TData>({
    ...publicSlugCheckAvailabilityQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface ReportReportPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  offender: string;
}

export type ReportReportError = Fetcher.ErrorWrapper<undefined>;

export type ReportReportVariables = {
  body?: Schemas.ReportDto;
  pathParams: ReportReportPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchReportReport = (variables: ReportReportVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, ReportReportError, Schemas.ReportDto, {}, {}, ReportReportPathParams>({
    method: "post",
    url: "/api/Report/{offender}",
    ...variables,
    signal,
  });

export const useReportReport = (
  options?: Omit<reactQuery.UseMutationOptions<undefined, ReportReportError, ReportReportVariables>, "mutationFn">,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, ReportReportError, ReportReportVariables>({
    mutationFn: (variables: ReportReportVariables) => fetchReportReport(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type ReportGetCategoriesError = Fetcher.ErrorWrapper<undefined>;

export type ReportGetCategoriesResponse = string[];

export type ReportGetCategoriesVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchReportGetCategories = (variables: ReportGetCategoriesVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<ReportGetCategoriesResponse, ReportGetCategoriesError, undefined, {}, {}, {}>({
    method: "get",
    url: "/api/Report/categories",
    ...variables,
    signal,
  });

export function reportGetCategoriesQuery(variables: ReportGetCategoriesVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<ReportGetCategoriesResponse>;
};

export function reportGetCategoriesQuery(variables: ReportGetCategoriesVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<ReportGetCategoriesResponse>) | reactQuery.SkipToken;
};

export function reportGetCategoriesQuery(variables: ReportGetCategoriesVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchReportGetCategories(variables, signal),
    queryKey: queryKeyFn({
      operationId: "reportGetCategories",
      path: "/api/Report/categories",
      variables,
    }),
  };
}

export const useSuspenseReportGetCategories = <TData = ReportGetCategoriesResponse>(
  variables: ReportGetCategoriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<ReportGetCategoriesResponse, ReportGetCategoriesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<ReportGetCategoriesResponse, ReportGetCategoriesError, TData>({
    ...reportGetCategoriesQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useReportGetCategories = <TData = ReportGetCategoriesResponse>(
  variables: ReportGetCategoriesVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<ReportGetCategoriesResponse, ReportGetCategoriesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<ReportGetCategoriesResponse, ReportGetCategoriesError, TData>({
    ...reportGetCategoriesQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export type ReportGetUnresolvedReportsError = Fetcher.ErrorWrapper<undefined>;

export type ReportGetUnresolvedReportsResponse = Schemas.ReportDto[];

export type ReportGetUnresolvedReportsVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchReportGetUnresolvedReports = (variables: ReportGetUnresolvedReportsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<ReportGetUnresolvedReportsResponse, ReportGetUnresolvedReportsError, undefined, {}, {}, {}>({
    method: "get",
    url: "/api/Report/unresolved",
    ...variables,
    signal,
  });

export function reportGetUnresolvedReportsQuery(variables: ReportGetUnresolvedReportsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<ReportGetUnresolvedReportsResponse>;
};

export function reportGetUnresolvedReportsQuery(
  variables: ReportGetUnresolvedReportsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<ReportGetUnresolvedReportsResponse>) | reactQuery.SkipToken;
};

export function reportGetUnresolvedReportsQuery(variables: ReportGetUnresolvedReportsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchReportGetUnresolvedReports(variables, signal),
    queryKey: queryKeyFn({
      operationId: "reportGetUnresolvedReports",
      path: "/api/Report/unresolved",
      variables,
    }),
  };
}

export const useSuspenseReportGetUnresolvedReports = <TData = ReportGetUnresolvedReportsResponse>(
  variables: ReportGetUnresolvedReportsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<ReportGetUnresolvedReportsResponse, ReportGetUnresolvedReportsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<ReportGetUnresolvedReportsResponse, ReportGetUnresolvedReportsError, TData>({
    ...reportGetUnresolvedReportsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useReportGetUnresolvedReports = <TData = ReportGetUnresolvedReportsResponse>(
  variables: ReportGetUnresolvedReportsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<ReportGetUnresolvedReportsResponse, ReportGetUnresolvedReportsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<ReportGetUnresolvedReportsResponse, ReportGetUnresolvedReportsError, TData>({
    ...reportGetUnresolvedReportsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ReportAddModeratorResponseError = Fetcher.ErrorWrapper<undefined>;

export type ReportAddModeratorResponseVariables = {
  body?: Schemas.ReportDto;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchReportAddModeratorResponse = (variables: ReportAddModeratorResponseVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, ReportAddModeratorResponseError, Schemas.ReportDto, {}, {}, {}>({
    method: "put",
    url: "/api/Report/moderator-response",
    ...variables,
    signal,
  });

export const useReportAddModeratorResponse = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, ReportAddModeratorResponseError, ReportAddModeratorResponseVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, ReportAddModeratorResponseError, ReportAddModeratorResponseVariables>({
    mutationFn: (variables: ReportAddModeratorResponseVariables) =>
      fetchReportAddModeratorResponse(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type ResumeGetValidFileExtensionsError = Fetcher.ErrorWrapper<undefined>;

export type ResumeGetValidFileExtensionsResponse = string[];

export type ResumeGetValidFileExtensionsVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchResumeGetValidFileExtensions = (
  variables: ResumeGetValidFileExtensionsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<ResumeGetValidFileExtensionsResponse, ResumeGetValidFileExtensionsError, undefined, {}, {}, {}>(
    { method: "get", url: "/api/Resume/valid-file-extensions", ...variables, signal },
  );

export function resumeGetValidFileExtensionsQuery(variables: ResumeGetValidFileExtensionsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<ResumeGetValidFileExtensionsResponse>;
};

export function resumeGetValidFileExtensionsQuery(
  variables: ResumeGetValidFileExtensionsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<ResumeGetValidFileExtensionsResponse>) | reactQuery.SkipToken;
};

export function resumeGetValidFileExtensionsQuery(
  variables: ResumeGetValidFileExtensionsVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchResumeGetValidFileExtensions(variables, signal),
    queryKey: queryKeyFn({
      operationId: "resumeGetValidFileExtensions",
      path: "/api/Resume/valid-file-extensions",
      variables,
    }),
  };
}

export const useSuspenseResumeGetValidFileExtensions = <TData = ResumeGetValidFileExtensionsResponse>(
  variables: ResumeGetValidFileExtensionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<ResumeGetValidFileExtensionsResponse, ResumeGetValidFileExtensionsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<ResumeGetValidFileExtensionsResponse, ResumeGetValidFileExtensionsError, TData>({
    ...resumeGetValidFileExtensionsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useResumeGetValidFileExtensions = <TData = ResumeGetValidFileExtensionsResponse>(
  variables: ResumeGetValidFileExtensionsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<ResumeGetValidFileExtensionsResponse, ResumeGetValidFileExtensionsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<ResumeGetValidFileExtensionsResponse, ResumeGetValidFileExtensionsError, TData>({
    ...resumeGetValidFileExtensionsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ResumeUpsertUserResumeError = Fetcher.ErrorWrapper<undefined>;

export type ResumeUpsertUserResumeVariables = {
  body?: Schemas.ResumeDto;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchResumeUpsertUserResume = (variables: ResumeUpsertUserResumeVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, ResumeUpsertUserResumeError, Schemas.ResumeDto, {}, {}, {}>({
    method: "put",
    url: "/api/Resume/update",
    ...variables,
    signal,
  });

export const useResumeUpsertUserResume = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, ResumeUpsertUserResumeError, ResumeUpsertUserResumeVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, ResumeUpsertUserResumeError, ResumeUpsertUserResumeVariables>({
    mutationFn: (variables: ResumeUpsertUserResumeVariables) =>
      fetchResumeUpsertUserResume(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface ResumeGetUserResumePathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type ResumeGetUserResumeError = Fetcher.ErrorWrapper<undefined>;

export type ResumeGetUserResumeVariables = {
  pathParams: ResumeGetUserResumePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchResumeGetUserResume = (variables: ResumeGetUserResumeVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<Schemas.ResumeDto, ResumeGetUserResumeError, undefined, {}, {}, ResumeGetUserResumePathParams>({
    method: "get",
    url: "/api/Resume/user/{userId}",
    ...variables,
    signal,
  });

export function resumeGetUserResumeQuery(variables: ResumeGetUserResumeVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ResumeDto>;
};

export function resumeGetUserResumeQuery(variables: ResumeGetUserResumeVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.ResumeDto>) | reactQuery.SkipToken;
};

export function resumeGetUserResumeQuery(variables: ResumeGetUserResumeVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchResumeGetUserResume(variables, signal),
    queryKey: queryKeyFn({
      operationId: "resumeGetUserResume",
      path: "/api/Resume/user/{userId}",
      variables,
    }),
  };
}

export const useSuspenseResumeGetUserResume = <TData = Schemas.ResumeDto>(
  variables: ResumeGetUserResumeVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ResumeDto, ResumeGetUserResumeError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.ResumeDto, ResumeGetUserResumeError, TData>({
    ...resumeGetUserResumeQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useResumeGetUserResume = <TData = Schemas.ResumeDto>(
  variables: ResumeGetUserResumeVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ResumeDto, ResumeGetUserResumeError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.ResumeDto, ResumeGetUserResumeError, TData>({
    ...resumeGetUserResumeQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface ResumeParseFileIntoResumePathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type ResumeParseFileIntoResumeError = Fetcher.ErrorWrapper<undefined>;

export interface ResumeParseFileIntoResumeRequestBody {
  /**
   * @format binary
   */
  FormFile?: Blob;
}

export type ResumeParseFileIntoResumeVariables = {
  body?: ResumeParseFileIntoResumeRequestBody;
  pathParams: ResumeParseFileIntoResumePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchResumeParseFileIntoResume = (variables: ResumeParseFileIntoResumeVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.ResumeDto,
    ResumeParseFileIntoResumeError,
    ResumeParseFileIntoResumeRequestBody,
    {},
    {},
    ResumeParseFileIntoResumePathParams
  >({ method: "post", url: "/api/Resume/user/{userId}/parse-file", ...variables, signal });

export const useResumeParseFileIntoResume = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ResumeDto,
      ResumeParseFileIntoResumeError,
      ResumeParseFileIntoResumeVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<Schemas.ResumeDto, ResumeParseFileIntoResumeError, ResumeParseFileIntoResumeVariables>({
    mutationFn: (variables: ResumeParseFileIntoResumeVariables) =>
      fetchResumeParseFileIntoResume(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type ResumeGetCertsAndSkillsError = Fetcher.ErrorWrapper<undefined>;

export type ResumeGetCertsAndSkillsVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchResumeGetCertsAndSkills = (variables: ResumeGetCertsAndSkillsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<Schemas.CertsAndSkillsDto, ResumeGetCertsAndSkillsError, undefined, {}, {}, {}>({
    method: "get",
    url: "/api/Resume/skills-and-certs-stats",
    ...variables,
    signal,
  });

export function resumeGetCertsAndSkillsQuery(variables: ResumeGetCertsAndSkillsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.CertsAndSkillsDto>;
};

export function resumeGetCertsAndSkillsQuery(variables: ResumeGetCertsAndSkillsVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.CertsAndSkillsDto>) | reactQuery.SkipToken;
};

export function resumeGetCertsAndSkillsQuery(variables: ResumeGetCertsAndSkillsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchResumeGetCertsAndSkills(variables, signal),
    queryKey: queryKeyFn({
      operationId: "resumeGetCertsAndSkills",
      path: "/api/Resume/skills-and-certs-stats",
      variables,
    }),
  };
}

export const useSuspenseResumeGetCertsAndSkills = <TData = Schemas.CertsAndSkillsDto>(
  variables: ResumeGetCertsAndSkillsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.CertsAndSkillsDto, ResumeGetCertsAndSkillsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.CertsAndSkillsDto, ResumeGetCertsAndSkillsError, TData>({
    ...resumeGetCertsAndSkillsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useResumeGetCertsAndSkills = <TData = Schemas.CertsAndSkillsDto>(
  variables: ResumeGetCertsAndSkillsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.CertsAndSkillsDto, ResumeGetCertsAndSkillsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.CertsAndSkillsDto, ResumeGetCertsAndSkillsError, TData>({
    ...resumeGetCertsAndSkillsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type ResumeGetEmploymentPreferenceTagsCatalogError = Fetcher.ErrorWrapper<undefined>;

export type ResumeGetEmploymentPreferenceTagsCatalogResponse = Schemas.EmploymentPreferenceTagDto[];

export type ResumeGetEmploymentPreferenceTagsCatalogVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchResumeGetEmploymentPreferenceTagsCatalog = (
  variables: ResumeGetEmploymentPreferenceTagsCatalogVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    ResumeGetEmploymentPreferenceTagsCatalogResponse,
    ResumeGetEmploymentPreferenceTagsCatalogError,
    undefined,
    {},
    {},
    {}
  >({ method: "get", url: "/api/Resume/employment-preference-tags", ...variables, signal });

export function resumeGetEmploymentPreferenceTagsCatalogQuery(
  variables: ResumeGetEmploymentPreferenceTagsCatalogVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<ResumeGetEmploymentPreferenceTagsCatalogResponse>;
};

export function resumeGetEmploymentPreferenceTagsCatalogQuery(
  variables: ResumeGetEmploymentPreferenceTagsCatalogVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<ResumeGetEmploymentPreferenceTagsCatalogResponse>)
    | reactQuery.SkipToken;
};

export function resumeGetEmploymentPreferenceTagsCatalogQuery(
  variables: ResumeGetEmploymentPreferenceTagsCatalogVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchResumeGetEmploymentPreferenceTagsCatalog(variables, signal),
    queryKey: queryKeyFn({
      operationId: "resumeGetEmploymentPreferenceTagsCatalog",
      path: "/api/Resume/employment-preference-tags",
      variables,
    }),
  };
}

export const useSuspenseResumeGetEmploymentPreferenceTagsCatalog = <
  TData = ResumeGetEmploymentPreferenceTagsCatalogResponse,
>(
  variables: ResumeGetEmploymentPreferenceTagsCatalogVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ResumeGetEmploymentPreferenceTagsCatalogResponse,
      ResumeGetEmploymentPreferenceTagsCatalogError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    ResumeGetEmploymentPreferenceTagsCatalogResponse,
    ResumeGetEmploymentPreferenceTagsCatalogError,
    TData
  >({
    ...resumeGetEmploymentPreferenceTagsCatalogQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useResumeGetEmploymentPreferenceTagsCatalog = <TData = ResumeGetEmploymentPreferenceTagsCatalogResponse>(
  variables: ResumeGetEmploymentPreferenceTagsCatalogVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ResumeGetEmploymentPreferenceTagsCatalogResponse,
      ResumeGetEmploymentPreferenceTagsCatalogError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    ResumeGetEmploymentPreferenceTagsCatalogResponse,
    ResumeGetEmploymentPreferenceTagsCatalogError,
    TData
  >({
    ...resumeGetEmploymentPreferenceTagsCatalogQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface ResumeGetUserEmploymentPreferenceTagsPathParams {
  /**
   * @format uuid
   */
  userId: string;
}

export type ResumeGetUserEmploymentPreferenceTagsError = Fetcher.ErrorWrapper<undefined>;

export type ResumeGetUserEmploymentPreferenceTagsResponse = string[];

export type ResumeGetUserEmploymentPreferenceTagsVariables = {
  pathParams: ResumeGetUserEmploymentPreferenceTagsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchResumeGetUserEmploymentPreferenceTags = (
  variables: ResumeGetUserEmploymentPreferenceTagsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    ResumeGetUserEmploymentPreferenceTagsResponse,
    ResumeGetUserEmploymentPreferenceTagsError,
    undefined,
    {},
    {},
    ResumeGetUserEmploymentPreferenceTagsPathParams
  >({ method: "get", url: "/api/Resume/user/{userId}/employment-preference-tags", ...variables, signal });

export function resumeGetUserEmploymentPreferenceTagsQuery(variables: ResumeGetUserEmploymentPreferenceTagsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<ResumeGetUserEmploymentPreferenceTagsResponse>;
};

export function resumeGetUserEmploymentPreferenceTagsQuery(
  variables: ResumeGetUserEmploymentPreferenceTagsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<ResumeGetUserEmploymentPreferenceTagsResponse>) | reactQuery.SkipToken;
};

export function resumeGetUserEmploymentPreferenceTagsQuery(
  variables: ResumeGetUserEmploymentPreferenceTagsVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchResumeGetUserEmploymentPreferenceTags(variables, signal),
    queryKey: queryKeyFn({
      operationId: "resumeGetUserEmploymentPreferenceTags",
      path: "/api/Resume/user/{userId}/employment-preference-tags",
      variables,
    }),
  };
}

export const useSuspenseResumeGetUserEmploymentPreferenceTags = <TData = ResumeGetUserEmploymentPreferenceTagsResponse>(
  variables: ResumeGetUserEmploymentPreferenceTagsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ResumeGetUserEmploymentPreferenceTagsResponse,
      ResumeGetUserEmploymentPreferenceTagsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    ResumeGetUserEmploymentPreferenceTagsResponse,
    ResumeGetUserEmploymentPreferenceTagsError,
    TData
  >({
    ...resumeGetUserEmploymentPreferenceTagsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useResumeGetUserEmploymentPreferenceTags = <TData = ResumeGetUserEmploymentPreferenceTagsResponse>(
  variables: ResumeGetUserEmploymentPreferenceTagsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      ResumeGetUserEmploymentPreferenceTagsResponse,
      ResumeGetUserEmploymentPreferenceTagsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    ResumeGetUserEmploymentPreferenceTagsResponse,
    ResumeGetUserEmploymentPreferenceTagsError,
    TData
  >({
    ...resumeGetUserEmploymentPreferenceTagsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface ResumePutUserEmploymentPreferenceTagsPathParams {
  /**
   * @format uuid
   */
  userId: string;
}

export type ResumePutUserEmploymentPreferenceTagsError = Fetcher.ErrorWrapper<undefined>;

export type ResumePutUserEmploymentPreferenceTagsVariables = {
  body?: Schemas.SetUserEmploymentPreferenceTagsRequest;
  pathParams: ResumePutUserEmploymentPreferenceTagsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchResumePutUserEmploymentPreferenceTags = (
  variables: ResumePutUserEmploymentPreferenceTagsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    ResumePutUserEmploymentPreferenceTagsError,
    Schemas.SetUserEmploymentPreferenceTagsRequest,
    {},
    {},
    ResumePutUserEmploymentPreferenceTagsPathParams
  >({ method: "put", url: "/api/Resume/user/{userId}/employment-preference-tags", ...variables, signal });

export const useResumePutUserEmploymentPreferenceTags = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      ResumePutUserEmploymentPreferenceTagsError,
      ResumePutUserEmploymentPreferenceTagsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    ResumePutUserEmploymentPreferenceTagsError,
    ResumePutUserEmploymentPreferenceTagsVariables
  >({
    mutationFn: (variables: ResumePutUserEmploymentPreferenceTagsVariables) =>
      fetchResumePutUserEmploymentPreferenceTags(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomGetRoomPathParams {
  /**
   * Required, non-null
   *
   * @format uuid
   */
  roomId: string;
}

export type RoomGetRoomError = Fetcher.ErrorWrapper<undefined>;

export type RoomGetRoomVariables = {
  pathParams: RoomGetRoomPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomGetRoom = (variables: RoomGetRoomVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<Schemas.RoomDto, RoomGetRoomError, undefined, {}, {}, RoomGetRoomPathParams>({
    method: "get",
    url: "/api/v1/room/{roomId}",
    ...variables,
    signal,
  });

export function roomGetRoomQuery(variables: RoomGetRoomVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.RoomDto>;
};

export function roomGetRoomQuery(variables: RoomGetRoomVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.RoomDto>) | reactQuery.SkipToken;
};

export function roomGetRoomQuery(variables: RoomGetRoomVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchRoomGetRoom(variables, signal),
    queryKey: queryKeyFn({
      operationId: "roomGetRoom",
      path: "/api/v1/room/{roomId}",
      variables,
    }),
  };
}

export const useSuspenseRoomGetRoom = <TData = Schemas.RoomDto>(
  variables: RoomGetRoomVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.RoomDto, RoomGetRoomError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.RoomDto, RoomGetRoomError, TData>({
    ...roomGetRoomQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useRoomGetRoom = <TData = Schemas.RoomDto>(
  variables: RoomGetRoomVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.RoomDto, RoomGetRoomError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.RoomDto, RoomGetRoomError, TData>({
    ...roomGetRoomQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface RoomDeleteRoomPathParams {
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  roomId: string;
}

export type RoomDeleteRoomError = Fetcher.ErrorWrapper<undefined>;

export type RoomDeleteRoomVariables = {
  pathParams: RoomDeleteRoomPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomDeleteRoom = (variables: RoomDeleteRoomVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, RoomDeleteRoomError, undefined, {}, {}, RoomDeleteRoomPathParams>({
    method: "delete",
    url: "/api/v1/room/{roomId}",
    ...variables,
    signal,
  });

export const useRoomDeleteRoom = (
  options?: Omit<reactQuery.UseMutationOptions<undefined, RoomDeleteRoomError, RoomDeleteRoomVariables>, "mutationFn">,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, RoomDeleteRoomError, RoomDeleteRoomVariables>({
    mutationFn: (variables: RoomDeleteRoomVariables) => fetchRoomDeleteRoom(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomGetMyRoomsPathParams {
  /**
   * Required, non-default
   *
   * @format uuid
   */
  userId: string;
}

export type RoomGetMyRoomsError = Fetcher.ErrorWrapper<undefined>;

export type RoomGetMyRoomsResponse = Schemas.RoomDto[];

export type RoomGetMyRoomsVariables = {
  pathParams: RoomGetMyRoomsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomGetMyRooms = (variables: RoomGetMyRoomsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<RoomGetMyRoomsResponse, RoomGetMyRoomsError, undefined, {}, {}, RoomGetMyRoomsPathParams>({
    method: "get",
    url: "/api/v1/room/my-rooms/{userId}",
    ...variables,
    signal,
  });

export function roomGetMyRoomsQuery(variables: RoomGetMyRoomsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<RoomGetMyRoomsResponse>;
};

export function roomGetMyRoomsQuery(variables: RoomGetMyRoomsVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<RoomGetMyRoomsResponse>) | reactQuery.SkipToken;
};

export function roomGetMyRoomsQuery(variables: RoomGetMyRoomsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchRoomGetMyRooms(variables, signal),
    queryKey: queryKeyFn({
      operationId: "roomGetMyRooms",
      path: "/api/v1/room/my-rooms/{userId}",
      variables,
    }),
  };
}

export const useSuspenseRoomGetMyRooms = <TData = RoomGetMyRoomsResponse>(
  variables: RoomGetMyRoomsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<RoomGetMyRoomsResponse, RoomGetMyRoomsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<RoomGetMyRoomsResponse, RoomGetMyRoomsError, TData>({
    ...roomGetMyRoomsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useRoomGetMyRooms = <TData = RoomGetMyRoomsResponse>(
  variables: RoomGetMyRoomsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<RoomGetMyRoomsResponse, RoomGetMyRoomsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<RoomGetMyRoomsResponse, RoomGetMyRoomsError, TData>({
    ...roomGetMyRoomsQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export type RoomCreateRoomError = Fetcher.ErrorWrapper<undefined>;

export type RoomCreateRoomVariables = {
  body: Schemas.CreateRoomRequest;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomCreateRoom = (variables: RoomCreateRoomVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<Schemas.RoomDto, RoomCreateRoomError, Schemas.CreateRoomRequest, {}, {}, {}>({
    method: "post",
    url: "/api/v1/room",
    ...variables,
    signal,
  });

export const useRoomCreateRoom = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.RoomDto, RoomCreateRoomError, RoomCreateRoomVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<Schemas.RoomDto, RoomCreateRoomError, RoomCreateRoomVariables>({
    mutationFn: (variables: RoomCreateRoomVariables) => fetchRoomCreateRoom(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomUpdateRoomPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  roomId: string;
}

export type RoomUpdateRoomError = Fetcher.ErrorWrapper<undefined>;

export type RoomUpdateRoomVariables = {
  body: Schemas.UpdateRoomRequest;
  pathParams: RoomUpdateRoomPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomUpdateRoom = (variables: RoomUpdateRoomVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, RoomUpdateRoomError, Schemas.UpdateRoomRequest, {}, {}, RoomUpdateRoomPathParams>({
    method: "post",
    url: "/api/v1/room/{roomId}/update",
    ...variables,
    signal,
  });

export const useRoomUpdateRoom = (
  options?: Omit<reactQuery.UseMutationOptions<undefined, RoomUpdateRoomError, RoomUpdateRoomVariables>, "mutationFn">,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, RoomUpdateRoomError, RoomUpdateRoomVariables>({
    mutationFn: (variables: RoomUpdateRoomVariables) => fetchRoomUpdateRoom(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomAddToRoomPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  roomId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type RoomAddToRoomError = Fetcher.ErrorWrapper<undefined>;

export type RoomAddToRoomVariables = {
  pathParams: RoomAddToRoomPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomAddToRoom = (variables: RoomAddToRoomVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, RoomAddToRoomError, undefined, {}, {}, RoomAddToRoomPathParams>({
    method: "post",
    url: "/api/v1/room/{roomId}/add/{userId}",
    ...variables,
    signal,
  });

export const useRoomAddToRoom = (
  options?: Omit<reactQuery.UseMutationOptions<undefined, RoomAddToRoomError, RoomAddToRoomVariables>, "mutationFn">,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, RoomAddToRoomError, RoomAddToRoomVariables>({
    mutationFn: (variables: RoomAddToRoomVariables) => fetchRoomAddToRoom(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomAddToRoomByEmailPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  roomId: string;
}

export type RoomAddToRoomByEmailError = Fetcher.ErrorWrapper<undefined>;

export type RoomAddToRoomByEmailVariables = {
  body: Schemas.AddMemberRequest;
  pathParams: RoomAddToRoomByEmailPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomAddToRoomByEmail = (variables: RoomAddToRoomByEmailVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    RoomAddToRoomByEmailError,
    Schemas.AddMemberRequest,
    {},
    {},
    RoomAddToRoomByEmailPathParams
  >({ method: "post", url: "/api/v1/room/{roomId}/add-member-by-email", ...variables, signal });

export const useRoomAddToRoomByEmail = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, RoomAddToRoomByEmailError, RoomAddToRoomByEmailVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, RoomAddToRoomByEmailError, RoomAddToRoomByEmailVariables>({
    mutationFn: (variables: RoomAddToRoomByEmailVariables) =>
      fetchRoomAddToRoomByEmail(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomRequestAddToRoomPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  roomId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type RoomRequestAddToRoomError = Fetcher.ErrorWrapper<undefined>;

export type RoomRequestAddToRoomVariables = {
  pathParams: RoomRequestAddToRoomPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomRequestAddToRoom = (variables: RoomRequestAddToRoomVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, RoomRequestAddToRoomError, undefined, {}, {}, RoomRequestAddToRoomPathParams>({
    method: "post",
    url: "/api/v1/room/{roomId}/request/{userId}",
    ...variables,
    signal,
  });

export const useRoomRequestAddToRoom = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, RoomRequestAddToRoomError, RoomRequestAddToRoomVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, RoomRequestAddToRoomError, RoomRequestAddToRoomVariables>({
    mutationFn: (variables: RoomRequestAddToRoomVariables) =>
      fetchRoomRequestAddToRoom(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomCancelRequestAddToRoomPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  roomId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type RoomCancelRequestAddToRoomError = Fetcher.ErrorWrapper<undefined>;

export type RoomCancelRequestAddToRoomVariables = {
  pathParams: RoomCancelRequestAddToRoomPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomCancelRequestAddToRoom = (variables: RoomCancelRequestAddToRoomVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    RoomCancelRequestAddToRoomError,
    undefined,
    {},
    {},
    RoomCancelRequestAddToRoomPathParams
  >({ method: "delete", url: "/api/v1/room/{roomId}/request/{userId}", ...variables, signal });

export const useRoomCancelRequestAddToRoom = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, RoomCancelRequestAddToRoomError, RoomCancelRequestAddToRoomVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, RoomCancelRequestAddToRoomError, RoomCancelRequestAddToRoomVariables>({
    mutationFn: (variables: RoomCancelRequestAddToRoomVariables) =>
      fetchRoomCancelRequestAddToRoom(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomDenyRequestPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  roomId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type RoomDenyRequestError = Fetcher.ErrorWrapper<undefined>;

export type RoomDenyRequestVariables = {
  pathParams: RoomDenyRequestPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomDenyRequest = (variables: RoomDenyRequestVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, RoomDenyRequestError, undefined, {}, {}, RoomDenyRequestPathParams>({
    method: "post",
    url: "/api/v1/room/{roomId}/request/{userId}/deny",
    ...variables,
    signal,
  });

export const useRoomDenyRequest = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, RoomDenyRequestError, RoomDenyRequestVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, RoomDenyRequestError, RoomDenyRequestVariables>({
    mutationFn: (variables: RoomDenyRequestVariables) => fetchRoomDenyRequest(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomRemoveFromRoomPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  roomId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type RoomRemoveFromRoomError = Fetcher.ErrorWrapper<undefined>;

export type RoomRemoveFromRoomVariables = {
  pathParams: RoomRemoveFromRoomPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomRemoveFromRoom = (variables: RoomRemoveFromRoomVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, RoomRemoveFromRoomError, undefined, {}, {}, RoomRemoveFromRoomPathParams>({
    method: "post",
    url: "/api/v1/room/{roomId}/remove/{userId}",
    ...variables,
    signal,
  });

export const useRoomRemoveFromRoom = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, RoomRemoveFromRoomError, RoomRemoveFromRoomVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, RoomRemoveFromRoomError, RoomRemoveFromRoomVariables>({
    mutationFn: (variables: RoomRemoveFromRoomVariables) =>
      fetchRoomRemoveFromRoom(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomBlockFromRoomPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  roomId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type RoomBlockFromRoomError = Fetcher.ErrorWrapper<undefined>;

export type RoomBlockFromRoomVariables = {
  pathParams: RoomBlockFromRoomPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomBlockFromRoom = (variables: RoomBlockFromRoomVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, RoomBlockFromRoomError, undefined, {}, {}, RoomBlockFromRoomPathParams>({
    method: "post",
    url: "/api/v1/room/{roomId}/block/{userId}",
    ...variables,
    signal,
  });

export const useRoomBlockFromRoom = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, RoomBlockFromRoomError, RoomBlockFromRoomVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, RoomBlockFromRoomError, RoomBlockFromRoomVariables>({
    mutationFn: (variables: RoomBlockFromRoomVariables) => fetchRoomBlockFromRoom(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomAddFacilitatorPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  roomId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type RoomAddFacilitatorError = Fetcher.ErrorWrapper<undefined>;

export type RoomAddFacilitatorVariables = {
  pathParams: RoomAddFacilitatorPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomAddFacilitator = (variables: RoomAddFacilitatorVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, RoomAddFacilitatorError, undefined, {}, {}, RoomAddFacilitatorPathParams>({
    method: "post",
    url: "/api/v1/room/{roomId}/facilitator/{userId}",
    ...variables,
    signal,
  });

export const useRoomAddFacilitator = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, RoomAddFacilitatorError, RoomAddFacilitatorVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, RoomAddFacilitatorError, RoomAddFacilitatorVariables>({
    mutationFn: (variables: RoomAddFacilitatorVariables) =>
      fetchRoomAddFacilitator(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomDeleteFacilitatorPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  roomId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type RoomDeleteFacilitatorError = Fetcher.ErrorWrapper<undefined>;

export type RoomDeleteFacilitatorVariables = {
  pathParams: RoomDeleteFacilitatorPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomDeleteFacilitator = (variables: RoomDeleteFacilitatorVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, RoomDeleteFacilitatorError, undefined, {}, {}, RoomDeleteFacilitatorPathParams>({
    method: "delete",
    url: "/api/v1/room/{roomId}/facilitator/{userId}",
    ...variables,
    signal,
  });

export const useRoomDeleteFacilitator = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, RoomDeleteFacilitatorError, RoomDeleteFacilitatorVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, RoomDeleteFacilitatorError, RoomDeleteFacilitatorVariables>({
    mutationFn: (variables: RoomDeleteFacilitatorVariables) =>
      fetchRoomDeleteFacilitator(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomChangeRoomOwnershipPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  roomId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type RoomChangeRoomOwnershipError = Fetcher.ErrorWrapper<undefined>;

export type RoomChangeRoomOwnershipVariables = {
  pathParams: RoomChangeRoomOwnershipPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomChangeRoomOwnership = (variables: RoomChangeRoomOwnershipVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, RoomChangeRoomOwnershipError, undefined, {}, {}, RoomChangeRoomOwnershipPathParams>({
    method: "post",
    url: "/api/v1/room/{roomId}/owner/{userId}",
    ...variables,
    signal,
  });

export const useRoomChangeRoomOwnership = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, RoomChangeRoomOwnershipError, RoomChangeRoomOwnershipVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, RoomChangeRoomOwnershipError, RoomChangeRoomOwnershipVariables>({
    mutationFn: (variables: RoomChangeRoomOwnershipVariables) =>
      fetchRoomChangeRoomOwnership(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomUploadRoomPicturePathParams {
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  roomId: string;
}

export type RoomUploadRoomPictureError = Fetcher.ErrorWrapper<undefined>;

export interface RoomUploadRoomPictureRequestBody {
  /**
   * @format binary
   */
  FormFile?: Blob;
}

export type RoomUploadRoomPictureVariables = {
  body?: RoomUploadRoomPictureRequestBody;
  pathParams: RoomUploadRoomPicturePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomUploadRoomPicture = (variables: RoomUploadRoomPictureVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    RoomUploadRoomPictureError,
    RoomUploadRoomPictureRequestBody,
    {},
    {},
    RoomUploadRoomPicturePathParams
  >({ method: "put", url: "/api/v1/room/{roomId}/picture", ...variables, signal });

export const useRoomUploadRoomPicture = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, RoomUploadRoomPictureError, RoomUploadRoomPictureVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, RoomUploadRoomPictureError, RoomUploadRoomPictureVariables>({
    mutationFn: (variables: RoomUploadRoomPictureVariables) =>
      fetchRoomUploadRoomPicture(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomGetRoomPicturePathParams {
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  roomId: string;
}

export type RoomGetRoomPictureError = Fetcher.ErrorWrapper<undefined>;

export type RoomGetRoomPictureVariables = {
  pathParams: RoomGetRoomPicturePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomGetRoomPicture = (variables: RoomGetRoomPictureVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, RoomGetRoomPictureError, undefined, {}, {}, RoomGetRoomPicturePathParams>({
    method: "get",
    url: "/api/v1/room/{roomId}/picture",
    ...variables,
    signal,
  });

export function roomGetRoomPictureQuery(variables: RoomGetRoomPictureVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function roomGetRoomPictureQuery(variables: RoomGetRoomPictureVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function roomGetRoomPictureQuery(variables: RoomGetRoomPictureVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchRoomGetRoomPicture(variables, signal),
    queryKey: queryKeyFn({
      operationId: "roomGetRoomPicture",
      path: "/api/v1/room/{roomId}/picture",
      variables,
    }),
  };
}

export const useSuspenseRoomGetRoomPicture = <TData = undefined>(
  variables: RoomGetRoomPictureVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, RoomGetRoomPictureError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, RoomGetRoomPictureError, TData>({
    ...roomGetRoomPictureQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useRoomGetRoomPicture = <TData = undefined>(
  variables: RoomGetRoomPictureVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, RoomGetRoomPictureError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, RoomGetRoomPictureError, TData>({
    ...roomGetRoomPictureQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface RoomGetRoomCheckInQrCodePathParams {
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  roomId: string;
}

export type RoomGetRoomCheckInQrCodeError = Fetcher.ErrorWrapper<undefined>;

export type RoomGetRoomCheckInQrCodeVariables = {
  pathParams: RoomGetRoomCheckInQrCodePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomGetRoomCheckInQrCode = (variables: RoomGetRoomCheckInQrCodeVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<string, RoomGetRoomCheckInQrCodeError, undefined, {}, {}, RoomGetRoomCheckInQrCodePathParams>({
    method: "get",
    url: "/api/v1/room/{roomId}/check-in.svg",
    ...variables,
    signal,
  });

export function roomGetRoomCheckInQrCodeQuery(variables: RoomGetRoomCheckInQrCodeVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<string>;
};

export function roomGetRoomCheckInQrCodeQuery(variables: RoomGetRoomCheckInQrCodeVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<string>) | reactQuery.SkipToken;
};

export function roomGetRoomCheckInQrCodeQuery(variables: RoomGetRoomCheckInQrCodeVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchRoomGetRoomCheckInQrCode(variables, signal),
    queryKey: queryKeyFn({
      operationId: "roomGetRoomCheckInQrCode",
      path: "/api/v1/room/{roomId}/check-in.svg",
      variables,
    }),
  };
}

export const useSuspenseRoomGetRoomCheckInQrCode = <TData = string>(
  variables: RoomGetRoomCheckInQrCodeVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<string, RoomGetRoomCheckInQrCodeError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<string, RoomGetRoomCheckInQrCodeError, TData>({
    ...roomGetRoomCheckInQrCodeQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useRoomGetRoomCheckInQrCode = <TData = string>(
  variables: RoomGetRoomCheckInQrCodeVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<string, RoomGetRoomCheckInQrCodeError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<string, RoomGetRoomCheckInQrCodeError, TData>({
    ...roomGetRoomCheckInQrCodeQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface RoomRoomCheckInPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  roomId: string;
}

export type RoomRoomCheckInError = Fetcher.ErrorWrapper<undefined>;

export type RoomRoomCheckInVariables = {
  pathParams: RoomRoomCheckInPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomRoomCheckIn = (variables: RoomRoomCheckInVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, RoomRoomCheckInError, undefined, {}, {}, RoomRoomCheckInPathParams>({
    method: "post",
    url: "/api/v1/room/{roomId}/check-in",
    ...variables,
    signal,
  });

export const useRoomRoomCheckIn = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, RoomRoomCheckInError, RoomRoomCheckInVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, RoomRoomCheckInError, RoomRoomCheckInVariables>({
    mutationFn: (variables: RoomRoomCheckInVariables) => fetchRoomRoomCheckIn(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomRoomCheckInByIdentifierPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  roomId: string;
  /**
   * Required, non-empty
   */
  identifier: string;
}

export type RoomRoomCheckInByIdentifierError = Fetcher.ErrorWrapper<undefined>;

export type RoomRoomCheckInByIdentifierVariables = {
  pathParams: RoomRoomCheckInByIdentifierPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomRoomCheckInByIdentifier = (
  variables: RoomRoomCheckInByIdentifierVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    RoomRoomCheckInByIdentifierError,
    undefined,
    {},
    {},
    RoomRoomCheckInByIdentifierPathParams
  >({ method: "post", url: "/api/v1/room/{roomId}/check-in/{identifier}", ...variables, signal });

export const useRoomRoomCheckInByIdentifier = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, RoomRoomCheckInByIdentifierError, RoomRoomCheckInByIdentifierVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, RoomRoomCheckInByIdentifierError, RoomRoomCheckInByIdentifierVariables>({
    mutationFn: (variables: RoomRoomCheckInByIdentifierVariables) =>
      fetchRoomRoomCheckInByIdentifier(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomCreateRoomMilestonePathParams {
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  roomId: string;
}

export type RoomCreateRoomMilestoneError = Fetcher.ErrorWrapper<undefined>;

export type RoomCreateRoomMilestoneVariables = {
  body: Schemas.CreateRoomMilestoneRequest;
  pathParams: RoomCreateRoomMilestonePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomCreateRoomMilestone = (variables: RoomCreateRoomMilestoneVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    string,
    RoomCreateRoomMilestoneError,
    Schemas.CreateRoomMilestoneRequest,
    {},
    {},
    RoomCreateRoomMilestonePathParams
  >({ method: "post", url: "/api/v1/room/{roomId}/milestones", ...variables, signal });

export const useRoomCreateRoomMilestone = (
  options?: Omit<
    reactQuery.UseMutationOptions<string, RoomCreateRoomMilestoneError, RoomCreateRoomMilestoneVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<string, RoomCreateRoomMilestoneError, RoomCreateRoomMilestoneVariables>({
    mutationFn: (variables: RoomCreateRoomMilestoneVariables) =>
      fetchRoomCreateRoomMilestone(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomCreateRoomTaskPathParams {
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  roomId: string;
}

export type RoomCreateRoomTaskError = Fetcher.ErrorWrapper<undefined>;

export type RoomCreateRoomTaskVariables = {
  body: Schemas.CreateRoomTaskRequest;
  pathParams: RoomCreateRoomTaskPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomCreateRoomTask = (variables: RoomCreateRoomTaskVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    string,
    RoomCreateRoomTaskError,
    Schemas.CreateRoomTaskRequest,
    {},
    {},
    RoomCreateRoomTaskPathParams
  >({ method: "post", url: "/api/v1/room/{roomId}/tasks", ...variables, signal });

export const useRoomCreateRoomTask = (
  options?: Omit<
    reactQuery.UseMutationOptions<string, RoomCreateRoomTaskError, RoomCreateRoomTaskVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<string, RoomCreateRoomTaskError, RoomCreateRoomTaskVariables>({
    mutationFn: (variables: RoomCreateRoomTaskVariables) =>
      fetchRoomCreateRoomTask(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomDeleteRoomMilestonePathParams {
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  roomId: string;
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  milestoneId: string;
}

export type RoomDeleteRoomMilestoneError = Fetcher.ErrorWrapper<undefined>;

export type RoomDeleteRoomMilestoneVariables = {
  pathParams: RoomDeleteRoomMilestonePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomDeleteRoomMilestone = (variables: RoomDeleteRoomMilestoneVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, RoomDeleteRoomMilestoneError, undefined, {}, {}, RoomDeleteRoomMilestonePathParams>({
    method: "post",
    url: "/api/v1/room/{roomId}/milestones/{milestoneId}",
    ...variables,
    signal,
  });

export const useRoomDeleteRoomMilestone = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, RoomDeleteRoomMilestoneError, RoomDeleteRoomMilestoneVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, RoomDeleteRoomMilestoneError, RoomDeleteRoomMilestoneVariables>({
    mutationFn: (variables: RoomDeleteRoomMilestoneVariables) =>
      fetchRoomDeleteRoomMilestone(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface RoomDeleteRoomTaskPathParams {
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  roomId: string;
  /**
   * Require, non-empty
   *
   * @format uuid
   */
  taskId: string;
}

export type RoomDeleteRoomTaskError = Fetcher.ErrorWrapper<undefined>;

export type RoomDeleteRoomTaskVariables = {
  pathParams: RoomDeleteRoomTaskPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchRoomDeleteRoomTask = (variables: RoomDeleteRoomTaskVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, RoomDeleteRoomTaskError, undefined, {}, {}, RoomDeleteRoomTaskPathParams>({
    method: "post",
    url: "/api/v1/room/{roomId}/tasks/{taskId}",
    ...variables,
    signal,
  });

export const useRoomDeleteRoomTask = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, RoomDeleteRoomTaskError, RoomDeleteRoomTaskVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, RoomDeleteRoomTaskError, RoomDeleteRoomTaskVariables>({
    mutationFn: (variables: RoomDeleteRoomTaskVariables) =>
      fetchRoomDeleteRoomTask(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type SalesGetSalesContactsError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetSalesContactsVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetSalesContacts = (variables: SalesGetSalesContactsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<Schemas.SalesContactsAggregateDto, SalesGetSalesContactsError, undefined, {}, {}, {}>({
    method: "get",
    url: "/api/v1/sales/contacts",
    ...variables,
    signal,
  });

export function salesGetSalesContactsQuery(variables: SalesGetSalesContactsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.SalesContactsAggregateDto>;
};

export function salesGetSalesContactsQuery(variables: SalesGetSalesContactsVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.SalesContactsAggregateDto>) | reactQuery.SkipToken;
};

export function salesGetSalesContactsQuery(variables: SalesGetSalesContactsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetSalesContacts(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetSalesContacts",
      path: "/api/v1/sales/contacts",
      variables,
    }),
  };
}

export const useSuspenseSalesGetSalesContacts = <TData = Schemas.SalesContactsAggregateDto>(
  variables: SalesGetSalesContactsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.SalesContactsAggregateDto, SalesGetSalesContactsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.SalesContactsAggregateDto, SalesGetSalesContactsError, TData>({
    ...salesGetSalesContactsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetSalesContacts = <TData = Schemas.SalesContactsAggregateDto>(
  variables: SalesGetSalesContactsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.SalesContactsAggregateDto, SalesGetSalesContactsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.SalesContactsAggregateDto, SalesGetSalesContactsError, TData>({
    ...salesGetSalesContactsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type SalesBulkCreateSalesContactsError = Fetcher.ErrorWrapper<undefined>;

export type SalesBulkCreateSalesContactsVariables = {
  body?: Schemas.SalesBulkContactsRequestDto;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesBulkCreateSalesContacts = (
  variables: SalesBulkCreateSalesContactsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.SalesBulkContactsResponseDto,
    SalesBulkCreateSalesContactsError,
    Schemas.SalesBulkContactsRequestDto,
    {},
    {},
    {}
  >({ method: "post", url: "/api/v1/sales/contacts/bulk", ...variables, signal });

export const useSalesBulkCreateSalesContacts = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SalesBulkContactsResponseDto,
      SalesBulkCreateSalesContactsError,
      SalesBulkCreateSalesContactsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.SalesBulkContactsResponseDto,
    SalesBulkCreateSalesContactsError,
    SalesBulkCreateSalesContactsVariables
  >({
    mutationFn: (variables: SalesBulkCreateSalesContactsVariables) =>
      fetchSalesBulkCreateSalesContacts(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesGetProspectsPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export interface SalesGetProspectsQueryParams {
  search?: string;
  stage?: Schemas.ProspectStage;
  /**
   * @format uuid
   */
  ownerUserId?: string;
  /**
   * @format int32
   */
  limit?: number;
  /**
   * @format int32
   */
  offset?: number;
}

export type SalesGetProspectsError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetProspectsVariables = {
  pathParams: SalesGetProspectsPathParams;
  queryParams?: SalesGetProspectsQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetProspects = (variables: SalesGetProspectsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    SalesGetProspectsError,
    undefined,
    {},
    SalesGetProspectsQueryParams,
    SalesGetProspectsPathParams
  >({ method: "get", url: "/api/v1/sales/bubbles/{bubbleId}/prospects", ...variables, signal });

export function salesGetProspectsQuery(variables: SalesGetProspectsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function salesGetProspectsQuery(variables: SalesGetProspectsVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function salesGetProspectsQuery(variables: SalesGetProspectsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetProspects(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetProspects",
      path: "/api/v1/sales/bubbles/{bubbleId}/prospects",
      variables,
    }),
  };
}

export const useSuspenseSalesGetProspects = <TData = undefined>(
  variables: SalesGetProspectsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetProspectsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, SalesGetProspectsError, TData>({
    ...salesGetProspectsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetProspects = <TData = undefined>(
  variables: SalesGetProspectsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetProspectsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, SalesGetProspectsError, TData>({
    ...salesGetProspectsQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface SalesCreateProspectPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type SalesCreateProspectError = Fetcher.ErrorWrapper<undefined>;

export type SalesCreateProspectVariables = {
  body?: Schemas.ProspectCreateDto;
  pathParams: SalesCreateProspectPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesCreateProspect = (variables: SalesCreateProspectVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.ProspectDto,
    SalesCreateProspectError,
    Schemas.ProspectCreateDto,
    {},
    {},
    SalesCreateProspectPathParams
  >({ method: "post", url: "/api/v1/sales/bubbles/{bubbleId}/prospects", ...variables, signal });

export const useSalesCreateProspect = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.ProspectDto, SalesCreateProspectError, SalesCreateProspectVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<Schemas.ProspectDto, SalesCreateProspectError, SalesCreateProspectVariables>({
    mutationFn: (variables: SalesCreateProspectVariables) =>
      fetchSalesCreateProspect(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesGetProspectPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type SalesGetProspectError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetProspectVariables = {
  pathParams: SalesGetProspectPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetProspect = (variables: SalesGetProspectVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<Schemas.ProspectDto, SalesGetProspectError, undefined, {}, {}, SalesGetProspectPathParams>({
    method: "get",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}",
    ...variables,
    signal,
  });

export function salesGetProspectQuery(variables: SalesGetProspectVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.ProspectDto>;
};

export function salesGetProspectQuery(variables: SalesGetProspectVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.ProspectDto>) | reactQuery.SkipToken;
};

export function salesGetProspectQuery(variables: SalesGetProspectVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetProspect(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetProspect",
      path: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}",
      variables,
    }),
  };
}

export const useSuspenseSalesGetProspect = <TData = Schemas.ProspectDto>(
  variables: SalesGetProspectVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ProspectDto, SalesGetProspectError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.ProspectDto, SalesGetProspectError, TData>({
    ...salesGetProspectQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetProspect = <TData = Schemas.ProspectDto>(
  variables: SalesGetProspectVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.ProspectDto, SalesGetProspectError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.ProspectDto, SalesGetProspectError, TData>({
    ...salesGetProspectQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface SalesUpdateProspectPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type SalesUpdateProspectError = Fetcher.ErrorWrapper<undefined>;

export type SalesUpdateProspectVariables = {
  body?: Schemas.ProspectUpdateDto;
  pathParams: SalesUpdateProspectPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesUpdateProspect = (variables: SalesUpdateProspectVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    SalesUpdateProspectError,
    Schemas.ProspectUpdateDto,
    {},
    {},
    SalesUpdateProspectPathParams
  >({ method: "put", url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}", ...variables, signal });

export const useSalesUpdateProspect = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesUpdateProspectError, SalesUpdateProspectVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesUpdateProspectError, SalesUpdateProspectVariables>({
    mutationFn: (variables: SalesUpdateProspectVariables) =>
      fetchSalesUpdateProspect(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesDeleteProspectPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type SalesDeleteProspectError = Fetcher.ErrorWrapper<undefined>;

export type SalesDeleteProspectVariables = {
  pathParams: SalesDeleteProspectPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesDeleteProspect = (variables: SalesDeleteProspectVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesDeleteProspectError, undefined, {}, {}, SalesDeleteProspectPathParams>({
    method: "delete",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}",
    ...variables,
    signal,
  });

export const useSalesDeleteProspect = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesDeleteProspectError, SalesDeleteProspectVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesDeleteProspectError, SalesDeleteProspectVariables>({
    mutationFn: (variables: SalesDeleteProspectVariables) =>
      fetchSalesDeleteProspect(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesGetDealsPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export interface SalesGetDealsQueryParams {
  search?: string;
  stage?: Schemas.ProspectStage;
  /**
   * @format uuid
   */
  ownerUserId?: string;
  /**
   * @format int32
   */
  limit?: number;
  /**
   * @format int32
   */
  offset?: number;
}

export type SalesGetDealsError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetDealsVariables = {
  pathParams: SalesGetDealsPathParams;
  queryParams?: SalesGetDealsQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetDeals = (variables: SalesGetDealsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    SalesGetDealsError,
    undefined,
    {},
    SalesGetDealsQueryParams,
    SalesGetDealsPathParams
  >({ method: "get", url: "/api/v1/sales/bubbles/{bubbleId}/deals", ...variables, signal });

export function salesGetDealsQuery(variables: SalesGetDealsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function salesGetDealsQuery(variables: SalesGetDealsVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function salesGetDealsQuery(variables: SalesGetDealsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetDeals(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetDeals",
      path: "/api/v1/sales/bubbles/{bubbleId}/deals",
      variables,
    }),
  };
}

export const useSuspenseSalesGetDeals = <TData = undefined>(
  variables: SalesGetDealsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetDealsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, SalesGetDealsError, TData>({
    ...salesGetDealsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetDeals = <TData = undefined>(
  variables: SalesGetDealsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetDealsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, SalesGetDealsError, TData>({
    ...salesGetDealsQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface SalesCreateDealPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type SalesCreateDealError = Fetcher.ErrorWrapper<undefined>;

export type SalesCreateDealVariables = {
  body?: Schemas.DealCreateDto;
  pathParams: SalesCreateDealPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesCreateDeal = (variables: SalesCreateDealVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.DealDto,
    SalesCreateDealError,
    Schemas.DealCreateDto,
    {},
    {},
    SalesCreateDealPathParams
  >({ method: "post", url: "/api/v1/sales/bubbles/{bubbleId}/deals", ...variables, signal });

export const useSalesCreateDeal = (
  options?: Omit<
    reactQuery.UseMutationOptions<Schemas.DealDto, SalesCreateDealError, SalesCreateDealVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<Schemas.DealDto, SalesCreateDealError, SalesCreateDealVariables>({
    mutationFn: (variables: SalesCreateDealVariables) => fetchSalesCreateDeal(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesGetDealPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type SalesGetDealError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetDealVariables = {
  pathParams: SalesGetDealPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetDeal = (variables: SalesGetDealVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<Schemas.DealDto, SalesGetDealError, undefined, {}, {}, SalesGetDealPathParams>({
    method: "get",
    url: "/api/v1/sales/bubbles/{bubbleId}/deals/{id}",
    ...variables,
    signal,
  });

export function salesGetDealQuery(variables: SalesGetDealVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.DealDto>;
};

export function salesGetDealQuery(variables: SalesGetDealVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.DealDto>) | reactQuery.SkipToken;
};

export function salesGetDealQuery(variables: SalesGetDealVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetDeal(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetDeal",
      path: "/api/v1/sales/bubbles/{bubbleId}/deals/{id}",
      variables,
    }),
  };
}

export const useSuspenseSalesGetDeal = <TData = Schemas.DealDto>(
  variables: SalesGetDealVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.DealDto, SalesGetDealError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.DealDto, SalesGetDealError, TData>({
    ...salesGetDealQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetDeal = <TData = Schemas.DealDto>(
  variables: SalesGetDealVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.DealDto, SalesGetDealError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.DealDto, SalesGetDealError, TData>({
    ...salesGetDealQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface SalesUpdateDealPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type SalesUpdateDealError = Fetcher.ErrorWrapper<undefined>;

export type SalesUpdateDealVariables = {
  body?: Schemas.DealUpdateDto;
  pathParams: SalesUpdateDealPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesUpdateDeal = (variables: SalesUpdateDealVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesUpdateDealError, Schemas.DealUpdateDto, {}, {}, SalesUpdateDealPathParams>({
    method: "put",
    url: "/api/v1/sales/bubbles/{bubbleId}/deals/{id}",
    ...variables,
    signal,
  });

export const useSalesUpdateDeal = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesUpdateDealError, SalesUpdateDealVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesUpdateDealError, SalesUpdateDealVariables>({
    mutationFn: (variables: SalesUpdateDealVariables) => fetchSalesUpdateDeal(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesDeleteDealPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type SalesDeleteDealError = Fetcher.ErrorWrapper<undefined>;

export type SalesDeleteDealVariables = {
  pathParams: SalesDeleteDealPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesDeleteDeal = (variables: SalesDeleteDealVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesDeleteDealError, undefined, {}, {}, SalesDeleteDealPathParams>({
    method: "delete",
    url: "/api/v1/sales/bubbles/{bubbleId}/deals/{id}",
    ...variables,
    signal,
  });

export const useSalesDeleteDeal = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesDeleteDealError, SalesDeleteDealVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesDeleteDealError, SalesDeleteDealVariables>({
    mutationFn: (variables: SalesDeleteDealVariables) => fetchSalesDeleteDeal(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesAddProspectToDealPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type SalesAddProspectToDealError = Fetcher.ErrorWrapper<undefined>;

export type SalesAddProspectToDealVariables = {
  body?: Schemas.DealProspectAddDto;
  pathParams: SalesAddProspectToDealPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesAddProspectToDeal = (variables: SalesAddProspectToDealVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    SalesAddProspectToDealError,
    Schemas.DealProspectAddDto,
    {},
    {},
    SalesAddProspectToDealPathParams
  >({ method: "post", url: "/api/v1/sales/bubbles/{bubbleId}/deals/{id}/prospects", ...variables, signal });

export const useSalesAddProspectToDeal = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesAddProspectToDealError, SalesAddProspectToDealVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesAddProspectToDealError, SalesAddProspectToDealVariables>({
    mutationFn: (variables: SalesAddProspectToDealVariables) =>
      fetchSalesAddProspectToDeal(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesRemoveProspectFromDealPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  prospectId: string;
}

export type SalesRemoveProspectFromDealError = Fetcher.ErrorWrapper<undefined>;

export type SalesRemoveProspectFromDealVariables = {
  pathParams: SalesRemoveProspectFromDealPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesRemoveProspectFromDeal = (
  variables: SalesRemoveProspectFromDealVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    SalesRemoveProspectFromDealError,
    undefined,
    {},
    {},
    SalesRemoveProspectFromDealPathParams
  >({
    method: "delete",
    url: "/api/v1/sales/bubbles/{bubbleId}/deals/{id}/prospects/{prospectId}",
    ...variables,
    signal,
  });

export const useSalesRemoveProspectFromDeal = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesRemoveProspectFromDealError, SalesRemoveProspectFromDealVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesRemoveProspectFromDealError, SalesRemoveProspectFromDealVariables>({
    mutationFn: (variables: SalesRemoveProspectFromDealVariables) =>
      fetchSalesRemoveProspectFromDeal(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesGetAssignmentsPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type SalesGetAssignmentsError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetAssignmentsVariables = {
  pathParams: SalesGetAssignmentsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetAssignments = (variables: SalesGetAssignmentsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesGetAssignmentsError, undefined, {}, {}, SalesGetAssignmentsPathParams>({
    method: "get",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/assignments",
    ...variables,
    signal,
  });

export function salesGetAssignmentsQuery(variables: SalesGetAssignmentsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function salesGetAssignmentsQuery(variables: SalesGetAssignmentsVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function salesGetAssignmentsQuery(variables: SalesGetAssignmentsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetAssignments(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetAssignments",
      path: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/assignments",
      variables,
    }),
  };
}

export const useSuspenseSalesGetAssignments = <TData = undefined>(
  variables: SalesGetAssignmentsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetAssignmentsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, SalesGetAssignmentsError, TData>({
    ...salesGetAssignmentsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetAssignments = <TData = undefined>(
  variables: SalesGetAssignmentsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetAssignmentsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, SalesGetAssignmentsError, TData>({
    ...salesGetAssignmentsQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface SalesAddAssignmentPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type SalesAddAssignmentError = Fetcher.ErrorWrapper<undefined>;

export type SalesAddAssignmentVariables = {
  body?: Schemas.AssignmentDto;
  pathParams: SalesAddAssignmentPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesAddAssignment = (variables: SalesAddAssignmentVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    SalesAddAssignmentError,
    Schemas.AssignmentDto,
    {},
    {},
    SalesAddAssignmentPathParams
  >({ method: "post", url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/assignments", ...variables, signal });

export const useSalesAddAssignment = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesAddAssignmentError, SalesAddAssignmentVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesAddAssignmentError, SalesAddAssignmentVariables>({
    mutationFn: (variables: SalesAddAssignmentVariables) =>
      fetchSalesAddAssignment(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesRemoveAssignmentPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  userId: string;
}

export type SalesRemoveAssignmentError = Fetcher.ErrorWrapper<undefined>;

export type SalesRemoveAssignmentVariables = {
  pathParams: SalesRemoveAssignmentPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesRemoveAssignment = (variables: SalesRemoveAssignmentVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesRemoveAssignmentError, undefined, {}, {}, SalesRemoveAssignmentPathParams>({
    method: "delete",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/assignments/{userId}",
    ...variables,
    signal,
  });

export const useSalesRemoveAssignment = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesRemoveAssignmentError, SalesRemoveAssignmentVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesRemoveAssignmentError, SalesRemoveAssignmentVariables>({
    mutationFn: (variables: SalesRemoveAssignmentVariables) =>
      fetchSalesRemoveAssignment(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesSetOwnerPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  userId: string;
}

export type SalesSetOwnerError = Fetcher.ErrorWrapper<undefined>;

export type SalesSetOwnerVariables = {
  pathParams: SalesSetOwnerPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesSetOwner = (variables: SalesSetOwnerVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesSetOwnerError, undefined, {}, {}, SalesSetOwnerPathParams>({
    method: "put",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/owner/{userId}",
    ...variables,
    signal,
  });

export const useSalesSetOwner = (
  options?: Omit<reactQuery.UseMutationOptions<undefined, SalesSetOwnerError, SalesSetOwnerVariables>, "mutationFn">,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesSetOwnerError, SalesSetOwnerVariables>({
    mutationFn: (variables: SalesSetOwnerVariables) => fetchSalesSetOwner(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesGetContactsPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type SalesGetContactsError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetContactsVariables = {
  pathParams: SalesGetContactsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetContacts = (variables: SalesGetContactsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesGetContactsError, undefined, {}, {}, SalesGetContactsPathParams>({
    method: "get",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/contacts",
    ...variables,
    signal,
  });

export function salesGetContactsQuery(variables: SalesGetContactsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function salesGetContactsQuery(variables: SalesGetContactsVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function salesGetContactsQuery(variables: SalesGetContactsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetContacts(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetContacts",
      path: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/contacts",
      variables,
    }),
  };
}

export const useSuspenseSalesGetContacts = <TData = undefined>(
  variables: SalesGetContactsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetContactsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, SalesGetContactsError, TData>({
    ...salesGetContactsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetContacts = <TData = undefined>(
  variables: SalesGetContactsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetContactsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, SalesGetContactsError, TData>({
    ...salesGetContactsQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface SalesCreateContactPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type SalesCreateContactError = Fetcher.ErrorWrapper<undefined>;

export type SalesCreateContactVariables = {
  body?: Schemas.ContactCreateDto;
  pathParams: SalesCreateContactPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesCreateContact = (variables: SalesCreateContactVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    SalesCreateContactError,
    Schemas.ContactCreateDto,
    {},
    {},
    SalesCreateContactPathParams
  >({ method: "post", url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/contacts", ...variables, signal });

export const useSalesCreateContact = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesCreateContactError, SalesCreateContactVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesCreateContactError, SalesCreateContactVariables>({
    mutationFn: (variables: SalesCreateContactVariables) =>
      fetchSalesCreateContact(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesGetContactPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  contactId: string;
}

export type SalesGetContactError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetContactVariables = {
  pathParams: SalesGetContactPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetContact = (variables: SalesGetContactVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesGetContactError, undefined, {}, {}, SalesGetContactPathParams>({
    method: "get",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/contacts/{contactId}",
    ...variables,
    signal,
  });

export function salesGetContactQuery(variables: SalesGetContactVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function salesGetContactQuery(variables: SalesGetContactVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function salesGetContactQuery(variables: SalesGetContactVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetContact(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetContact",
      path: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/contacts/{contactId}",
      variables,
    }),
  };
}

export const useSuspenseSalesGetContact = <TData = undefined>(
  variables: SalesGetContactVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetContactError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, SalesGetContactError, TData>({
    ...salesGetContactQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetContact = <TData = undefined>(
  variables: SalesGetContactVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetContactError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, SalesGetContactError, TData>({
    ...salesGetContactQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface SalesUpdateContactPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  contactId: string;
}

export type SalesUpdateContactError = Fetcher.ErrorWrapper<undefined>;

export type SalesUpdateContactVariables = {
  body?: Schemas.ContactUpdateDto;
  pathParams: SalesUpdateContactPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesUpdateContact = (variables: SalesUpdateContactVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    SalesUpdateContactError,
    Schemas.ContactUpdateDto,
    {},
    {},
    SalesUpdateContactPathParams
  >({
    method: "put",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/contacts/{contactId}",
    ...variables,
    signal,
  });

export const useSalesUpdateContact = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesUpdateContactError, SalesUpdateContactVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesUpdateContactError, SalesUpdateContactVariables>({
    mutationFn: (variables: SalesUpdateContactVariables) =>
      fetchSalesUpdateContact(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesDeleteContactPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  contactId: string;
}

export type SalesDeleteContactError = Fetcher.ErrorWrapper<undefined>;

export type SalesDeleteContactVariables = {
  pathParams: SalesDeleteContactPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesDeleteContact = (variables: SalesDeleteContactVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesDeleteContactError, undefined, {}, {}, SalesDeleteContactPathParams>({
    method: "delete",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/contacts/{contactId}",
    ...variables,
    signal,
  });

export const useSalesDeleteContact = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesDeleteContactError, SalesDeleteContactVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesDeleteContactError, SalesDeleteContactVariables>({
    mutationFn: (variables: SalesDeleteContactVariables) =>
      fetchSalesDeleteContact(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesGetNotesPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type SalesGetNotesError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetNotesVariables = {
  pathParams: SalesGetNotesPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetNotes = (variables: SalesGetNotesVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesGetNotesError, undefined, {}, {}, SalesGetNotesPathParams>({
    method: "get",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/notes",
    ...variables,
    signal,
  });

export function salesGetNotesQuery(variables: SalesGetNotesVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function salesGetNotesQuery(variables: SalesGetNotesVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function salesGetNotesQuery(variables: SalesGetNotesVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetNotes(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetNotes",
      path: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/notes",
      variables,
    }),
  };
}

export const useSuspenseSalesGetNotes = <TData = undefined>(
  variables: SalesGetNotesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetNotesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, SalesGetNotesError, TData>({
    ...salesGetNotesQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetNotes = <TData = undefined>(
  variables: SalesGetNotesVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetNotesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, SalesGetNotesError, TData>({
    ...salesGetNotesQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface SalesCreateNotePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type SalesCreateNoteError = Fetcher.ErrorWrapper<undefined>;

export type SalesCreateNoteVariables = {
  body?: Schemas.NoteCreateDto;
  pathParams: SalesCreateNotePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesCreateNote = (variables: SalesCreateNoteVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesCreateNoteError, Schemas.NoteCreateDto, {}, {}, SalesCreateNotePathParams>({
    method: "post",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/notes",
    ...variables,
    signal,
  });

export const useSalesCreateNote = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesCreateNoteError, SalesCreateNoteVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesCreateNoteError, SalesCreateNoteVariables>({
    mutationFn: (variables: SalesCreateNoteVariables) => fetchSalesCreateNote(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesUpdateNotePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  noteId: string;
}

export type SalesUpdateNoteError = Fetcher.ErrorWrapper<undefined>;

export type SalesUpdateNoteVariables = {
  body?: Schemas.NoteUpdateDto;
  pathParams: SalesUpdateNotePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesUpdateNote = (variables: SalesUpdateNoteVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesUpdateNoteError, Schemas.NoteUpdateDto, {}, {}, SalesUpdateNotePathParams>({
    method: "put",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/notes/{noteId}",
    ...variables,
    signal,
  });

export const useSalesUpdateNote = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesUpdateNoteError, SalesUpdateNoteVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesUpdateNoteError, SalesUpdateNoteVariables>({
    mutationFn: (variables: SalesUpdateNoteVariables) => fetchSalesUpdateNote(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesDeleteNotePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  noteId: string;
}

export type SalesDeleteNoteError = Fetcher.ErrorWrapper<undefined>;

export type SalesDeleteNoteVariables = {
  pathParams: SalesDeleteNotePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesDeleteNote = (variables: SalesDeleteNoteVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesDeleteNoteError, undefined, {}, {}, SalesDeleteNotePathParams>({
    method: "delete",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/notes/{noteId}",
    ...variables,
    signal,
  });

export const useSalesDeleteNote = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesDeleteNoteError, SalesDeleteNoteVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesDeleteNoteError, SalesDeleteNoteVariables>({
    mutationFn: (variables: SalesDeleteNoteVariables) => fetchSalesDeleteNote(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesGetInteractionsPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type SalesGetInteractionsError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetInteractionsVariables = {
  pathParams: SalesGetInteractionsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetInteractions = (variables: SalesGetInteractionsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesGetInteractionsError, undefined, {}, {}, SalesGetInteractionsPathParams>({
    method: "get",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/interactions",
    ...variables,
    signal,
  });

export function salesGetInteractionsQuery(variables: SalesGetInteractionsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function salesGetInteractionsQuery(variables: SalesGetInteractionsVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function salesGetInteractionsQuery(variables: SalesGetInteractionsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetInteractions(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetInteractions",
      path: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/interactions",
      variables,
    }),
  };
}

export const useSuspenseSalesGetInteractions = <TData = undefined>(
  variables: SalesGetInteractionsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetInteractionsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, SalesGetInteractionsError, TData>({
    ...salesGetInteractionsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetInteractions = <TData = undefined>(
  variables: SalesGetInteractionsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetInteractionsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, SalesGetInteractionsError, TData>({
    ...salesGetInteractionsQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface SalesCreateInteractionPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type SalesCreateInteractionError = Fetcher.ErrorWrapper<undefined>;

export type SalesCreateInteractionVariables = {
  body?: Schemas.InteractionCreateDto;
  pathParams: SalesCreateInteractionPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesCreateInteraction = (variables: SalesCreateInteractionVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    SalesCreateInteractionError,
    Schemas.InteractionCreateDto,
    {},
    {},
    SalesCreateInteractionPathParams
  >({ method: "post", url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/interactions", ...variables, signal });

export const useSalesCreateInteraction = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesCreateInteractionError, SalesCreateInteractionVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesCreateInteractionError, SalesCreateInteractionVariables>({
    mutationFn: (variables: SalesCreateInteractionVariables) =>
      fetchSalesCreateInteraction(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesUpdateInteractionPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  interactionId: string;
}

export type SalesUpdateInteractionError = Fetcher.ErrorWrapper<undefined>;

export type SalesUpdateInteractionVariables = {
  body?: Schemas.InteractionUpdateDto;
  pathParams: SalesUpdateInteractionPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesUpdateInteraction = (variables: SalesUpdateInteractionVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    SalesUpdateInteractionError,
    Schemas.InteractionUpdateDto,
    {},
    {},
    SalesUpdateInteractionPathParams
  >({
    method: "put",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/interactions/{interactionId}",
    ...variables,
    signal,
  });

export const useSalesUpdateInteraction = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesUpdateInteractionError, SalesUpdateInteractionVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesUpdateInteractionError, SalesUpdateInteractionVariables>({
    mutationFn: (variables: SalesUpdateInteractionVariables) =>
      fetchSalesUpdateInteraction(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesDeleteInteractionPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
  /**
   * @format uuid
   */
  interactionId: string;
}

export type SalesDeleteInteractionError = Fetcher.ErrorWrapper<undefined>;

export type SalesDeleteInteractionVariables = {
  pathParams: SalesDeleteInteractionPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesDeleteInteraction = (variables: SalesDeleteInteractionVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesDeleteInteractionError, undefined, {}, {}, SalesDeleteInteractionPathParams>({
    method: "delete",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/interactions/{interactionId}",
    ...variables,
    signal,
  });

export const useSalesDeleteInteraction = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesDeleteInteractionError, SalesDeleteInteractionVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesDeleteInteractionError, SalesDeleteInteractionVariables>({
    mutationFn: (variables: SalesDeleteInteractionVariables) =>
      fetchSalesDeleteInteraction(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesGetProspectTasksPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export interface SalesGetProspectTasksQueryParams {
  status?: Schemas.TaskStatus;
  /**
   * @format date-time
   */
  dueBefore?: string;
}

export type SalesGetProspectTasksError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetProspectTasksVariables = {
  pathParams: SalesGetProspectTasksPathParams;
  queryParams?: SalesGetProspectTasksQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetProspectTasks = (variables: SalesGetProspectTasksVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    SalesGetProspectTasksError,
    undefined,
    {},
    SalesGetProspectTasksQueryParams,
    SalesGetProspectTasksPathParams
  >({ method: "get", url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/tasks", ...variables, signal });

export function salesGetProspectTasksQuery(variables: SalesGetProspectTasksVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function salesGetProspectTasksQuery(variables: SalesGetProspectTasksVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function salesGetProspectTasksQuery(variables: SalesGetProspectTasksVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetProspectTasks(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetProspectTasks",
      path: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/tasks",
      variables,
    }),
  };
}

export const useSuspenseSalesGetProspectTasks = <TData = undefined>(
  variables: SalesGetProspectTasksVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetProspectTasksError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, SalesGetProspectTasksError, TData>({
    ...salesGetProspectTasksQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetProspectTasks = <TData = undefined>(
  variables: SalesGetProspectTasksVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetProspectTasksError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, SalesGetProspectTasksError, TData>({
    ...salesGetProspectTasksQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface SalesCreateTaskPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type SalesCreateTaskError = Fetcher.ErrorWrapper<undefined>;

export type SalesCreateTaskVariables = {
  body?: Schemas.TaskCreateDto;
  pathParams: SalesCreateTaskPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesCreateTask = (variables: SalesCreateTaskVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesCreateTaskError, Schemas.TaskCreateDto, {}, {}, SalesCreateTaskPathParams>({
    method: "post",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/tasks",
    ...variables,
    signal,
  });

export const useSalesCreateTask = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesCreateTaskError, SalesCreateTaskVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesCreateTaskError, SalesCreateTaskVariables>({
    mutationFn: (variables: SalesCreateTaskVariables) => fetchSalesCreateTask(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesGetMyTasksPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export interface SalesGetMyTasksQueryParams {
  status?: Schemas.TaskStatus;
  /**
   * @format date-time
   */
  dueBefore?: string;
}

export type SalesGetMyTasksError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetMyTasksVariables = {
  pathParams: SalesGetMyTasksPathParams;
  queryParams?: SalesGetMyTasksQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetMyTasks = (variables: SalesGetMyTasksVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    SalesGetMyTasksError,
    undefined,
    {},
    SalesGetMyTasksQueryParams,
    SalesGetMyTasksPathParams
  >({ method: "get", url: "/api/v1/sales/bubbles/{bubbleId}/tasks", ...variables, signal });

export function salesGetMyTasksQuery(variables: SalesGetMyTasksVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function salesGetMyTasksQuery(variables: SalesGetMyTasksVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function salesGetMyTasksQuery(variables: SalesGetMyTasksVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetMyTasks(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetMyTasks",
      path: "/api/v1/sales/bubbles/{bubbleId}/tasks",
      variables,
    }),
  };
}

export const useSuspenseSalesGetMyTasks = <TData = undefined>(
  variables: SalesGetMyTasksVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetMyTasksError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, SalesGetMyTasksError, TData>({
    ...salesGetMyTasksQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetMyTasks = <TData = undefined>(
  variables: SalesGetMyTasksVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetMyTasksError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, SalesGetMyTasksError, TData>({
    ...salesGetMyTasksQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface SalesGetTaskPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  taskId: string;
}

export type SalesGetTaskError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetTaskVariables = {
  pathParams: SalesGetTaskPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetTask = (variables: SalesGetTaskVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesGetTaskError, undefined, {}, {}, SalesGetTaskPathParams>({
    method: "get",
    url: "/api/v1/sales/bubbles/{bubbleId}/tasks/{taskId}",
    ...variables,
    signal,
  });

export function salesGetTaskQuery(variables: SalesGetTaskVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function salesGetTaskQuery(variables: SalesGetTaskVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function salesGetTaskQuery(variables: SalesGetTaskVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetTask(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetTask",
      path: "/api/v1/sales/bubbles/{bubbleId}/tasks/{taskId}",
      variables,
    }),
  };
}

export const useSuspenseSalesGetTask = <TData = undefined>(
  variables: SalesGetTaskVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetTaskError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, SalesGetTaskError, TData>({
    ...salesGetTaskQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetTask = <TData = undefined>(
  variables: SalesGetTaskVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetTaskError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, SalesGetTaskError, TData>({
    ...salesGetTaskQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface SalesUpdateTaskPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  taskId: string;
}

export type SalesUpdateTaskError = Fetcher.ErrorWrapper<undefined>;

export type SalesUpdateTaskVariables = {
  body?: Schemas.TaskUpdateDto;
  pathParams: SalesUpdateTaskPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesUpdateTask = (variables: SalesUpdateTaskVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesUpdateTaskError, Schemas.TaskUpdateDto, {}, {}, SalesUpdateTaskPathParams>({
    method: "put",
    url: "/api/v1/sales/bubbles/{bubbleId}/tasks/{taskId}",
    ...variables,
    signal,
  });

export const useSalesUpdateTask = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesUpdateTaskError, SalesUpdateTaskVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesUpdateTaskError, SalesUpdateTaskVariables>({
    mutationFn: (variables: SalesUpdateTaskVariables) => fetchSalesUpdateTask(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesDeleteTaskPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  taskId: string;
}

export type SalesDeleteTaskError = Fetcher.ErrorWrapper<undefined>;

export type SalesDeleteTaskVariables = {
  pathParams: SalesDeleteTaskPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesDeleteTask = (variables: SalesDeleteTaskVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesDeleteTaskError, undefined, {}, {}, SalesDeleteTaskPathParams>({
    method: "delete",
    url: "/api/v1/sales/bubbles/{bubbleId}/tasks/{taskId}",
    ...variables,
    signal,
  });

export const useSalesDeleteTask = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesDeleteTaskError, SalesDeleteTaskVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesDeleteTaskError, SalesDeleteTaskVariables>({
    mutationFn: (variables: SalesDeleteTaskVariables) => fetchSalesDeleteTask(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesCompleteTaskPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  taskId: string;
}

export type SalesCompleteTaskError = Fetcher.ErrorWrapper<undefined>;

export type SalesCompleteTaskVariables = {
  pathParams: SalesCompleteTaskPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesCompleteTask = (variables: SalesCompleteTaskVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesCompleteTaskError, undefined, {}, {}, SalesCompleteTaskPathParams>({
    method: "post",
    url: "/api/v1/sales/bubbles/{bubbleId}/tasks/{taskId}/complete",
    ...variables,
    signal,
  });

export const useSalesCompleteTask = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesCompleteTaskError, SalesCompleteTaskVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesCompleteTaskError, SalesCompleteTaskVariables>({
    mutationFn: (variables: SalesCompleteTaskVariables) => fetchSalesCompleteTask(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesReassignTaskPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  taskId: string;
}

export type SalesReassignTaskError = Fetcher.ErrorWrapper<undefined>;

export type SalesReassignTaskVariables = {
  body?: Schemas.TaskReassignDto;
  pathParams: SalesReassignTaskPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesReassignTask = (variables: SalesReassignTaskVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    SalesReassignTaskError,
    Schemas.TaskReassignDto,
    {},
    {},
    SalesReassignTaskPathParams
  >({ method: "post", url: "/api/v1/sales/bubbles/{bubbleId}/tasks/{taskId}/reassign", ...variables, signal });

export const useSalesReassignTask = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesReassignTaskError, SalesReassignTaskVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesReassignTaskError, SalesReassignTaskVariables>({
    mutationFn: (variables: SalesReassignTaskVariables) => fetchSalesReassignTask(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesSnoozeTaskPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  taskId: string;
}

export type SalesSnoozeTaskError = Fetcher.ErrorWrapper<undefined>;

export type SalesSnoozeTaskVariables = {
  body?: Schemas.TaskSnoozeDto;
  pathParams: SalesSnoozeTaskPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesSnoozeTask = (variables: SalesSnoozeTaskVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesSnoozeTaskError, Schemas.TaskSnoozeDto, {}, {}, SalesSnoozeTaskPathParams>({
    method: "post",
    url: "/api/v1/sales/bubbles/{bubbleId}/tasks/{taskId}/snooze",
    ...variables,
    signal,
  });

export const useSalesSnoozeTask = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesSnoozeTaskError, SalesSnoozeTaskVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesSnoozeTaskError, SalesSnoozeTaskVariables>({
    mutationFn: (variables: SalesSnoozeTaskVariables) => fetchSalesSnoozeTask(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesUpdateStagePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type SalesUpdateStageError = Fetcher.ErrorWrapper<undefined>;

export type SalesUpdateStageVariables = {
  body?: Schemas.StageUpdateDto;
  pathParams: SalesUpdateStagePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesUpdateStage = (variables: SalesUpdateStageVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesUpdateStageError, Schemas.StageUpdateDto, {}, {}, SalesUpdateStagePathParams>({
    method: "put",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/stage",
    ...variables,
    signal,
  });

export const useSalesUpdateStage = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesUpdateStageError, SalesUpdateStageVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesUpdateStageError, SalesUpdateStageVariables>({
    mutationFn: (variables: SalesUpdateStageVariables) => fetchSalesUpdateStage(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesGetStageHistoryPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * @format uuid
   */
  id: string;
}

export type SalesGetStageHistoryError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetStageHistoryVariables = {
  pathParams: SalesGetStageHistoryPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetStageHistory = (variables: SalesGetStageHistoryVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesGetStageHistoryError, undefined, {}, {}, SalesGetStageHistoryPathParams>({
    method: "get",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/stage/history",
    ...variables,
    signal,
  });

export function salesGetStageHistoryQuery(variables: SalesGetStageHistoryVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function salesGetStageHistoryQuery(variables: SalesGetStageHistoryVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function salesGetStageHistoryQuery(variables: SalesGetStageHistoryVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetStageHistory(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetStageHistory",
      path: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/stage/history",
      variables,
    }),
  };
}

export const useSuspenseSalesGetStageHistory = <TData = undefined>(
  variables: SalesGetStageHistoryVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetStageHistoryError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, SalesGetStageHistoryError, TData>({
    ...salesGetStageHistoryQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetStageHistory = <TData = undefined>(
  variables: SalesGetStageHistoryVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetStageHistoryError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, SalesGetStageHistoryError, TData>({
    ...salesGetStageHistoryQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface SalesGetPipelinePathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export type SalesGetPipelineError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetPipelineVariables = {
  pathParams: SalesGetPipelinePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetPipeline = (variables: SalesGetPipelineVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SalesGetPipelineError, undefined, {}, {}, SalesGetPipelinePathParams>({
    method: "get",
    url: "/api/v1/sales/bubbles/{bubbleId}/pipeline",
    ...variables,
    signal,
  });

export function salesGetPipelineQuery(variables: SalesGetPipelineVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function salesGetPipelineQuery(variables: SalesGetPipelineVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function salesGetPipelineQuery(variables: SalesGetPipelineVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetPipeline(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetPipeline",
      path: "/api/v1/sales/bubbles/{bubbleId}/pipeline",
      variables,
    }),
  };
}

export const useSuspenseSalesGetPipeline = <TData = undefined>(
  variables: SalesGetPipelineVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetPipelineError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, SalesGetPipelineError, TData>({
    ...salesGetPipelineQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetPipeline = <TData = undefined>(
  variables: SalesGetPipelineVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetPipelineError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, SalesGetPipelineError, TData>({
    ...salesGetPipelineQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface SalesGetStaleProspectsPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export interface SalesGetStaleProspectsQueryParams {
  /**
   * @format int32
   * @default 30
   */
  days?: number;
}

export type SalesGetStaleProspectsError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetStaleProspectsVariables = {
  pathParams: SalesGetStaleProspectsPathParams;
  queryParams?: SalesGetStaleProspectsQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetStaleProspects = (variables: SalesGetStaleProspectsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    SalesGetStaleProspectsError,
    undefined,
    {},
    SalesGetStaleProspectsQueryParams,
    SalesGetStaleProspectsPathParams
  >({ method: "get", url: "/api/v1/sales/bubbles/{bubbleId}/reports/stale", ...variables, signal });

export function salesGetStaleProspectsQuery(variables: SalesGetStaleProspectsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function salesGetStaleProspectsQuery(variables: SalesGetStaleProspectsVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function salesGetStaleProspectsQuery(variables: SalesGetStaleProspectsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetStaleProspects(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetStaleProspects",
      path: "/api/v1/sales/bubbles/{bubbleId}/reports/stale",
      variables,
    }),
  };
}

export const useSuspenseSalesGetStaleProspects = <TData = undefined>(
  variables: SalesGetStaleProspectsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetStaleProspectsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, SalesGetStaleProspectsError, TData>({
    ...salesGetStaleProspectsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetStaleProspects = <TData = undefined>(
  variables: SalesGetStaleProspectsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetStaleProspectsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, SalesGetStaleProspectsError, TData>({
    ...salesGetStaleProspectsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface SalesGetTasksDueSoonPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export interface SalesGetTasksDueSoonQueryParams {
  /**
   * @format int32
   * @default 7
   */
  days?: number;
}

export type SalesGetTasksDueSoonError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetTasksDueSoonVariables = {
  pathParams: SalesGetTasksDueSoonPathParams;
  queryParams?: SalesGetTasksDueSoonQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetTasksDueSoon = (variables: SalesGetTasksDueSoonVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    SalesGetTasksDueSoonError,
    undefined,
    {},
    SalesGetTasksDueSoonQueryParams,
    SalesGetTasksDueSoonPathParams
  >({ method: "get", url: "/api/v1/sales/bubbles/{bubbleId}/reports/tasks/due-soon", ...variables, signal });

export function salesGetTasksDueSoonQuery(variables: SalesGetTasksDueSoonVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<undefined>;
};

export function salesGetTasksDueSoonQuery(variables: SalesGetTasksDueSoonVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<undefined>) | reactQuery.SkipToken;
};

export function salesGetTasksDueSoonQuery(variables: SalesGetTasksDueSoonVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetTasksDueSoon(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetTasksDueSoon",
      path: "/api/v1/sales/bubbles/{bubbleId}/reports/tasks/due-soon",
      variables,
    }),
  };
}

export const useSuspenseSalesGetTasksDueSoon = <TData = undefined>(
  variables: SalesGetTasksDueSoonVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetTasksDueSoonError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<undefined, SalesGetTasksDueSoonError, TData>({
    ...salesGetTasksDueSoonQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetTasksDueSoon = <TData = undefined>(
  variables: SalesGetTasksDueSoonVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<undefined, SalesGetTasksDueSoonError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<undefined, SalesGetTasksDueSoonError, TData>({
    ...salesGetTasksDueSoonQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export type SalesGetSalesActivityError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetSalesActivityVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetSalesActivity = (variables: SalesGetSalesActivityVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<Schemas.SalesActivityDto, SalesGetSalesActivityError, undefined, {}, {}, {}>({
    method: "get",
    url: "/api/v1/sales/reports/all-user-activity",
    ...variables,
    signal,
  });

export function salesGetSalesActivityQuery(variables: SalesGetSalesActivityVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.SalesActivityDto>;
};

export function salesGetSalesActivityQuery(variables: SalesGetSalesActivityVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.SalesActivityDto>) | reactQuery.SkipToken;
};

export function salesGetSalesActivityQuery(variables: SalesGetSalesActivityVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetSalesActivity(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetSalesActivity",
      path: "/api/v1/sales/reports/all-user-activity",
      variables,
    }),
  };
}

export const useSuspenseSalesGetSalesActivity = <TData = Schemas.SalesActivityDto>(
  variables: SalesGetSalesActivityVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.SalesActivityDto, SalesGetSalesActivityError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.SalesActivityDto, SalesGetSalesActivityError, TData>({
    ...salesGetSalesActivityQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetSalesActivity = <TData = Schemas.SalesActivityDto>(
  variables: SalesGetSalesActivityVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.SalesActivityDto, SalesGetSalesActivityError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.SalesActivityDto, SalesGetSalesActivityError, TData>({
    ...salesGetSalesActivityQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type SalesGetSalesFolksError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetSalesFolksResponse = Schemas.UserDto[];

export type SalesGetSalesFolksVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetSalesFolks = (variables: SalesGetSalesFolksVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<SalesGetSalesFolksResponse, SalesGetSalesFolksError, undefined, {}, {}, {}>({
    method: "get",
    url: "/api/v1/sales/personnel/sales",
    ...variables,
    signal,
  });

export function salesGetSalesFolksQuery(variables: SalesGetSalesFolksVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<SalesGetSalesFolksResponse>;
};

export function salesGetSalesFolksQuery(variables: SalesGetSalesFolksVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<SalesGetSalesFolksResponse>) | reactQuery.SkipToken;
};

export function salesGetSalesFolksQuery(variables: SalesGetSalesFolksVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetSalesFolks(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetSalesFolks",
      path: "/api/v1/sales/personnel/sales",
      variables,
    }),
  };
}

export const useSuspenseSalesGetSalesFolks = <TData = SalesGetSalesFolksResponse>(
  variables: SalesGetSalesFolksVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<SalesGetSalesFolksResponse, SalesGetSalesFolksError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<SalesGetSalesFolksResponse, SalesGetSalesFolksError, TData>({
    ...salesGetSalesFolksQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetSalesFolks = <TData = SalesGetSalesFolksResponse>(
  variables: SalesGetSalesFolksVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<SalesGetSalesFolksResponse, SalesGetSalesFolksError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<SalesGetSalesFolksResponse, SalesGetSalesFolksError, TData>({
    ...salesGetSalesFolksQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export type SalesSendSalesTemplateEmailError = Fetcher.ErrorWrapper<undefined>;

export type SalesSendSalesTemplateEmailVariables = {
  body?: Schemas.SendSalesTemplateEmailDto;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesSendSalesTemplateEmail = (
  variables: SalesSendSalesTemplateEmailVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<undefined, SalesSendSalesTemplateEmailError, Schemas.SendSalesTemplateEmailDto, {}, {}, {}>({
    method: "post",
    url: "/api/v1/sales/emails/send-template",
    ...variables,
    signal,
  });

export const useSalesSendSalesTemplateEmail = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesSendSalesTemplateEmailError, SalesSendSalesTemplateEmailVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesSendSalesTemplateEmailError, SalesSendSalesTemplateEmailVariables>({
    mutationFn: (variables: SalesSendSalesTemplateEmailVariables) =>
      fetchSalesSendSalesTemplateEmail(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type SalesGetSalesEmailTemplatesError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetSalesEmailTemplatesResponse = Schemas.SalesEmailTemplateDto[];

export type SalesGetSalesEmailTemplatesVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetSalesEmailTemplates = (
  variables: SalesGetSalesEmailTemplatesVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<SalesGetSalesEmailTemplatesResponse, SalesGetSalesEmailTemplatesError, undefined, {}, {}, {}>({
    method: "get",
    url: "/api/v1/sales/email-templates",
    ...variables,
    signal,
  });

export function salesGetSalesEmailTemplatesQuery(variables: SalesGetSalesEmailTemplatesVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<SalesGetSalesEmailTemplatesResponse>;
};

export function salesGetSalesEmailTemplatesQuery(
  variables: SalesGetSalesEmailTemplatesVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<SalesGetSalesEmailTemplatesResponse>) | reactQuery.SkipToken;
};

export function salesGetSalesEmailTemplatesQuery(
  variables: SalesGetSalesEmailTemplatesVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetSalesEmailTemplates(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetSalesEmailTemplates",
      path: "/api/v1/sales/email-templates",
      variables,
    }),
  };
}

export const useSuspenseSalesGetSalesEmailTemplates = <TData = SalesGetSalesEmailTemplatesResponse>(
  variables: SalesGetSalesEmailTemplatesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<SalesGetSalesEmailTemplatesResponse, SalesGetSalesEmailTemplatesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<SalesGetSalesEmailTemplatesResponse, SalesGetSalesEmailTemplatesError, TData>({
    ...salesGetSalesEmailTemplatesQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetSalesEmailTemplates = <TData = SalesGetSalesEmailTemplatesResponse>(
  variables: SalesGetSalesEmailTemplatesVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<SalesGetSalesEmailTemplatesResponse, SalesGetSalesEmailTemplatesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<SalesGetSalesEmailTemplatesResponse, SalesGetSalesEmailTemplatesError, TData>({
    ...salesGetSalesEmailTemplatesQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type SalesCreateSalesEmailTemplateError = Fetcher.ErrorWrapper<undefined>;

export type SalesCreateSalesEmailTemplateVariables = {
  body?: Schemas.SalesEmailTemplateSaveDto;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesCreateSalesEmailTemplate = (
  variables: SalesCreateSalesEmailTemplateVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.SalesEmailTemplateDto,
    SalesCreateSalesEmailTemplateError,
    Schemas.SalesEmailTemplateSaveDto,
    {},
    {},
    {}
  >({ method: "post", url: "/api/v1/sales/email-templates", ...variables, signal });

export const useSalesCreateSalesEmailTemplate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SalesEmailTemplateDto,
      SalesCreateSalesEmailTemplateError,
      SalesCreateSalesEmailTemplateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.SalesEmailTemplateDto,
    SalesCreateSalesEmailTemplateError,
    SalesCreateSalesEmailTemplateVariables
  >({
    mutationFn: (variables: SalesCreateSalesEmailTemplateVariables) =>
      fetchSalesCreateSalesEmailTemplate(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesGetSalesEmailTemplatePathParams {
  /**
   * @format uuid
   */
  templateId: string;
}

export type SalesGetSalesEmailTemplateError = Fetcher.ErrorWrapper<undefined>;

export type SalesGetSalesEmailTemplateVariables = {
  pathParams: SalesGetSalesEmailTemplatePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesGetSalesEmailTemplate = (variables: SalesGetSalesEmailTemplateVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.SalesEmailTemplateDto,
    SalesGetSalesEmailTemplateError,
    undefined,
    {},
    {},
    SalesGetSalesEmailTemplatePathParams
  >({ method: "get", url: "/api/v1/sales/email-templates/{templateId}", ...variables, signal });

export function salesGetSalesEmailTemplateQuery(variables: SalesGetSalesEmailTemplateVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.SalesEmailTemplateDto>;
};

export function salesGetSalesEmailTemplateQuery(
  variables: SalesGetSalesEmailTemplateVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.SalesEmailTemplateDto>) | reactQuery.SkipToken;
};

export function salesGetSalesEmailTemplateQuery(variables: SalesGetSalesEmailTemplateVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSalesGetSalesEmailTemplate(variables, signal),
    queryKey: queryKeyFn({
      operationId: "salesGetSalesEmailTemplate",
      path: "/api/v1/sales/email-templates/{templateId}",
      variables,
    }),
  };
}

export const useSuspenseSalesGetSalesEmailTemplate = <TData = Schemas.SalesEmailTemplateDto>(
  variables: SalesGetSalesEmailTemplateVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.SalesEmailTemplateDto, SalesGetSalesEmailTemplateError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.SalesEmailTemplateDto, SalesGetSalesEmailTemplateError, TData>({
    ...salesGetSalesEmailTemplateQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSalesGetSalesEmailTemplate = <TData = Schemas.SalesEmailTemplateDto>(
  variables: SalesGetSalesEmailTemplateVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.SalesEmailTemplateDto, SalesGetSalesEmailTemplateError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.SalesEmailTemplateDto, SalesGetSalesEmailTemplateError, TData>({
    ...salesGetSalesEmailTemplateQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface SalesUpdateSalesEmailTemplatePathParams {
  /**
   * @format uuid
   */
  templateId: string;
}

export type SalesUpdateSalesEmailTemplateError = Fetcher.ErrorWrapper<undefined>;

export type SalesUpdateSalesEmailTemplateVariables = {
  body?: Schemas.SalesEmailTemplateSaveDto;
  pathParams: SalesUpdateSalesEmailTemplatePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesUpdateSalesEmailTemplate = (
  variables: SalesUpdateSalesEmailTemplateVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    SalesUpdateSalesEmailTemplateError,
    Schemas.SalesEmailTemplateSaveDto,
    {},
    {},
    SalesUpdateSalesEmailTemplatePathParams
  >({ method: "put", url: "/api/v1/sales/email-templates/{templateId}", ...variables, signal });

export const useSalesUpdateSalesEmailTemplate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SalesUpdateSalesEmailTemplateError,
      SalesUpdateSalesEmailTemplateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesUpdateSalesEmailTemplateError, SalesUpdateSalesEmailTemplateVariables>({
    mutationFn: (variables: SalesUpdateSalesEmailTemplateVariables) =>
      fetchSalesUpdateSalesEmailTemplate(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesDeleteSalesEmailTemplatePathParams {
  /**
   * @format uuid
   */
  templateId: string;
}

export type SalesDeleteSalesEmailTemplateError = Fetcher.ErrorWrapper<undefined>;

export type SalesDeleteSalesEmailTemplateVariables = {
  pathParams: SalesDeleteSalesEmailTemplatePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesDeleteSalesEmailTemplate = (
  variables: SalesDeleteSalesEmailTemplateVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    SalesDeleteSalesEmailTemplateError,
    undefined,
    {},
    {},
    SalesDeleteSalesEmailTemplatePathParams
  >({ method: "delete", url: "/api/v1/sales/email-templates/{templateId}", ...variables, signal });

export const useSalesDeleteSalesEmailTemplate = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SalesDeleteSalesEmailTemplateError,
      SalesDeleteSalesEmailTemplateVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesDeleteSalesEmailTemplateError, SalesDeleteSalesEmailTemplateVariables>({
    mutationFn: (variables: SalesDeleteSalesEmailTemplateVariables) =>
      fetchSalesDeleteSalesEmailTemplate(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SalesSetTimeZoneForProspectPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  prospectId: string;
}

export interface SalesSetTimeZoneForProspectQueryParams {
  /**
   * Optional, defaults to America/New_York
   */
  timezone?: string;
}

export type SalesSetTimeZoneForProspectError = Fetcher.ErrorWrapper<undefined>;

export type SalesSetTimeZoneForProspectVariables = {
  pathParams: SalesSetTimeZoneForProspectPathParams;
  queryParams?: SalesSetTimeZoneForProspectQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSalesSetTimeZoneForProspect = (
  variables: SalesSetTimeZoneForProspectVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    SalesSetTimeZoneForProspectError,
    undefined,
    {},
    SalesSetTimeZoneForProspectQueryParams,
    SalesSetTimeZoneForProspectPathParams
  >({
    method: "post",
    url: "/api/v1/sales/bubbles/{bubbleId}/prospects/{prospectId}/set-timezone",
    ...variables,
    signal,
  });

export const useSalesSetTimeZoneForProspect = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SalesSetTimeZoneForProspectError, SalesSetTimeZoneForProspectVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SalesSetTimeZoneForProspectError, SalesSetTimeZoneForProspectVariables>({
    mutationFn: (variables: SalesSetTimeZoneForProspectVariables) =>
      fetchSalesSetTimeZoneForProspect(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SchoolDistrictGetSchoolDistrictPathParams {
  /**
   * @format uuid
   */
  schoolDistrictId: string;
  bubbleId: string;
}

export type SchoolDistrictGetSchoolDistrictError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictGetSchoolDistrictVariables = {
  pathParams: SchoolDistrictGetSchoolDistrictPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictGetSchoolDistrict = (
  variables: SchoolDistrictGetSchoolDistrictVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.SchoolDistrictDto,
    SchoolDistrictGetSchoolDistrictError,
    undefined,
    {},
    {},
    SchoolDistrictGetSchoolDistrictPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/{schoolDistrictId}", ...variables, signal });

export function schoolDistrictGetSchoolDistrictQuery(variables: SchoolDistrictGetSchoolDistrictVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.SchoolDistrictDto>;
};

export function schoolDistrictGetSchoolDistrictQuery(
  variables: SchoolDistrictGetSchoolDistrictVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.SchoolDistrictDto>) | reactQuery.SkipToken;
};

export function schoolDistrictGetSchoolDistrictQuery(
  variables: SchoolDistrictGetSchoolDistrictVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSchoolDistrictGetSchoolDistrict(variables, signal),
    queryKey: queryKeyFn({
      operationId: "schoolDistrictGetSchoolDistrict",
      path: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/{schoolDistrictId}",
      variables,
    }),
  };
}

export const useSuspenseSchoolDistrictGetSchoolDistrict = <TData = Schemas.SchoolDistrictDto>(
  variables: SchoolDistrictGetSchoolDistrictVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.SchoolDistrictDto, SchoolDistrictGetSchoolDistrictError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.SchoolDistrictDto, SchoolDistrictGetSchoolDistrictError, TData>({
    ...schoolDistrictGetSchoolDistrictQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSchoolDistrictGetSchoolDistrict = <TData = Schemas.SchoolDistrictDto>(
  variables: SchoolDistrictGetSchoolDistrictVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.SchoolDistrictDto, SchoolDistrictGetSchoolDistrictError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.SchoolDistrictDto, SchoolDistrictGetSchoolDistrictError, TData>({
    ...schoolDistrictGetSchoolDistrictQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface SchoolDistrictGetSchoolPathParams {
  /**
   * @format uuid
   */
  schoolId: string;
  bubbleId: string;
}

export type SchoolDistrictGetSchoolError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictGetSchoolVariables = {
  pathParams: SchoolDistrictGetSchoolPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictGetSchool = (variables: SchoolDistrictGetSchoolVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.SchoolDto,
    SchoolDistrictGetSchoolError,
    undefined,
    {},
    {},
    SchoolDistrictGetSchoolPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/schools/{schoolId}", ...variables, signal });

export function schoolDistrictGetSchoolQuery(variables: SchoolDistrictGetSchoolVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.SchoolDto>;
};

export function schoolDistrictGetSchoolQuery(variables: SchoolDistrictGetSchoolVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.SchoolDto>) | reactQuery.SkipToken;
};

export function schoolDistrictGetSchoolQuery(variables: SchoolDistrictGetSchoolVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSchoolDistrictGetSchool(variables, signal),
    queryKey: queryKeyFn({
      operationId: "schoolDistrictGetSchool",
      path: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/schools/{schoolId}",
      variables,
    }),
  };
}

export const useSuspenseSchoolDistrictGetSchool = <TData = Schemas.SchoolDto>(
  variables: SchoolDistrictGetSchoolVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.SchoolDto, SchoolDistrictGetSchoolError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.SchoolDto, SchoolDistrictGetSchoolError, TData>({
    ...schoolDistrictGetSchoolQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSchoolDistrictGetSchool = <TData = Schemas.SchoolDto>(
  variables: SchoolDistrictGetSchoolVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.SchoolDto, SchoolDistrictGetSchoolError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.SchoolDto, SchoolDistrictGetSchoolError, TData>({
    ...schoolDistrictGetSchoolQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface SchoolDistrictGetSchoolsForSchoolDistrictPathParams {
  /**
   * @format uuid
   */
  schoolDistrictId: string;
  bubbleId: string;
}

export type SchoolDistrictGetSchoolsForSchoolDistrictError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictGetSchoolsForSchoolDistrictResponse = Schemas.SchoolSummaryDto[];

export type SchoolDistrictGetSchoolsForSchoolDistrictVariables = {
  pathParams: SchoolDistrictGetSchoolsForSchoolDistrictPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictGetSchoolsForSchoolDistrict = (
  variables: SchoolDistrictGetSchoolsForSchoolDistrictVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    SchoolDistrictGetSchoolsForSchoolDistrictResponse,
    SchoolDistrictGetSchoolsForSchoolDistrictError,
    undefined,
    {},
    {},
    SchoolDistrictGetSchoolsForSchoolDistrictPathParams
  >({
    method: "get",
    url: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/{schoolDistrictId}/schools",
    ...variables,
    signal,
  });

export function schoolDistrictGetSchoolsForSchoolDistrictQuery(
  variables: SchoolDistrictGetSchoolsForSchoolDistrictVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<SchoolDistrictGetSchoolsForSchoolDistrictResponse>;
};

export function schoolDistrictGetSchoolsForSchoolDistrictQuery(
  variables: SchoolDistrictGetSchoolsForSchoolDistrictVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<SchoolDistrictGetSchoolsForSchoolDistrictResponse>)
    | reactQuery.SkipToken;
};

export function schoolDistrictGetSchoolsForSchoolDistrictQuery(
  variables: SchoolDistrictGetSchoolsForSchoolDistrictVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSchoolDistrictGetSchoolsForSchoolDistrict(variables, signal),
    queryKey: queryKeyFn({
      operationId: "schoolDistrictGetSchoolsForSchoolDistrict",
      path: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/{schoolDistrictId}/schools",
      variables,
    }),
  };
}

export const useSuspenseSchoolDistrictGetSchoolsForSchoolDistrict = <
  TData = SchoolDistrictGetSchoolsForSchoolDistrictResponse,
>(
  variables: SchoolDistrictGetSchoolsForSchoolDistrictVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      SchoolDistrictGetSchoolsForSchoolDistrictResponse,
      SchoolDistrictGetSchoolsForSchoolDistrictError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    SchoolDistrictGetSchoolsForSchoolDistrictResponse,
    SchoolDistrictGetSchoolsForSchoolDistrictError,
    TData
  >({
    ...schoolDistrictGetSchoolsForSchoolDistrictQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSchoolDistrictGetSchoolsForSchoolDistrict = <TData = SchoolDistrictGetSchoolsForSchoolDistrictResponse>(
  variables: SchoolDistrictGetSchoolsForSchoolDistrictVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      SchoolDistrictGetSchoolsForSchoolDistrictResponse,
      SchoolDistrictGetSchoolsForSchoolDistrictError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    SchoolDistrictGetSchoolsForSchoolDistrictResponse,
    SchoolDistrictGetSchoolsForSchoolDistrictError,
    TData
  >({
    ...schoolDistrictGetSchoolsForSchoolDistrictQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface SchoolDistrictGetSearchableSchoolsForSchoolDistrictPathParams {
  /**
   * @format uuid
   */
  schoolDistrictId: string;
}

export type SchoolDistrictGetSearchableSchoolsForSchoolDistrictError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictGetSearchableSchoolsForSchoolDistrictResponse = Schemas.SchoolSummaryDto[];

export type SchoolDistrictGetSearchableSchoolsForSchoolDistrictVariables = {
  pathParams: SchoolDistrictGetSearchableSchoolsForSchoolDistrictPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictGetSearchableSchoolsForSchoolDistrict = (
  variables: SchoolDistrictGetSearchableSchoolsForSchoolDistrictVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    SchoolDistrictGetSearchableSchoolsForSchoolDistrictResponse,
    SchoolDistrictGetSearchableSchoolsForSchoolDistrictError,
    undefined,
    {},
    {},
    SchoolDistrictGetSearchableSchoolsForSchoolDistrictPathParams
  >({ method: "get", url: "/api/v1/SchoolDistrict/{schoolDistrictId}/schools", ...variables, signal });

export function schoolDistrictGetSearchableSchoolsForSchoolDistrictQuery(
  variables: SchoolDistrictGetSearchableSchoolsForSchoolDistrictVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<SchoolDistrictGetSearchableSchoolsForSchoolDistrictResponse>;
};

export function schoolDistrictGetSearchableSchoolsForSchoolDistrictQuery(
  variables: SchoolDistrictGetSearchableSchoolsForSchoolDistrictVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<SchoolDistrictGetSearchableSchoolsForSchoolDistrictResponse>)
    | reactQuery.SkipToken;
};

export function schoolDistrictGetSearchableSchoolsForSchoolDistrictQuery(
  variables: SchoolDistrictGetSearchableSchoolsForSchoolDistrictVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSchoolDistrictGetSearchableSchoolsForSchoolDistrict(variables, signal),
    queryKey: queryKeyFn({
      operationId: "schoolDistrictGetSearchableSchoolsForSchoolDistrict",
      path: "/api/v1/SchoolDistrict/{schoolDistrictId}/schools",
      variables,
    }),
  };
}

export const useSuspenseSchoolDistrictGetSearchableSchoolsForSchoolDistrict = <
  TData = SchoolDistrictGetSearchableSchoolsForSchoolDistrictResponse,
>(
  variables: SchoolDistrictGetSearchableSchoolsForSchoolDistrictVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      SchoolDistrictGetSearchableSchoolsForSchoolDistrictResponse,
      SchoolDistrictGetSearchableSchoolsForSchoolDistrictError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    SchoolDistrictGetSearchableSchoolsForSchoolDistrictResponse,
    SchoolDistrictGetSearchableSchoolsForSchoolDistrictError,
    TData
  >({
    ...schoolDistrictGetSearchableSchoolsForSchoolDistrictQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSchoolDistrictGetSearchableSchoolsForSchoolDistrict = <
  TData = SchoolDistrictGetSearchableSchoolsForSchoolDistrictResponse,
>(
  variables: SchoolDistrictGetSearchableSchoolsForSchoolDistrictVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      SchoolDistrictGetSearchableSchoolsForSchoolDistrictResponse,
      SchoolDistrictGetSearchableSchoolsForSchoolDistrictError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    SchoolDistrictGetSearchableSchoolsForSchoolDistrictResponse,
    SchoolDistrictGetSearchableSchoolsForSchoolDistrictError,
    TData
  >({
    ...schoolDistrictGetSearchableSchoolsForSchoolDistrictQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface SchoolDistrictApproveVettedUserPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type SchoolDistrictApproveVettedUserError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictApproveVettedUserVariables = {
  pathParams: SchoolDistrictApproveVettedUserPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictApproveVettedUser = (
  variables: SchoolDistrictApproveVettedUserVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    SchoolDistrictApproveVettedUserError,
    undefined,
    {},
    {},
    SchoolDistrictApproveVettedUserPathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/user/{userId}/approve", ...variables, signal });

export const useSchoolDistrictApproveVettedUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SchoolDistrictApproveVettedUserError,
      SchoolDistrictApproveVettedUserVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    SchoolDistrictApproveVettedUserError,
    SchoolDistrictApproveVettedUserVariables
  >({
    mutationFn: (variables: SchoolDistrictApproveVettedUserVariables) =>
      fetchSchoolDistrictApproveVettedUser(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SchoolDistrictRemoveVettedUserPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type SchoolDistrictRemoveVettedUserError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictRemoveVettedUserVariables = {
  pathParams: SchoolDistrictRemoveVettedUserPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictRemoveVettedUser = (
  variables: SchoolDistrictRemoveVettedUserVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    SchoolDistrictRemoveVettedUserError,
    undefined,
    {},
    {},
    SchoolDistrictRemoveVettedUserPathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/user/{userId}/remove", ...variables, signal });

export const useSchoolDistrictRemoveVettedUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SchoolDistrictRemoveVettedUserError,
      SchoolDistrictRemoveVettedUserVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    SchoolDistrictRemoveVettedUserError,
    SchoolDistrictRemoveVettedUserVariables
  >({
    mutationFn: (variables: SchoolDistrictRemoveVettedUserVariables) =>
      fetchSchoolDistrictRemoveVettedUser(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SchoolDistrictPinSchoolPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  districtId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  schoolId: string;
  bubbleId: string;
}

export type SchoolDistrictPinSchoolError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictPinSchoolVariables = {
  pathParams: SchoolDistrictPinSchoolPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictPinSchool = (variables: SchoolDistrictPinSchoolVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, SchoolDistrictPinSchoolError, undefined, {}, {}, SchoolDistrictPinSchoolPathParams>({
    method: "post",
    url: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/{districtId}/school/{schoolId}/pin",
    ...variables,
    signal,
  });

export const useSchoolDistrictPinSchool = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SchoolDistrictPinSchoolError, SchoolDistrictPinSchoolVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SchoolDistrictPinSchoolError, SchoolDistrictPinSchoolVariables>({
    mutationFn: (variables: SchoolDistrictPinSchoolVariables) =>
      fetchSchoolDistrictPinSchool(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SchoolDistrictUnpinSchoolPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  districtId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  schoolId: string;
  bubbleId: string;
}

export type SchoolDistrictUnpinSchoolError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictUnpinSchoolVariables = {
  pathParams: SchoolDistrictUnpinSchoolPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictUnpinSchool = (variables: SchoolDistrictUnpinSchoolVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    SchoolDistrictUnpinSchoolError,
    undefined,
    {},
    {},
    SchoolDistrictUnpinSchoolPathParams
  >({
    method: "post",
    url: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/{districtId}/school/{schoolId}/unpin",
    ...variables,
    signal,
  });

export const useSchoolDistrictUnpinSchool = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SchoolDistrictUnpinSchoolError, SchoolDistrictUnpinSchoolVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SchoolDistrictUnpinSchoolError, SchoolDistrictUnpinSchoolVariables>({
    mutationFn: (variables: SchoolDistrictUnpinSchoolVariables) =>
      fetchSchoolDistrictUnpinSchool(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SchoolDistrictCreateNewDistrictPathParams {
  bubbleId: string;
}

export type SchoolDistrictCreateNewDistrictError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictCreateNewDistrictVariables = {
  body?: Schemas.CreateSchoolDistrictRequest;
  pathParams: SchoolDistrictCreateNewDistrictPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictCreateNewDistrict = (
  variables: SchoolDistrictCreateNewDistrictVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    SchoolDistrictCreateNewDistrictError,
    Schemas.CreateSchoolDistrictRequest,
    {},
    {},
    SchoolDistrictCreateNewDistrictPathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/create-district", ...variables, signal });

export const useSchoolDistrictCreateNewDistrict = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SchoolDistrictCreateNewDistrictError,
      SchoolDistrictCreateNewDistrictVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    SchoolDistrictCreateNewDistrictError,
    SchoolDistrictCreateNewDistrictVariables
  >({
    mutationFn: (variables: SchoolDistrictCreateNewDistrictVariables) =>
      fetchSchoolDistrictCreateNewDistrict(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SchoolDistrictCreateNewSchoolPathParams {
  bubbleId: string;
}

export type SchoolDistrictCreateNewSchoolError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictCreateNewSchoolVariables = {
  body?: Schemas.CreateSchoolRequest;
  pathParams: SchoolDistrictCreateNewSchoolPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictCreateNewSchool = (
  variables: SchoolDistrictCreateNewSchoolVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    SchoolDistrictCreateNewSchoolError,
    Schemas.CreateSchoolRequest,
    {},
    {},
    SchoolDistrictCreateNewSchoolPathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/create-school", ...variables, signal });

export const useSchoolDistrictCreateNewSchool = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      SchoolDistrictCreateNewSchoolError,
      SchoolDistrictCreateNewSchoolVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SchoolDistrictCreateNewSchoolError, SchoolDistrictCreateNewSchoolVariables>({
    mutationFn: (variables: SchoolDistrictCreateNewSchoolVariables) =>
      fetchSchoolDistrictCreateNewSchool(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SchoolDistrictGetSchoolsForLoggedInUserPathParams {
  bubbleId: string;
}

export type SchoolDistrictGetSchoolsForLoggedInUserError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictGetSchoolsForLoggedInUserResponse = Schemas.SchoolDto[];

export type SchoolDistrictGetSchoolsForLoggedInUserVariables = {
  pathParams: SchoolDistrictGetSchoolsForLoggedInUserPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictGetSchoolsForLoggedInUser = (
  variables: SchoolDistrictGetSchoolsForLoggedInUserVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    SchoolDistrictGetSchoolsForLoggedInUserResponse,
    SchoolDistrictGetSchoolsForLoggedInUserError,
    undefined,
    {},
    {},
    SchoolDistrictGetSchoolsForLoggedInUserPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/get-schools-for-user", ...variables, signal });

export function schoolDistrictGetSchoolsForLoggedInUserQuery(
  variables: SchoolDistrictGetSchoolsForLoggedInUserVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<SchoolDistrictGetSchoolsForLoggedInUserResponse>;
};

export function schoolDistrictGetSchoolsForLoggedInUserQuery(
  variables: SchoolDistrictGetSchoolsForLoggedInUserVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<SchoolDistrictGetSchoolsForLoggedInUserResponse>)
    | reactQuery.SkipToken;
};

export function schoolDistrictGetSchoolsForLoggedInUserQuery(
  variables: SchoolDistrictGetSchoolsForLoggedInUserVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSchoolDistrictGetSchoolsForLoggedInUser(variables, signal),
    queryKey: queryKeyFn({
      operationId: "schoolDistrictGetSchoolsForLoggedInUser",
      path: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/get-schools-for-user",
      variables,
    }),
  };
}

export const useSuspenseSchoolDistrictGetSchoolsForLoggedInUser = <
  TData = SchoolDistrictGetSchoolsForLoggedInUserResponse,
>(
  variables: SchoolDistrictGetSchoolsForLoggedInUserVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      SchoolDistrictGetSchoolsForLoggedInUserResponse,
      SchoolDistrictGetSchoolsForLoggedInUserError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    SchoolDistrictGetSchoolsForLoggedInUserResponse,
    SchoolDistrictGetSchoolsForLoggedInUserError,
    TData
  >({
    ...schoolDistrictGetSchoolsForLoggedInUserQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSchoolDistrictGetSchoolsForLoggedInUser = <TData = SchoolDistrictGetSchoolsForLoggedInUserResponse>(
  variables: SchoolDistrictGetSchoolsForLoggedInUserVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      SchoolDistrictGetSchoolsForLoggedInUserResponse,
      SchoolDistrictGetSchoolsForLoggedInUserError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    SchoolDistrictGetSchoolsForLoggedInUserResponse,
    SchoolDistrictGetSchoolsForLoggedInUserError,
    TData
  >({
    ...schoolDistrictGetSchoolsForLoggedInUserQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface SchoolDistrictGetSchoolSignInsPathParams {
  /**
   * @format uuid
   */
  bubbleId: string;
}

export interface SchoolDistrictGetSchoolSignInsQueryParams {
  /**
   * @format date-time
   */
  beginDate?: string;
  /**
   * @format date-time
   */
  endDate?: string;
}

export type SchoolDistrictGetSchoolSignInsError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictGetSchoolSignInsResponse = Schemas.SchoolSignInDto[];

export type SchoolDistrictGetSchoolSignInsVariables = {
  pathParams: SchoolDistrictGetSchoolSignInsPathParams;
  queryParams?: SchoolDistrictGetSchoolSignInsQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictGetSchoolSignIns = (
  variables: SchoolDistrictGetSchoolSignInsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    SchoolDistrictGetSchoolSignInsResponse,
    SchoolDistrictGetSchoolSignInsError,
    undefined,
    {},
    SchoolDistrictGetSchoolSignInsQueryParams,
    SchoolDistrictGetSchoolSignInsPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/get-school-sign-ins", ...variables, signal });

export function schoolDistrictGetSchoolSignInsQuery(variables: SchoolDistrictGetSchoolSignInsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<SchoolDistrictGetSchoolSignInsResponse>;
};

export function schoolDistrictGetSchoolSignInsQuery(
  variables: SchoolDistrictGetSchoolSignInsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<SchoolDistrictGetSchoolSignInsResponse>) | reactQuery.SkipToken;
};

export function schoolDistrictGetSchoolSignInsQuery(
  variables: SchoolDistrictGetSchoolSignInsVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSchoolDistrictGetSchoolSignIns(variables, signal),
    queryKey: queryKeyFn({
      operationId: "schoolDistrictGetSchoolSignIns",
      path: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/get-school-sign-ins",
      variables,
    }),
  };
}

export const useSuspenseSchoolDistrictGetSchoolSignIns = <TData = SchoolDistrictGetSchoolSignInsResponse>(
  variables: SchoolDistrictGetSchoolSignInsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<SchoolDistrictGetSchoolSignInsResponse, SchoolDistrictGetSchoolSignInsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    SchoolDistrictGetSchoolSignInsResponse,
    SchoolDistrictGetSchoolSignInsError,
    TData
  >({
    ...schoolDistrictGetSchoolSignInsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSchoolDistrictGetSchoolSignIns = <TData = SchoolDistrictGetSchoolSignInsResponse>(
  variables: SchoolDistrictGetSchoolSignInsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<SchoolDistrictGetSchoolSignInsResponse, SchoolDistrictGetSchoolSignInsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<SchoolDistrictGetSchoolSignInsResponse, SchoolDistrictGetSchoolSignInsError, TData>({
    ...schoolDistrictGetSchoolSignInsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface SchoolDistrictGetActiveSchoolVisitorSignInsPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type SchoolDistrictGetActiveSchoolVisitorSignInsError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictGetActiveSchoolVisitorSignInsResponse = Schemas.SchoolSignInDto[];

export type SchoolDistrictGetActiveSchoolVisitorSignInsVariables = {
  pathParams: SchoolDistrictGetActiveSchoolVisitorSignInsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictGetActiveSchoolVisitorSignIns = (
  variables: SchoolDistrictGetActiveSchoolVisitorSignInsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    SchoolDistrictGetActiveSchoolVisitorSignInsResponse,
    SchoolDistrictGetActiveSchoolVisitorSignInsError,
    undefined,
    {},
    {},
    SchoolDistrictGetActiveSchoolVisitorSignInsPathParams
  >({
    method: "get",
    url: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/get-active-school-sign-ins",
    ...variables,
    signal,
  });

export function schoolDistrictGetActiveSchoolVisitorSignInsQuery(
  variables: SchoolDistrictGetActiveSchoolVisitorSignInsVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<SchoolDistrictGetActiveSchoolVisitorSignInsResponse>;
};

export function schoolDistrictGetActiveSchoolVisitorSignInsQuery(
  variables: SchoolDistrictGetActiveSchoolVisitorSignInsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<SchoolDistrictGetActiveSchoolVisitorSignInsResponse>)
    | reactQuery.SkipToken;
};

export function schoolDistrictGetActiveSchoolVisitorSignInsQuery(
  variables: SchoolDistrictGetActiveSchoolVisitorSignInsVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSchoolDistrictGetActiveSchoolVisitorSignIns(variables, signal),
    queryKey: queryKeyFn({
      operationId: "schoolDistrictGetActiveSchoolVisitorSignIns",
      path: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/get-active-school-sign-ins",
      variables,
    }),
  };
}

export const useSuspenseSchoolDistrictGetActiveSchoolVisitorSignIns = <
  TData = SchoolDistrictGetActiveSchoolVisitorSignInsResponse,
>(
  variables: SchoolDistrictGetActiveSchoolVisitorSignInsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      SchoolDistrictGetActiveSchoolVisitorSignInsResponse,
      SchoolDistrictGetActiveSchoolVisitorSignInsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    SchoolDistrictGetActiveSchoolVisitorSignInsResponse,
    SchoolDistrictGetActiveSchoolVisitorSignInsError,
    TData
  >({
    ...schoolDistrictGetActiveSchoolVisitorSignInsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSchoolDistrictGetActiveSchoolVisitorSignIns = <
  TData = SchoolDistrictGetActiveSchoolVisitorSignInsResponse,
>(
  variables: SchoolDistrictGetActiveSchoolVisitorSignInsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      SchoolDistrictGetActiveSchoolVisitorSignInsResponse,
      SchoolDistrictGetActiveSchoolVisitorSignInsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    SchoolDistrictGetActiveSchoolVisitorSignInsResponse,
    SchoolDistrictGetActiveSchoolVisitorSignInsError,
    TData
  >({
    ...schoolDistrictGetActiveSchoolVisitorSignInsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface SchoolDistrictSignInUserPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type SchoolDistrictSignInUserError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictSignInUserVariables = {
  pathParams: SchoolDistrictSignInUserPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictSignInUser = (variables: SchoolDistrictSignInUserVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    SchoolDistrictSignInUserError,
    undefined,
    {},
    {},
    SchoolDistrictSignInUserPathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/users/{userId}/sign-in", ...variables, signal });

export const useSchoolDistrictSignInUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SchoolDistrictSignInUserError, SchoolDistrictSignInUserVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SchoolDistrictSignInUserError, SchoolDistrictSignInUserVariables>({
    mutationFn: (variables: SchoolDistrictSignInUserVariables) =>
      fetchSchoolDistrictSignInUser(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SchoolDistrictSignOutUserPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export interface SchoolDistrictSignOutUserQueryParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  parentId?: string;
}

export type SchoolDistrictSignOutUserError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictSignOutUserVariables = {
  pathParams: SchoolDistrictSignOutUserPathParams;
  queryParams?: SchoolDistrictSignOutUserQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictSignOutUser = (variables: SchoolDistrictSignOutUserVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    SchoolDistrictSignOutUserError,
    undefined,
    {},
    SchoolDistrictSignOutUserQueryParams,
    SchoolDistrictSignOutUserPathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/users/{userId}/sign-out", ...variables, signal });

export const useSchoolDistrictSignOutUser = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SchoolDistrictSignOutUserError, SchoolDistrictSignOutUserVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SchoolDistrictSignOutUserError, SchoolDistrictSignOutUserVariables>({
    mutationFn: (variables: SchoolDistrictSignOutUserVariables) =>
      fetchSchoolDistrictSignOutUser(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SchoolDistrictCreateParentPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
  bubbleId: string;
}

export type SchoolDistrictCreateParentError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictCreateParentVariables = {
  body?: Schemas.CreateParentRequest;
  pathParams: SchoolDistrictCreateParentPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictCreateParent = (variables: SchoolDistrictCreateParentVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    SchoolDistrictCreateParentError,
    Schemas.CreateParentRequest,
    {},
    {},
    SchoolDistrictCreateParentPathParams
  >({
    method: "post",
    url: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/users/{userId}/create-parent",
    ...variables,
    signal,
  });

export const useSchoolDistrictCreateParent = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, SchoolDistrictCreateParentError, SchoolDistrictCreateParentVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, SchoolDistrictCreateParentError, SchoolDistrictCreateParentVariables>({
    mutationFn: (variables: SchoolDistrictCreateParentVariables) =>
      fetchSchoolDistrictCreateParent(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SchoolDistrictGetParentsPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
  bubbleId: string;
}

export type SchoolDistrictGetParentsError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictGetParentsResponse = Schemas.UserDto[];

export type SchoolDistrictGetParentsVariables = {
  pathParams: SchoolDistrictGetParentsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictGetParents = (variables: SchoolDistrictGetParentsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    SchoolDistrictGetParentsResponse,
    SchoolDistrictGetParentsError,
    undefined,
    {},
    {},
    SchoolDistrictGetParentsPathParams
  >({ method: "get", url: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/users/{userId}/parents", ...variables, signal });

export function schoolDistrictGetParentsQuery(variables: SchoolDistrictGetParentsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<SchoolDistrictGetParentsResponse>;
};

export function schoolDistrictGetParentsQuery(variables: SchoolDistrictGetParentsVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<SchoolDistrictGetParentsResponse>) | reactQuery.SkipToken;
};

export function schoolDistrictGetParentsQuery(variables: SchoolDistrictGetParentsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSchoolDistrictGetParents(variables, signal),
    queryKey: queryKeyFn({
      operationId: "schoolDistrictGetParents",
      path: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/users/{userId}/parents",
      variables,
    }),
  };
}

export const useSuspenseSchoolDistrictGetParents = <TData = SchoolDistrictGetParentsResponse>(
  variables: SchoolDistrictGetParentsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<SchoolDistrictGetParentsResponse, SchoolDistrictGetParentsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<SchoolDistrictGetParentsResponse, SchoolDistrictGetParentsError, TData>({
    ...schoolDistrictGetParentsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSchoolDistrictGetParents = <TData = SchoolDistrictGetParentsResponse>(
  variables: SchoolDistrictGetParentsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<SchoolDistrictGetParentsResponse, SchoolDistrictGetParentsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<SchoolDistrictGetParentsResponse, SchoolDistrictGetParentsError, TData>({
    ...schoolDistrictGetParentsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface SchoolDistrictSearchSexOffendersPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type SchoolDistrictSearchSexOffendersError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictSearchSexOffendersVariables = {
  body?: Schemas.SexOffenderSearchRequestDto;
  pathParams: SchoolDistrictSearchSexOffendersPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictSearchSexOffenders = (
  variables: SchoolDistrictSearchSexOffendersVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.SexOffenderSearchResponseDto,
    SchoolDistrictSearchSexOffendersError,
    Schemas.SexOffenderSearchRequestDto,
    {},
    {},
    SchoolDistrictSearchSexOffendersPathParams
  >({ method: "post", url: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/sex-offender-search", ...variables, signal });

export const useSchoolDistrictSearchSexOffenders = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.SexOffenderSearchResponseDto,
      SchoolDistrictSearchSexOffendersError,
      SchoolDistrictSearchSexOffendersVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.SexOffenderSearchResponseDto,
    SchoolDistrictSearchSexOffendersError,
    SchoolDistrictSearchSexOffendersVariables
  >({
    mutationFn: (variables: SchoolDistrictSearchSexOffendersVariables) =>
      fetchSchoolDistrictSearchSexOffenders(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SchoolDistrictParseDriverLicenseBarcodePathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type SchoolDistrictParseDriverLicenseBarcodeError = Fetcher.ErrorWrapper<undefined>;

export type SchoolDistrictParseDriverLicenseBarcodeVariables = {
  body?: Schemas.ParseDriverLicenseBarcodeRequestDto;
  pathParams: SchoolDistrictParseDriverLicenseBarcodePathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSchoolDistrictParseDriverLicenseBarcode = (
  variables: SchoolDistrictParseDriverLicenseBarcodeVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.ParsedDriverLicenseDto,
    SchoolDistrictParseDriverLicenseBarcodeError,
    Schemas.ParseDriverLicenseBarcodeRequestDto,
    {},
    {},
    SchoolDistrictParseDriverLicenseBarcodePathParams
  >({
    method: "post",
    url: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/parse-driver-license-barcode",
    ...variables,
    signal,
  });

export const useSchoolDistrictParseDriverLicenseBarcode = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      Schemas.ParsedDriverLicenseDto,
      SchoolDistrictParseDriverLicenseBarcodeError,
      SchoolDistrictParseDriverLicenseBarcodeVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    Schemas.ParsedDriverLicenseDto,
    SchoolDistrictParseDriverLicenseBarcodeError,
    SchoolDistrictParseDriverLicenseBarcodeVariables
  >({
    mutationFn: (variables: SchoolDistrictParseDriverLicenseBarcodeVariables) =>
      fetchSchoolDistrictParseDriverLicenseBarcode(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type SearchSearchError = Fetcher.ErrorWrapper<undefined>;

export type SearchSearchResponse = Schemas.SearchResultDto[];

export type SearchSearchVariables = {
  body?: Schemas.SearchDto;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSearchSearch = (variables: SearchSearchVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<SearchSearchResponse, SearchSearchError, Schemas.SearchDto, {}, {}, {}>({
    method: "post",
    url: "/api/Search/search",
    ...variables,
    signal,
  });

export const useSearchSearch = (
  options?: Omit<
    reactQuery.UseMutationOptions<SearchSearchResponse, SearchSearchError, SearchSearchVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<SearchSearchResponse, SearchSearchError, SearchSearchVariables>({
    mutationFn: (variables: SearchSearchVariables) => fetchSearchSearch(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type SearchSearchRoomsAndEventsError = Fetcher.ErrorWrapper<undefined>;

export type SearchSearchRoomsAndEventsResponse = Schemas.SearchResultDto[];

export type SearchSearchRoomsAndEventsVariables = {
  body?: Schemas.SearchDto;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSearchSearchRoomsAndEvents = (variables: SearchSearchRoomsAndEventsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    SearchSearchRoomsAndEventsResponse,
    SearchSearchRoomsAndEventsError,
    Schemas.SearchDto,
    {},
    {},
    {}
  >({ method: "post", url: "/api/Search/search/rooms-and-events", ...variables, signal });

export const useSearchSearchRoomsAndEvents = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      SearchSearchRoomsAndEventsResponse,
      SearchSearchRoomsAndEventsError,
      SearchSearchRoomsAndEventsVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    SearchSearchRoomsAndEventsResponse,
    SearchSearchRoomsAndEventsError,
    SearchSearchRoomsAndEventsVariables
  >({
    mutationFn: (variables: SearchSearchRoomsAndEventsVariables) =>
      fetchSearchSearchRoomsAndEvents(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type SearchSearchRoomsError = Fetcher.ErrorWrapper<undefined>;

export type SearchSearchRoomsResponse = Schemas.SearchResultDto[];

export type SearchSearchRoomsVariables = {
  body?: Schemas.SearchDto;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSearchSearchRooms = (variables: SearchSearchRoomsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<SearchSearchRoomsResponse, SearchSearchRoomsError, Schemas.SearchDto, {}, {}, {}>({
    method: "post",
    url: "/api/Search/search/rooms",
    ...variables,
    signal,
  });

export const useSearchSearchRooms = (
  options?: Omit<
    reactQuery.UseMutationOptions<SearchSearchRoomsResponse, SearchSearchRoomsError, SearchSearchRoomsVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<SearchSearchRoomsResponse, SearchSearchRoomsError, SearchSearchRoomsVariables>({
    mutationFn: (variables: SearchSearchRoomsVariables) => fetchSearchSearchRooms(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type SearchSearchEventsError = Fetcher.ErrorWrapper<undefined>;

export type SearchSearchEventsResponse = Schemas.SearchResultDto[];

export type SearchSearchEventsVariables = {
  body?: Schemas.SearchDto;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSearchSearchEvents = (variables: SearchSearchEventsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<SearchSearchEventsResponse, SearchSearchEventsError, Schemas.SearchDto, {}, {}, {}>({
    method: "post",
    url: "/api/Search/search/events",
    ...variables,
    signal,
  });

export const useSearchSearchEvents = (
  options?: Omit<
    reactQuery.UseMutationOptions<SearchSearchEventsResponse, SearchSearchEventsError, SearchSearchEventsVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<SearchSearchEventsResponse, SearchSearchEventsError, SearchSearchEventsVariables>({
    mutationFn: (variables: SearchSearchEventsVariables) =>
      fetchSearchSearchEvents(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface SearchGetRoomsAndEventsSearchQueryParams {
  /**
   * @format int32
   */
  Page?: number;
  /**
   * @format int32
   */
  PageSize?: number;
  RoomName?: string;
  /**
   * @format uuid
   */
  SchoolDistrictBubbleId?: string;
  /**
   * @format uuid
   */
  SchoolBubbleId?: string;
  StartDate?: string;
  EndDate?: string;
  MeetingDays?: string[];
}

export type SearchGetRoomsAndEventsSearchError = Fetcher.ErrorWrapper<undefined>;

export type SearchGetRoomsAndEventsSearchResponse = Schemas.SearchResultDto[];

export type SearchGetRoomsAndEventsSearchVariables = {
  queryParams?: SearchGetRoomsAndEventsSearchQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSearchGetRoomsAndEventsSearch = (
  variables: SearchGetRoomsAndEventsSearchVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    SearchGetRoomsAndEventsSearchResponse,
    SearchGetRoomsAndEventsSearchError,
    undefined,
    {},
    SearchGetRoomsAndEventsSearchQueryParams,
    {}
  >({ method: "get", url: "/api/Search/search/get-rooms-and-events", ...variables, signal });

export function searchGetRoomsAndEventsSearchQuery(variables: SearchGetRoomsAndEventsSearchVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<SearchGetRoomsAndEventsSearchResponse>;
};

export function searchGetRoomsAndEventsSearchQuery(
  variables: SearchGetRoomsAndEventsSearchVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<SearchGetRoomsAndEventsSearchResponse>) | reactQuery.SkipToken;
};

export function searchGetRoomsAndEventsSearchQuery(
  variables: SearchGetRoomsAndEventsSearchVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSearchGetRoomsAndEventsSearch(variables, signal),
    queryKey: queryKeyFn({
      operationId: "searchGetRoomsAndEventsSearch",
      path: "/api/Search/search/get-rooms-and-events",
      variables,
    }),
  };
}

export const useSuspenseSearchGetRoomsAndEventsSearch = <TData = SearchGetRoomsAndEventsSearchResponse>(
  variables: SearchGetRoomsAndEventsSearchVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<SearchGetRoomsAndEventsSearchResponse, SearchGetRoomsAndEventsSearchError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<SearchGetRoomsAndEventsSearchResponse, SearchGetRoomsAndEventsSearchError, TData>({
    ...searchGetRoomsAndEventsSearchQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSearchGetRoomsAndEventsSearch = <TData = SearchGetRoomsAndEventsSearchResponse>(
  variables: SearchGetRoomsAndEventsSearchVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<SearchGetRoomsAndEventsSearchResponse, SearchGetRoomsAndEventsSearchError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<SearchGetRoomsAndEventsSearchResponse, SearchGetRoomsAndEventsSearchError, TData>({
    ...searchGetRoomsAndEventsSearchQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface SearchGetRoomsSearchQueryParams {
  /**
   * @format int32
   */
  Page?: number;
  /**
   * @format int32
   */
  PageSize?: number;
  RoomName?: string;
  /**
   * @format uuid
   */
  SchoolDistrictBubbleId?: string;
  /**
   * @format uuid
   */
  SchoolBubbleId?: string;
  StartDate?: string;
  EndDate?: string;
  MeetingDays?: string[];
}

export type SearchGetRoomsSearchError = Fetcher.ErrorWrapper<undefined>;

export type SearchGetRoomsSearchResponse = Schemas.SearchResultDto[];

export type SearchGetRoomsSearchVariables = {
  queryParams?: SearchGetRoomsSearchQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSearchGetRoomsSearch = (variables: SearchGetRoomsSearchVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    SearchGetRoomsSearchResponse,
    SearchGetRoomsSearchError,
    undefined,
    {},
    SearchGetRoomsSearchQueryParams,
    {}
  >({ method: "get", url: "/api/Search/search/get-rooms", ...variables, signal });

export function searchGetRoomsSearchQuery(variables: SearchGetRoomsSearchVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<SearchGetRoomsSearchResponse>;
};

export function searchGetRoomsSearchQuery(variables: SearchGetRoomsSearchVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<SearchGetRoomsSearchResponse>) | reactQuery.SkipToken;
};

export function searchGetRoomsSearchQuery(variables: SearchGetRoomsSearchVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSearchGetRoomsSearch(variables, signal),
    queryKey: queryKeyFn({
      operationId: "searchGetRoomsSearch",
      path: "/api/Search/search/get-rooms",
      variables,
    }),
  };
}

export const useSuspenseSearchGetRoomsSearch = <TData = SearchGetRoomsSearchResponse>(
  variables: SearchGetRoomsSearchVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<SearchGetRoomsSearchResponse, SearchGetRoomsSearchError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<SearchGetRoomsSearchResponse, SearchGetRoomsSearchError, TData>({
    ...searchGetRoomsSearchQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSearchGetRoomsSearch = <TData = SearchGetRoomsSearchResponse>(
  variables: SearchGetRoomsSearchVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<SearchGetRoomsSearchResponse, SearchGetRoomsSearchError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<SearchGetRoomsSearchResponse, SearchGetRoomsSearchError, TData>({
    ...searchGetRoomsSearchQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export interface SearchGetEventsSearchQueryParams {
  /**
   * @format int32
   */
  Page?: number;
  /**
   * @format int32
   */
  PageSize?: number;
  RoomName?: string;
  /**
   * @format uuid
   */
  SchoolDistrictBubbleId?: string;
  /**
   * @format uuid
   */
  SchoolBubbleId?: string;
  StartDate?: string;
  EndDate?: string;
  MeetingDays?: string[];
}

export type SearchGetEventsSearchError = Fetcher.ErrorWrapper<undefined>;

export type SearchGetEventsSearchResponse = Schemas.SearchResultDto[];

export type SearchGetEventsSearchVariables = {
  queryParams?: SearchGetEventsSearchQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSearchGetEventsSearch = (variables: SearchGetEventsSearchVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    SearchGetEventsSearchResponse,
    SearchGetEventsSearchError,
    undefined,
    {},
    SearchGetEventsSearchQueryParams,
    {}
  >({ method: "get", url: "/api/Search/search/get-events", ...variables, signal });

export function searchGetEventsSearchQuery(variables: SearchGetEventsSearchVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<SearchGetEventsSearchResponse>;
};

export function searchGetEventsSearchQuery(variables: SearchGetEventsSearchVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<SearchGetEventsSearchResponse>) | reactQuery.SkipToken;
};

export function searchGetEventsSearchQuery(variables: SearchGetEventsSearchVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSearchGetEventsSearch(variables, signal),
    queryKey: queryKeyFn({
      operationId: "searchGetEventsSearch",
      path: "/api/Search/search/get-events",
      variables,
    }),
  };
}

export const useSuspenseSearchGetEventsSearch = <TData = SearchGetEventsSearchResponse>(
  variables: SearchGetEventsSearchVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<SearchGetEventsSearchResponse, SearchGetEventsSearchError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<SearchGetEventsSearchResponse, SearchGetEventsSearchError, TData>({
    ...searchGetEventsSearchQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSearchGetEventsSearch = <TData = SearchGetEventsSearchResponse>(
  variables: SearchGetEventsSearchVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<SearchGetEventsSearchResponse, SearchGetEventsSearchError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<SearchGetEventsSearchResponse, SearchGetEventsSearchError, TData>({
    ...searchGetEventsSearchQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface SearchGetSearchQueriesQueryParams {
  /**
   * Optional, defaults to one week ago
   *
   * @format date-time
   */
  start?: string;
  /**
   * Optional, defaults to now
   *
   * @format date-time
   */
  end?: string;
}

export type SearchGetSearchQueriesError = Fetcher.ErrorWrapper<undefined>;

export type SearchGetSearchQueriesResponse = Schemas.SearchAnalyticsEventDto[];

export type SearchGetSearchQueriesVariables = {
  queryParams?: SearchGetSearchQueriesQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchSearchGetSearchQueries = (variables: SearchGetSearchQueriesVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    SearchGetSearchQueriesResponse,
    SearchGetSearchQueriesError,
    undefined,
    {},
    SearchGetSearchQueriesQueryParams,
    {}
  >({ method: "get", url: "/api/Search/candidate-search-history", ...variables, signal });

export function searchGetSearchQueriesQuery(variables: SearchGetSearchQueriesVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<SearchGetSearchQueriesResponse>;
};

export function searchGetSearchQueriesQuery(variables: SearchGetSearchQueriesVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<SearchGetSearchQueriesResponse>) | reactQuery.SkipToken;
};

export function searchGetSearchQueriesQuery(variables: SearchGetSearchQueriesVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchSearchGetSearchQueries(variables, signal),
    queryKey: queryKeyFn({
      operationId: "searchGetSearchQueries",
      path: "/api/Search/candidate-search-history",
      variables,
    }),
  };
}

export const useSuspenseSearchGetSearchQueries = <TData = SearchGetSearchQueriesResponse>(
  variables: SearchGetSearchQueriesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<SearchGetSearchQueriesResponse, SearchGetSearchQueriesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<SearchGetSearchQueriesResponse, SearchGetSearchQueriesError, TData>({
    ...searchGetSearchQueriesQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useSearchGetSearchQueries = <TData = SearchGetSearchQueriesResponse>(
  variables: SearchGetSearchQueriesVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<SearchGetSearchQueriesResponse, SearchGetSearchQueriesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<SearchGetSearchQueriesResponse, SearchGetSearchQueriesError, TData>({
    ...searchGetSearchQueriesQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface UserGetPublicUserInfoPathParams {
  /**
   * @format uuid
   */
  userId: string;
}

export type UserGetPublicUserInfoError = Fetcher.ErrorWrapper<undefined>;

export type UserGetPublicUserInfoVariables = {
  pathParams: UserGetPublicUserInfoPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchUserGetPublicUserInfo = (variables: UserGetPublicUserInfoVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    Schemas.UserDto,
    UserGetPublicUserInfoError,
    undefined,
    {},
    {},
    UserGetPublicUserInfoPathParams
  >({ method: "get", url: "/api/v1/User/{userId}/public", ...variables, signal });

export function userGetPublicUserInfoQuery(variables: UserGetPublicUserInfoVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.UserDto>;
};

export function userGetPublicUserInfoQuery(variables: UserGetPublicUserInfoVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.UserDto>) | reactQuery.SkipToken;
};

export function userGetPublicUserInfoQuery(variables: UserGetPublicUserInfoVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchUserGetPublicUserInfo(variables, signal),
    queryKey: queryKeyFn({
      operationId: "userGetPublicUserInfo",
      path: "/api/v1/User/{userId}/public",
      variables,
    }),
  };
}

export const useSuspenseUserGetPublicUserInfo = <TData = Schemas.UserDto>(
  variables: UserGetPublicUserInfoVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.UserDto, UserGetPublicUserInfoError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.UserDto, UserGetPublicUserInfoError, TData>({
    ...userGetPublicUserInfoQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useUserGetPublicUserInfo = <TData = Schemas.UserDto>(
  variables: UserGetPublicUserInfoVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.UserDto, UserGetPublicUserInfoError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.UserDto, UserGetPublicUserInfoError, TData>({
    ...userGetPublicUserInfoQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface UserGetUserRsvpsSearchPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export interface UserGetUserRsvpsSearchQueryParams {
  /**
   * Optional, defaults to today
   *
   * @format date-time
   */
  BeginTime?: string;
  /**
   * Optional, defaults to the end of next year
   *
   * @format date-time
   */
  EndTime?: string;
}

export type UserGetUserRsvpsSearchError = Fetcher.ErrorWrapper<undefined>;

export type UserGetUserRsvpsSearchResponse = Schemas.RsvpResponse[];

export type UserGetUserRsvpsSearchVariables = {
  pathParams: UserGetUserRsvpsSearchPathParams;
  queryParams?: UserGetUserRsvpsSearchQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchUserGetUserRsvpsSearch = (variables: UserGetUserRsvpsSearchVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    UserGetUserRsvpsSearchResponse,
    UserGetUserRsvpsSearchError,
    undefined,
    {},
    UserGetUserRsvpsSearchQueryParams,
    UserGetUserRsvpsSearchPathParams
  >({ method: "get", url: "/api/v1/User/{userId}/rsvps", ...variables, signal });

export function userGetUserRsvpsSearchQuery(variables: UserGetUserRsvpsSearchVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<UserGetUserRsvpsSearchResponse>;
};

export function userGetUserRsvpsSearchQuery(variables: UserGetUserRsvpsSearchVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<UserGetUserRsvpsSearchResponse>) | reactQuery.SkipToken;
};

export function userGetUserRsvpsSearchQuery(variables: UserGetUserRsvpsSearchVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchUserGetUserRsvpsSearch(variables, signal),
    queryKey: queryKeyFn({
      operationId: "userGetUserRsvpsSearch",
      path: "/api/v1/User/{userId}/rsvps",
      variables,
    }),
  };
}

export const useSuspenseUserGetUserRsvpsSearch = <TData = UserGetUserRsvpsSearchResponse>(
  variables: UserGetUserRsvpsSearchVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<UserGetUserRsvpsSearchResponse, UserGetUserRsvpsSearchError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<UserGetUserRsvpsSearchResponse, UserGetUserRsvpsSearchError, TData>({
    ...userGetUserRsvpsSearchQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useUserGetUserRsvpsSearch = <TData = UserGetUserRsvpsSearchResponse>(
  variables: UserGetUserRsvpsSearchVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<UserGetUserRsvpsSearchResponse, UserGetUserRsvpsSearchError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<UserGetUserRsvpsSearchResponse, UserGetUserRsvpsSearchError, TData>({
    ...userGetUserRsvpsSearchQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface UserSetDailyEmailNotificationPreferencesPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export interface UserSetDailyEmailNotificationPreferencesQueryParams {
  /**
   * Required
   */
  allowNotifications?: boolean;
}

export type UserSetDailyEmailNotificationPreferencesError = Fetcher.ErrorWrapper<undefined>;

export type UserSetDailyEmailNotificationPreferencesVariables = {
  pathParams: UserSetDailyEmailNotificationPreferencesPathParams;
  queryParams?: UserSetDailyEmailNotificationPreferencesQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchUserSetDailyEmailNotificationPreferences = (
  variables: UserSetDailyEmailNotificationPreferencesVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    UserSetDailyEmailNotificationPreferencesError,
    undefined,
    {},
    UserSetDailyEmailNotificationPreferencesQueryParams,
    UserSetDailyEmailNotificationPreferencesPathParams
  >({ method: "post", url: "/api/v1/User/{userId}/daily-email-notifications", ...variables, signal });

export const useUserSetDailyEmailNotificationPreferences = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UserSetDailyEmailNotificationPreferencesError,
      UserSetDailyEmailNotificationPreferencesVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    UserSetDailyEmailNotificationPreferencesError,
    UserSetDailyEmailNotificationPreferencesVariables
  >({
    mutationFn: (variables: UserSetDailyEmailNotificationPreferencesVariables) =>
      fetchUserSetDailyEmailNotificationPreferences(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface UserSetWeeklyEmailNotificationPreferencesPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export interface UserSetWeeklyEmailNotificationPreferencesQueryParams {
  /**
   * Required
   */
  allowNotifications?: boolean;
}

export type UserSetWeeklyEmailNotificationPreferencesError = Fetcher.ErrorWrapper<undefined>;

export type UserSetWeeklyEmailNotificationPreferencesVariables = {
  pathParams: UserSetWeeklyEmailNotificationPreferencesPathParams;
  queryParams?: UserSetWeeklyEmailNotificationPreferencesQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchUserSetWeeklyEmailNotificationPreferences = (
  variables: UserSetWeeklyEmailNotificationPreferencesVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    UserSetWeeklyEmailNotificationPreferencesError,
    undefined,
    {},
    UserSetWeeklyEmailNotificationPreferencesQueryParams,
    UserSetWeeklyEmailNotificationPreferencesPathParams
  >({ method: "post", url: "/api/v1/User/{userId}/weekly-email-notifications", ...variables, signal });

export const useUserSetWeeklyEmailNotificationPreferences = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UserSetWeeklyEmailNotificationPreferencesError,
      UserSetWeeklyEmailNotificationPreferencesVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    UserSetWeeklyEmailNotificationPreferencesError,
    UserSetWeeklyEmailNotificationPreferencesVariables
  >({
    mutationFn: (variables: UserSetWeeklyEmailNotificationPreferencesVariables) =>
      fetchUserSetWeeklyEmailNotificationPreferences(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface UserSetGenderPathParams {
  /**
   * CrowdCoursing.Domain.Entities.Users.Gender
   */
  gender: Schemas.Gender;
  userId: string;
}

export type UserSetGenderError = Fetcher.ErrorWrapper<undefined>;

export type UserSetGenderVariables = {
  pathParams: UserSetGenderPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchUserSetGender = (variables: UserSetGenderVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, UserSetGenderError, undefined, {}, {}, UserSetGenderPathParams>({
    method: "post",
    url: "/api/v1/User/{userId}/set-gender/{gender}",
    ...variables,
    signal,
  });

export const useUserSetGender = (
  options?: Omit<reactQuery.UseMutationOptions<undefined, UserSetGenderError, UserSetGenderVariables>, "mutationFn">,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, UserSetGenderError, UserSetGenderVariables>({
    mutationFn: (variables: UserSetGenderVariables) => fetchUserSetGender(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface UserSetAgeBracketPathParams {
  /**
   * CrowdCoursing.Domain.Entities.Users.AgeBracket
   */
  age: Schemas.AgeBracket;
  userId: string;
}

export type UserSetAgeBracketError = Fetcher.ErrorWrapper<undefined>;

export type UserSetAgeBracketVariables = {
  pathParams: UserSetAgeBracketPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchUserSetAgeBracket = (variables: UserSetAgeBracketVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<undefined, UserSetAgeBracketError, undefined, {}, {}, UserSetAgeBracketPathParams>({
    method: "post",
    url: "/api/v1/User/{userId}/set-age-bracket/{age}",
    ...variables,
    signal,
  });

export const useUserSetAgeBracket = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, UserSetAgeBracketError, UserSetAgeBracketVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, UserSetAgeBracketError, UserSetAgeBracketVariables>({
    mutationFn: (variables: UserSetAgeBracketVariables) => fetchUserSetAgeBracket(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface UserMarkNotificationReadPathParams {
  /**
   * Notification Id
   *
   * @format uuid
   */
  notificationId: string;
  userId: string;
}

export type UserMarkNotificationReadError = Fetcher.ErrorWrapper<undefined>;

export type UserMarkNotificationReadVariables = {
  pathParams: UserMarkNotificationReadPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchUserMarkNotificationRead = (variables: UserMarkNotificationReadVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    undefined,
    UserMarkNotificationReadError,
    undefined,
    {},
    {},
    UserMarkNotificationReadPathParams
  >({ method: "post", url: "/api/v1/User/{userId}/mark-notification-read/{notificationId}", ...variables, signal });

export const useUserMarkNotificationRead = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, UserMarkNotificationReadError, UserMarkNotificationReadVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, UserMarkNotificationReadError, UserMarkNotificationReadVariables>({
    mutationFn: (variables: UserMarkNotificationReadVariables) =>
      fetchUserMarkNotificationRead(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface UserMarkNotificationsAsReadPathParams {
  userId: string;
}

export type UserMarkNotificationsAsReadError = Fetcher.ErrorWrapper<undefined>;

export type UserMarkNotificationsAsReadVariables = {
  body?: Schemas.BulkNotificationsOperation;
  pathParams: UserMarkNotificationsAsReadPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchUserMarkNotificationsAsRead = (
  variables: UserMarkNotificationsAsReadVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    UserMarkNotificationsAsReadError,
    Schemas.BulkNotificationsOperation,
    {},
    {},
    UserMarkNotificationsAsReadPathParams
  >({ method: "post", url: "/api/v1/User/{userId}/mark-notifications-as-read", ...variables, signal });

export const useUserMarkNotificationsAsRead = (
  options?: Omit<
    reactQuery.UseMutationOptions<undefined, UserMarkNotificationsAsReadError, UserMarkNotificationsAsReadVariables>,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<undefined, UserMarkNotificationsAsReadError, UserMarkNotificationsAsReadVariables>({
    mutationFn: (variables: UserMarkNotificationsAsReadVariables) =>
      fetchUserMarkNotificationsAsRead(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface UserMarkNotificationsAsArchivedPathParams {
  userId: string;
}

export type UserMarkNotificationsAsArchivedError = Fetcher.ErrorWrapper<undefined>;

export type UserMarkNotificationsAsArchivedVariables = {
  body?: Schemas.BulkNotificationsOperation;
  pathParams: UserMarkNotificationsAsArchivedPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchUserMarkNotificationsAsArchived = (
  variables: UserMarkNotificationsAsArchivedVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    UserMarkNotificationsAsArchivedError,
    Schemas.BulkNotificationsOperation,
    {},
    {},
    UserMarkNotificationsAsArchivedPathParams
  >({ method: "post", url: "/api/v1/User/{userId}/mark-notifications-as-archived", ...variables, signal });

export const useUserMarkNotificationsAsArchived = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      UserMarkNotificationsAsArchivedError,
      UserMarkNotificationsAsArchivedVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    UserMarkNotificationsAsArchivedError,
    UserMarkNotificationsAsArchivedVariables
  >({
    mutationFn: (variables: UserMarkNotificationsAsArchivedVariables) =>
      fetchUserMarkNotificationsAsArchived(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface UserGetUserHistoryInformationPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  userId: string;
}

export type UserGetUserHistoryInformationError = Fetcher.ErrorWrapper<undefined>;

export type UserGetUserHistoryInformationVariables = {
  pathParams: UserGetUserHistoryInformationPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchUserGetUserHistoryInformation = (
  variables: UserGetUserHistoryInformationVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.UserHistoryDto,
    UserGetUserHistoryInformationError,
    undefined,
    {},
    {},
    UserGetUserHistoryInformationPathParams
  >({ method: "get", url: "/api/v1/User/{userId}/user-history", ...variables, signal });

export function userGetUserHistoryInformationQuery(variables: UserGetUserHistoryInformationVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.UserHistoryDto>;
};

export function userGetUserHistoryInformationQuery(
  variables: UserGetUserHistoryInformationVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.UserHistoryDto>) | reactQuery.SkipToken;
};

export function userGetUserHistoryInformationQuery(
  variables: UserGetUserHistoryInformationVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchUserGetUserHistoryInformation(variables, signal),
    queryKey: queryKeyFn({
      operationId: "userGetUserHistoryInformation",
      path: "/api/v1/User/{userId}/user-history",
      variables,
    }),
  };
}

export const useSuspenseUserGetUserHistoryInformation = <TData = Schemas.UserHistoryDto>(
  variables: UserGetUserHistoryInformationVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.UserHistoryDto, UserGetUserHistoryInformationError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.UserHistoryDto, UserGetUserHistoryInformationError, TData>({
    ...userGetUserHistoryInformationQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useUserGetUserHistoryInformation = <TData = Schemas.UserHistoryDto>(
  variables: UserGetUserHistoryInformationVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.UserHistoryDto, UserGetUserHistoryInformationError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.UserHistoryDto, UserGetUserHistoryInformationError, TData>({
    ...userGetUserHistoryInformationQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type UserGetUserResourcesError = Fetcher.ErrorWrapper<undefined>;

export type UserGetUserResourcesResponse = Schemas.ResourceDto[];

export type UserGetUserResourcesVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchUserGetUserResources = (variables: UserGetUserResourcesVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<UserGetUserResourcesResponse, UserGetUserResourcesError, undefined, {}, {}, {}>({
    method: "get",
    url: "/api/v1/User/my-resources",
    ...variables,
    signal,
  });

export function userGetUserResourcesQuery(variables: UserGetUserResourcesVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<UserGetUserResourcesResponse>;
};

export function userGetUserResourcesQuery(variables: UserGetUserResourcesVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<UserGetUserResourcesResponse>) | reactQuery.SkipToken;
};

export function userGetUserResourcesQuery(variables: UserGetUserResourcesVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchUserGetUserResources(variables, signal),
    queryKey: queryKeyFn({
      operationId: "userGetUserResources",
      path: "/api/v1/User/my-resources",
      variables,
    }),
  };
}

export const useSuspenseUserGetUserResources = <TData = UserGetUserResourcesResponse>(
  variables: UserGetUserResourcesVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<UserGetUserResourcesResponse, UserGetUserResourcesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<UserGetUserResourcesResponse, UserGetUserResourcesError, TData>({
    ...userGetUserResourcesQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useUserGetUserResources = <TData = UserGetUserResourcesResponse>(
  variables: UserGetUserResourcesVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<UserGetUserResourcesResponse, UserGetUserResourcesError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<UserGetUserResourcesResponse, UserGetUserResourcesError, TData>({
    ...userGetUserResourcesQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export type UserGetMyUpcomingRsvpsError = Fetcher.ErrorWrapper<undefined>;

export type UserGetMyUpcomingRsvpsResponse = Schemas.MeetingTimeDto[];

export type UserGetMyUpcomingRsvpsVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchUserGetMyUpcomingRsvps = (variables: UserGetMyUpcomingRsvpsVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<UserGetMyUpcomingRsvpsResponse, UserGetMyUpcomingRsvpsError, undefined, {}, {}, {}>({
    method: "get",
    url: "/api/v1/User/my-upcoming-rsvps",
    ...variables,
    signal,
  });

export function userGetMyUpcomingRsvpsQuery(variables: UserGetMyUpcomingRsvpsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<UserGetMyUpcomingRsvpsResponse>;
};

export function userGetMyUpcomingRsvpsQuery(variables: UserGetMyUpcomingRsvpsVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<UserGetMyUpcomingRsvpsResponse>) | reactQuery.SkipToken;
};

export function userGetMyUpcomingRsvpsQuery(variables: UserGetMyUpcomingRsvpsVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchUserGetMyUpcomingRsvps(variables, signal),
    queryKey: queryKeyFn({
      operationId: "userGetMyUpcomingRsvps",
      path: "/api/v1/User/my-upcoming-rsvps",
      variables,
    }),
  };
}

export const useSuspenseUserGetMyUpcomingRsvps = <TData = UserGetMyUpcomingRsvpsResponse>(
  variables: UserGetMyUpcomingRsvpsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<UserGetMyUpcomingRsvpsResponse, UserGetMyUpcomingRsvpsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<UserGetMyUpcomingRsvpsResponse, UserGetMyUpcomingRsvpsError, TData>({
    ...userGetMyUpcomingRsvpsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useUserGetMyUpcomingRsvps = <TData = UserGetMyUpcomingRsvpsResponse>(
  variables: UserGetMyUpcomingRsvpsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<UserGetMyUpcomingRsvpsResponse, UserGetMyUpcomingRsvpsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<UserGetMyUpcomingRsvpsResponse, UserGetMyUpcomingRsvpsError, TData>({
    ...userGetMyUpcomingRsvpsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface UserGetUserSiteDataQueryParams {
  /**
   * Optional, defaults to today
   *
   * @format date-time
   */
  end?: string;
}

export type UserGetUserSiteDataError = Fetcher.ErrorWrapper<undefined>;

export type UserGetUserSiteDataResponse = Schemas.UserDto[];

export type UserGetUserSiteDataVariables = {
  queryParams?: UserGetUserSiteDataQueryParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchUserGetUserSiteData = (variables: UserGetUserSiteDataVariables, signal?: AbortSignal) =>
  crowdcoursingApiFetch<
    UserGetUserSiteDataResponse,
    UserGetUserSiteDataError,
    undefined,
    {},
    UserGetUserSiteDataQueryParams,
    {}
  >({ method: "get", url: "/api/v1/User/site-data", ...variables, signal });

export function userGetUserSiteDataQuery(variables: UserGetUserSiteDataVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<UserGetUserSiteDataResponse>;
};

export function userGetUserSiteDataQuery(variables: UserGetUserSiteDataVariables | reactQuery.SkipToken): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<UserGetUserSiteDataResponse>) | reactQuery.SkipToken;
};

export function userGetUserSiteDataQuery(variables: UserGetUserSiteDataVariables | reactQuery.SkipToken) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchUserGetUserSiteData(variables, signal),
    queryKey: queryKeyFn({
      operationId: "userGetUserSiteData",
      path: "/api/v1/User/site-data",
      variables,
    }),
  };
}

export const useSuspenseUserGetUserSiteData = <TData = UserGetUserSiteDataResponse>(
  variables: UserGetUserSiteDataVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<UserGetUserSiteDataResponse, UserGetUserSiteDataError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<UserGetUserSiteDataResponse, UserGetUserSiteDataError, TData>({
    ...userGetUserSiteDataQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useUserGetUserSiteData = <TData = UserGetUserSiteDataResponse>(
  variables: UserGetUserSiteDataVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<UserGetUserSiteDataResponse, UserGetUserSiteDataError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<UserGetUserSiteDataResponse, UserGetUserSiteDataError, TData>({
    ...userGetUserSiteDataQuery(variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export type VolunteeringManuallyAddVolunteeringTimeError = Fetcher.ErrorWrapper<undefined>;

export type VolunteeringManuallyAddVolunteeringTimeVariables = {
  body?: Schemas.ManualVolunteerAddRequest;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchVolunteeringManuallyAddVolunteeringTime = (
  variables: VolunteeringManuallyAddVolunteeringTimeVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    VolunteeringManuallyAddVolunteeringTimeError,
    Schemas.ManualVolunteerAddRequest,
    {},
    {},
    {}
  >({ method: "post", url: "/api/v1/Volunteering/add-volunteer-time", ...variables, signal });

export const useVolunteeringManuallyAddVolunteeringTime = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      VolunteeringManuallyAddVolunteeringTimeError,
      VolunteeringManuallyAddVolunteeringTimeVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    VolunteeringManuallyAddVolunteeringTimeError,
    VolunteeringManuallyAddVolunteeringTimeVariables
  >({
    mutationFn: (variables: VolunteeringManuallyAddVolunteeringTimeVariables) =>
      fetchVolunteeringManuallyAddVolunteeringTime(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface VolunteeringGetVolunteeringRecordPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  volunteeringRecordId: string;
}

export type VolunteeringGetVolunteeringRecordError = Fetcher.ErrorWrapper<undefined>;

export type VolunteeringGetVolunteeringRecordVariables = {
  pathParams: VolunteeringGetVolunteeringRecordPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchVolunteeringGetVolunteeringRecord = (
  variables: VolunteeringGetVolunteeringRecordVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    Schemas.VolunteeringRecordDto,
    VolunteeringGetVolunteeringRecordError,
    undefined,
    {},
    {},
    VolunteeringGetVolunteeringRecordPathParams
  >({ method: "get", url: "/api/v1/Volunteering/volunteering-record/{volunteeringRecordId}", ...variables, signal });

export function volunteeringGetVolunteeringRecordQuery(variables: VolunteeringGetVolunteeringRecordVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.VolunteeringRecordDto>;
};

export function volunteeringGetVolunteeringRecordQuery(
  variables: VolunteeringGetVolunteeringRecordVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.VolunteeringRecordDto>) | reactQuery.SkipToken;
};

export function volunteeringGetVolunteeringRecordQuery(
  variables: VolunteeringGetVolunteeringRecordVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchVolunteeringGetVolunteeringRecord(variables, signal),
    queryKey: queryKeyFn({
      operationId: "volunteeringGetVolunteeringRecord",
      path: "/api/v1/Volunteering/volunteering-record/{volunteeringRecordId}",
      variables,
    }),
  };
}

export const useSuspenseVolunteeringGetVolunteeringRecord = <TData = Schemas.VolunteeringRecordDto>(
  variables: VolunteeringGetVolunteeringRecordVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.VolunteeringRecordDto, VolunteeringGetVolunteeringRecordError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.VolunteeringRecordDto, VolunteeringGetVolunteeringRecordError, TData>({
    ...volunteeringGetVolunteeringRecordQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useVolunteeringGetVolunteeringRecord = <TData = Schemas.VolunteeringRecordDto>(
  variables: VolunteeringGetVolunteeringRecordVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.VolunteeringRecordDto, VolunteeringGetVolunteeringRecordError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.VolunteeringRecordDto, VolunteeringGetVolunteeringRecordError, TData>({
    ...volunteeringGetVolunteeringRecordQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface VolunteeringDeleteVolunteeringRecordPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  volunteeringRecordId: string;
}

export type VolunteeringDeleteVolunteeringRecordError = Fetcher.ErrorWrapper<undefined>;

export type VolunteeringDeleteVolunteeringRecordVariables = {
  pathParams: VolunteeringDeleteVolunteeringRecordPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchVolunteeringDeleteVolunteeringRecord = (
  variables: VolunteeringDeleteVolunteeringRecordVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    VolunteeringDeleteVolunteeringRecordError,
    undefined,
    {},
    {},
    VolunteeringDeleteVolunteeringRecordPathParams
  >({ method: "delete", url: "/api/v1/Volunteering/volunteering-record/{volunteeringRecordId}", ...variables, signal });

export const useVolunteeringDeleteVolunteeringRecord = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      VolunteeringDeleteVolunteeringRecordError,
      VolunteeringDeleteVolunteeringRecordVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    VolunteeringDeleteVolunteeringRecordError,
    VolunteeringDeleteVolunteeringRecordVariables
  >({
    mutationFn: (variables: VolunteeringDeleteVolunteeringRecordVariables) =>
      fetchVolunteeringDeleteVolunteeringRecord(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface VolunteeringConfirmVolunteeringRecordPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  volunteeringRecordId: string;
}

export type VolunteeringConfirmVolunteeringRecordError = Fetcher.ErrorWrapper<undefined>;

export type VolunteeringConfirmVolunteeringRecordVariables = {
  pathParams: VolunteeringConfirmVolunteeringRecordPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchVolunteeringConfirmVolunteeringRecord = (
  variables: VolunteeringConfirmVolunteeringRecordVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    VolunteeringConfirmVolunteeringRecordError,
    undefined,
    {},
    {},
    VolunteeringConfirmVolunteeringRecordPathParams
  >({
    method: "post",
    url: "/api/v1/Volunteering/volunteering-record/{volunteeringRecordId}/confirm-volunteer-time",
    ...variables,
    signal,
  });

export const useVolunteeringConfirmVolunteeringRecord = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      VolunteeringConfirmVolunteeringRecordError,
      VolunteeringConfirmVolunteeringRecordVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    VolunteeringConfirmVolunteeringRecordError,
    VolunteeringConfirmVolunteeringRecordVariables
  >({
    mutationFn: (variables: VolunteeringConfirmVolunteeringRecordVariables) =>
      fetchVolunteeringConfirmVolunteeringRecord(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export interface VolunteeringModifyVolunteeringRecordPathParams {
  volunteeringRecordId: string;
}

export type VolunteeringModifyVolunteeringRecordError = Fetcher.ErrorWrapper<undefined>;

export type VolunteeringModifyVolunteeringRecordVariables = {
  body?: Schemas.UpdateVolunteerRecord;
  pathParams: VolunteeringModifyVolunteeringRecordPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchVolunteeringModifyVolunteeringRecord = (
  variables: VolunteeringModifyVolunteeringRecordVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    undefined,
    VolunteeringModifyVolunteeringRecordError,
    Schemas.UpdateVolunteerRecord,
    {},
    {},
    VolunteeringModifyVolunteeringRecordPathParams
  >({
    method: "post",
    url: "/api/v1/Volunteering/volunteering-record/{volunteeringRecordId}/update",
    ...variables,
    signal,
  });

export const useVolunteeringModifyVolunteeringRecord = (
  options?: Omit<
    reactQuery.UseMutationOptions<
      undefined,
      VolunteeringModifyVolunteeringRecordError,
      VolunteeringModifyVolunteeringRecordVariables
    >,
    "mutationFn"
  >,
) => {
  const { fetcherOptions } = useCrowdcoursingApiContext();
  return reactQuery.useMutation<
    undefined,
    VolunteeringModifyVolunteeringRecordError,
    VolunteeringModifyVolunteeringRecordVariables
  >({
    mutationFn: (variables: VolunteeringModifyVolunteeringRecordVariables) =>
      fetchVolunteeringModifyVolunteeringRecord(deepMerge(fetcherOptions, variables)),
    ...options,
  });
};

export type VolunteeringGetMyVolunteeringRecordsError = Fetcher.ErrorWrapper<undefined>;

export type VolunteeringGetMyVolunteeringRecordsResponse = Schemas.VolunteeringRecordDto[];

export type VolunteeringGetMyVolunteeringRecordsVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchVolunteeringGetMyVolunteeringRecords = (
  variables: VolunteeringGetMyVolunteeringRecordsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    VolunteeringGetMyVolunteeringRecordsResponse,
    VolunteeringGetMyVolunteeringRecordsError,
    undefined,
    {},
    {},
    {}
  >({ method: "get", url: "/api/v1/Volunteering/my-records", ...variables, signal });

export function volunteeringGetMyVolunteeringRecordsQuery(variables: VolunteeringGetMyVolunteeringRecordsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<VolunteeringGetMyVolunteeringRecordsResponse>;
};

export function volunteeringGetMyVolunteeringRecordsQuery(
  variables: VolunteeringGetMyVolunteeringRecordsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<VolunteeringGetMyVolunteeringRecordsResponse>) | reactQuery.SkipToken;
};

export function volunteeringGetMyVolunteeringRecordsQuery(
  variables: VolunteeringGetMyVolunteeringRecordsVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchVolunteeringGetMyVolunteeringRecords(variables, signal),
    queryKey: queryKeyFn({
      operationId: "volunteeringGetMyVolunteeringRecords",
      path: "/api/v1/Volunteering/my-records",
      variables,
    }),
  };
}

export const useSuspenseVolunteeringGetMyVolunteeringRecords = <TData = VolunteeringGetMyVolunteeringRecordsResponse>(
  variables: VolunteeringGetMyVolunteeringRecordsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      VolunteeringGetMyVolunteeringRecordsResponse,
      VolunteeringGetMyVolunteeringRecordsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    VolunteeringGetMyVolunteeringRecordsResponse,
    VolunteeringGetMyVolunteeringRecordsError,
    TData
  >({
    ...volunteeringGetMyVolunteeringRecordsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useVolunteeringGetMyVolunteeringRecords = <TData = VolunteeringGetMyVolunteeringRecordsResponse>(
  variables: VolunteeringGetMyVolunteeringRecordsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      VolunteeringGetMyVolunteeringRecordsResponse,
      VolunteeringGetMyVolunteeringRecordsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    VolunteeringGetMyVolunteeringRecordsResponse,
    VolunteeringGetMyVolunteeringRecordsError,
    TData
  >({
    ...volunteeringGetMyVolunteeringRecordsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type VolunteeringGetMyPendingVolunteeringRecordsError = Fetcher.ErrorWrapper<undefined>;

export type VolunteeringGetMyPendingVolunteeringRecordsResponse = Schemas.VolunteeringRecordDto[];

export type VolunteeringGetMyPendingVolunteeringRecordsVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchVolunteeringGetMyPendingVolunteeringRecords = (
  variables: VolunteeringGetMyPendingVolunteeringRecordsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    VolunteeringGetMyPendingVolunteeringRecordsResponse,
    VolunteeringGetMyPendingVolunteeringRecordsError,
    undefined,
    {},
    {},
    {}
  >({ method: "get", url: "/api/v1/Volunteering/my-pending-volunteering-records", ...variables, signal });

export function volunteeringGetMyPendingVolunteeringRecordsQuery(
  variables: VolunteeringGetMyPendingVolunteeringRecordsVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<VolunteeringGetMyPendingVolunteeringRecordsResponse>;
};

export function volunteeringGetMyPendingVolunteeringRecordsQuery(
  variables: VolunteeringGetMyPendingVolunteeringRecordsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<VolunteeringGetMyPendingVolunteeringRecordsResponse>)
    | reactQuery.SkipToken;
};

export function volunteeringGetMyPendingVolunteeringRecordsQuery(
  variables: VolunteeringGetMyPendingVolunteeringRecordsVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchVolunteeringGetMyPendingVolunteeringRecords(variables, signal),
    queryKey: queryKeyFn({
      operationId: "volunteeringGetMyPendingVolunteeringRecords",
      path: "/api/v1/Volunteering/my-pending-volunteering-records",
      variables,
    }),
  };
}

export const useSuspenseVolunteeringGetMyPendingVolunteeringRecords = <
  TData = VolunteeringGetMyPendingVolunteeringRecordsResponse,
>(
  variables: VolunteeringGetMyPendingVolunteeringRecordsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      VolunteeringGetMyPendingVolunteeringRecordsResponse,
      VolunteeringGetMyPendingVolunteeringRecordsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    VolunteeringGetMyPendingVolunteeringRecordsResponse,
    VolunteeringGetMyPendingVolunteeringRecordsError,
    TData
  >({
    ...volunteeringGetMyPendingVolunteeringRecordsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useVolunteeringGetMyPendingVolunteeringRecords = <
  TData = VolunteeringGetMyPendingVolunteeringRecordsResponse,
>(
  variables: VolunteeringGetMyPendingVolunteeringRecordsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      VolunteeringGetMyPendingVolunteeringRecordsResponse,
      VolunteeringGetMyPendingVolunteeringRecordsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    VolunteeringGetMyPendingVolunteeringRecordsResponse,
    VolunteeringGetMyPendingVolunteeringRecordsError,
    TData
  >({
    ...volunteeringGetMyPendingVolunteeringRecordsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export interface VolunteeringGetMyAdminVolunteeringRecordsPathParams {
  /**
   * Required, non-empty
   *
   * @format uuid
   */
  bubbleId: string;
}

export type VolunteeringGetMyAdminVolunteeringRecordsError = Fetcher.ErrorWrapper<undefined>;

export type VolunteeringGetMyAdminVolunteeringRecordsResponse = Schemas.VolunteeringRecordDto[];

export type VolunteeringGetMyAdminVolunteeringRecordsVariables = {
  pathParams: VolunteeringGetMyAdminVolunteeringRecordsPathParams;
} & CrowdcoursingApiContext["fetcherOptions"];

export const fetchVolunteeringGetMyAdminVolunteeringRecords = (
  variables: VolunteeringGetMyAdminVolunteeringRecordsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<
    VolunteeringGetMyAdminVolunteeringRecordsResponse,
    VolunteeringGetMyAdminVolunteeringRecordsError,
    undefined,
    {},
    {},
    VolunteeringGetMyAdminVolunteeringRecordsPathParams
  >({ method: "get", url: "/api/v1/Volunteering/my-records/admin/{bubbleId}", ...variables, signal });

export function volunteeringGetMyAdminVolunteeringRecordsQuery(
  variables: VolunteeringGetMyAdminVolunteeringRecordsVariables,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<VolunteeringGetMyAdminVolunteeringRecordsResponse>;
};

export function volunteeringGetMyAdminVolunteeringRecordsQuery(
  variables: VolunteeringGetMyAdminVolunteeringRecordsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn:
    | ((options: QueryFnOptions) => Promise<VolunteeringGetMyAdminVolunteeringRecordsResponse>)
    | reactQuery.SkipToken;
};

export function volunteeringGetMyAdminVolunteeringRecordsQuery(
  variables: VolunteeringGetMyAdminVolunteeringRecordsVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchVolunteeringGetMyAdminVolunteeringRecords(variables, signal),
    queryKey: queryKeyFn({
      operationId: "volunteeringGetMyAdminVolunteeringRecords",
      path: "/api/v1/Volunteering/my-records/admin/{bubbleId}",
      variables,
    }),
  };
}

export const useSuspenseVolunteeringGetMyAdminVolunteeringRecords = <
  TData = VolunteeringGetMyAdminVolunteeringRecordsResponse,
>(
  variables: VolunteeringGetMyAdminVolunteeringRecordsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<
      VolunteeringGetMyAdminVolunteeringRecordsResponse,
      VolunteeringGetMyAdminVolunteeringRecordsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<
    VolunteeringGetMyAdminVolunteeringRecordsResponse,
    VolunteeringGetMyAdminVolunteeringRecordsError,
    TData
  >({
    ...volunteeringGetMyAdminVolunteeringRecordsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useVolunteeringGetMyAdminVolunteeringRecords = <TData = VolunteeringGetMyAdminVolunteeringRecordsResponse>(
  variables: VolunteeringGetMyAdminVolunteeringRecordsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<
      VolunteeringGetMyAdminVolunteeringRecordsResponse,
      VolunteeringGetMyAdminVolunteeringRecordsError,
      TData
    >,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<
    VolunteeringGetMyAdminVolunteeringRecordsResponse,
    VolunteeringGetMyAdminVolunteeringRecordsError,
    TData
  >({
    ...volunteeringGetMyAdminVolunteeringRecordsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type VolunteeringGetMyVolunteeringStatsError = Fetcher.ErrorWrapper<undefined>;

export type VolunteeringGetMyVolunteeringStatsVariables = CrowdcoursingApiContext["fetcherOptions"];

export const fetchVolunteeringGetMyVolunteeringStats = (
  variables: VolunteeringGetMyVolunteeringStatsVariables,
  signal?: AbortSignal,
) =>
  crowdcoursingApiFetch<Schemas.CurrentVolunteerStats, VolunteeringGetMyVolunteeringStatsError, undefined, {}, {}, {}>({
    method: "get",
    url: "/api/v1/Volunteering/my-volunteering-history-stats",
    ...variables,
    signal,
  });

export function volunteeringGetMyVolunteeringStatsQuery(variables: VolunteeringGetMyVolunteeringStatsVariables): {
  queryKey: reactQuery.QueryKey;
  queryFn: (options: QueryFnOptions) => Promise<Schemas.CurrentVolunteerStats>;
};

export function volunteeringGetMyVolunteeringStatsQuery(
  variables: VolunteeringGetMyVolunteeringStatsVariables | reactQuery.SkipToken,
): {
  queryKey: reactQuery.QueryKey;
  queryFn: ((options: QueryFnOptions) => Promise<Schemas.CurrentVolunteerStats>) | reactQuery.SkipToken;
};

export function volunteeringGetMyVolunteeringStatsQuery(
  variables: VolunteeringGetMyVolunteeringStatsVariables | reactQuery.SkipToken,
) {
  return {
    queryFn:
      variables === reactQuery.skipToken
        ? reactQuery.skipToken
        : ({ signal }: QueryFnOptions) => fetchVolunteeringGetMyVolunteeringStats(variables, signal),
    queryKey: queryKeyFn({
      operationId: "volunteeringGetMyVolunteeringStats",
      path: "/api/v1/Volunteering/my-volunteering-history-stats",
      variables,
    }),
  };
}

export const useSuspenseVolunteeringGetMyVolunteeringStats = <TData = Schemas.CurrentVolunteerStats>(
  variables: VolunteeringGetMyVolunteeringStatsVariables,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.CurrentVolunteerStats, VolunteeringGetMyVolunteeringStatsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useSuspenseQuery<Schemas.CurrentVolunteerStats, VolunteeringGetMyVolunteeringStatsError, TData>({
    ...volunteeringGetMyVolunteeringStatsQuery(deepMerge(fetcherOptions, variables)),
    ...options,
    ...queryOptions,
  });
};

export const useVolunteeringGetMyVolunteeringStats = <TData = Schemas.CurrentVolunteerStats>(
  variables: VolunteeringGetMyVolunteeringStatsVariables | reactQuery.SkipToken,
  options?: Omit<
    reactQuery.UseQueryOptions<Schemas.CurrentVolunteerStats, VolunteeringGetMyVolunteeringStatsError, TData>,
    "queryKey" | "queryFn" | "initialData"
  >,
) => {
  const { queryOptions, fetcherOptions } = useCrowdcoursingApiContext(options);
  return reactQuery.useQuery<Schemas.CurrentVolunteerStats, VolunteeringGetMyVolunteeringStatsError, TData>({
    ...volunteeringGetMyVolunteeringStatsQuery(
      variables === reactQuery.skipToken ? variables : deepMerge(fetcherOptions, variables),
    ),
    ...options,
    ...queryOptions,
  });
};

export type QueryOperation =
  | {
      path: "/api/v1/chat/ai/conversations";
      operationId: "aiChatGetUserConversations";
      variables: AiChatGetUserConversationsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/chat/ai/conversations/{threadId}";
      operationId: "aiChatGetConversation";
      variables: AiChatGetConversationVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/background-checks/products";
      operationId: "backgroundCheckGetProducts";
      variables: BackgroundCheckGetProductsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/admin/site";
      operationId: "bubbleGetSiteId";
      variables: BubbleGetSiteIdVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}";
      operationId: "bubbleGetBubble";
      variables: BubbleGetBubbleVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/users/{userId}";
      operationId: "bubbleGetBubblesForUser";
      variables: BubbleGetBubblesForUserVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/role";
      operationId: "bubbleGetRoles";
      variables: BubbleGetRolesVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/users";
      operationId: "bubbleGetUsersForBubble";
      variables: BubbleGetUsersForBubbleVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/upcoming-rsvps";
      operationId: "bubbleGetUpcomingRsvps";
      variables: BubbleGetUpcomingRsvpsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/events";
      operationId: "bubbleGetAllEventsForBubble";
      variables: BubbleGetAllEventsForBubbleVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/upcoming-events";
      operationId: "bubbleGetUpcomingEventsForBubble";
      variables: BubbleGetUpcomingEventsForBubbleVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/picture";
      operationId: "bubbleGetBubblePicture";
      variables: BubbleGetBubblePictureVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/public-page";
      operationId: "bubbleGetPublicPageSettings";
      variables: BubbleGetPublicPageSettingsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/candidates";
      operationId: "bubbleGetCandidates";
      variables: BubbleGetCandidatesVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/candidate-stats";
      operationId: "bubbleGetCandidateStats";
      variables: BubbleGetCandidateStatsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/skills-and-certs-stats";
      operationId: "bubbleGetSkillsAndCertsStatsForBubble";
      variables: BubbleGetSkillsAndCertsStatsForBubbleVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/candidate-search-history";
      operationId: "bubbleGetCandidateSearchHistoryForBubble";
      variables: BubbleGetCandidateSearchHistoryForBubbleVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/check-in.svg";
      operationId: "bubbleGetBubbleCheckInQrCode";
      variables: BubbleGetBubbleCheckInQrCodeVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/recent-sign-ups";
      operationId: "bubbleGetRecentSignUps";
      variables: BubbleGetRecentSignUpsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/volunteering-statistics";
      operationId: "bubbleGetVolunteeringStatistics";
      variables: BubbleGetVolunteeringStatisticsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/all-related-bubbles";
      operationId: "bubbleGetAllRelatedBubbles";
      variables: BubbleGetAllRelatedBubblesVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/current";
      operationId: "bubbleDayOfEmergencyGetCurrent";
      variables: BubbleDayOfEmergencyGetCurrentVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/{dayOfEmergencyId}";
      operationId: "bubbleDayOfEmergencyGetById";
      variables: BubbleDayOfEmergencyGetByIdVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/{dayOfEmergencyId}/timeline";
      operationId: "bubbleDayOfEmergencyListTimeline";
      variables: BubbleDayOfEmergencyListTimelineVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/{dayOfEmergencyId}/participants";
      operationId: "bubbleDayOfEmergencyListParticipants";
      variables: BubbleDayOfEmergencyListParticipantsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/day-of-emergency/{dayOfEmergencyId}/access-audits";
      operationId: "bubbleDayOfEmergencyListAccessAudits";
      variables: BubbleDayOfEmergencyListAccessAuditsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/emergency-config";
      operationId: "bubbleEmergencyConfigGetConfig";
      variables: BubbleEmergencyConfigGetConfigVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/emergency-declarations";
      operationId: "bubbleEmergencyDeclarationsList";
      variables: BubbleEmergencyDeclarationsListVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/emergency-declarations/active";
      operationId: "bubbleEmergencyDeclarationsGetActive";
      variables: BubbleEmergencyDeclarationsGetActiveVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/emergency-declarations/active-list";
      operationId: "bubbleEmergencyDeclarationsListActive";
      variables: BubbleEmergencyDeclarationsListActiveVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/emergency-map-locations";
      operationId: "bubbleEmergencyMapLocationsList";
      variables: BubbleEmergencyMapLocationsListVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/emergency-plan-visibility";
      operationId: "bubbleEmergencyPlanVisibilityGet";
      variables: BubbleEmergencyPlanVisibilityGetVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/groups";
      operationId: "bubbleGroupsListGroups";
      variables: BubbleGroupsListGroupsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/groups/{groupId}";
      operationId: "bubbleGroupsGetGroup";
      variables: BubbleGroupsGetGroupVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/groups/{groupId}/members";
      operationId: "bubbleGroupsListMembers";
      variables: BubbleGroupsListMembersVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/law-enforcement-users";
      operationId: "bubbleLawEnforcementUsersList";
      variables: BubbleLawEnforcementUsersListVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Calendar/links";
      operationId: "calendarLinks";
      variables: CalendarLinksVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/day";
      operationId: "dayOfEmergencyAnonymousAccessGetDayForLawEnforcement";
      variables: DayOfEmergencyAnonymousAccessGetDayForLawEnforcementVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/participants";
      operationId: "dayOfEmergencyAnonymousAccessListParticipantsForLawEnforcement";
      variables: DayOfEmergencyAnonymousAccessListParticipantsForLawEnforcementVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/timeline";
      operationId: "dayOfEmergencyAnonymousAccessListTimelineForLawEnforcement";
      variables: DayOfEmergencyAnonymousAccessListTimelineForLawEnforcementVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/emergency-declarations/active";
      operationId: "dayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcement";
      variables:
        | DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForLawEnforcementVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/bubble-context";
      operationId: "dayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcement";
      variables: DayOfEmergencyAnonymousAccessGetBubbleContextForLawEnforcementVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/admin-contacts";
      operationId: "dayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcement";
      variables: DayOfEmergencyAnonymousAccessListAdminContactsForLawEnforcementVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/map-locations";
      operationId: "dayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcement";
      variables: DayOfEmergencyAnonymousAccessListMapLocationsForLawEnforcementVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/day";
      operationId: "dayOfEmergencyAnonymousAccessGetDayForRecipient";
      variables: DayOfEmergencyAnonymousAccessGetDayForRecipientVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/participants";
      operationId: "dayOfEmergencyAnonymousAccessListParticipantsForRecipient";
      variables: DayOfEmergencyAnonymousAccessListParticipantsForRecipientVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/timeline";
      operationId: "dayOfEmergencyAnonymousAccessListTimelineForRecipient";
      variables: DayOfEmergencyAnonymousAccessListTimelineForRecipientVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/emergency-declarations/active";
      operationId: "dayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipient";
      variables:
        | DayOfEmergencyAnonymousAccessListActiveEmergencyDeclarationsForRecipientVariables
        | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/bubble-context";
      operationId: "dayOfEmergencyAnonymousAccessGetBubbleContextForRecipient";
      variables: DayOfEmergencyAnonymousAccessGetBubbleContextForRecipientVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/admin-contacts";
      operationId: "dayOfEmergencyAnonymousAccessListAdminContactsForRecipient";
      variables: DayOfEmergencyAnonymousAccessListAdminContactsForRecipientVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/map-locations";
      operationId: "dayOfEmergencyAnonymousAccessListMapLocationsForRecipient";
      variables: DayOfEmergencyAnonymousAccessListMapLocationsForRecipientVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/law-enforcement/chat/messages";
      operationId: "dayOfEmergencyAnonymousAccessListLawEnforcementChatMessages";
      variables: DayOfEmergencyAnonymousAccessListLawEnforcementChatMessagesVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/day-of-emergency/{dayOfEmergencyId}/recipient/chat/messages";
      operationId: "dayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessages";
      variables: DayOfEmergencyAnonymousAccessListRecipientEmergencyChatMessagesVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/snapshot";
      operationId: "districtEmergencyConsoleGetSnapshot";
      variables: DistrictEmergencyConsoleGetSnapshotVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/map-aggregate";
      operationId: "districtEmergencyConsoleGetMapAggregate";
      variables: DistrictEmergencyConsoleGetMapAggregateVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/schools/{schoolBubbleId}/day/{dayOfEmergencyId}";
      operationId: "districtEmergencyConsoleGetDayForSchool";
      variables: DistrictEmergencyConsoleGetDayForSchoolVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/schools/{schoolBubbleId}/day/{dayOfEmergencyId}/participants";
      operationId: "districtEmergencyConsoleListParticipants";
      variables: DistrictEmergencyConsoleListParticipantsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/schools/{schoolBubbleId}/day/{dayOfEmergencyId}/timeline";
      operationId: "districtEmergencyConsoleListTimeline";
      variables: DistrictEmergencyConsoleListTimelineVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/schools/{schoolBubbleId}/map-locations";
      operationId: "districtEmergencyConsoleListMapLocations";
      variables: DistrictEmergencyConsoleListMapLocationsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/school-districts/{schoolDistrictId}/emergency-console/schools/{schoolBubbleId}/emergency-declarations/active";
      operationId: "districtEmergencyConsoleListActiveDeclarations";
      variables: DistrictEmergencyConsoleListActiveDeclarationsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/event/{eventId}";
      operationId: "eventGetEvent";
      variables: EventGetEventVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/event/my-events/{userId}";
      operationId: "eventGetMyEvents";
      variables: EventGetMyEventsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/event/{eventId}/check-in.svg";
      operationId: "eventGetEventCheckInQrCode";
      variables: EventGetEventCheckInQrCodeVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/event/{eventId}/picture";
      operationId: "eventGetEventPicture";
      variables: EventGetEventPictureVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Login/whoami";
      operationId: "loginWhoAmI";
      variables: LoginWhoAmIVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Login/google";
      operationId: "loginGoogleStart";
      variables: LoginGoogleStartVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Login/google/callback";
      operationId: "loginGoogleCallback";
      variables: LoginGoogleCallbackVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Login/google/finish";
      operationId: "loginGoogleFinish";
      variables: LoginGoogleFinishVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Organization/{organizationId}";
      operationId: "organizationGetOrganization";
      variables: OrganizationGetOrganizationVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Organization/{organizationId}/picture";
      operationId: "organizationGetOrganizationPicture";
      variables: OrganizationGetOrganizationPictureVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Organization/{organizationId}/donations";
      operationId: "organizationGetOrganizationDonations";
      variables: OrganizationGetOrganizationDonationsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Organization/{organizationId}/members";
      operationId: "organizationGetOrganizationMembers";
      variables: OrganizationGetOrganizationMembersVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Organization/roles";
      operationId: "organizationGetOrganizationRoles";
      variables: OrganizationGetOrganizationRolesVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Organization/my-organizations";
      operationId: "organizationGetMyOrganizations";
      variables: OrganizationGetMyOrganizationsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Profile/{userId}/payment-account";
      operationId: "paymentGetPaymentAccount";
      variables: PaymentGetPaymentAccountVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Profile/{userId}/payment-account/login";
      operationId: "paymentGetStripeLogin";
      variables: PaymentGetStripeLoginVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/platform-chats/my-chats/{userId}";
      operationId: "platformChatsGetMyChats";
      variables: PlatformChatsGetMyChatsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/platform-insights/login-history";
      operationId: "platformInsightsGetLoginHistory";
      variables: PlatformInsightsGetLoginHistoryVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/platform-insights/district-onboarding";
      operationId: "platformInsightsGetDistrictOnboarding";
      variables: PlatformInsightsGetDistrictOnboardingVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/proficiency/{proficiencyId}";
      operationId: "proficiencyGetProficiency";
      variables: ProficiencyGetProficiencyVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/proficiencies";
      operationId: "proficiencyGetAllProficiencies";
      variables: ProficiencyGetAllProficienciesVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Profile/{userId}";
      operationId: "profileGetProfile";
      variables: ProfileGetProfileVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Profile/{userId}/picture";
      operationId: "profileGetProfilePicture";
      variables: ProfileGetProfilePictureVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/public/organizations";
      operationId: "publicOrganizationGetDirectory";
      variables: PublicOrganizationGetDirectoryVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/public/organizations/{slug}";
      operationId: "publicOrganizationGetBySlug";
      variables: PublicOrganizationGetBySlugVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/public/organizations/{slug}/upcoming-events";
      operationId: "publicOrganizationGetUpcomingEvents";
      variables: PublicOrganizationGetUpcomingEventsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/public/slugs/available/{slug}";
      operationId: "publicSlugCheckAvailability";
      variables: PublicSlugCheckAvailabilityVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/Report/categories";
      operationId: "reportGetCategories";
      variables: ReportGetCategoriesVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/Report/unresolved";
      operationId: "reportGetUnresolvedReports";
      variables: ReportGetUnresolvedReportsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/Resume/valid-file-extensions";
      operationId: "resumeGetValidFileExtensions";
      variables: ResumeGetValidFileExtensionsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/Resume/user/{userId}";
      operationId: "resumeGetUserResume";
      variables: ResumeGetUserResumeVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/Resume/skills-and-certs-stats";
      operationId: "resumeGetCertsAndSkills";
      variables: ResumeGetCertsAndSkillsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/Resume/employment-preference-tags";
      operationId: "resumeGetEmploymentPreferenceTagsCatalog";
      variables: ResumeGetEmploymentPreferenceTagsCatalogVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/Resume/user/{userId}/employment-preference-tags";
      operationId: "resumeGetUserEmploymentPreferenceTags";
      variables: ResumeGetUserEmploymentPreferenceTagsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/room/{roomId}";
      operationId: "roomGetRoom";
      variables: RoomGetRoomVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/room/my-rooms/{userId}";
      operationId: "roomGetMyRooms";
      variables: RoomGetMyRoomsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/room/{roomId}/picture";
      operationId: "roomGetRoomPicture";
      variables: RoomGetRoomPictureVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/room/{roomId}/check-in.svg";
      operationId: "roomGetRoomCheckInQrCode";
      variables: RoomGetRoomCheckInQrCodeVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/contacts";
      operationId: "salesGetSalesContacts";
      variables: SalesGetSalesContactsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/bubbles/{bubbleId}/prospects";
      operationId: "salesGetProspects";
      variables: SalesGetProspectsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}";
      operationId: "salesGetProspect";
      variables: SalesGetProspectVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/bubbles/{bubbleId}/deals";
      operationId: "salesGetDeals";
      variables: SalesGetDealsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/bubbles/{bubbleId}/deals/{id}";
      operationId: "salesGetDeal";
      variables: SalesGetDealVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/assignments";
      operationId: "salesGetAssignments";
      variables: SalesGetAssignmentsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/contacts";
      operationId: "salesGetContacts";
      variables: SalesGetContactsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/contacts/{contactId}";
      operationId: "salesGetContact";
      variables: SalesGetContactVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/notes";
      operationId: "salesGetNotes";
      variables: SalesGetNotesVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/interactions";
      operationId: "salesGetInteractions";
      variables: SalesGetInteractionsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/tasks";
      operationId: "salesGetProspectTasks";
      variables: SalesGetProspectTasksVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/bubbles/{bubbleId}/tasks";
      operationId: "salesGetMyTasks";
      variables: SalesGetMyTasksVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/bubbles/{bubbleId}/tasks/{taskId}";
      operationId: "salesGetTask";
      variables: SalesGetTaskVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/bubbles/{bubbleId}/prospects/{id}/stage/history";
      operationId: "salesGetStageHistory";
      variables: SalesGetStageHistoryVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/bubbles/{bubbleId}/pipeline";
      operationId: "salesGetPipeline";
      variables: SalesGetPipelineVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/bubbles/{bubbleId}/reports/stale";
      operationId: "salesGetStaleProspects";
      variables: SalesGetStaleProspectsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/bubbles/{bubbleId}/reports/tasks/due-soon";
      operationId: "salesGetTasksDueSoon";
      variables: SalesGetTasksDueSoonVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/reports/all-user-activity";
      operationId: "salesGetSalesActivity";
      variables: SalesGetSalesActivityVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/personnel/sales";
      operationId: "salesGetSalesFolks";
      variables: SalesGetSalesFolksVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/email-templates";
      operationId: "salesGetSalesEmailTemplates";
      variables: SalesGetSalesEmailTemplatesVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/sales/email-templates/{templateId}";
      operationId: "salesGetSalesEmailTemplate";
      variables: SalesGetSalesEmailTemplateVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/{schoolDistrictId}";
      operationId: "schoolDistrictGetSchoolDistrict";
      variables: SchoolDistrictGetSchoolDistrictVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/schools/{schoolId}";
      operationId: "schoolDistrictGetSchool";
      variables: SchoolDistrictGetSchoolVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/{schoolDistrictId}/schools";
      operationId: "schoolDistrictGetSchoolsForSchoolDistrict";
      variables: SchoolDistrictGetSchoolsForSchoolDistrictVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/SchoolDistrict/{schoolDistrictId}/schools";
      operationId: "schoolDistrictGetSearchableSchoolsForSchoolDistrict";
      variables: SchoolDistrictGetSearchableSchoolsForSchoolDistrictVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/get-schools-for-user";
      operationId: "schoolDistrictGetSchoolsForLoggedInUser";
      variables: SchoolDistrictGetSchoolsForLoggedInUserVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/get-school-sign-ins";
      operationId: "schoolDistrictGetSchoolSignIns";
      variables: SchoolDistrictGetSchoolSignInsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/get-active-school-sign-ins";
      operationId: "schoolDistrictGetActiveSchoolVisitorSignIns";
      variables: SchoolDistrictGetActiveSchoolVisitorSignInsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Bubbles/{bubbleId}/SchoolDistrict/users/{userId}/parents";
      operationId: "schoolDistrictGetParents";
      variables: SchoolDistrictGetParentsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/Search/search/get-rooms-and-events";
      operationId: "searchGetRoomsAndEventsSearch";
      variables: SearchGetRoomsAndEventsSearchVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/Search/search/get-rooms";
      operationId: "searchGetRoomsSearch";
      variables: SearchGetRoomsSearchVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/Search/search/get-events";
      operationId: "searchGetEventsSearch";
      variables: SearchGetEventsSearchVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/Search/candidate-search-history";
      operationId: "searchGetSearchQueries";
      variables: SearchGetSearchQueriesVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/User/{userId}/public";
      operationId: "userGetPublicUserInfo";
      variables: UserGetPublicUserInfoVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/User/{userId}/rsvps";
      operationId: "userGetUserRsvpsSearch";
      variables: UserGetUserRsvpsSearchVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/User/{userId}/user-history";
      operationId: "userGetUserHistoryInformation";
      variables: UserGetUserHistoryInformationVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/User/my-resources";
      operationId: "userGetUserResources";
      variables: UserGetUserResourcesVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/User/my-upcoming-rsvps";
      operationId: "userGetMyUpcomingRsvps";
      variables: UserGetMyUpcomingRsvpsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/User/site-data";
      operationId: "userGetUserSiteData";
      variables: UserGetUserSiteDataVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Volunteering/volunteering-record/{volunteeringRecordId}";
      operationId: "volunteeringGetVolunteeringRecord";
      variables: VolunteeringGetVolunteeringRecordVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Volunteering/my-records";
      operationId: "volunteeringGetMyVolunteeringRecords";
      variables: VolunteeringGetMyVolunteeringRecordsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Volunteering/my-pending-volunteering-records";
      operationId: "volunteeringGetMyPendingVolunteeringRecords";
      variables: VolunteeringGetMyPendingVolunteeringRecordsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Volunteering/my-records/admin/{bubbleId}";
      operationId: "volunteeringGetMyAdminVolunteeringRecords";
      variables: VolunteeringGetMyAdminVolunteeringRecordsVariables | reactQuery.SkipToken;
    }
  | {
      path: "/api/v1/Volunteering/my-volunteering-history-stats";
      operationId: "volunteeringGetMyVolunteeringStats";
      variables: VolunteeringGetMyVolunteeringStatsVariables | reactQuery.SkipToken;
    };
